export const content = [
	{ id: "administration", en: "administration", ar: "ادارة النظام" },
	{ id: "notifications", en: "notifications", ar: "اشعارات" },
	{ id: "fleet management", en: "fleet management", ar: "ادارة الأسطول" },
	{ id: "dashboard", en: "dashboard", ar: "لوحة التحكم" },
	{ id: "live tracking", en: "live tracking", ar: "تتبع مباشر" },
	{ id: "geofences", en: "geofences", ar: "المناطق الجغرافية" },
	{ id: "reports", en: "reports", ar: "التقارير" },
	{ id: "historical", en: "historical", ar: "السجل" },
	{ id: "account settings", en: "account settings", ar: "إعدادات الحساب" },
	{ id: "report types", en: "report types", ar: "انواع التقارير" },
	{ id: "Vehicles", en: "Vehicles", ar: "المركبات" },
	{
		id: "Search Report Name...",
		en: "Search Report Name...",
		ar: "بحث عن اسم التقرير...",
	},
	{ id: "Name", en: "Name", ar: "الاسم" },
	{ id: "Description", en: "Description", ar: "وصف" },
	{ id: "ReportType", en: "ReportType", ar: "نوع التقرير" },
	{
		id: "Vehicles Trips Report",
		en: "Vehicles Trips Report",
		ar: "تقرير رحلات المركبات",
	},
	{
		id: "Vehicles Trips Report des",
		en: "This report will provide you with the vehicles current location, distances traveled, and alerts.",
		ar: "سيوفر لك هذا التقرير الموقع الحالي للمركبات والمسافات المقطوعة والتنبيهات",
	},
	{ id: "Stop Report", en: "Stop Report", ar: "تقرير التوقف" },
	{
		id: "Stop Report des",
		en: "This report will provide details on the stops made by vehicles and the duration of each stop.",
		ar: "سيوفر هذا التقرير تفاصيل حول التوقفات التي قامت بها المركبات ومدة كل توقف",
	},
	{ id: "Distance Report", en: "Distance Report", ar: "تقرير المسافة" },
	{
		id: "Distance Report des",
		en: "This report will provide the traveled distances for each vehicle, along with the odometer readings at the start and end.",
		ar: "سيوفر هذا التقرير المسافات المقطوعة لكل مركبة، بالإضافة إلى قراءات عداد المسافات في البداية والنهاية",
	},
	{ id: "Speed Report", en: "Speed Report", ar: "تقرير السرعة" },
	{
		id: "Speed Report des",
		en: "This report will provide you with the vehicles speed average, highest speed and number of speed alerts.",
		ar: "سيوفر لك هذا التقرير متوسط ​​سرعة المركبات وأعلى سرعة وعدد تنبيهات السرعة",
	},
	{ id: "Route Report", en: "Route Report", ar: "تقرير المسار" },
	{
		id: "Route Report des",
		en: "This report will provide detailed movement information for each vehicle.",
		ar: "سيوفر هذا التقرير معلومات تفصيلية عن حركة كل مركبة.",
	},
	{ id: "Fuel Report", en: "Fuel Report", ar: "تقرير الوقود" },
	{
		id: "Fuel Report des",
		en: "This report will provide details on the distance traveled by vehicles, fuel consumption, and fuel costs.",
		ar: "سيوفر هذا التقرير تفاصيل حول المسافة التي قطعتها المركبات، واستهلاك الوقود، وتكاليف الوقود.",
	},
	{ id: "Odometer Report", en: "Odometer Report", ar: "تقرير عداد المسافات" },
	{
		id: "Odometer Report des",
		en: "This report will provide the odometer readings for all vehicles.",
		ar: "سيوفر هذا التقرير قراءات عداد المسافات لجميع المركبات.",
	},
	{ id: "Export Report", en: "Export Report", ar: "استخراج تقرير" },
	{
		id: "No Reports Found",
		en: "No Reports Found",
		ar: "لم يتم العثور على أي تقارير",
	},
	{ id: "Vehicle", en: "Vehicle", ar: "المركبة" },
	{ id: "device", en: "device", ar: "المركبة" },
	{
		id: "Create new report now!",
		en: "Create new report now!",
		ar: "إنشاء تقرير جديد الآن!",
	},
	
	{ id: "Start Time", en: "Start Time", ar: "وقت البدء" },
	{ id: "Low_Priority", en: "Low Priority", ar: "الأقل أولوية" },
	{ id: "Medium_Priority", en: "Medium Priority", ar: "الأولوية المتوسطة" },
	{ id: "High_Priority", en: "High Priority", ar: "الأعلي أولوية" },
	{ id: "Start Address", en: "Start Address", ar: "عنوان البداية" },
	{ id: "Odometer Start", en: "Odometer Start", ar: "بدء عداد المسافات" },
	{ id: "End Time", en: "End Time", ar: "وقت النهاية" },
	{ id: "End Address", en: "End Address", ar: "عنوان النهاية" },
	{ id: "Odometer End", en: "Odometer End", ar: "نهاية عداد المسافات" },
	{ id: "AVG Speed", en: "AVG Speed", ar: "متوسط السرعة" },
	{ id: "Distance", en: "Distance", ar: "المسافة" },
	{ id: "Duration", en: "Duration", ar: "المدة" },
	{ id: "Max Speed", en: "Max Speed", ar: "اقصي سرعة" },
	{ id: "Engine Hours", en: "Engine Hours", ar: "ساعات عمل المحرك" },
	{ id: "Odometer", en: "Odometer", ar: "عداد المسافات" },
	{ id: "Address", en: "Address", ar: "العنوان" },
	{ id: "Date", en: "Date", ar: "التاريخ" },
	{ id: "Speed", en: "Speed", ar: "السرعة" },
	{ id: "Total Distance", en: "Total Distance", ar: "المسافة الإجمالية" },
	{ id: "Ignition", en: "Ignition", ar: "اشتعال" },
	{ id: "Event", en: "Event", ar: "الحدث" },
	{ id: "Power", en: "Power", ar: "الطاقة" },
	{ id: "Battery Level", en: "Battery Level", ar: "مستوى البطارية" },
	{ id: "Spent Fuel", en: "Spent Fuel", ar: "الوقود المستهلك" },
	{ id: "Search", en: "Search", ar: "ابحث" },
	{ id: "Filter", en: "Filter", ar: "تصفية" },
	{ id: "vehiclestrips", en: "Vehicles Trips", ar: "رحلات المركبات" },
	{ id: "speed", en: "Speed", ar: "السرعة" },
	{ id: "stop", en: "Stop", ar: "التوقف" },
	{ id: "distance", en: "Distance", ar: "المسافة" },
	{ id: "route", en: "Route", ar: "المسار" },
	{ id: "fuel", en: "Fuel", ar: "الوقود" },
	{ id: "odometer", en: "odometer", ar: "عداد المسافات" },
	{ id: "Create Filter", en: "Create Filter", ar: "إنشاء فيلتر" },
	{
		id: "Click on filter and create report filter to extract data",
		en: "Click on filter and create report filter to extract data",
		ar: "انقر علي الفلتر ثم قم بإنشاء فلتر تقرير لاستخراج البيانات",
	},
	{ id: "Report Filter", en: "Report Filter", ar: "فلتر التقرير" },
	{ id: "User", en: "User", ar: "المستخدم" },
	{ id: "managedUser", en: "managedUser", ar: "المستخدم" },
	{ id: "Date Range", en: "Date Range", ar: "نطاق التاريخ" },
	{ id: "Select Parent", en: "Select Parent", ar: "اختر الحساب الاساسي" },
	{ id: "Select...", en: "Select...", ar: "اختر..." },
	{ id: "Start Date", en: "Start Date", ar: "من" },
	{ id: "End Date", en: "End Date", ar: "الي" },
	{ id: "Show", en: "Show", ar: "عرض" },
	{ id: "Save", en: "Save", ar: "حفظ" },
	{ id: "Cancel", en: "Cancel", ar: "الغاء" },
	{
		id: "Total Vehicles Tracked",
		en: "Total Vehicles Tracked",
		ar: "إجمالي المركبات المتعقبة",
	},
	{ id: "Highest Max Speed", en: "Highest Max Speed", ar: "أعلى سرعة قصوى" },
	{
		id: "Total Fuel Consumed",
		en: "Total Fuel Consumed",
		ar: "إجمالي الوقود المستهلك",
	},
	{
		id: "Total Odometers",
		en: "Total Odometers",
		ar: "إجمالي عدادات المسافات",
	},
	{
		id: "Total Engine Hours",
		en: "Total Engine Hours",
		ar: "إجمالي ساعات تشغيل المحرك",
	},
	{
		id: "Average Engine Hours",
		en: "Average Engine Hours",
		ar: "متوسط ساعات تشغيل المحرك",
	},
	{ id: "Total Duration", en: "Total Duration", ar: "المدة الإجمالية" },
	{ id: "Add notification", en: "Add Notification", ar: "اضافة اشعار" },
	{ id: "configuration", en: "configuration", ar: "اعدادات الاشعارات" },
	{ id: "Type", en: "Type", ar: "النوع" },
	{ id: "Actions", en: "Actions", ar: "الإجراءات" },
	{
		id: "No notifications found",
		en: "No notifications found",
		ar: "لم يتم العثور على إشعارات",
	},
	{ id: "Edit notification", en: "Edit Notification", ar: "تعديل اشعار" },
	{
		id: "Speed limit exceeded",
		en: "Speed limit exceeded",
		ar: "تم تجاوز حد السرعة",
	},
	{
		id: "Geofence entered",
		en: "Geofence entered",
		ar: "تم إدخال السياج الجغرافي",
	},
	{
		id: "Geofence exited",
		en: "Geofence exited",
		ar: "تم الخروج من السياج الجغرافي",
	},
	{ id: "Fuel drop", en: "Fuel drop", ar: "نقص الوقود" },
	{ id: "Fuel increase", en: "Fuel increase", ar: "زيادة الوقود" },
	{
		id: "Filter to get your notifications",
		en: "Filter to get your notifications",
		ar: "فلتر للحصول على إشعاراتك",
	},
	{ id: "Add new vehicle", en: "Add new vehicle", ar: "اضافة مركبة جديدة" },
	{ id: "plate number", en: "Plate Number", ar: "رقم اللوحة" },
	{ id: "status", en: "Status", ar: "الحالة" },
	{ id: "last update", en: "last update", ar: "آخر تحديث" },
	{ id: "condition", en: "condition", ar: "الوضع" },
	{ id: "parent", en: "parent", ar: "الحساب الاساسي" },
	{ id: "Items Per Page", en: "Items Per Page", ar: "العناصر لكل صفحة" },
	{ id: "Next", en: "Next", ar: "التالي" },
	{ id: "Previous", en: "Previous", ar: "السابق" },
	{ id: "drivers", en: "drivers", ar: "السائقين" },
	{ id: "Add new driver", en: "Add new driver", ar: "اضافة سائق جديد" },
	{ id: "driver code", en: "driver code", ar: "رمز السائق" },
	{ id: "ID number", en: "ID number", ar: "رقم الهوية" },
	{ id: "phone number", en: "Phone Number", ar: "رقم الهاتف" },
	{ id: "Edit Vehicle", en: "Edit Vehicle", ar: "تعديل بيانات المركبة" },
	{ id: "Vehicle name", en: "Vehicle name", ar: "اسم المركبة" },
	{ id: "License plate", en: "License plate", ar: "لوحة ترخيص" },
	{ id: "Code", en: "Code", ar: "الكود" },
	{ id: "Vehicle type", en: "Vehicle type", ar: "نوع المركبة" },
	{
		id: "Select Vehicle Type",
		en: "Select Vehicle Type",
		ar: "اختر نوع المركبة",
	},
	{ id: "Registration number", en: "Registration number", ar: "رقم التسجيل" },
	{ id: "Model", en: "Model", ar: "النموذج" },
	{ id: "Brand", en: "Brand", ar: "الماركة" },
	{ id: "Vehicle Brand", en: "Vehicle Brand", ar: "ماركة المركبة" },
	{ id: "color", en: "color", ar: "اللون" },
	{ id: "Vehicle Color", en: "Vehicle Color", ar: "لون المركبة" },
	{ id: "Year", en: "Year", ar: "السنة" },
	{ id: "Manfacture country", en: "Manfacture country", ar: "بلد المصنّع" },
	{ id: "Select country", en: "Select country", ar: "اختر البلد" },
	{ id: "Fuel Type", en: "Fuel Type", ar: "نوع الوقود" },
	{ id: "Select Fuel Type", en: "Select Fuel Type", ar: "اختر نوع الوقود" },
	{ id: "Gas", en: "Gas", ar: "غاز" },
	{ id: "Diesel", en: "Diesel", ar: "بنزين" },
	{ id: "Sollar", en: "Sollar", ar: "سولار" },
	{ id: "Fuel Consumption", en: "Fuel Consumption", ar: "استهلاك الوقود" },
	{ id: "Fuel Cost", en: "Fuel Cost", ar: "تكلفة الوقود" },
	{ id: "Fuel support", en: "Fuel support", ar: "دعم الوقود" },
	{ id: "Fuel Capacity", en: "Fuel Capacity", ar: "سعة الوقود" },
	{ id: "Tank Height", en: "Tank Height", ar: "ارتفاع الخزان" },
	{ id: "Tank Width", en: "Tank Width", ar: "عرض الخزان" },
	{ id: "Tank Length", en: "Tank Length", ar: "طول الخزان" },
	{ id: "vehicle info", en: "vehicle info", ar: "البيانات المركبة" },
	{ id: "vehicle setup", en: "vehicle setup", ar: "إعداد المركبة" },
	{ id: "SIM Number", en: "SIM Number", ar: "رقم الشريحة" },
	{
		id: "SIM Number Serial",
		en: "SIM Number Serial",
		ar: "الرقم التسلسلي للشريحة",
	},
	{
		id: "Vehicle Expiration",
		en: "Vehicle Expiration",
		ar: "انتهاء صلاحية المركبة",
	},
	{
		id: "Liscense Expiration Reminder",
		en: "Liscense Expiration Reminder",
		ar: "تذكير بانتهاء صلاحية الترخيص",
	},
	{ id: "License Expire", en: "License Expire", ar: "انتهاء صلاحية الترخيص" },
	{
		id: "Vehicle related to",
		en: "Vehicle related to",
		ar: "المسؤول عن المركبة",
	},
	{ id: "Idle time", en: "Idle time", ar: "وقت الخمول" },
	{ id: "Alert", en: "Alert", ar: "تحذير" },
	{ id: "Vehicle condition", en: "Vehicle condition", ar: "حالة المركبة" },
	{ id: "Archived", en: "Archived", ar: "مؤرشفة" },
	{
		id: "sensors supported",
		en: "sensors supported",
		ar: "أجهزة الاستشعار المدعومة",
	},
	{ id: "Attachments", en: "Attachments", ar: "المرفقات" },
	{
		id: "Drag files here or",
		en: "Drag files here or",
		ar: "اسحب الملفات هنا أو",
	},
	{ id: "Upload", en: "Upload", ar: "قم برفع ملف" },
	{ id: "IMEI number", en: "IMEI number", ar: "الرقم التعريفي" },
	{ id: "IMEI", en: "IMEI", ar: "الرقم التعريفي" },
	{ id: "Delete", en: "Delete", ar: "حذف" },
	{
		id: "Are you sure you want to delete this",
		en: "Are you sure you want to delete this",
		ar: "هل أنت متأكد أنك تريد حذف هذا",
	},
	{ id: "Vehicle Details", en: "Vehicle Details", ar: "تفاصيل السيارة" },
	{ id: "VIN", en: "VIN", ar: "VIN" },
	{ id: "Make", en: "Make", ar: "مصنع" },
	{ id: "FMS Status", en: "FMS Status", ar: "الحالة" },
	{ id: "Idle Alert", en: "Idle Alert", ar: "تنبيه الخمول" },
	{ id: "Assigned Driver", en: "Assigned Driver", ar: "السائق المعين" },
	{ id: "Events Filter", en: "Events Filter", ar: "فلتر الاحداث" },
	{ id: "Select Vehicle", en: "Select Vehicle", ar: "اختر مركبة" },
	{ id: "Save Changes", en: "Save Changes", ar: "حفظ التغييرات" },
	{
		id: "PTO sensor support",
		en: "PTO Sensor Support",
		ar: "دعم مستشعر سحب الطاقة",
	},
	{
		id: "acc sensor support",
		en: "Acc Sensor Support",
		ar: "دعم مستشعر التسارع",
	},
	{
		id: "seat sensor support",
		en: "Seat Sensor Support",
		ar: "دعم مستشعر المقعد",
	},
	{
		id: "door sensor support",
		en: "Door Sensor Support",
		ar: "دعم مستشعر الباب",
	},
	{
		id: "refrigerator sensor support",
		en: "Refrigerator Sensor Support",
		ar: "دعم مستشعر الثلاجة",
	},
	{
		id: "weight sensor support",
		en: "Weight Sensor Support",
		ar: "دعم مستشعر سحب الوزن",
	},
	{
		id: "headlights sensor support",
		en: "Headlights Sensor Support",
		ar: "دعم مستشعر المصابيح الأمامية",
	},
	{
		id: "temperature sensor support",
		en: "Temperature Sensor Support",
		ar: "دعم مستشعر سحب الحرارة",
	},
	{
		id: "IButton sensor support",
		en: "IButton Sensor Support",
		ar: "دعم مستشعر سحب الوزن",
	},
	{
		id: "Sensors Supported",
		en: "Sensors Supported",
		ar: "أجهزة الاستشعار المدعومة",
	},

	{ id: "Account", en: "Account", ar: "الحساب" },
	{
		id: "Manage your personal and organization settings.",
		en: "Manage your personal and organization settings.",
		ar: "إدارة إعداداتك الشخصية والتنظيمية.",
	},
	{ id: "Profile", en: "Profile", ar: "بيانات الحساب الشخصي" },
	{
		id: "Manage details of your personal profile.",
		en: "Manage details of your personal profile.",
		ar: "إدارة تفاصيل ملفك الشخصي.",
	},
	{ id: "Password", en: "Password", ar: "كلمة المرور" },
	{
		id: "Update your password",
		en: "Update your password",
		ar: "تحديث كلمة المرور",
	},
	{ id: "New Password", en: "New Password", ar: "كلمة مرور جديدة" },
	{ id: "Confirm Password", en: "Confirm Password", ar: "تأكيد كلمة المرور" },
	{ id: "Preferences", en: "Preferences", ar: "التفضيلات" },
	{
		id: "Manage pereferences of your profile.",
		en: "Manage pereferences of your profile.",
		ar: "إدارة تفضيلات ملفك الشخصي",
	},
	{ id: "Speed Unit", en: "Speed Unit", ar: "وحدة السرعة" },
	{ id: "Altitude Unit", en: "Altitude Unit", ar: "وحدة الارتفاع" },
	{ id: "Distance Unit", en: "Distance Unit", ar: "وحدة المسافة" },
	{ id: "Volume Unit", en: "Volume Unit", ar: "وحدة الحجم" },
	{ id: "Location", en: "Location", ar: "الموقع" },
	{
		id: "Update your current location.",
		en: "Update your current location",
		ar: "تحديث موقعك الحالي",
	},
	{ id: "Latitude", en: "Latitude", ar: "خط العرض" },
	{ id: "Longitude", en: "Longitude", ar: "خط الطول" },
	{
		id: "Get Current Location",
		en: "Get Current Location",
		ar: "الحصول علي الموقع الحالي",
	},
	{ id: "Login", en: "Login", ar: "تسجيل الدخول" },
	{ id: "Sign Out", en: "Sign Out", ar: "تسجيل الخروج" },
	{
		id: "Please Check Required Inputs",
		en: "Please Check Required Inputs",
		ar: "يرجى التحقق من المدخلات المطلوبة",
	},
	{
		id: "Please check password",
		en: "Please check password",
		ar: "الرجاء التحقق من كلمة المرور",
	},
	{ id: "Email", en: "Email", ar: "البريد الإلكتروني" },
	{
		id: "Confirm password must match password",
		en: "Confirm password must match password",
		ar: "تأكيد كلمة المرور يجب أن تتطابق مع كلمة المرور",
	},
	{ id: "Select Speed Unit", en: "Select Speed Unit", ar: "اختر وحدة السرعة" },
	{
		id: "Select Distance Unit",
		en: "Select Distance Unit",
		ar: "اختر وحدة المسافة",
	},
	{
		id: "Select Altitude Unit",
		en: "Select Altitude Unit",
		ar: "اختر وحدة الارتفاع",
	},
	{ id: "Select Volume Unit", en: "Select Volume Unit", ar: "اختر وحدة الحجم" },
	{ id: "Edit Driver", en: "Edit Driver", ar: "تعديل البيانات السائق" },
	{ id: "license number", en: "License Number", ar: "رقم الرخصة" },
	{ id: "Upload Image", en: "Upload Image", ar: "تحميل الصورة" },
	{ id: "Emergency Number", en: "Emergency Number", ar: "رقم الطوارئ" },
	{ id: "date info", en: "Date Info", ar: "معلومات التاريخ" },
	{
		id: "Contract start date",
		en: "Contract start date",
		ar: "تاريخ بدأ العقد",
	},
	{
		id: "Contract expiry date",
		en: "Contract expiry date",
		ar: "تاريخ انتهاء العقد",
	},
	{
		id: "Contract Expire Reminder",
		en: "Contract Expire Reminder",
		ar: "تذكير بانتهاء العقد",
	},
	{
		id: "license start date",
		en: "license start date",
		ar: "تاريخ بدأ صلاحية الترخيص",
	},
	{
		id: "license expiry date",
		en: "license expiry date",
		ar: "تاريخ انتهاء صلاحية الترخيص",
	},
	{
		id: "license Expire Reminder",
		en: "license Expire Reminder",
		ar: "تذكير بانتهاء صلاحية الترخيص",
	},
	{ id: "truck driver", en: "truck driver", ar: "سائق شاحنة" },
	{ id: "Driver Details", en: "Driver Details", ar: "تفاصيل السائق" },
	{ id: "Driver Name", en: "Driver Name", ar: "اسم السائق" },
	{ id: "Driver Code", en: "Driver Code", ar: "رمز السائق" },
	{ id: "users & roles", en: "users & roles", ar: "المستخدمين و الصلاحيات" },
	{ id: "users", en: "users", ar: "المستخدمين" },
	{ id: "sub-users", en: "sub-users", ar: "المستخدمون الفرعيون" },
	{ id: "view", en: "view", ar: "عرض" },
	{ id: "Edit User", en: "Edit User", ar: "تعديل البيانات المستخدم" },
	{ id: "User related to", en: "User related to", ar: "المستخدم الاساسي" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Add new user", en: "Add New User", ar: "إضافة مستخدم جديد" },
	{ id: "user info", en: "User Info", ar: "بيانات المستخدم" },
	{ id: "user preferences", en: "User Preferences", ar: "تفضيلات المستخدم" },
	{ id: "user location", en: "User Location", ar: "موقع المستخدم" },
	{
		id: "Choose Location from map",
		en: "Choose Location from map",
		ar: "إختيار الموقع من الخريطة",
	},
	{ id: "user permissions", en: "User Permissions", ar: "أذونات المستخدم" },
	{ id: "role", en: "Role", ar: "الصلاحية" },
	{ id: "Device Read Only", en: "Device Read Only", ar: "صلاحية الاجهزة فقط" },
	{ id: "Read Only", en: "Read Only", ar: "صلاحية العرض فقط" },
	{
		id: "Expiration Date",
		en: "Expiration Date",
		ar: "تاريخ انتهاء صلاحية المستخدم",
	},
	{ id: "Device Limit", en: "Device Limit", ar: "حد الجهاز" },
	{ id: "User Limit", en: "User Limit", ar: "حد المستخدم" },
	{ id: "User Details", en: "User Details", ar: "تفاصيل المستخدم" },
	{ id: "Geofence Name", en: "Geofence Name", ar: "اسم السياج الجغرافي" },
	// ---------------------------------Omar--------------------------------
	{ id: "History Playback", en: "History Playback", ar: "عرض السجل" },
	{ id: "Update", en: "Update", ar: "تحديث" },
	{ id: "History", en: "History", ar: "السجل" },
	{ id: "Events", en: "Events", ar: "الاحداث" },
	{ id: "Play all history", en: "Play all history", ar: "تشغيل كل السجل" },
	{
		id: "Overview of all history",
		en: "Overview of all history",
		ar: "نظرة عامة على كل سجل",
	},
	{ id: "Export selected", en: "Export selected", ar: "استخراج المحدد" },
	{ id: "More actions", en: "More actions", ar: "اجراءات اخري" },
	{ id: "Parking Periods", en: "Parking Periods", ar: "فترات وقوف" },
	{ id: "Idle Periods", en: "Idle Periods", ar: "فترات الخمول" },
	{ id: "Center Tracker", en: "Center Tracker", ar: "مركز التتبع" },
	{
		id: "Get current address",
		en: "Get current address",
		ar: "احصل على العنوان الحالي",
	},
	{ id: "Reset", en: "Reset", ar: "اعادة" },
	{ id: "Show Vehicles", en: "Show Vehicles", ar: "عرض المركبات" },
	{ id: "Track Player", en: "Track Player", ar: "مشغل المسار" },
	{ id: "Parameters", en: "Parameters", ar: "تفاصيل" },
	{ id: "protocol", en: "protocol", ar: "بروتوكول" },
	{ id: "altitude", en: "altitude", ar: "الارتفاع" },
	{ id: "course", en: "course", ar: "الاتجاه" },
	{ id: "batteryLevel", en: "Battery Level", ar: "مستوى البطارية" },
	{ id: "distance", en: "Distance", ar: "المسافة" },
	{ id: "totalDistance", en: "Total Distance", ar: "اجمالي المسافة" },
	{ id: "motion", en: "Motion", ar: "الحركة" },
	{
		id: "Geofence Details",
		en: "Geofence Details",
		ar: "تفاصيل السياج الجغرافي",
	},
	{ id: "Speed Limit", en: "Speed Limit", ar: "الحد الأقصى للسرعة" },
	{
		id: "add new geofence",
		en: "add new geofence",
		ar: "إضافة سياج جغرافي جديد",
	},
	{ id: "edit geofence", en: "edit geofence", ar: "تعديل سياج جغرافي" },
	{ id: "Geofence Status", en: "Geofence Status", ar: "حالة السياج الجغرافي" },
	{
		id: "Select Geofence Status",
		en: "Select Geofence Status",
		ar: "اختر حالة السياج الجغرافي",
	},
	{ id: "Allowed", en: "Allowed", ar: "مسموح" },
	{ id: "Not Allowed", en: "Not Allowed", ar: "غير مسموح" },
	{ id: "Set Speed Limit", en: "Set Speed Limit", ar: "حدد السرعة القصوي" },
	{
		id: "Geofence Description",
		en: "Geofence Description",
		ar: "وصف السياج الجغرافي",
	},
	{ id: "network", en: "network", ar: "الشبكة" },
	{ id: "valid", en: "valid", ar: "صالح" },
	{ id: "outdated", en: "outdated", ar: "قديم" },
	{ id: "latitude", en: "latitude", ar: "خط العرض" },
	{ id: "longitude", en: "longitude", ar: "خط الطول" },
	{ id: "device time", en: "device time", ar: "وقت الجهاز" },
	{ id: "fix time", en: "fix time", ar: "وقت الإصلاح" },
	{ id: "server time", en: "server time", ar: "وقت الخادم" },
	{ id: "sensors", en: "sensors", ar: "أجهزة الاستشعار" },
	{ id: "ignition", en: "ignition", ar: "اشتعال" },
	{ id: "output", en: "output", ar: "الناتج" },
	{ id: "input", en: "input", ar: "مدخل" },
	{ id: "battery", en: "battery", ar: "بطارية" },
	{ id: "power", en: "power", ar: "الطاقة" },
	{ id: "event", en: "event", ar: "الحدث" },
	{ id: "runtime", en: "runtime", ar: "وقت التشغيل" },
	{
		id: "location area code",
		en: "location area code",
		ar: "رمز منطقة الموقع",
	},
	{
		id: "mobile country code",
		en: "mobile country code",
		ar: "رمز البلد للجوال",
	},
	{
		id: "mobile network code",
		en: "mobile network code",
		ar: "رمز شبكة الهاتف المحمول",
	},
	{ id: "signal strength", en: "signal strength", ar: "قوة الإشارة" },
	{ id: "radio type", en: "radio type", ar: "نوع الراديو" },
	{ id: "Welcome back,", en: "Welcome back,", ar: "مرحبا!" },
	{ id: "Total Vehicles", en: "Total Vehicles", ar: "اجمالي المركبات" },
	{ id: "Total Drivers", en: "Total Drivers", ar: "اجمالي السائقين" },
	{ id: "Total Users", en: "Total Users", ar: "اجمالي المستخدمين" },
	{
		id: "Maintenance Requests",
		en: "Maintenance Requests",
		ar: "طلبات الصيانة",
	},
	{ id: "in this month", en: "in this month", ar: "خلال الشهر الحالي" },
	{ id: "Total Alerts", en: "Total Alerts", ar: "إجمالي التنبيهات" },
	{ id: "Speed Alerts", en: "Speed Alerts", ar: "تنبيهات السرعة" },
	{ id: "Idle Alerts", en: "Idle Alerts", ar: "تنبيهات الخمول" },
	{ id: "Power Cut", en: "Power Cut", ar: "التيار الكهربائي" },
	{ id: "Geofences", en: "Geofences", ar: "الأسوار الجغرافية" },
	{ id: "Other Alerts", en: "Other Alerts", ar: "تنبيهات اخري" },
	{ id: "Alert Time", en: "Alert Time", ar: "وقت التنبيه" },
	{ id: "Get Address", en: "Get Address", ar: "احصل على العنوان" },
	{ id: "Geofence Type", en: "Geofence Type", ar: "نوع السياج الجغرافي" },
	{ id: "Vehicles Status", en: "Vehicles Status", ar: "حالة المركبات" },
	{
		id: "Number of Total Vehicles",
		en: "Number of Total Vehicles",
		ar: "عدد المركبات الإجمالي",
	},
	{ id: "Running", en: "Running", ar: "نشيط" },
	{ id: "Idle", en: "Idle", ar: "خامل" },
	{ id: "Stopped", en: "Stopped", ar: "متوقف" },
	{ id: "No data", en: "No data", ar: "غير متاح" },
	{ id: "Online", en: "Online", ar: "متصل" },
	{ id: "GPS not updated", en: "GPS not updated", ar: "لم يتم التحديث" },
	{ id: "Offline", en: "Offline", ar: "غير متصل" },
	{ id: "In Maintenance", en: "In Maintenance", ar: "في الصيانة" },
	{ id: "Fleet Location", en: "Fleet Location", ar: "موقع الأسطول" },
	// ------------------------- joe --------------------------------
	{
		id: "Please Check Required Inputs",
		en: "Please Check Required Inputs",
		ar: "يرجى التحقق من المدخلات المطلوبة",
	},
	{
		id: "Email is required",
		en: "Email is required",
		ar: "برجاء إدخال البريد الإلكتروني",
	},
	{
		id: "Password is required",
		en: "Password is required",
		ar: "برجاء إدخال كلمة المرور",
	},
	{
		id: "Enter Your Email",
		en: "Enter Your Email",
		ar: "أدخل البريد الإلكتروني",
	},
	{
		id: "Enter Your Password",
		en: "Enter Your Password",
		ar: "أدخل كلمة المرور",
	},
	{
		id: "Invalid Email or Password",
		en: "Invalid Email or Password",
		ar: "البريد الإلكتروني أو كلمة المرور غير صالحة",
	},
	{
		id: "Internal Server Error",
		en: "Internal Server Error",
		ar: "خطأ في السيرفر",
	},
	{
		id: "Error can't login",
		en: "Error can't login",
		ar: "خطأ لا يمكن تسجيل الدخول",
	},
	{ id: "Car Number", en: "Car Number", ar: "رقم المركبة" },
	{ id: "Device Id", en: "Device Id", ar: "الرقم التعريفي بالجهاز " },
	{ id: "Car Activity", en: "Car Activity", ar: "حالة نشاط المركبة" },
	{ id: "Related User", en: "Related User", ar: "المستخدم المسئول " },
	{ id: "Assigned Driver", en: "Assigned Driver", ar: "السائق المختص" },
	{ id: "Vehicle Details", en: "Vehicle Details", ar: "تفاصيل المركبة" },
	{ id: "Assign Driver", en: "Assign Driver", ar: "إسناد سائق" },
	{ id: "working status", en: "working status", ar: "حالة التشغيل" },
	{ id: "GPS status", en: "GPS status", ar: "حالة نظام تحديد المواقع" },
	{ id: "Available", en: "Available", ar: "متاح" },
	{ id: "UnAvailable", en: "UnAvailable", ar: "غير متاح" },
	{ id: "Accuracy", en: "Accuracy", ar: "الدقة" },
	{ id: "N/A", en: "N/A", ar: "غير متاح" },
	{ id: "connectivity", en: "connectivity", ar: "الاتصال" },
	{ id: "Connected", en: "Connected", ar: "متصل" },
	{ id: "Disconnected", en: "Disconnected", ar: "غير متصل" },
	{ id: "controls", en: "controls", ar: "التحكم" },
	{ id: "start engine", en: "start engine", ar: "تشغيل المحرك" },
	{ id: "stop engine", en: "stop engine", ar: "إطفاء المحرك" },
	{
		id: "set speed limit",
		en: "set speed limit",
		ar: "ضبط الحد الأقصى للسرعة",
	},
	{ id: "set geofence", en: "set geofence", ar: "ضبط السياج" },
	{ id: "share location", en: "share location", ar: "مشاركة الموقع" },
	{ id: "open sessions", en: "open sessions", ar: "جلسات نشطة" },
	{
		id: "fuel drop threshold",
		en: "fuel drop threshold",
		ar: "الحد الأدني للوقود",
	},
	{
		id: "fuel increase threshold",
		en: "fuel increase threshold",
		ar: "الحد الأقصي للوقود",
	},
	{ id: "set notification", en: "set notification", ar: "ضبط الإشعارات" },
	{
		id: "Do you want to start the engine for",
		en: "Do you want to start the engine for",
		ar: "هل تريد تشغيل المحرك لـ",
	},
	{
		id: "Do you want to stop the engine for",
		en: "Do you want to stop the engine for",
		ar: "هل تريد إطفاء المحرك لـ",
	},
	{ id: "Yes", en: "Yes", ar: "نعم" },
	{
		id: "Speed limit is required",
		en: "Speed limit is required",
		ar: "يجب تحديد السرعة",
	},
	{
		id: "Speed limit must be more than 0",
		en: "Speed limit must be more than 0",
		ar: "يجب أن يكون الحد الأقصى للسرعة أكثر من 0",
	},
	{
		id: "Speed Limit has been set successfully",
		en: "Speed Limit has been set successfully",
		ar: "تم ضبط حد السرعة بنجاح",
	},
	{
		id: "Error while setting Speed Limit, please try again later",
		en: "Error while setting Speed Limit, please try again later",
		ar: "حدث خطأ أثناء ضبط حد السرعة، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Enter Speed Limit",
		en: "Enter Speed Limit",
		ar: "أدخل الحد الاقصي للسرعة",
	},
	{
		id: "At least one Geofence is required",
		en: "At least one Geofence is required",
		ar: "مطلوب سياج جغرافي واحد على الأقل",
	},
	{
		id: "New Geofence Is linked to device",
		en: "New Geofence Is linked to device",
		ar: "تم ربط السياج الجغرافي الجديد بالجهاز",
	},
	{
		id: "Error linking the Geofence to device, please try again later",
		en: "Error linking the Geofence to device, please try again later",
		ar: "حدث خطأ أثناء ربط السياج الجغرافي بالجهاز، يُرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Selected GeoFences",
		en: "Selected GeoFences",
		ar: "أسوار جغرافية مختارة",
	},
	{
		id: "There is no selected geofences",
		en: "There is no selected geofences",
		ar: "لا يوجد أسوار جغرافية محددة",
	},
	{
		id: "Select Geofences",
		en: "Select Geofences",
		ar: "تحديد السياج الجغرافي",
	},
	{
		id: "Fuel Drop Threshold must be more than 0 ",
		en: "Fuel Drop Threshold must be more than 0 ",
		ar: "يجب أن يكون الحد الأدني للوقود أكبر من 0",
	},
	{
		id: "Fuel Drop Threshold is required",
		en: "Fuel Drop Threshold is required",
		ar: "يجب تحديد الحد الأدني للوقود",
	},
	{
		id: "Fuel Drop Threshold has been set successfully",
		en: "Fuel Drop Threshold has been set successfully",
		ar: "تم ضبط الحد الأدني للوقود بنجاح",
	},
	{
		id: "Error while setting fuel drop threshold, please try again later",
		en: "Error while setting fuel drop threshold, please try again later",
		ar: "حدث خطأ أثناء ضبط الحد الأدني للوقود، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Enter Fuel Drop Threshold",
		en: "Enter Fuel Drop Threshold",
		ar: "أدخل الحد الأدني للوقود",
	},
	{
		id: "Fuel Increase Threshold must be more than 0",
		en: "Fuel Increase Threshold must be more than 0",
		ar: "يجب أن يكون الحد الأقصي للوقود أكبر من 0",
	},
	{
		id: "Fuel Increase Threshold is required",
		en: "Fuel Increase Threshold is required",
		ar: "يجب تحديدالحد الأقصي للوقود",
	},
	{
		id: "Fuel Increase Threshold has been set successfully",
		en: "Fuel Increase Threshold has been set successfully",
		ar: "تم ضبط الحد الأقصي للوقود بنجاح",
	},
	{
		id: "Error while setting fuel increase threshold, please try again later",
		en: "Error while setting fuel increase threshold, please try again later",
		ar: "حدث خطأ أثناء ضبط حد انخفاض الوقود، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Enter Fuel Increase Threshold",
		en: "Enter Fuel Increase Threshold",
		ar: "أدخل الحد الأقصي للوقود",
	},
	{
		id: "At least one notification is required",
		en: "At least one notification is required",
		ar: "مطلوب إشعار واحد على الأقل",
	},
	{
		id: "New Notification is linked to the device",
		en: "New Notification is linked to the device",
		ar: "لإشعار الجديد مرتبط بالجهاز",
	},
	{
		id: "Error linking the Notification to device, please try again later",
		en: "Error linking the Notification to device, please try again later",
		ar: "حدث خطأ أثناء ربط الإشعار بالجهاز، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Selected Notifications",
		en: "Selected Notifications",
		ar: "الإشعارات المحددة",
	},
	{
		id: "There is no selected notifications",
		en: "There is no selected notifications",
		ar: "لا يوجد إشعارات محددة",
	},
	{ id: "Select Notification", en: "Select Notification", ar: "حدد الإشعار" },
	{ id: "liter", en: "liter", ar: "لتر" },
	{ id: "km/h", en: "km/h", ar: "كم/س" },
	{ id: "kmh", en: "kmh", ar: "كم/س" },
	{ id: "mph", en: "mph", ar: "ميل/س" },
	{ id: "kn", en: "kn", ar: "عقدة" },
	{ id: "m", en: "m", ar: "متر" },
	{ id: "ft", en: "ft", ar: "قدم" },
	{ id: "km", en: "km", ar: "كم" },
	{ id: "mi", en: "mi", ar: "ميل" },
	{ id: "nmi", en: "nmi", ar: "ميل بحري" },
	{ id: "U.S. Gallon", en: "U.S. Gallon", ar: "غالون أمريكي" },
	{ id: "IMP. Gallon", en: "IMP. Gallon", ar: "غالون بريطاني" },
	{ id: "Driver", en: "Driver", ar: "السائق" },
	{ id: "Select Driver", en: "Select Driver", ar: "اختر سائق" },
	{
		id: "Error while setting Driver, please try again later",
		en: "Error while setting Driver, please try again later",
		ar: "حدث خطأ أثناء إعداد برنامج التشغيل، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "with speed limit",
		en: "with speed limit",
		ar: "مع الحد الأقصى للسرعة",
	},
	{ id: "Speed Alert", en: "Speed Alert", ar: "تنبيه السرعة" },
	{ id: "Geofence Alert", en: "Geofence Alert", ar: "تنبيه السياج" },
	{ id: "total", en: "total", ar: "المجموع" },
	{ id: "online", en: "online", ar: "متصل" },
	{ id: "offline", en: "offline", ar: "غير متصل" },
	{ id: "moving", en: "moving", ar: "متحرك" },
	{ id: "unknown", en: "unknown", ar: "مجهول" },
	{ id: "idle", en: "idle", ar: "خمول" },
	{ id: "Language", en: "Language", ar: "اللغة" },
	{ id: "sign out", en: "sign out", ar: "تسجيل الخروج" },
	// ------------------------- Omar --------------------------------
	{ id: "Name is required", en: "Name is required", ar: "الاسم مطلوب" },
	{ id: "Code is required", en: "Code is required", ar: "الكود مطلوب" },
	{
		id: "Phone number must be international",
		en: "Phone number must be international",
		ar: "يجب أن يكون رقم الهاتف دوليًا",
	},
	{
		id: "Emergency number must be international",
		en: "Emergency number must be international",
		ar: "يجب أن يكون رقم الطوارئ دوليًا",
	},
	{
		id: "Parent Is Required",
		en: "Parent Is Required",
		ar: "الحساب الاساسي مطلوب",
	},
	{
		id: "Email Is Required",
		en: "Email Is Required",
		ar: "البريد الالكتروني مطلوب",
	},
	{
		id: "Password Is Required",
		en: "Password Is Required",
		ar: "كلمة المرور مطلوبة",
	},
	{
		id: "Please select at least one date",
		en: "Please select at least one date",
		ar: "الرجاء تحديد تاريخ واحد على الأقل",
	},
	{ id: "Color is required", en: "Color is required", ar: "اللون مطلوب" },
	{
		id: "Speed limit can't be less than 1",
		en: "Speed limit can't be less than 1",
		ar: "الحد الأقصى للسرعة لا يمكن أن يكون أقل من 1",
	},
	{
		id: "Speed Limit must be a number",
		en: "Speed Limit must be a number",
		ar: "يجب أن يكون حد السرعة رقمًا",
	},
	{
		id: "Geofence status is required",
		en: "Geofence status is required",
		ar: "حالة السياج الجغرافي مطلوبة",
	},
	{
		id: "Please Fill Inputs First",
		en: "Please Fill Inputs First",
		ar: "يرجى ملء المدخلات أولاً",
	},
	{
		id: "Please select at least one date and a vehicle",
		en: "Please select at least one date and a vehicle",
		ar: "الرجاء تحديد تاريخ واحد على الأقل ومركبة واحدة",
	},
	{ id: "Type Is Required", en: "Type Is Required", ar: "النوع مطلوب" },
	{
		id: "Email must be from gmail.com, outlook.com, yahoo.com, or hotmail.com",
		en: "Email must be from gmail.com, outlook.com, yahoo.com, or hotmail.com",
		ar: "يجب أن يكون البريد الإلكتروني من gmail.com أو outlook.com أو yahoo.com أو hotmail.com",
	},
	{
		id: "Latitude must be a number",
		en: "Latitude must be a number",
		ar: "يجب أن يكون خط العرض رقمًا",
	},
	{
		id: "Latitude must be between -90 and 90",
		en: "Latitude must be between -90 and 90",
		ar: "يجب أن يكون خط العرض بين -90 و 90",
	},
	{
		id: "Longitude must be a number",
		en: "Longitude must be a number",
		ar: "يجب أن يكون خط الطول رقمًا",
	},
	{
		id: "Longitude must be between -180 and 180",
		en: "Longitude must be between -180 and 180",
		ar: "يجب أن يكون خط الطول بين -180 و 180",
	},
	{
		id: "Name must be at least 3 characters",
		en: "Name must be at least 3 characters",
		ar: "يجب أن يتكون الاسم من 3 أحرف على الأقل",
	},
	{
		id: "Name must be at most 45 characters",
		en: "Name must be at most 45 characters",
		ar: "يجب أن يتكون الاسم من 45 حرفًا على الأكثر",
	},
	{
		id: "Name cannot be only spaces",
		en: "Name cannot be only spaces",
		ar: "لا يمكن أن يتكون الاسم من مسافات فقط",
	},
	{
		id: "Name cannot have consecutive spaces",
		en: "Name cannot have consecutive spaces",
		ar: "لا يمكن أن يحتوي الاسم على مسافات متتالية",
	},
	{
		id: "Name can only contain letters and spaces",
		en: "Name can only contain letters and spaces",
		ar: "يجب أن يحتوي الاسم على أحرف ومسافات فقط",
	},
	{
		id: "Name must be a string",
		en: "Name must be a string",
		ar: "يجب أن يكون الاسم عبارة عن حروف",
	},
	{
		id: "Code accept only numbers,letters and (-) not as first",
		en: "Code accept only numbers,letters and (-) not as first",
		ar: "يقبل الكود فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Address accept only numbers,letters and (-) not as first",
		en: "Address accept only numbers,letters and (-) not as first",
		ar: "العنوان يقبل فقط الأرقام والحروف و(-) وليس الأول",
	},
	{
		id: "IdNo accept only numbers,letters and (-) not as first",
		en: "IdNo accept only numbers,letters and (-) not as first",
		ar: "فقط الأرقام والحروف و(-) ليس كأول",
	},
	{
		id: "License Expiration Date is required",
		en: "License Expiration Date is required",
		ar: "تاريخ انتهاء صلاحية الترخيص مطلوب",
	},
	{
		id: "Contract Expiration Date Is Required",
		en: "Contract Expiration Date Is Required",
		ar: "تاريخ انتهاء العقد مطلوب",
	},
	// ------------------------ joe --------------------------------
	{ id: "Name Is Required", en: "Name Is Required", ar: "الاسم مطلوب" },
	{
		id: "No special characters or decimal points",
		en: "No special characters or decimal points",
		ar: "لا توجد أحرف خاصة أو نقاط عشرية",
	},
	{
		id: "IMEI is required",
		en: "IMEI is required",
		ar: "الرقم التعريفي مطلوب",
	},
	{
		id: "Plate Number accepts only numbers, letters, hyphens (not as first character)",
		en: "Plate Number accepts only numbers, letters, hyphens (not as first character)",
		ar: "يقبل الكود فقط الأرقام والحروف والواصلات (وليس كحرف أول)",
	},
	{
		id: "Plate Number Is Required",
		en: "Plate Number Is Required",
		ar: "رقم اللوحة مطلوب",
	},
	{
		id: "Code accept only numbers,letters and (-) not as first",
		en: "Code accept only numbers,letters and (-) not as first",
		ar: "يقبل الكود فقط الأرقام والحروف و(-) وليس كأول",
	},
	{ id: "Code Is Required", en: "Code Is Required", ar: "الكود مطلوب" },
	{
		id: "Registration Number accept only numbers,letters and (-) not as first",
		en: "Registration Number accept only numbers,letters and (-) not as first",
		ar: "يقبل الرقم التسجيلي فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Model accept only numbers,letters and (-) not as first",
		en: "Model accept only numbers,letters and (-) not as first",
		ar: "يقبل الموديل فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Brand accept only numbers,letters and (-) not as first",
		en: "Brand accept only numbers,letters and (-) not as first",
		ar: "تقبل العلامة التجارية فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Color must be a valid name or hex code .",
		en: "Color must be a valid name or hex code .",
		ar: "يجب أن يكون اللون اسمًا صالحًا أو رمزًا سداسيًا عشريًا.",
	},
	{
		id: "Vehicle Type Is Required",
		en: "Vehicle Type Is Required",
		ar: "نوع المركبة مطلوب",
	},
	{
		id: "License Expiration Is Required",
		en: "License Expiration Is Required",
		ar: "انتهاء صلاحية الترخيص مطلوب",
	},
	{
		id: "Sim Number must be a number",
		en: "Sim Number must be a number",
		ar: "يجب أن يكون رقم الشريحة رقمًا",
	},
	{
		id: "Sim Number Is Required",
		en: "Sim Number Is Required",
		ar: "رقم الشريحة مطلوب",
	},
	{
		id: "Sim must be an international number",
		en: "Sim must be an international number",
		ar: "يجب أن يكون رقم الشريحة دوليًا",
	},
	{
		id: "Sim Number Serial must be a number",
		en: "Sim Number Serial must be a number",
		ar: "يجب أن يكون الرقم التسلسلي للشريحة رقمًا",
	},
	{
		id: "Sim Number Serial must be a whole number",
		en: "Sim Number Serial must be a whole number",
		ar: "يجب أن يكون الرقم التسلسلي للشريحة عددًا صحيحًا",
	},
	{
		id: "Sim Number Serial must be a positive number",
		en: "Sim Number Serial must be a positive number",
		ar: "يجب أن يكون الرقم التسلسلي للشريحة رقمًا موجبًا",
	},
	{
		id: "Sim Number Serial is required",
		en: "Sim Number Serial is required",
		ar: "الرقم التسلسلي للشريحة مطلوب",
	},
	{
		id: "Vehicle Expiration Is Required",
		en: "Vehicle Expiration Is Required",
		ar: "انتهاء صلاحية السيارة مطلوب",
	},
	{
		id: "Fuel Cost can't be less than 1",
		en: "Fuel Cost can't be less than 1",
		ar: "لا يمكن أن تكون تكلفة الوقود أقل من 1",
	},
	{
		id: "Fuel Cost must be a number",
		en: "Fuel Cost must be a number",
		ar: "يجب أن تكون تكلفة الوقود رقمًا",
	},
	{
		id: "Fuel Consumption can't be less than 1",
		en: "Fuel Consumption can't be less than 1",
		ar: "لا يمكن أن يكون استهلاك الوقود أقل من 1",
	},
	{
		id: "Fuel Consumption must be a number",
		en: "Fuel Consumption must be a number",
		ar: "يجب أن يكون استهلاك الوقود رقمًا",
	},
	{
		id: "Fuel Capacity can't be less than 1",
		en: "Fuel Capacity can't be less than 1",
		ar: "لا يمكن أن تكون سعة الوقود أقل من 1",
	},
	{
		id: "Fuel Capacity must be a number",
		en: "Fuel Capacity must be a number",
		ar: "يجب أن تكون سعة الوقود رقمًا",
	},
	{
		id: "Fuel Capacity Is Required",
		en: "Fuel Capacity Is Required",
		ar: "سعة الوقود مطلوبة",
	},
	{
		id: "Tank Height can't be less than 1",
		en: "Tank Height can't be less than 1",
		ar: "لا يمكن أن يكون ارتفاع الخزان أقل من 1",
	},
	{
		id: "Tank Height must be a number",
		en: "Tank Height must be a number",
		ar: "يجب أن يكون ارتفاع الخزان رقمًا",
	},
	{
		id: "Tank Height Is Required",
		en: "Tank Height Is Required",
		ar: "ارتفاع الخزان مطلوب",
	},
	{
		id: "Tank Width can't be less than 1",
		en: "Tank Width can't be less than 1",
		ar: "لا يمكن أن يكون عرض الخزان أقل من 1",
	},
	{
		id: "Tank Width must be a number",
		en: "Tank Width must be a number",
		ar: "يجب أن يكون عرض الخزان رقمًا",
	},
	{
		id: "Tank Width Is Required",
		en: "Tank Width Is Required",
		ar: "عرض الخزان مطلوب",
	},
	{
		id: "Tank Length can't be less than 1",
		en: "Tank Length can't be less than 1",
		ar: "لا يمكن أن يكون طول الخزان أقل من 1",
	},
	{
		id: "Tank Length must be a number",
		en: "Tank Length must be a number",
		ar: "يجب أن يكون طول الخزان رقمًا",
	},
	{
		id: "Tank Length Is Required",
		en: "Tank Length Is Required",
		ar: "طول الخزان مطلوب",
	},
	{
		id: "Idle Time can't be less than 1",
		en: "Idle Time can't be less than 1",
		ar: "لا يمكن أن يكون وقت الخمول أقل من 1",
	},
	{
		id: "Idle Time must be a number",
		en: "Idle Time must be a number",
		ar: "يجب أن يكون وقت الخمول رقمًا",
	},
	{
		id: "Idle Time Is Required",
		en: "Idle Time Is Required",
		ar: "وقت الخمول مطلوب",
	},
	{
		id: "Year must be a number",
		en: "Year must be a number",
		ar: "يجب أن يكون العام رقمًا",
	},
	{
		id: "Year cannot be less than 1970",
		en: "Year cannot be less than 1970",
		ar: "لا يمكن أن تكون السنة أقل من 1970",
	},
	{
		id: "Odometer can't be less than 1",
		en: "Odometer can't be less than 1",
		ar: "لا يمكن أن يكون عداد المسافات أقل من 1",
	},
	{
		id: "Odometer must be a number",
		en: "Odometer must be a number",
		ar: "يجب أن يكون عداد المسافات رقمًا",
	},
	/*------------------------YOUSSSSSEF---------------------*/
	{
		id: "Vehicle Edited Successfully",
		en: "Vehicle Edited Successfully",
		ar: "تم تعديل المركبة بنجاح",
	},
	{
		id: "New Vehicle Is Added",
		en: "New Vehicle Is Added",
		ar: "تم إضافة مركبة جديدة",
	},
	{
		id: "Driver Edited Successfully",
		en: "Driver Edited Successfully",
		ar: "تم تعديل بيانات السائق بنجاح",
	},
	{
		id: "New Driver Is Added",
		en: "New Driver Is Added",
		ar: "تم إضافة سائق جديد",
	},
	{
		id: "User Edited Successfully",
		en: "User Edited Successfully",
		ar: "تم تعديل بيانات المستخدم بنجاح",
	},
	{
		id: "Geofence Is Edited Successfully",
		en: "Geofence Is Edited Successfully",
		ar: "تم تعديل بيانات السياج بنجاح",
	},
	{
		id: "New User Is Added",
		en: "New User Is Added",
		ar: "تم إضافة مستخدم جديد",
	},
	{
		id: "Notification Edited Successfully",
		en: "Notification Edited Successfully",
		ar: "تم تعديل الإشعار بنجاح",
	},
	{
		id: "New Notification Is Added",
		en: "New Notification Is Added",
		ar: "تم إضافة إشعار جديد",
	},
	{
		id: "User Profile Edited Successfully",
		en: "User Profile Edited Successfully",
		ar: "تم تعديل بيانات ملف المستخدم بنجاح",
	},
	{
		id: "Can't Edit User Profile Data",
		en: "Can't Edit User Profile Data",
		ar: "لا يمكن تعديل بيانات ملف المستخدم",
	},
	{
		id: "Notification Edited Successfully",
		en: "Notification Edited Successfully",
		ar: "تم تعديل الإشعار بنجاح",
	},
	{
		id: "New Geofence Is Added",
		en: "New Geofence Is Added",
		ar: "تم إضافة سياج جديد",
	},
	{
		id: "Vehicle Deleted Successfully",
		en: "Vehicle Deleted Successfully",
		ar: "تم حذف المركبة بنجاح",
	},
	{
		id: "Driver Deleted Successfully",
		en: "Driver Deleted Successfully",
		ar: "تم حذف السائق بنجاح",
	},
	{
		id: "User Deleted Successfully",
		en: "User Deleted Successfully",
		ar: "تم حذف المستخدم بنجاح",
	},
	{
		id: "Geofence Deleted Successfully",
		en: "Geofence Deleted Successfully",
		ar: "تم حذف السياج بنجاح",
	},
	{
		id: "Notification Deleted Successfully",
		en: "Notification Deleted Successfully",
		ar: "تم حذف الإشعار بنجاح",
	},
	/*------------------------YOUSSSSSEF---------------------*/
	{
		id: "license start date",
		en: "license start date",
		ar: "تاريخ بدأ صلاحية الترخيص",
	},
	{
		id: "license expiry date",
		en: "license expiry date",
		ar: "تاريخ انتهاء صلاحية الترخيص",
	},
	{
		id: "license Expire Reminder",
		en: "license Expire Reminder",
		ar: "تذكير بانتهاء صلاحية الترخيص",
	},
	{ id: "truck driver", en: "truck driver", ar: "سائق شاحنة" },
	{ id: "Driver Details", en: "Driver Details", ar: "تفاصيل السائق" },
	{ id: "Driver Name", en: "Driver Name", ar: "اسم السائق" },
	{ id: "Driver Code", en: "Driver Code", ar: "رمز السائق" },
	{ id: "users & roles", en: "users & roles", ar: "المستخدمين و الصلاحيات" },
	{ id: "users", en: "users", ar: "المستخدمين" },
	{ id: "sub-users", en: "sub-users", ar: "المستخدمون الفرعيون" },
	{ id: "view", en: "View", ar: "اعرض" },
	{ id: "Edit User", en: "Edit User", ar: "تعديل البيانات المستخدم" },
	{ id: "User related to", en: "User related to", ar: "المستخدم الاساسي" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Add new user", en: "Add New User", ar: "إضافة مستخدم جديد" },
	{ id: "user info", en: "User Info", ar: "بيانات المستخدم" },
	{ id: "user preferences", en: "User Preferences", ar: "تفضيلات المستخدم" },
	{ id: "user location", en: "User Location", ar: "موقع المستخدم" },
	{
		id: "Choose Location from map",
		en: "Choose Location from map",
		ar: "إختيار الموقع من الخريطة",
	},
	{ id: "user permissions", en: "User Permissions", ar: "أذونات المستخدم" },
	{ id: "role", en: "Role", ar: "الدور" },
	{ id: "Device Read Only", en: "Device Read Only", ar: "صلاحية الاجهزة فقط" },
	{ id: "Read Only", en: "Read Only", ar: "صلاحية العرض فقط" },
	{
		id: "Expiration Date",
		en: "Expiration Date",
		ar: "تاريخ انتهاء صلاحية المستخدم",
	},
	{ id: "Device Limit", en: "Device Limit", ar: "حد الجهاز" },
	{ id: "User Limit", en: "User Limit", ar: "حد المستخدم" },
	{ id: "User Details", en: "User Details", ar: "تفاصيل المستخدم" },
	{ id: "Geofence Name", en: "Geofence Name", ar: "اسم السياج الجغرافي" },
	// ---------------------------------Omar--------------------------------
	{ id: "History Playback", en: "History Playback", ar: "عرض السجل" },
	{ id: "Update", en: "Update", ar: "تحديث" },
	{ id: "History", en: "History", ar: "السجل" },
	{ id: "Events", en: "Events", ar: "الاحداث" },
	{ id: "Play all history", en: "Play all history", ar: "تشغيل كل السجل" },
	{
		id: "Overview of all history",
		en: "Overview of all history",
		ar: "نظرة عامة على كل سجل",
	},
	{ id: "Export selected", en: "Export selected", ar: "استخراج المحدد" },
	{ id: "More actions", en: "More actions", ar: "اجراءات اخري" },
	{ id: "Parking Periods", en: "Parking Periods", ar: "فترات وقوف" },
	{ id: "Idle Periods", en: "Idle Periods", ar: "فترات الخمول" },
	{ id: "Center Tracker", en: "Center Tracker", ar: "مركز التتبع" },
	{
		id: "Get current address",
		en: "Get current address",
		ar: "احصل على العنوان الحالي",
	},
	{ id: "Reset", en: "Reset", ar: "اعادة" },
	{ id: "Show Vehicles", en: "Show Vehicles", ar: "عرض المركبات" },
	{ id: "Track Player", en: "Track Player", ar: "مشغل المسار" },
	{ id: "Parameters", en: "Parameters", ar: "تفاصيل" },
	{ id: "protocol", en: "protocol", ar: "بروتوكول" },
	{ id: "altitude", en: "altitude", ar: "الارتفاع" },
	{ id: "course", en: "course", ar: "الاتجاه" },
	{ id: "batteryLevel", en: "Battery Level", ar: "مستوى البطارية" },
	{ id: "distance", en: "Distance", ar: "المسافة" },
	{ id: "totalDistance", en: "Total Distance", ar: "اجمالي المسافة" },
	{ id: "motion", en: "Motion", ar: "الحركة" },
	{
		id: "Geofence Details",
		en: "Geofence Details",
		ar: "تفاصيل السياج الجغرافي",
	},
	{ id: "Speed Limit", en: "Speed Limit", ar: "الحد الأقصى للسرعة" },
	{
		id: "add new geofence",
		en: "add new geofence",
		ar: "إضافة سياج جغرافي جديد",
	},
	{ id: "edit geofence", en: "edit geofence", ar: "تعديل سياج جغرافي" },
	{ id: "Geofence Status", en: "Geofence Status", ar: "حالة السياج الجغرافي" },
	{
		id: "Select Geofence Status",
		en: "Select Geofence Status",
		ar: "اختر حالة السياج الجغرافي",
	},
	{ id: "Allowed", en: "Allowed", ar: "مسموح" },
	{ id: "Not Allowed", en: "Not Allowed", ar: "غير مسموح" },
	{ id: "Set Speed Limit", en: "Set Speed Limit", ar: "حدد السرعة القصوي" },
	{
		id: "Geofence Description",
		en: "Geofence Description",
		ar: "وصف السياج الجغرافي",
	},
	{ id: "network", en: "network", ar: "الشبكة" },
	{ id: "valid", en: "valid", ar: "صالح" },
	{ id: "outdated", en: "outdated", ar: "قديم" },
	{ id: "latitude", en: "latitude", ar: "خط العرض" },
	{ id: "longitude", en: "longitude", ar: "خط الطول" },
	{ id: "device time", en: "device time", ar: "وقت الجهاز" },
	{ id: "fix time", en: "fix time", ar: "وقت الإصلاح" },
	{ id: "server time", en: "server time", ar: "وقت الخادم" },
	{ id: "sensors", en: "sensors", ar: "أجهزة الاستشعار" },
	{ id: "ignition", en: "ignition", ar: "اشتعال" },
	{ id: "output", en: "output", ar: "الناتج" },
	{ id: "input", en: "input", ar: "مدخل" },
	{ id: "battery", en: "battery", ar: "بطارية" },
	{ id: "power", en: "power", ar: "الطاقة" },
	{ id: "event", en: "event", ar: "الحدث" },
	{ id: "runtime", en: "runtime", ar: "وقت التشغيل" },
	{
		id: "location area code",
		en: "location area code",
		ar: "رمز منطقة الموقع",
	},
	{
		id: "mobile country code",
		en: "mobile country code",
		ar: "رمز البلد للجوال",
	},
	{
		id: "mobile network code",
		en: "mobile network code",
		ar: "رمز شبكة الهاتف المحمول",
	},
	{ id: "signal strength", en: "signal strength", ar: "قوة الإشارة" },
	{ id: "radio type", en: "radio type", ar: "نوع الراديو" },
	{ id: "Welcome back,", en: "Welcome back,", ar: "مرحبا!" },
	{ id: "Total Vehicles", en: "Total Vehicles", ar: "اجمالي المركبات" },
	{ id: "Total Drivers", en: "Total Drivers", ar: "اجمالي السائقين" },
	{ id: "Total Users", en: "Total Users", ar: "اجمالي المستخدمين" },
	{
		id: "Maintenance Requests",
		en: "Maintenance Requests",
		ar: "طلبات الصيانة",
	},
	{ id: "in this month", en: "in this month", ar: "خلال الشهر الحالي" },
	{ id: "Total Alerts", en: "Total Alerts", ar: "إجمالي التنبيهات" },
	{ id: "Speed Alerts", en: "Speed Alerts", ar: "تنبيهات السرعة" },
	{ id: "Idle Alerts", en: "Idle Alerts", ar: "تنبيهات الخمول" },
	{ id: "Power Cut", en: "Power Cut", ar: "التيار الكهربائي" },
	{ id: "Geofences", en: "Geofences", ar: "الأسوار الجغرافية" },
	{ id: "Other Alerts", en: "Other Alerts", ar: "تنبيهات اخري" },
	{ id: "Alert Time", en: "Alert Time", ar: "وقت التنبيه" },
	{ id: "Get Address", en: "Get Address", ar: "احصل على العنوان" },
	{ id: "Geofence Type", en: "Geofence Type", ar: "نوع السياج الجغرافي" },
	{ id: "Vehicles Status", en: "Vehicles Status", ar: "حالة المركبات" },
	{
		id: "Number of Total Vehicles",
		en: "Number of Total Vehicles",
		ar: "عدد المركبات الإجمالي",
	},
	{ id: "Running", en: "Running", ar: "نشيط" },
	{ id: "idle", en: "idle", ar: "خامل" },
	{ id: "Stopped", en: "Stopped", ar: "متوقف" },
	{ id: "No data", en: "No data", ar: "غير متاح" },
	{ id: "Online", en: "Online", ar: "متصل" },
	{ id: "GPS not updated", en: "GPS not updated", ar: "لم يتم التحديث" },
	{ id: "Offline", en: "Offline", ar: "غير متصل" },
	{ id: "In Maintenance", en: "In Maintenance", ar: "في الصيانة" },
	{ id: "Fleet Location", en: "Fleet Location", ar: "موقع الأسطول" },
	// ------------------------- joe --------------------------------
	{
		id: "Please Check Required Inputs",
		en: "Please Check Required Inputs",
		ar: "يرجى التحقق من المدخلات المطلوبة",
	},
	{
		id: "Email is required",
		en: "Email is required",
		ar: "برجاء إدخال البريد الإلكتروني",
	},
	{
		id: "Password is required",
		en: "Password is required",
		ar: "برجاء إدخال كلمة المرور",
	},
	{
		id: "Enter Your Email",
		en: "Enter Your Email",
		ar: "أدخل البريد الإلكتروني",
	},
	{
		id: "Enter Your Password",
		en: "Enter Your Password",
		ar: "أدخل كلمة المرور",
	},
	{
		id: "Invalid Email or Password",
		en: "Invalid Email or Password",
		ar: "البريد الإلكتروني أو كلمة المرور غير صالحة",
	},
	{
		id: "Internal Server Error",
		en: "Internal Server Error",
		ar: "خطأ في السيرفر",
	},
	{
		id: "Error can't login",
		en: "Error can't login",
		ar: "خطأ لا يمكن تسجيل الدخول",
	},
	{ id: "Car Number", en: "Car Number", ar: "رقم المركبة" },
	{ id: "Device Id", en: "Device Id", ar: "الرقم التعريفي بالجهاز " },
	{ id: "Car Activity", en: "Car Activity", ar: "حالة نشاط المركبة" },
	{ id: "Related User", en: "Related User", ar: "المستخدم المسئول " },
	{ id: "Assigned Driver", en: "Assigned Driver", ar: "السائق المختص" },
	{ id: "Vehicle Details", en: "Vehicle Details", ar: "تفاصيل المركبة" },
	{ id: "Assign Driver", en: "Assign Driver", ar: "إسناد سائق" },
	{ id: "working status", en: "working status", ar: "حالة التشغيل" },
	{ id: "GPS status", en: "GPS status", ar: "حالة نظام تحديد المواقع" },
	{ id: "Available", en: "Available", ar: "متاح" },
	{ id: "UnAvailable", en: "UnAvailable", ar: "غير متاح" },
	{ id: "Accuracy", en: "Accuracy", ar: "الدقة" },
	{ id: "N/A", en: "N/A", ar: "غير متاح" },
	{ id: "connectivity", en: "connectivity", ar: "الاتصال" },
	{ id: "Connected", en: "Connected", ar: "متصل" },
	{ id: "Disconnected", en: "Disconnected", ar: "غير متصل" },
	{ id: "controls", en: "controls", ar: "التحكم" },
	{ id: "start engine", en: "start engine", ar: "تشغيل المحرك" },
	{ id: "stop engine", en: "stop engine", ar: "إطفاء المحرك" },
	{
		id: "set speed limit",
		en: "set speed limit",
		ar: "ضبط الحد الأقصى للسرعة",
	},
	{ id: "set geofence", en: "set geofence", ar: "ضبط السياج" },
	{ id: "share location", en: "share location", ar: "مشاركة الموقع" },
	{ id: "open sessions", en: "open sessions", ar: "open sessions" },
	{
		id: "fuel drop threshold",
		en: "fuel drop threshold",
		ar: "الحد الأدني للوقود",
	},
	{
		id: "fuel increase threshold",
		en: "fuel increase threshold",
		ar: "الحد الأقصي للوقود",
	},
	{ id: "set notification", en: "set notification", ar: "ضبط الإشعارات" },
	{
		id: "Do you want to start the engine for ",
		en: "Do you want to start the engine for ",
		ar: "هل تريد تشغيل المحرك لـ",
	},
	{
		id: "Do you want to stop the engine for ",
		en: "Do you want to stop the engine for ",
		ar: "هل تريد إطفاء المحرك لـ",
	},
	{ id: "Yes", en: "Yes", ar: "نعم" },
	{
		id: "Speed limit is required",
		en: "Speed limit is required",
		ar: "يجب تحديد السرعة",
	},
	{
		id: "Speed limit must be more than 0",
		en: "Speed limit must be more than 0",
		ar: "يجب أن يكون الحد الأقصى للسرعة أكثر من 0",
	},
	{
		id: "Speed Limit has been set successfully",
		en: "Speed Limit has been set successfully",
		ar: "تم ضبط حد السرعة بنجاح",
	},
	{
		id: "Error while setting Speed Limit, please try again later",
		en: "Error while setting Speed Limit, please try again later",
		ar: "حدث خطأ أثناء ضبط حد السرعة، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Enter Speed Limit",
		en: "Enter Speed Limit",
		ar: "أدخل الحد الاقصي للسرعة",
	},
	{
		id: "At least one Geofence is required",
		en: "At least one Geofence is required",
		ar: "مطلوب سياج جغرافي واحد على الأقل",
	},
	{
		id: "New Geofence Is linked to device",
		en: "New Geofence Is linked to device",
		ar: "تم ربط السياج الجغرافي الجديد بالجهاز",
	},
	{
		id: "Error linking the Geofence to device, please try again later",
		en: "Error linking the Geofence to device, please try again later",
		ar: "حدث خطأ أثناء ربط السياج الجغرافي بالجهاز، يُرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Selected GeoFences",
		en: "Selected GeoFences",
		ar: "أسوار جغرافية مختارة",
	},
	{
		id: "There is no selected geofences",
		en: "There is no selected geofences",
		ar: "لا يوجد أسوار جغرافية محددة",
	},
	{
		id: "Select Geofences",
		en: "Select Geofences",
		ar: "تحديد السياج الجغرافي",
	},
	{
		id: "Fuel Drop Threshold must be more than 0 ",
		en: "Fuel Drop Threshold must be more than 0 ",
		ar: "يجب أن تكون الحد الأدني للوقود أكبر من 0",
	},
	{
		id: "Fuel Drop Threshold is required",
		en: "Fuel Drop Threshold is required",
		ar: "يجب تحديد الحد الأدني للوقود",
	},
	{
		id: "Fuel Drop Threshold has been set successfully",
		en: "Fuel Drop Threshold has been set successfully",
		ar: "تم ضبط الحد الأدني للوقود بنجاح",
	},
	{
		id: "Error while setting fuel drop threshold, please try again later",
		en: "Error while setting fuel drop threshold, please try again later",
		ar: "حدث خطأ أثناء ضبط الحد الأدني للوقود، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Enter Fuel Drop Threshold",
		en: "Enter Fuel Drop Threshold",
		ar: "أدخل الحد الأدني للوقود",
	},
	{
		id: "Fuel Increase Threshold must be more than 0",
		en: "Fuel Increase Threshold must be more than 0",
		ar: "يجب أن يكون الحد الأقصي للوقود أكبر من 0",
	},
	{
		id: "Fuel Increase Threshold is required",
		en: "Fuel Increase Threshold is required",
		ar: "يجب تحديدالحد الأقصي للوقود",
	},
	{
		id: "Fuel Increase Threshold has been set successfully",
		en: "Fuel Increase Threshold has been set successfully",
		ar: "تم ضبط الحد الأقصي للوقود بنجاح",
	},
	{
		id: "Error while setting fuel increase threshold, please try again later",
		en: "Error while setting fuel increase threshold, please try again later",
		ar: "حدث خطأ أثناء ضبط حد انخفاض الوقود، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Enter Fuel Increase Threshold",
		en: "Enter Fuel Increase Threshold",
		ar: "أدخل الحد الأقصي للوقود",
	},
	{
		id: "At least one notification is required",
		en: "At least one notification is required",
		ar: "مطلوب إشعار واحد على الأقل",
	},
	{
		id: "New Notification is linked to the device",
		en: "New Notification is linked to the device",
		ar: "لإشعار الجديد مرتبط بالجهاز",
	},
	{
		id: "Error linking the Notification to device, please try again later",
		en: "Error linking the Notification to device, please try again later",
		ar: "حدث خطأ أثناء ربط الإشعار بالجهاز، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "Selected Notifications",
		en: "Selected Notifications",
		ar: "الإشعارات المحددة",
	},
	{
		id: "There is no selected notifications",
		en: "There is no selected notifications",
		ar: "لا يوجد إشعارات محددة",
	},
	{ id: "Select Notification", en: "Select Notification", ar: "حدد الإشعار" },
	{ id: "liter", en: "liter", ar: "لتر" },
	{ id: "km/h", en: "km/h", ar: "كم/س" },
	{ id: "mph", en: "mph", ar: "ميل/س" },
	{ id: "kn", en: "kn", ar: "عقدة" },
	{ id: "m", en: "m", ar: "متر" },
	{ id: "ft", en: "ft", ar: "قدم" },
	{ id: "km", en: "km", ar: "كم" },
	{ id: "mi", en: "mi", ar: "ميل" },
	{ id: "nmi", en: "nmi", ar: "ميل بحري" },
	{ id: "usGal", en: "usGal", ar: "غالون أمريكي" },
	{ id: "impGal", en: "impGal", ar: "غالون بريطاني" },
	{ id: "U.S. Gallon", en: "U.S. Gallon", ar: "غالون أمريكي" },
	{ id: "IMP. Gallon", en: "IMP. Gallon", ar: "غالون بريطاني" },
	{ id: "Driver", en: "Driver", ar: "السائق" },
	{ id: "Select Driver", en: "Select Driver", ar: "اختر سائق" },
	{
		id: "Error while setting Driver, please try again later",
		en: "Error while setting Driver, please try again later",
		ar: "حدث خطأ أثناء إعداد برنامج التشغيل، يرجى المحاولة مرة أخرى لاحقًا",
	},
	{
		id: "with speed limit",
		en: "with speed limit",
		ar: "مع الحد الأقصى للسرعة",
	},
	{ id: "Speed Alert", en: "Speed Alert", ar: "تنبيه السرعة" },
	{ id: "Geofence Alert", en: "Geofence Alert", ar: "تنبيه السياج" },
	{ id: "total", en: "total", ar: "المجموع" },
	{ id: "online", en: "online", ar: "متصل" },
	{ id: "offline", en: "Offline", ar: "غير متصل" },
	{ id: "moving", en: "moving", ar: "متحرك" },
	{ id: "unknown", en: "unknown", ar: "مجهول" },
	{ id: "idle", en: "idle", ar: "خمول" },
	{ id: "Language", en: "Language", ar: "اللغة" },
	{ id: "sign out", en: "sign out", ar: "تسجيل الخروج" },
	// ------------------------- Omar --------------------------------
	{ id: "Name is required", en: "Name is required", ar: "الاسم مطلوب" },
	{ id: "Code is required", en: "Code is required", ar: "الكود مطلوب" },
	{
		id: "Phone number must be international",
		en: "Phone number must be international",
		ar: "يجب أن يكون رقم الهاتف دوليًا",
	},
	{
		id: "Emergency number must be international",
		en: "Emergency number must be international",
		ar: "يجب أن يكون رقم الطوارئ دوليًا",
	},
	{
		id: "Parent Is Required",
		en: "Parent Is Required",
		ar: "الحساب الاساسي مطلوب",
	},
	{
		id: "Email Is Required",
		en: "Email Is Required",
		ar: "البريد الالكتروني مطلوب",
	},
	{
		id: "Password Is Required",
		en: "Password Is Required",
		ar: "كلمة المرور مطلوبة",
	},
	{
		id: "Please select at least one date",
		en: "Please select at least one date",
		ar: "الرجاء تحديد تاريخ واحد على الأقل",
	},
	{ id: "Color is required", en: "Color is required", ar: "اللون مطلوب" },
	{
		id: "Speed limit can't be less than 1",
		en: "Speed limit can't be less than 1",
		ar: "الحد الأقصى للسرعة لا يمكن أن يكون أقل من 1",
	},
	{
		id: "Speed Limit must be a number",
		en: "Speed Limit must be a number",
		ar: "يجب أن يكون حد السرعة رقمًا",
	},
	{
		id: "Geofence status is required",
		en: "Geofence status is required",
		ar: "حالة السياج الجغرافي مطلوبة",
	},
	{
		id: "Please Fill Inputs First",
		en: "Please Fill Inputs First",
		ar: "يرجى ملء المدخلات أولاً",
	},
	{
		id: "Please select at least one date and a vehicle",
		en: "Please select at least one date and a vehicle",
		ar: "الرجاء تحديد تاريخ واحد على الأقل ومركبة واحدة",
	},
	{ id: "Type Is Required", en: "Type Is Required", ar: "النوع مطلوب" },
	{
		id: "Email must be from gmail.com, outlook.com, yahoo.com, or hotmail.com",
		en: "Email must be from gmail.com, outlook.com, yahoo.com, or hotmail.com",
		ar: "يجب أن يكون البريد الإلكتروني من gmail.com أو outlook.com أو yahoo.com أو hotmail.com",
	},
	{
		id: "Latitude must be a number",
		en: "Latitude must be a number",
		ar: "يجب أن يكون خط العرض رقمًا",
	},
	{
		id: "Latitude must be between -90 and 90",
		en: "Latitude must be between -90 and 90",
		ar: "يجب أن يكون خط العرض بين -90 و 90",
	},
	{
		id: "Longitude must be a number",
		en: "Longitude must be a number",
		ar: "يجب أن يكون خط الطول رقمًا",
	},
	{
		id: "Longitude must be between -180 and 180",
		en: "Longitude must be between -180 and 180",
		ar: "يجب أن يكون خط الطول بين -180 و 180",
	},
	{
		id: "Name must be at least 3 characters",
		en: "Name must be at least 3 characters",
		ar: "يجب أن يتكون الاسم من 3 أحرف على الأقل",
	},
	{
		id: "Name must be at most 45 characters",
		en: "Name must be at most 45 characters",
		ar: "يجب أن يتكون الاسم من 45 حرفًا على الأكثر",
	},
	{
		id: "Name cannot be only spaces",
		en: "Name cannot be only spaces",
		ar: "لا يمكن أن يتكون الاسم من مسافات فقط",
	},
	{
		id: "Name cannot have consecutive spaces",
		en: "Name cannot have consecutive spaces",
		ar: "لا يمكن أن يحتوي الاسم على مسافات متتالية",
	},
	{
		id: "Name can only contain letters and spaces",
		en: "Name can only contain letters and spaces",
		ar: "يجب أن يحتوي الاسم على أحرف ومسافات فقط",
	},
	{
		id: "Name must be a string",
		en: "Name must be a string",
		ar: "يجب أن يكون الاسم عبارة عن حروف",
	},
	{
		id: "Code accept only numbers,letters and (-) not as first",
		en: "Code accept only numbers,letters and (-) not as first",
		ar: "يقبل الكود فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Address accept only numbers,letters and (-) not as first",
		en: "Address accept only numbers,letters and (-) not as first",
		ar: "العنوان يقبل فقط الأرقام والحروف و(-) وليس الأول",
	},
	{
		id: "IdNo accept only numbers,letters and (-) not as first",
		en: "IdNo accept only numbers,letters and (-) not as first",
		ar: "فقط الأرقام والحروف و(-) ليس كأول",
	},
	{
		id: "License Expiration Date is required",
		en: "License Expiration Date is required",
		ar: "تاريخ انتهاء صلاحية الترخيص مطلوب",
	},
	{
		id: "Contract Expiration Date Is Required",
		en: "Contract Expiration Date Is Required",
		ar: "تاريخ انتهاء العقد مطلوب",
	},
	// ------------------------ joe --------------------------------
	{ id: "Name Is Required", en: "Name Is Required", ar: "الاسم مطلوب" },
	{
		id: "No special characters or decimal points",
		en: "No special characters or decimal points",
		ar: "لا توجد أحرف خاصة أو نقاط عشرية",
	},
	{
		id: "IMEI is required",
		en: "IMEI is required",
		ar: "الرقم التعريفي مطلوب",
	},
	{
		id: "Plate Number accepts only numbers, letters, hyphens (not as first character)",
		en: "Plate Number accepts only numbers, letters, hyphens (not as first character)",
		ar: "يقبل الكود فقط الأرقام والحروف والواصلات (وليس كحرف أول)",
	},
	{
		id: "Plate Number Is Required",
		en: "Plate Number Is Required",
		ar: "رقم اللوحة مطلوب",
	},
	{
		id: "Code accept only numbers,letters and (-) not as first",
		en: "Code accept only numbers,letters and (-) not as first",
		ar: "يقبل الكود فقط الأرقام والحروف و(-) وليس كأول",
	},
	{ id: "Code Is Required", en: "Code Is Required", ar: "الكود مطلوب" },
	{
		id: "Registration Number accept only numbers,letters and (-) not as first",
		en: "Registration Number accept only numbers,letters and (-) not as first",
		ar: "يقبل الرقم التسجيلي فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Model accept only numbers,letters and (-) not as first",
		en: "Model accept only numbers,letters and (-) not as first",
		ar: "يقبل الموديل فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Brand accept only numbers,letters and (-) not as first",
		en: "Brand accept only numbers,letters and (-) not as first",
		ar: "تقبل العلامة التجارية فقط الأرقام والحروف و(-) وليس كأول",
	},
	{
		id: "Color must be a valid name or hex code .",
		en: "Color must be a valid name or hex code .",
		ar: "يجب أن يكون اللون اسمًا صالحًا أو رمزًا سداسيًا عشريًا.",
	},
	{
		id: "Vehicle Type Is Required",
		en: "Vehicle Type Is Required",
		ar: "نوع المركبة مطلوب",
	},
	{
		id: "License Expiration Is Required",
		en: "License Expiration Is Required",
		ar: "انتهاء صلاحية الترخيص مطلوب",
	},
	{
		id: "Sim Number must be a number",
		en: "Sim Number must be a number",
		ar: "يجب أن يكون رقم الشريحة رقمًا",
	},
	{
		id: "Sim Number Is Required",
		en: "Sim Number Is Required",
		ar: "رقم الشريحة مطلوب",
	},
	{
		id: "Sim must be an international number",
		en: "Sim must be an international number",
		ar: "يجب أن يكون رقم الشريحة دوليًا",
	},
	{
		id: "Sim Number Serial must be a number",
		en: "Sim Number Serial must be a number",
		ar: "يجب أن يكون الرقم التسلسلي للشريحة رقمًا",
	},
	{
		id: "Sim Number Serial must be a whole number",
		en: "Sim Number Serial must be a whole number",
		ar: "يجب أن يكون الرقم التسلسلي للشريحة عددًا صحيحًا",
	},
	{
		id: "Sim Number Serial must be a positive number",
		en: "Sim Number Serial must be a positive number",
		ar: "يجب أن يكون الرقم التسلسلي للشريحة رقمًا موجبًا",
	},
	{
		id: "Sim Number Serial Is Required",
		en: "Sim Number Serial Is Required",
		ar: "الرقم التسلسلي للشريحة مطلوب",
	},
	{
		id: "Vehicle Expiration Is Required",
		en: "Vehicle Expiration Is Required",
		ar: "انتهاء صلاحية السيارة مطلوب",
	},
	{
		id: "Fuel Cost can't be less than 1",
		en: "Fuel Cost can't be less than 1",
		ar: "لا يمكن أن تكون تكلفة الوقود أقل من 1",
	},
	{
		id: "Fuel Cost must be a number",
		en: "Fuel Cost must be a number",
		ar: "يجب أن تكون تكلفة الوقود رقمًا",
	},
	{
		id: "Fuel Consumption can't be less than 1",
		en: "Fuel Consumption can't be less than 1",
		ar: "لا يمكن أن يكون استهلاك الوقود أقل من 1",
	},
	{
		id: "Fuel Consumption must be a number",
		en: "Fuel Consumption must be a number",
		ar: "يجب أن يكون استهلاك الوقود رقمًا",
	},
	{
		id: "Fuel Capacity can't be less than 1",
		en: "Fuel Capacity can't be less than 1",
		ar: "لا يمكن أن تكون سعة الوقود أقل من 1",
	},
	{
		id: "Fuel Capacity must be a number",
		en: "Fuel Capacity must be a number",
		ar: "يجب أن تكون سعة الوقود رقمًا",
	},
	{
		id: "Fuel Capacity Is Required",
		en: "Fuel Capacity Is Required",
		ar: "سعة الوقود مطلوبة",
	},
	{
		id: "Tank Height can't be less than 1",
		en: "Tank Height can't be less than 1",
		ar: "لا يمكن أن يكون ارتفاع الخزان أقل من 1",
	},
	{
		id: "Tank Height must be a number",
		en: "Tank Height must be a number",
		ar: "يجب أن يكون ارتفاع الخزان رقمًا",
	},
	{
		id: "Tank Height Is Required",
		en: "Tank Height Is Required",
		ar: "ارتفاع الخزان مطلوب",
	},
	{
		id: "Tank Width can't be less than 1",
		en: "Tank Width can't be less than 1",
		ar: "لا يمكن أن يكون عرض الخزان أقل من 1",
	},
	{
		id: "Tank Width must be a number",
		en: "Tank Width must be a number",
		ar: "يجب أن يكون عرض الخزان رقمًا",
	},
	{
		id: "Tank Width Is Required",
		en: "Tank Width Is Required",
		ar: "عرض الخزان مطلوب",
	},
	{
		id: "Tank Length can't be less than 1",
		en: "Tank Length can't be less than 1",
		ar: "لا يمكن أن يكون طول الخزان أقل من 1",
	},
	{
		id: "Tank Length must be a number",
		en: "Tank Length must be a number",
		ar: "يجب أن يكون طول الخزان رقمًا",
	},
	{
		id: "Tank Length Is Required",
		en: "Tank Length Is Required",
		ar: "طول الخزان مطلوب",
	},
	{
		id: "Idle Time can't be less than 1",
		en: "Idle Time can't be less than 1",
		ar: "لا يمكن أن يكون وقت الخمول أقل من 1",
	},
	{
		id: "Idle Time must be a number",
		en: "Idle Time must be a number",
		ar: "يجب أن يكون وقت الخمول رقمًا",
	},
	{
		id: "Idle Time Is Required",
		en: "Idle Time Is Required",
		ar: "وقت الخمول مطلوب",
	},
	{
		id: "Year must be a number",
		en: "Year must be a number",
		ar: "يجب أن يكون العام رقمًا",
	},
	{
		id: "Year cannot be less than 1970",
		en: "Year cannot be less than 1970",
		ar: "لا يمكن أن تكون السنة أقل من 1970",
	},
	{
		id: "Odometer can't be less than 1",
		en: "Odometer can't be less than 1",
		ar: "لا يمكن أن يكون عداد المسافات أقل من 1",
	},
	{
		id: "Odometer must be a number",
		en: "Odometer must be a number",
		ar: "يجب أن يكون عداد المسافات رقمًا",
	},
	{
		id: "Vehicle Edited Successfully",
		en: "Vehicle Edited Successfully",
		ar: "تم تعديل المركبة بنجاح",
	},
	{
		id: "New Vehicle Is Added",
		en: "New Vehicle Is Added",
		ar: "تم إضافة مركبة جديدة",
	},
	{
		id: "Driver Edited Successfully",
		en: "Driver Edited Successfully",
		ar: "تم تعديل بيانات السائق بنجاح",
	},
	{
		id: "New Driver Is Added",
		en: "New Driver Is Added",
		ar: "تم إضافة سائق جديد",
	},
	{
		id: "User Edited Successfully",
		en: "User Edited Successfully",
		ar: "تم تعديل بيانات المستخدم بنجاح",
	},
	{
		id: "New User Is Added",
		en: "New User Is Added",
		ar: "تم إضافة مستخدم جديد",
	},
	{
		id: "Notification Edited Successfully",
		en: "Notification Edited Successfully",
		ar: "تم تعديل الإشعار بنجاح",
	},
	{
		id: "New Notification Is Added",
		en: "New Notification Is Added",
		ar: "تم إضافة إشعار جديد",
	},
	{
		id: "User Profile Edited Successfully",
		en: "User Profile Edited Successfully",
		ar: "تم تعديل بيانات ملف المستخدم بنجاح",
	},
	{
		id: "Can't Edit User Profile Data",
		en: "Can't Edit User Profile Data",
		ar: "لا يمكن تعديل بيانات ملف المستخدم",
	},
	{
		id: "Notification Edited Successfully",
		en: "Notification Edited Successfully",
		ar: "تم تعديل الإشعار بنجاح",
	},
	{
		id: "New Geofence Is Added",
		en: "New Geofence Is Added",
		ar: "تم إضافة سياج جديد",
	},
	{
		id: "Vehicle Deleted Successfully",
		en: "Vehicle Deleted Successfully",
		ar: "تم حذف المركبة بنجاح",
	},
	{
		id: "Driver Deleted Successfully",
		en: "Driver Deleted Successfully",
		ar: "تم حذف السائق بنجاح",
	},
	{
		id: "User Deleted Successfully",
		en: "User Deleted Successfully",
		ar: "تم حذف المستخدم بنجاح",
	},
	{
		id: "Geofence Deleted Successfully",
		en: "Geofence Deleted Successfully",
		ar: "تم حذف السياج بنجاح",
	},
	{
		id: "Notification Deleted Successfully",
		en: "Notification Deleted Successfully",
		ar: "تم حذف الإشعار بنجاح",
	},
	{ id: "Available Users", en: "Available Users", ar: "المستخدمين المتاحين" },
	{ id: "No data shown", en: "No data shown", ar: "لم يتم عرض أي بيانات" },
	{ id: "Selected", en: "Selected", ar: "محدد" },
	{
		id: "Connect or link this vehicle to other modules.",
		en: "Connect or link this vehicle to other modules.",
		ar: "قم بتوصيل أو ربط هذه المركبة بوحدات أخرى.",
	},
	{ id: "Please select", en: "Please select", ar: "برجاء الاختيار" },
	{ id: "Liter/100 KM", en: "Liter/100 KM", ar: "لتر/100 كم" },
	{ id: "0.0 SAR", en: "0.0 SAR", ar: "ريال" },
	{ id: "Minutes/s", en: "Minutes/s", ar: "دقائق/ثانية" },
	{
		id: "Sim Number Is Required",
		en: "Sim Number Is Required",
		ar: "رقم الشريحة مطلوب",
	},
	{
		id: "Brand accept only letters and (-) not as first",
		en: "Brand accept only letters and (-) not as first",
		ar: "تقبل الماركة فقط الحروف و(-) وليس كأول",
	},
	{ id: "Files", en: "Files", ar: "الملفات" },
	{ id: "Delete Image", en: "Delete Image", ar: "حذف الصورة" },
	{ id: "Undo Image", en: "Undo Image", ar: "تراجع" },
	{ id: "Ex. Ahmed Ali", en: "Ex. Ahmed Ali", ar: "مثال: احمد علي" },
	{ id: "Ex. 123AB", en: "Ex. 123AB", ar: "مثال: 123" },
	{
		id: "EX. Riydah - SaudiArabia",
		en: "EX. Riydah - SaudiArabia",
		ar: "الرياض - المملكة العربية السعودية",
	},
	{ id: "EX. A12345678910", en: "EX. A12345678910", ar: "مثال: 12345678910" },
	{ id: "Ex. 30.15484612", en: "Ex. 30.15484612", ar: "مثال: 30.15484612" },
	{ id: "Ex. 33.45235645", en: "Ex. 33.45235645", ar: "مثال: 33.45235645" },
	{ id: "Ex. 3", en: "Ex. 3", ar: "مثال: 3" },
	{ id: "Ex. 5", en: "Ex. 5", ar: "مثال: 5" },
	{ id: "hours", en: "hours", ar: "ساعات" },
	{
		id: "No users found",
		en: "No users found",
		ar: "لم يتم العثور على أي مستخدمين",
	},
	{
		id: "Create your first user now!",
		en: "Create your first user now!",
		ar: "قم بإنشاء المستخدم الأول الخاص بك الآن!",
	},
	{
		id: "No Drivers Found",
		en: "No Drivers Found",
		ar: "لم يتم العثور على سائقين",
	},
	{
		id: "Add your new driver now!",
		en: "Add your new driver now!",
		ar: "أضف سائق جديد الآن!",
	},
	{
		id: "No Vehicles Found",
		en: "No Vehicles Found",
		ar: "لم يتم العثور على أي مركبات",
	},
	{
		id: "No Drivers Found",
		en: "No Drivers Found",
		ar: "لم يتم العثور على أي سائقين",
	},
	{
		id: "Create new driver now",
		en: "Create new driver now",
		ar: "أضف سائق الجديد!",
	},
	{
		id: "Create your new vehicle now!",
		en: "Create your new vehicle now!",
		ar: "أضف سيارتك الجديدة الآن!",
	},
	{
		id: "You have no alerts yet",
		en: "You have no alerts yet",
		ar: "ليس لديك أي تنبيهات حتى الآن",
	},
	{ id: "door", en: "door", ar: "الأبواب" },
	{ id: "temperature", en: "temperature", ar: "درجة حرارة" },
	{ id: "OFF", en: "OFF", ar: "أطفئ" },
	{ id: "ON", en: "ON", ar: "تشغيل" },
	{ id: "Closed", en: "Closed", ar: "مغلق" },
	{ id: "Opened", en: "Opened", ar: "مفتوح" },
	{ id: "Total", en: "Total", ar: "المجموع" },
	{ id: "geofence", en: "geofence", ar: "السياج جغرافي" },
	{ id: "driver", en: "driver", ar: "السائق" },
	{ id: "vehicle", en: "vehicle", ar: "المركبة" },
	{ id: "user", en: "user", ar: "المستخدم" },
	{ id: "subuser", en: "subuser", ar: "المستخدم" },
	{ id: "Alert Type", en: "Alert Type", ar: "نوع التنبيه" },
	{
		id: "Please select at least one vehicle",
		en: "Please select at least one vehicle",
		ar: "برجاء اختير مركبة واحدة علي الاقل",
	},
	{ id: "Multi-view", en: "Multi-view", ar: "عرض متعدد" },
	{ id: "Related to", en: "Related to", ar: "ذات صلة ب" },
	{ id: "Bulk Upload", en: "Bulk Upload", ar: "رفع مجمع" },
	{
		id: "Please upload the file in xlsx format",
		en: "Please upload the file in xlsx format",
		ar: "يرجى تحميل الملف بصيغة xlsx",
	},
	{
		id: "This field is required",
		en: "This field is required",
		ar: "هذه الخانة مطلوبه",
	},
	{
		id: "Please attach file",
		en: "Please attach file",
		ar: "الرجاء إرفاق الملف",
	},
	{ id: "File is required", en: "File is required", ar: "الملف مطلوب" },
	{
		id: "columns are required",
		en: "columns are required",
		ar: "الأعمدة مطلوبة",
	},
	{ id: "Upload Another File", en: "Upload Another File", ar: "رفع ملف جديد" },
	{
		id: "Duplicate IMEIs found",
		en: "Duplicate IMEIs found",
		ar: "تم العثور على أرقام تعريفية مكررة",
	},
	{
		id: "File uploaded successfully",
		en: "File uploaded successfully",
		ar: "تم تحميل الملف بنجاح",
	},
	{
		id: "vin must be a string",
		en: "vin must be a string",
		ar: "vin يجب ان يكون ",
	},
	{ id: "Upload File", en: "Upload File", ar: "قم برفع الملف" },
	{ id: "Perview Table", en: "Perview Table", ar: "مراجعة الملف" },
	{
		id: `vin" must be a string`,
		en: "VIN should contain letters and numbers",
		ar: "VIN يجب ان تحتوي على حروف و ارقام",
	},
	{ id: "Playback", en: "Playback", ar: "السجل" },
	{ id: "Media", en: "Media", ar: "المشغل" },
	{ id: "Vehicle Movement", en: "Vehicle Movement", ar: "تحركات المركبة" },
	{ id: "Groups", en: "Groups", ar: "المجموعات" },
	{ id: "No Groups Found", en: "No Groups Found", ar: "لا يوجد مجموعات" },
	{
		id: "Add your new group now!",
		en: "Add your new group now!",
		ar: "أضف مجموعتك الجديدة الأن",
	},
	{
		id: "No Data Found, Please reload",
		en: "No Data Found, Please reload",
		ar: "لا يوجد بيانات برجاء إعادة التحميل",
	},
	{ id: "Linked Group", en: "Linked Group", ar: "المجموعة المتصلة" },
	{
		id: "Fuel Increase Threshold",
		en: "Fuel Increase Threshold",
		ar: "الحد الأقصي للوقود",
	},
	{
		id: "Fuel Drop Threshold",
		en: "Fuel Drop Threshold",
		ar: "الحد الأدني للوقود",
	},
	{
		id: "Phone Number",
		en: "Phone Number",
		ar: "رقم الجوال",
	},
	{
		id: "Available Groups",
		en: "Available Groups",
		ar: "المجموعات",
	},
	{
		id: "Ungrouped Vehicles",
		en: "Ungrouped Vehicles",
		ar: "مركبات بدون مجموعة",
	},
	{
		id: "Phone Number",
		en: "Phone Number",
		ar: "رقم الجوال",
	},
	{
		id: "Available Groups",
		en: "Available Groups",
		ar: "المجموعات",
	},
	{
		id: "Ungrouped Vehicles",
		en: "Ungrouped Vehicles",
		ar: "مركبات بدون مجموعة",
	},
	{ id: "Add new group", en: "Add new group", ar: "أضف مجموعة جديدة" },
	{ id: "Edit Group", en: "Edit Group", ar: "تعديل مجموعة" },
	{
		id: "Group added successfully",
		en: "Group added successfully",
		ar: "تم إضافة مجموعة بنجاح",
	},
	{
		id: "Failed to add group",
		en: "Failed to add group",
		ar: "فشل في إضافة مجموعة",
	},
	{
		id: "Group edited successfully",
		en: "Group edited successfully",
		ar: "تم تعديل مجموعة بنجاح",
	},
	{
		id: "Failed to edit group",
		en: "Failed to edit group",
		ar: "فشل في تعديل مجموعة",
	},
	{
		id: "Only letters, numbers, and spaces are allowed",
		en: "Only letters, numbers, and spaces are allowed",
		ar: "يُسمح فقط بالأحرف والأرقام والمسافات",
	},
	{
		id: "Input contains potentially unfavor characters",
		en: "Input contains potentially unfavor characters",
		ar: "يحتوي الإدخال على أحرف غير مرغوب فيها محتملة",
	},
	{
		id: "Name cannot be just whitespace",
		en: "Name cannot be just whitespace",
		ar: "لا يمكن أن يكون الاسم مجرد مسافة بيضاء",
	},
	{
		id: "Name cannot contain consecutive spaces",
		en: "Name cannot contain consecutive spaces",
		ar: "لا يمكن أن يحتوي الاسم على مسافات متتالية",
	},
	{
		id: "Name cannot contain only numbers",
		en: "Name cannot contain only numbers",
		ar: "لا يمكن أن يحتوي الاسم على أرقام فقط",
	},
	{
		id: "Name contains invalid characters",
		en: "Name contains invalid characters",
		ar: "يحتوي الاسم على أحرف غير صالحة",
	},
	{
		id: "Speed Limit accepts numbers only",
		en: "Speed Limit accepts numbers only",
		ar: "الحد الأقصى للسرعة يقبل الأرقام فقط",
	},
	{
		id: "Speed Limit must be a whole number",
		en: "Speed Limit must be a whole number",
		ar: "يجب أن يكون حد السرعة عددًا صحيحًا",
	},
	{
		id: "Speed Limit must be a positive number",
		en: "Speed Limit must be a positive number",
		ar: "يجب أن يكون حد السرعة رقمًا موجبًا",
	},
	{
		id: "Fuel Increase Threshold accepts numbers only",
		en: "Fuel Increase Threshold accepts numbers only",
		ar: "الحد الأاقصي للوقود يقبل الأرقام فقط",
	},
	{
		id: "Fuel Increase Threshold must be a whole number",
		en: "Fuel Increase Threshold must be a whole number",
		ar: "يجب أن يكون حد زيادة الوقود عددًا صحيحًا",
	},
	{
		id: "Fuel Increase Threshold must be a positive number",
		en: "Fuel Increase Threshold must be a positive number",
		ar: "يجب أن يكون حد زيادة الوقود رقمًا موجبًا",
	},
	{
		id: "Fuel Drop Threshold accepts numbers only",
		en: "Fuel Drop Threshold accepts numbers only",
		ar: "عتبة إنخفاض الوقود تقبل الأرقام فقط",
	},
	{
		id: "Fuel Drop Threshold must be a whole number",
		en: "Fuel Drop Threshold must be a whole number",
		ar: "يجب أن يكون حد إنخفاض الوقود عددًا صحيحًا",
	},
	{
		id: "Fuel Drop Threshold must be a positive number",
		en: "Fuel Drop Threshold must be a positive number",
		ar: "يجب أن يكون حد إنخفاض الوقود رقمًا موجبًا",
	},
	{ id: "Enter Group Name", en: "Enter Group Name", ar: "أدخل اسم المجموعة" },
	{ id: "Ex. 10", en: "Ex. 10", ar: "مثال: 10" },
	{ id: "Ex. 10", en: "Ex. 10", ar: "مثال: 10" },
	{ id: "Ex. 10 Liter", en: "Ex. 10 Liter", ar: "مثال: 10 لتر" },
	{ id: "Ex. 10 Km/h", en: "Ex. 10 Km/h", ar: "مثال: 10 كم/س" },
	{ id: "Select Group", en: "Select Group", ar: "اختر مجموعة" },
	{ id: "Liter", en: "Liter", ar: "لتر" },
	{ id: "Vehicle Expiry", en: "Vehicle Expiry", ar: "انتهاء صلاحية المركبة" },
	{ id: "License Expiry", en: "License Expiry", ar: "انتهاء الرخصة" },
	{ id: "Contract Expiry", en: "Contract Expiry", ar: "انتهاء العقد" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Vehicle Movement", en: "Vehicle Movement", ar: "تحركات المركبة" },
	{ id: "Groups", en: "Groups", ar: "المجموعات" },
	{ id: "No Groups Found", en: "No Groups Found", ar: "لا يوجد مجموعات" },
	{
		id: "Add your new group now!",
		en: "Add your new group now!",
		ar: "أضف مجموعتك الجديدة الأن",
	},
	{
		id: "No Data Found, Please reload",
		en: "No Data Found, Please reload",
		ar: "لا يوجد بيانات برجاء إعادة التحميل",
	},
	{ id: "Linked Group", en: "Linked Group", ar: "المجموعة المتصلة" },
	{
		id: "Fuel Increase Threshold",
		en: "Fuel Increase Threshold",
		ar: "معدل زيادة الوقود",
	},
	{
		id: "Fuel Drop Threshold",
		en: "Fuel Drop Threshold",
		ar: "معدل انخفاض الوقود",
	},
	{ id: "Add new group", en: "Add new group", ar: "أضف مجموعة جديدة" },
	{ id: "Edit Group", en: "Edit Group", ar: "تعديل مجموعة" },
	{
		id: "Group added successfully",
		en: "Group added successfully",
		ar: "تم إضافة مجموعة بنجاح",
	},
	{
		id: "Failed to add group",
		en: "Failed to add group",
		ar: "فشل في إضافة مجموعة",
	},
	{
		id: "Group edited successfully",
		en: "Group edited successfully",
		ar: "تم تعديل مجموعة بنجاح",
	},
	{
		id: "Failed to edit group",
		en: "Failed to edit group",
		ar: "فشل في تعديل مجموعة",
	},
	{ id: "Vehicle Movement", en: "Vehicle Movement", ar: "تحركات المركبة" },
	{ id: "Groups", en: "Groups", ar: "المجموعات" },
	{ id: "No Groups Found", en: "No Groups Found", ar: "لا يوجد مجموعات" },
	{
		id: "Add your new group now!",
		en: "Add your new group now!",
		ar: "أضف مجموعتك الجديدة الأن",
	},
	{
		id: "No Data Found, Please reload",
		en: "No Data Found, Please reload",
		ar: "لا يوجد بيانات برجاء إعادة التحميل",
	},
	{ id: "Linked Group", en: "Linked Group", ar: "المجموعة المتصلة" },
	{
		id: "Fuel Increase Threshold",
		en: "Fuel Increase Threshold",
		ar: "معدل زيادة الوقود",
	},
	{
		id: "Fuel Drop Threshold",
		en: "Fuel Drop Threshold",
		ar: "معدل انخفاض الوقود",
	},
	{ id: "Add new group", en: "Add new group", ar: "أضف مجموعة جديدة" },
	{ id: "Edit Group", en: "Edit Group", ar: "تعديل مجموعة" },
	{
		id: "Group added successfully",
		en: "Group added successfully",
		ar: "تم إضافة مجموعة بنجاح",
	},
	{
		id: "Failed to add group",
		en: "Failed to add group",
		ar: "فشل في إضافة مجموعة",
	},
	{
		id: "Group edited successfully",
		en: "Group edited successfully",
		ar: "تم تعديل مجموعة بنجاح",
	},
	{
		id: "Failed to edit group",
		en: "Failed to edit group",
		ar: "فشل في تعديل مجموعة",
	},

	{
		id: "Only letters, numbers, and spaces are allowed",
		en: "Only letters, numbers, and spaces are allowed",
		ar: "يُسمح فقط بالأحرف والأرقام والمسافات",
	},
	{
		id: "Input contains potentially unfavor characters",
		en: "Input contains potentially unfavor characters",
		ar: "يحتوي الإدخال على أحرف غير مرغوب فيها محتملة",
	},
	{
		id: "Name cannot be just whitespace",
		en: "Name cannot be just whitespace",
		ar: "لا يمكن أن يكون الاسم مجرد مسافة بيضاء",
	},
	{
		id: "Name cannot contain consecutive spaces",
		en: "Name cannot contain consecutive spaces",
		ar: "لا يمكن أن يحتوي الاسم على مسافات متتالية",
	},
	{
		id: "Name cannot contain only numbers",
		en: "Name cannot contain only numbers",
		ar: "لا يمكن أن يحتوي الاسم على أرقام فقط",
	},
	{
		id: "Name contains invalid characters",
		en: "Name contains invalid characters",
		ar: "يحتوي الاسم على أحرف غير صالحة",
	},
	{
		id: "Speed Limit accepts numbers only",
		en: "Speed Limit accepts numbers only",
		ar: "الحد الأقصى للسرعة يقبل الأرقام فقط",
	},
	{
		id: "Speed Limit must be a whole number",
		en: "Speed Limit must be a whole number",
		ar: "يجب أن يكون حد السرعة عددًا صحيحًا",
	},
	{
		id: "Speed Limit must be a positive number",
		en: "Speed Limit must be a positive number",
		ar: "يجب أن يكون حد السرعة رقمًا موجبًا",
	},
	{
		id: "Fuel Increase Threshold accepts numbers only",
		en: "Fuel Increase Threshold accepts numbers only",
		ar: "معدل زيادة الوقود تقبل الأرقام فقط",
	},
	{
		id: "Fuel Increase Threshold must be a whole number",
		en: "Fuel Increase Threshold must be a whole number",
		ar: "يجب أن يكون حد زيادة الوقود عددًا صحيحًا",
	},
	{
		id: "Fuel Increase Threshold must be a positive number",
		en: "Fuel Increase Threshold must be a positive number",
		ar: "يجب أن يكون حد زيادة الوقود رقمًا موجبًا",
	},
	{
		id: "Fuel Drop Threshold accepts numbers only",
		en: "Fuel Drop Threshold accepts numbers only",
		ar: "معدل إنخفاض الوقود تقبل الأرقام فقط",
	},
	{
		id: "Fuel Drop Threshold must be a whole number",
		en: "Fuel Drop Threshold must be a whole number",
		ar: "يجب أن يكون حد إنخفاض الوقود عددًا صحيحًا",
	},
	{
		id: "Fuel Drop Threshold must be a positive number",
		en: "Fuel Drop Threshold must be a positive number",
		ar: "يجب أن يكون حد إنخفاض الوقود رقمًا موجبًا",
	},
	{ id: "Enter Group Name", en: "Enter Group Name", ar: "أدخل اسم المجموعة" },
	{ id: "Ex. 10 Liter", en: "Ex. 10 Liter", ar: "مثال: 10 لتر" },
	{ id: "Ex. 10 Km/h", en: "Ex. 10 Km/h", ar: "مثال: 10 كم/س" },
	{ id: "Select Group", en: "Select Group", ar: "اختر مجموعة" },
	{ id: "Liter", en: "Liter", ar: "لتر" },
	{ id: "group", en: "group", ar: "الجروب" },
	{ id: "Enter Group Code", en: "Enter Group Code", ar: "أدخل كود الجروب" },
	{
		id: "Geofence is linked to user successfully",
		en: "Geofence is linked to user successfully",
		ar: "تم ربط السياج الجغرافي بالمستخدم بنجاح",
	},
	{
		id: "Geofence is linked to vehicle successfully",
		en: "Geofence is linked to vehicle successfully",
		ar: "تم ربط السياج الجغرافي بالمركبة بنجاح",
	},
	{
		id: "Driver is linked to user successfully",
		en: "Driver is linked to user successfully",
		ar: "تم ربط السائق بالمستخدم بنجاح",
	},
	{
		id: "Driver is linked to vehicle successfully",
		en: "Driver is linked to vehicle successfully",
		ar: "تم ربط السائق بالمركبة بنجاح",
	},
	{
		id: "Notification is linked to user successfully",
		en: "Notification is linked to user successfully",
		ar: "تم ربط الإشعار بالمستخدم بنجاح",
	},
	{
		id: "Notification is linked to vehicle successfully",
		en: "Notification is linked to vehicle successfully",
		ar: "تم ربط الإشعار بالمركبة بنجاح",
	},
	{
		id: "Geofence is unlinked from user successfully",
		en: "Geofence is unlinked from user successfully",
		ar: "تم فصل السياج الجغرافي عن المستخدم بنجاح",
	},
	{
		id: "Geofence is unlinked from vehicle successfully",
		en: "Geofence is unlinked from vehicle successfully",
		ar: "تم فصل السياج الجغرافي عن المركبة بنجاح",
	},
	{
		id: "Driver is unlinked from user successfully",
		en: "Driver is unlinked from user successfully",
		ar: "تم فصل السائق عن المستخدم بنجاح",
	},
	{
		id: "Driver is unlinked from vehicle successfully",
		en: "Driver is unlinked from vehicle successfully",
		ar: "تم فصل السائق عن المركبة بنجاح",
	},
	{
		id: "Only letters, numbers, and spaces are allowed",
		en: "Only letters, numbers, and spaces are allowed",
		ar: "يُسمح فقط بالأحرف والأرقام والمسافات",
	},
	{
		id: "Input contains potentially unfavor characters",
		en: "Input contains potentially unfavor characters",
		ar: "يحتوي الإدخال على أحرف غير مرغوب فيها محتملة",
	},
	{
		id: "Name cannot be just whitespace",
		en: "Name cannot be just whitespace",
		ar: "لا يمكن أن يكون الاسم مجرد مسافة بيضاء",
	},
	{
		id: "Name cannot contain consecutive spaces",
		en: "Name cannot contain consecutive spaces",
		ar: "لا يمكن أن يحتوي الاسم على مسافات متتالية",
	},
	{
		id: "Name cannot contain only numbers",
		en: "Name cannot contain only numbers",
		ar: "لا يمكن أن يحتوي الاسم على أرقام فقط",
	},
	{
		id: "Name contains invalid characters",
		en: "Name contains invalid characters",
		ar: "يحتوي الاسم على أحرف غير صالحة",
	},
	{
		id: "Speed Limit accepts numbers only",
		en: "Speed Limit accepts numbers only",
		ar: "الحد الأقصى للسرعة يقبل الأرقام فقط",
	},
	{
		id: "Speed Limit must be a whole number",
		en: "Speed Limit must be a whole number",
		ar: "يجب أن يكون حد السرعة عددًا صحيحًا",
	},
	{
		id: "Speed Limit must be a positive number",
		en: "Speed Limit must be a positive number",
		ar: "يجب أن يكون حد السرعة رقمًا موجبًا",
	},
	{
		id: "Fuel Increase Threshold accepts numbers only",
		en: "Fuel Increase Threshold accepts numbers only",
		ar: "معدل زيادة الوقود تقبل الأرقام فقط",
	},
	{
		id: "Fuel Increase Threshold must be a whole number",
		en: "Fuel Increase Threshold must be a whole number",
		ar: "يجب أن يكون حد زيادة الوقود عددًا صحيحًا",
	},
	{
		id: "Fuel Increase Threshold must be a positive number",
		en: "Fuel Increase Threshold must be a positive number",
		ar: "يجب أن يكون حد زيادة الوقود رقمًا موجبًا",
	},
	{
		id: "Fuel Drop Threshold accepts numbers only",
		en: "Fuel Drop Threshold accepts numbers only",
		ar: "معدل إنخفاض الوقود تقبل الأرقام فقط",
	},
	{
		id: "Fuel Drop Threshold must be a whole number",
		en: "Fuel Drop Threshold must be a whole number",
		ar: "يجب أن يكون حد إنخفاض الوقود عددًا صحيحًا",
	},
	{
		id: "Fuel Drop Threshold must be a positive number",
		en: "Fuel Drop Threshold must be a positive number",
		ar: "يجب أن يكون حد إنخفاض الوقود رقمًا موجبًا",
	},
	{ id: "Enter Group Name", en: "Enter Group Name", ar: "أدخل اسم المجموعة" },
	{ id: "Ex. 10 Liter", en: "Ex. 10 Liter", ar: "مثال: 10 لتر" },
	{ id: "Ex. 10 Km/h", en: "Ex. 10 Km/h", ar: "مثال: 10 كم/س" },
	{ id: "Select Group", en: "Select Group", ar: "اختر مجموعة" },
	{ id: "Liter", en: "Liter", ar: "لتر" },
	{ id: "group", en: "group", ar: "الجروب" },
	{ id: "Enter Group Code", en: "Enter Group Code", ar: "أدخل كود الجروب" },
	{
		id: "Geofence is linked to user successfully",
		en: "Geofence is linked to user successfully",
		ar: "تم ربط السياج الجغرافي بالمستخدم بنجاح",
	},
	{
		id: "Geofence is linked to vehicle successfully",
		en: "Geofence is linked to vehicle successfully",
		ar: "تم ربط السياج الجغرافي بالمركبة بنجاح",
	},
	{
		id: "Driver is linked to user successfully",
		en: "Driver is linked to user successfully",
		ar: "تم ربط السائق بالمستخدم بنجاح",
	},
	{
		id: "Driver is linked to vehicle successfully",
		en: "Driver is linked to vehicle successfully",
		ar: "تم ربط السائق بالمركبة بنجاح",
	},
	{
		id: "Notification is linked to user successfully",
		en: "Notification is linked to user successfully",
		ar: "تم ربط الإشعار بالمستخدم بنجاح",
	},
	{
		id: "Notification is linked to vehicle successfully",
		en: "Notification is linked to vehicle successfully",
		ar: "تم ربط الإشعار بالمركبة بنجاح",
	},
	{
		id: "Geofence is unlinked from user successfully",
		en: "Geofence is unlinked from user successfully",
		ar: "تم فصل السياج الجغرافي عن المستخدم بنجاح",
	},
	{
		id: "Geofence is unlinked from vehicle successfully",
		en: "Geofence is unlinked from vehicle successfully",
		ar: "تم فصل السياج الجغرافي عن المركبة بنجاح",
	},
	{
		id: "Driver is unlinked from user successfully",
		en: "Driver is unlinked from user successfully",
		ar: "تم فصل السائق عن المستخدم بنجاح",
	},
	{
		id: "Driver is unlinked from vehicle successfully",
		en: "Driver is unlinked from vehicle successfully",
		ar: "تم فصل السائق عن المركبة بنجاح",
	},

	{
		id: "Notification is unlinked from user successfully",
		en: "Notification is unlinked from user successfully",
		ar: "تم فصل الإشعار عن المستخدم بنجاح",
	},
	{
		id: "Notification is unlinked from vehicle successfully",
		en: "Notification is unlinked from vehicle successfully",
		ar: "تم فصل الإشعار عن المركبة بنجاح",
	},
	{
		id: "Notification is unlinked from user successfully",
		en: "Notification is unlinked from user successfully",
		ar: "تم فصل الإشعار عن المستخدم بنجاح",
	},
	{
		id: "Notification is unlinked from vehicle successfully",
		en: "Notification is unlinked from vehicle successfully",
		ar: "تم فصل الإشعار عن المركبة بنجاح",
	},

	{
		id: "Vehicle is linked to user successfully",
		en: "Vehicle is linked to user successfully",
		ar: "تم ربط المركبة بالمستخدم بنجاح",
	},
	{
		id: "Vehicle is unlinked from user successfully",
		en: "Vehicle is unlinked from user successfully",
		ar: "تم فصل المركبة عن المستخدم بنجاح",
	},
	{
		id: "User is linked to user successfully",
		en: "User is linked to user successfully",
		ar: "تم ربط المستخدم بالمستخدم بنجاح",
	},
	{
		id: "User is unlinked from user successfully",
		en: "User is unlinked from user successfully",
		ar: "تم فصل المستخدم عن المستخدم بنجاح",
	},
	{
		id: "Vehicle is linked to user successfully",
		en: "Vehicle is linked to user successfully",
		ar: "تم ربط المركبة بالمستخدم بنجاح",
	},
	{
		id: "Vehicle is unlinked from user successfully",
		en: "Vehicle is unlinked from user successfully",
		ar: "تم فصل المركبة عن المستخدم بنجاح",
	},
	{
		id: "User is linked to user successfully",
		en: "User is linked to user successfully",
		ar: "تم ربط المستخدم بالمستخدم بنجاح",
	},
	{
		id: "User is unlinked from user successfully",
		en: "User is unlinked from user successfully",
		ar: "تم فصل المستخدم عن المستخدم بنجاح",
	},
	{
		id: "Group is linked to user successfully",
		en: "Group is linked to user successfully",
		ar: "تم ربط الجروب بالمستخدم بنجاح",
	},
	{
		id: "Group is unlinked from user successfully",
		en: "Group is unlinked from user successfully",
		ar: "تم فصل الجروب عن المستخدم بنجاح",
	},
	{ id: "Failed to link", en: "Failed to link", ar: "فشل في ربط" },
	{ id: "Failed to unlink", en: "Failed to unlink", ar: "فشل في فصل" },
	{ id: "to user", en: "to user", ar: "بالمستخدم" },
	{ id: "to vehicle", en: "to vehicle", ar: "بالمركبة" },
	{ id: "notification", en: "notification", ar: "الإشعار" },
	{ id: "Notification", en: "Notification", ar: "الإشعار" },

	{
		id: "Commercial Vehicles",
		en: "Commercial Vehicles",
		ar: "المركبات التجارية",
	},
	{ id: "Delivery Trucks", en: "Delivery Trucks", ar: "شاحنات التوصيل" },
	{ id: "Cargo Vans", en: "Cargo Vans", ar: "شاحنات البضائع" },
	{ id: "Utility Trucks", en: "Utility Trucks", ar: "شاحنات الخدمات" },

	{ id: "Passenger Vehicles", en: "Passenger Vehicles", ar: "مركبات الركاب" },
	{ id: "Sedans", en: "Sedans", ar: "سيارات سيدان" },
	{ id: "Suvs", en: "Suvs", ar: "سيارات الدفع الرباعي" },
	{ id: "Vans", en: "Vans", ar: "شاحنات صغيرة" },

	{
		id: "Specialized Vehicles",
		en: "Specialized Vehicles",
		ar: "المركبات المتخصصة",
	},
	{ id: "Ambulances", en: "Ambulances", ar: "سيارات الإسعاف" },
	{ id: "Police Cars", en: "Police Cars", ar: "سيارات الشرطة" },
	{ id: "Fire Trucks", en: "Fire Trucks", ar: "شاحنات الإطفاء" },
	{
		id: "Construction Vehicles",
		en: "Construction Vehicles",
		ar: "مركبات البناء",
	},

	{
		id: "Public Transportation Vehicles",
		en: "Public Transportation Vehicles",
		ar: "مركبات النقل العام",
	},
	{ id: "Buses", en: "Buses", ar: "الحافلات" },
	{ id: "Shuttles", en: "Shuttles", ar: "الحافلات الصغيرة" },

	{
		id: "Heavy-Duty Vehicles",
		en: "Heavy-Duty Vehicles",
		ar: "المركبات الثقيلة",
	},
	{ id: "Trucks", en: "Trucks", ar: "الشاحنات" },
	{ id: "Trailers", en: "Trailers", ar: "المقطورات" },

	{
		id: "Special Purpose Vehicles",
		en: "Special Purpose Vehicles",
		ar: "المركبات الخاصة",
	},
	{ id: "Refrigerated Trucks", en: "Refrigerated Trucks", ar: "شاحنات مبردة" },
	{ id: "Tanker Trucks", en: "Tanker Trucks", ar: "شاحنات صهريج" },
	{ id: "Tow Trucks", en: "Tow Trucks", ar: "شاحنات السحب" },

	{
		id: "Construction Off-Road Vehicles",
		en: "Construction Off-Road Vehicles",
		ar: "مركبات البناء غير الممهدة",
	},
	{ id: "Excavators", en: "Excavators", ar: "حفارات" },
	{ id: "Bulldozers", en: "Bulldozers", ar: "جرافات" },
	{
		id: "Off-Road Vehicles",
		en: "Off-Road Vehicles",
		ar: "مركبات الطرق الوعرة",
	},

	{
		id: "Electric Vehicles (EVs)",
		en: "Electric Vehicles (EVs)",
		ar: "المركبات الكهربائية",
	},
	{ id: "Electric Cars", en: "Electric Cars", ar: "السيارات الكهربائية" },
	{ id: "Electric Trucks", en: "Electric Trucks", ar: "الشاحنات الكهربائية" },
	{ id: "Electric Vans", en: "Electric Vans", ar: "الفانات الكهربائية" },

	{ id: "Motorcycles", en: "Motorcycles", ar: "الدراجات النارية" },
	{ id: "Cruiser", en: "Cruiser", ar: "كروزر" },
	{ id: "Sport bike", en: "Sport bike", ar: "دراجة رياضية" },
	{ id: "Scooter", en: "Scooter", ar: "سكوتر" },

	{ id: "North America", en: "North America", ar: "أمريكا الشمالية" },
	{ id: "Canada", en: "Canada", ar: "كندا" },
	{ id: "USA", en: "USA", ar: "الولايات المتحدة" },
	{ id: "Mexico", en: "Mexico", ar: "المكسيك" },

	{ id: "South America", en: "South America", ar: "أمريكا الجنوبية" },
	{ id: "Brazil", en: "Brazil", ar: "البرازيل" },
	{ id: "Argentina", en: "Argentina", ar: "الأرجنتين" },

	{ id: "Europe", en: "Europe", ar: "أوروبا" },
	{ id: "France", en: "France", ar: "فرنسا" },
	{ id: "Germany", en: "Germany", ar: "ألمانيا" },
	{ id: "Italy", en: "Italy", ar: "إيطاليا" },
	{ id: "Spain", en: "Spain", ar: "إسبانيا" },
	{ id: "UK", en: "UK", ar: "المملكة المتحدة" },
	{ id: "Belgium", en: "Belgium", ar: "بلجيكا" },
	{ id: "Netherlands", en: "Netherlands", ar: "هولندا" },
	{ id: "Portugal", en: "Portugal", ar: "البرتغال" },
	{ id: "Sweden", en: "Sweden", ar: "السويد" },
	{ id: "Russia", en: "Russia", ar: "روسيا" },

	{ id: "Asia", en: "Asia", ar: "آسيا" },
	{ id: "China", en: "China", ar: "الصين" },
	{ id: "India", en: "India", ar: "الهند" },
	{ id: "Japan", en: "Japan", ar: "اليابان" },
	{ id: "South Korea", en: "South Korea", ar: "كوريا الجنوبية" },
	{ id: "Taiwan", en: "Taiwan", ar: "تايوان" },
	{ id: "Turkey", en: "Turkey", ar: "تركيا" },
	{ id: "Oceania", en: "Oceania", ar: "أوقيانوسيا" },
	{ id: "Australia", en: "Australia", ar: "أستراليا" },
	{ id: "Select Date", en: "Select Date", ar: "أختر تاريخ" },
	{ id: "Expiration", en: "Expiration", ar: "الصلاحية" },
	{ id: "Expired", en: "Expired", ar: "منتهي الصلاحية" },
	{ id: "Active", en: "Active", ar: "نشط" },
	{ id: "Fuel Price", en: "Fuel Price", ar: "سعر الوقود" },
	{ id: "license expire", en: "license expire", ar: "صلاحية الرخصة" },
	{ id: "linked users", en: "linked users", ar: "المستخدمين المتصلين" },
	{ id: "days left", en: "days left", ar: "أيام متبقية" },
	{ id: "All Vehicles", en: "All Vehicles", ar: "جميع المركبات" },
	{ id: "/100 ", en: "/100 ", ar: "البيانات" },
	{ id: "Group Name", en: "Group Name", ar: "اسم المجموعة" },
	{ id: "Settings", en: "Settings", ar: "الإعدادت" },
	{ id: "has exceeded", en: "has exceeded", ar: "تجاوز" },
	{ id: "the speed limit", en: "the speed limit", ar: "الحد الأقصى للسرعة" },
	{ id: "with speed", en: "with speed", ar: "بسرعة" },
	{ id: "in geofence", en: "in geofence", ar: "في السياج" },
	{ id: "has exited geofence", en: "has exited geofence", ar: "خرج من السياج" },
	{ id: "at", en: "at", ar: "عند" },
	{
		id: "has entered geofence",
		en: "has entered geofence",
		ar: "دخل إلى السياج",
	},
	{
		id: "has entered an unknown state",
		en: "has entered an unknown state",
		ar: "دخل في حالة غير معروفة",
	},
	{ id: "is back online at", en: "is back online at", ar: "متصل مرة أخرى عند" },
	{
		id: "is back offline at",
		en: "is back offline at",
		ar: "غير متصل مرة أخرى عند",
	},
	{ id: "started moving at", en: "started moving at", ar: "بدأ التحرك عند" },
	{ id: "stopped at", en: "stopped at", ar: "توقف عند" },
	{
		id: "turned ignition ON at",
		en: "turned ignition ON at",
		ar: "تم تشغيل الإشعال عند",
	},
	{
		id: "turned ignition OFF at",
		en: "turned ignition OFF at",
		ar: "تم إيقاف الإشعال عند",
	},
	{
		id: "has a maintenance alert at",
		en: "has a maintenance alert at",
		ar: "لديه تنبيه صيانة عند",
	},
	{ id: "was idle for", en: "was idle for", ar: "كان خاملاً لمدة" },
	{ id: "mins", en: "mins", ar: "دقيقة" },
	{ id: "Oceania", en: "Oceania", ar: "أوقيانوسيا" },
	{ id: "Australia", en: "Australia", ar: "أستراليا" },
	{ id: "Select Date", en: "Select Date", ar: "أختر تاريخ" },
	{ id: "Expiration", en: "Expiration", ar: "الصلاحية" },
	{ id: "Expired", en: "Expired", ar: "منتهي الصلاحية" },
	{ id: "Active", en: "Active", ar: "نشط" },
	{ id: "Fuel Price", en: "Fuel Price", ar: "سعر الوقود" },
	{ id: "license expire", en: "license expire", ar: "صلاحية الرخصة" },
	{ id: "linked users", en: "linked users", ar: "المستخدمين المتصلين" },
	{ id: "days left", en: "days left", ar: "أيام متبقية" },
	{ id: "All Vehicles", en: "All Vehicles", ar: "جميع المركبات" },
	{ id: "/100 ", en: "/100 ", ar: "البيانات" },
	{ id: "Group Name", en: "Group Name", ar: "اسم المجموعة" },
	{
		id: "Loading, please wait...",
		en: "Loading, please wait...",
		ar: "جاري التحميل، الرجاء الانتظار...",
	},
	{ id: "Group", en: "Group", ar: "المجموعة" },
	{ id: "Edit", en: "Edit", ar: "تعديل" },
	{ id: "Connections", en: "Connections", ar: "الاتصالات" },
	{ id: "Quick Login", en: "Quick Login", ar: "تسجيل الدخول" },
	{
		id: "exceeded last month",
		en: "exceeded last month",
		ar: "تجاوز الشهر الماضي",
	},
	{
		id: "saved / to last month",
		en: "saved / to last month",
		ar: "اقل من الشهر الماضي",
	},
	{
		id: "more than last month",
		en: "more than last month",
		ar: "أكثر من الشهر الماضي",
	},
	{
		id: "less than last month",
		en: "less than last month",
		ar: "أقل من الشهر الماضي",
	},
	{ id: "SAR", en: "SAR", ar: "ريال" },
	{ id: "groups", en: "groups", ar: "المجموعات" },
	{ id: "all", en: "all", ar: "الجميع" },
	{ id: "fleetmanagement", en: "fleetmanagement", ar: "إدارة الأسطول" },
	{ id: "users&roles", en: "users&roles", ar: "المستخدمين و الصلاحيات" },
	{ id: "Vehicle Status", en: "Vehicle Status", ar: "حالة السيارات" },
	{
		id: "Number of Total Vehicles",
		en: "Number of Total Vehicles",
		ar: "عدد المركبات الإجمالي",
	},
	{ id: "Linked Groups", en: "Linked Groups", ar: "المجموعة المتربطة" },
	{ id: "Live Stream", en: "Live Stream", ar: "البث المباشر" },
	{ id: "Surveillance", en: "Surveillance", ar: "المراقبة" },
	{ id: "ltr", en: "ltr", ar: "لتر" },
	{
		id: "Speed unit is required",
		en: "Speed unit is required",
		ar: "وحدة قياس السرعة مطلوبة",
	},
	{
		id: "Volume unit is required",
		en: "Volume unit is required",
		ar: "وحدة قياس الكمية مطلوبة",
	},
	{
		id: "Distance unit is required",
		en: "Distance unit is required",
		ar: "وحدة قياس المسافة مطلوبة",
	},
	{
		id: "Altitude unit is required",
		en: "Altitude unit is required",
		ar: "وحدة قياس الارتفاع مطلوبة",
	},
	{ id: "Available Groups", en: "Available Groups", ar: "المجموعات المتاحة" },
	{ id: "Acc", en: "Acc", ar: "الدقة" },
	{
		id: "Ungrouped Vehicles",
		en: "Ungrouped Vehicles",
		ar: "المركبات الغير مصنفة",
	},
	{
		id: "User Limit must be a whole number",
		en: "User Limit must be a whole number",
		ar: "يجب أن يكون حد المستخدم عددًا صحيحًا",
	},
	{
		id: "Vehicles Limit must be a whole number",
		en: "Vehicles Limit must be a whole number",
		ar: "يجب أن يكون حد المركبات عددًا صحيحًا",
	},
	{
		id: "Vehicles Limit is required",
		en: "Vehicles Limit is required",
		ar: "حد المركبات مطلوب",
	},
	{
		id: "User Limit is required",
		en: "User Limit is required",
		ar: "حد المستخدمين مطلوب",
	},
	{
		id: "User expiration date is required",
		en: "User expiration date is required",
		ar: "تاريخ انتهاء صلاحية المستخدم مطلوب",
	},
	{ id: "Fleet Observer", en: "Fleet Observer", ar: "مراقب الأسطول" },
	{ id: "Fleet Operator", en: "Fleet Operator", ar: "مشغل الأسطول" },
	{ id: "Manager", en: "Manager", ar: "المدير" },
	{
		id: "ordinary user with a restriction on vehicle manipulation",
		en: "ordinary user with a restriction on vehicle manipulation",
		ar: "مستخدم عادي ليس له الصلاحية بالتعديل علي المركبات",
	},
	{
		id: "a user that cannot add/edit/remove anything in the system. They can only monitor their assigned objects.",
		en: "a user that cannot add/edit/remove anything in the system. They can only monitor their assigned objects.",
		ar: "مستخدم لا يمكنه إضافة/تعديل/إزالة أي شيء في النظام. يمكنه فقط مراقبة العناصر المُخصصة له.",
	},
	{ id: "Mark all as read", en: "Mark all as read", ar: "قراءة الكل" },
	{ id: "all", en: "all", ar: "الكل" },
	{ id: "unread", en: "unread", ar: "غير مقروء" },
	{
		id: "Device Behavior Report",
		en: "Device Behavior Report",
		ar: "تقرير الفني للجهاز",
	},
	{
		id: "Increase in alerts compared to yesterday",
		en: "Increase in alerts compared to yesterday",
		ar: "زيادة في التنبيهات مقارنة بالأمس",
	},
	{
		id: "Decrease in alerts compared to yesterday",
		en: "Decrease in alerts compared to yesterday",
		ar: "انخفاض في التنبيهات مقارنة بالأمس",
	},
	{ id: "today", en: "today", ar: "اليوم" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Playback", en: "Playback", ar: "السجل" },
	{ id: "Media", en: "Media", ar: "المشغل" },
	{ id: "Vehicle Movement", en: "Vehicle Movement", ar: "تحركات المركبة" },
	{ id: "running", en: "Moving", ar: "نشيط" },
	{ id: "stopped", en: "Parking", ar: "متوقف" },
	{ id: "gpsNotUpdated", en: "GPS Not Updated", ar: "الموقع غير محدث" },
	{ id: "facility-management", en: "facility-management", ar: "إدارة المرافق" },
	{ id: "technicians", en: "field staff", ar: "المندوبين" },
	{ id: "Add new technician", en: "Add new field staff", ar: "إضافة مندوب جديد" },
	{ id: "Employee Code", en: "Employee Code", ar: "كود المندوب" },
	{ id: "department", en: "department", ar: "القسم" },
	{ id: "work location", en: "Work Location", ar: "مكان العمل" },
	{ id: "On Call", en: "On Call", ar: "عند الطلب" },
	{ id: "Supervisor", en: "Supervisor", ar: "المشرف" },
	{
		id: "Basic Information",
		en: "Basic Information",
		ar: "المعلومات الاساسية",
	},
	{ id: "Work Information", en: "Work Information", ar: "معلومات العمل" },
	{ id: "Job Title", en: "Job Title", ar: "مسمى وظيفي" },
	{ id: "Not specified", en: "Not specified", ar: "غير محدد" },
	{ id: "Specialization", en: "Specialization", ar: "التخصص" },
	{ id: "On Call Status", en: "On Call Status", ar: "متاح عند الطلب" },
	{ id: "Device Assignment", en: "Device Assignment", ar: "اسناد الجهاز" },
	{
		id: "Device Assignment Option",
		en: "Device Assignment Option",
		ar: "خيار اسناد الجهاز",
	},
	{
		id: "Assign Existing Device",
		en: "Assign Existing Device",
		ar: "إسناد جهاز موجود",
	},
	{
		id: "Register New Hardware",
		en: "Register New Hardware",
		ar: "تسجيل جهاز جديد",
	},
	{
		id: "Enable Mobile App",
		en: "Enable Mobile App",
		ar: "تفعيل تطبيق الجوال",
	},
	{ id: "No Device", en: "No Device", ar: "بدون جهاز" },

	{ id: "Personal Tracker", en: "Personal Tracker", ar: "جهاز تتبع شخصي" },
	{
		id: "Wearable Tracker",
		en: "Wearable Tracker",
		ar: "جهاز تتبع قابل للارتداء",
	},
	{ id: "Handheld GPS", en: "Handheld GPS", ar: "جهاز تحديد مواقع محمول" },
	{ id: "Safety Beacon", en: "Safety Beacon", ar: "جهاز إنذار أمني" },
	{ id: "Asset Tag", en: "Asset Tag", ar: "جهاز تتبع الأصول" },
	{ id: "Mobile", en: "Mobile", ar: "الجوال" },
	{ id: "Tablet", en: "Tablet", ar: "تابلت" },
	{
		id: "Mobile app access will be enabled for this technician. They will receive registration details after account creation.",
		en: "Mobile app access will be enabled for this technician. They will receive registration details after account creation.",
		ar: "سيتم تفعيل الوصول إلى تطبيق الجوال لهذا العامل، وسيتلقى تفاصيل التسجيل بعد إنشاء الحساب.",
	},
	{
		id: "No device will be assigned to this technician. Device assignment can be done later if needed.",
		en: "No device will be assigned to this technician. Device assignment can be done later if needed.",
		ar: "لن يتم إسناد أي جهاز لهذا العامل، ويمكن إجراء إسناد الجهاز لاحقًا عند الحاجة.",
	},
	{ id: "Available Devices", en: "Available Devices", ar: "الأجهزة المتاحة" },

	{ id: "Device Summary:", en: "Device Summary:", ar: "ملخص الأجهزة:" },
	{
		id: "Filtered Devices:",
		en: "Filtered Devices:",
		ar: "الأجهزة بعد التصفية:",
	},
	{
		id: "Compatible Devices:",
		en: "Compatible Devices:",
		ar: "الأجهزة المتوافقة:",
	},
	{ id: "Total Access:", en: "Total Access:", ar: "إجمالي الأجهزة المتاحة:" },
	{
		id: "Currently Assigned:",
		en: "Currently Assigned:",
		ar: "الأجهزة المسندة حالياً:",
	},
	{
		id: "Active Filters:",
		en: "Active Filters:",
		ar: "عوامل التصفية المختارة:",
	},
	{ id: "Hardware Types", en: "Hardware Types", ar: "أنواع الأجهزة" },
	{ id: "Search", en: "Search", ar: "بحث" },
	{
		id: "Filter by Hardware Type",
		en: "Filter by Hardware Type",
		ar: "تصفية حسب نوع الجهاز",
	},
	{
		id: "Assignment Reason",
		en: "Assignment Reason",
		ar: "سبب الإسناد",
	},
	{
		id: "Enter reason for assignment",
		en: "Enter reason for assignment",
		ar: "أدخل سبب الإسناد",
	},
	{
		id: "Select hardware types to filter",
		en: "Select hardware types to filter",
		ar: "اختر أنواع الأجهزة للتصفية",
	},
	{
		id: "Device ID is required",
		en: "Device ID is required",
		ar: "مطلوب رقم تعريف الجهاز",
	},
	{ id: "Hardware Device Name", en: "Hardware Device Name", ar: "اسم الجهاز" },
	{ id: "Enter device name", en: "Enter device name", ar: "أدخل اسم الجهاز" },
	{
		id: "Hardware Device Unique ID",
		en: "Hardware Device Unique ID",
		ar: "المعرّف المميز للجهاز",
	},
	{
		id: "Enter unique device ID",
		en: "Enter unique device ID",
		ar: "أدخل المعرّف المميز للجهاز",
	},
	{ id: "Hardware Device Type", en: "Hardware Device Type", ar: "نوع الجهاز" },
	{ id: "Select device type", en: "Select device type", ar: "اختر نوع الجهاز" },
	{
		id: "Device unique ID is required",
		en: "Device unique ID is required",
		ar: "المعرّف المميز للجهاز مطلوب",
	},
	{ id: "Enter device name", en: "Enter device name", ar: "أدخل اسم الجهاز" },
	{ id: "Unique ID", en: "Unique ID", ar: "الرقم المميز" },
	{
		id: "No changes will be made to the current device assignment",
		en: "No changes will be made to the current device assignment",
		ar: "لن يتم إجراء أي تغييرات على إسناد الجهاز الحالي",
	},

	{
		id: "Current Device Assignment",
		en: "Current Device Assignment",
		ar: "بيانات الجهاز الحالي",
	},
	{
		id: "Current Device Assignment",
		en: "Current Device Assignment",
		ar: "إسناد الجهاز الحالي",
	},
	{ id: "Assignment Type", en: "Assignment Type", ar: "نوع الإسناد" },
	{ id: "Device Name", en: "Device Name", ar: "اسم الجهاز" },
	{ id: "Device Type", en: "Device Type", ar: "نوع الجهاز" },
	{ id: "Assignment Reason", en: "Assignment Reason", ar: "سبب الإسناد" },
	{
		id: "Device Assignment Option",
		en: "Device Assignment Option",
		ar: "خيار إسناد الجهاز",
	},
	{
		id: "Device Assignment Action",
		en: "Device Assignment Action",
		ar: "إجراء إسناد الجهاز",
	},
	{
		id: "Select device assignment option",
		en: "Select device assignment option",
		ar: "اختر خيار إسناد الجهاز",
	},
	{
		id: "Select device assignment action",
		en: "Select device assignment action",
		ar: "اختر إجراء إسناد الجهاز",
	},

	{
		id: "Keep Current Status",
		en: "Keep Current Status",
		ar: "الإبقاء على الوضع الحالي",
	},
	{
		id: "Change to Existing Device",
		en: "Change to Existing Device",
		ar: "تغيير إلى جهاز حالي",
	},
	{
		id: "Change to New Hardware",
		en: "Change to New Hardware",
		ar: "تغيير إلى جهاز جديد",
	},
	{
		id: "Change to Mobile App",
		en: "Change to Mobile App",
		ar: "تغيير إلى تطبيق الجوال",
	},
	{
		id: "Remove Device Assignment",
		en: "Remove Device Assignment",
		ar: "إلغاء إسناد الجهاز",
	},
	{
		id: "Current device will be replaced with the selected device",
		en: "Current device will be replaced with the selected device",
		ar: "سيتم استبدال الجهاز الحالي بالجهاز المحدد",
	},
	{
		id: "Select an available device",
		en: "Select an available device",
		ar: "اختر جهازاً متاحاً",
	},
	{
		id: "Enter reason for device change",
		en: "Enter reason for device change",
		ar: "أدخل سبب تغيير الجهاز",
	},
	{
		id: "Current assignment will be maintained",
		en: "Current assignment will be maintained",
		ar: "سيتم الإبقاء على الإسناد الحالي",
	},
	{
		id: "No changes will be made to the current device assignment",
		en: "No changes will be made to the current device assignment",
		ar: "لن يتم إجراء أي تغييرات على حالة الجهاز الحالي",
	},
	{
		id: "Current device will be replaced with a new hardware device",
		en: "Current device will be replaced with a new hardware device",
		ar: "سيتم استبدال الجهاز الحالي بجهاز جديد",
	},
	{
		id: "Enter reason for new hardware assignment",
		en: "Enter reason for new hardware assignment",
		ar: "أدخل سبب إسناد جهاز جديد",
	},
	{
		id: "Current device will be replaced with mobile app access",
		en: "Current device will be replaced with mobile app access",
		ar: "سيتم استبدال الجهاز الحالي واتاحة الوصول عبر تطبيق الجوال",
	},
	{
		id: "They will receive registration details after the change is saved",
		en: "They will receive registration details after the change is saved",
		ar: "سيتلقى المستخدم تفاصيل التسجيل بعد حفظ التغيير",
	},
	{
		id: "Device will be unassigned",
		en: "Device will be unassigned",
		ar: "سيتم إلغاء إسناد الجهاز",
	},
	{
		id: "The current device will be removed from this technician and become available for reassignment",
		en: "The current device will be removed from this technician and become available for reassignment",
		ar: "سيتم إزالة الجهاز الحالي من هذا العامل وسيصبح متاحًا لإسناد جديد",
	},
	{
		id: "Unassignment Reason",
		en: "Unassignment Reason",
		ar: "سبب إلغاء الإسناد",
	},
	{
		id: "Enter reason for removing device assignment",
		en: "Enter reason for removing device assignment",
		ar: "أدخل سبب إلغاء إسناد الجهاز",
	},
	{ id: "Change Password", en: "Change Password", ar: "تغيير كلمة المرور" },

	{ id: "Electrical", en: "Electrical", ar: "كهرباء" },
	{ id: "Plumbing", en: "Plumbing", ar: "سباكة" },
	{ id: "HVAC", en: "HVAC", ar: "تدفئة وتهوية وتكييف" },

	{ id: "Skill", en: "Skill", ar: "مهارة" }.ar,

	{
		id: "Schedule Information",
		en: "Schedule Information",
		ar: "معلومات الجدول الزمني",
	},
	{ id: "Shift Start", en: "Shift Start", ar: "بداية وردية" },
	{ id: "Shift End", en: "Shift End", ar: "نهاية وردية" },
	{ id: "Working Days", en: "Working Days", ar: "أيام العمل" },
	{ id: "Breaks", en: "Breaks", ar: "فترات راحة" },
	{ id: "Skills", en: "Skills", ar: "المهارات" },
	{ id: "Documents", en: "Documents", ar: "المرفقات" },
	{ id: "National ID", en: "National ID", ar: "الهوية الوطنية" },
	{ id: "Add Skill", en: "Add Skill", ar: "إضافة مهارة" },
	{ id: "Skill", en: "Skill", ar: "المهارة" },
	{ id: "Skill Level", en: "Skill Level", ar: "مستوى المهارة" },
	{ id: "Enter skill name", en: "Enter skill name", ar: "أدخل اسم المهارة" },
	{
		id: "Select Skill Level",
		en: "Select Skill Level",
		ar: "حدد مستوى المهارة",
	},

	{ id: "Full Time", en: "Full Time", ar: "دوام كامل" },
	{ id: "Part Time", en: "Part Time", ar: "دوام جزئي" },
	{ id: "Outsourced", en: "Outsourced", ar: "مقاول خارجي" },
	{
		id: "A new hardware device will be registered and assigned",
		en: "A new hardware device will be registered and assigned",
		ar: "سيتم تسجيل جهاز جديد وإسناده",
	},
	{
		id: "Contract Information",
		en: "Contract Information",
		ar: "معلومات العقد",
	},
	{ id: "Contract Start", en: "Contract Start", ar: "بداية العقد" },
	{ id: "Visa Expiry", en: "Visa Expiry", ar: "انتهاء صلاحية التأشيرة" },
	{ id: "Contract End", en: "Contract End", ar: "نهاية العقد" },
	{ id: "Device Information", en: "Device Information", ar: "معلومات الجهاز" },
	{ id: "Assignment Option", en: "Assignment Option", ar: "خيار الإسناد" },
	{ id: "Hardware Device", en: "Hardware Device", ar: "الجهاز المسند" },
	{ id: "Device Status", en: "Device Status", ar: "حالة الجهاز" },
	{
		id: "PENDING HARDWARE_CONFIG",
		en: "PENDING HARDWARE_CONFIG",
		ar: "في انتظار ضبط الجهاز",
	},

	{ id: "Restrict Location", en: "Restrict Location", ar: "تقييد الموقع" },
	{
		id: "Task will only started in its location. Requires both a POI location and assigned user to function properly.",
		en: "Task will only started in its location. Requires both a POI location and assigned user to function properly.",
		ar: "ستبدأ المهمة فقط في موقعها المحدد. يتطلب كل من موقع POI والمستخدم المعين لتعمل بشكل صحيح.",
	},
	{ id: "ON", en: "ON", ar: "تشغيل" },
	{ id: "OFF", en: "OFF", ar: "إيقاف" },
	{
		id: "Location tracking enabled",
		en: "Location tracking enabled",
		ar: "تم تفعيل تتبع الموقع",
	},
	{
		id: "Location tracking disabled",
		en: "Location tracking disabled",
		ar: "تم تعطيل تتبع الموقع",
	},
	{
		id: "Please assign a user and select a POI to enable location tracking",
		en: "Please assign a user and select a POI to enable location tracking",
		ar: "يرجى تعيين مستخدم وتحديد POI لتمكين تتبع الموقع",
	},
	{
		id: "The assigned user will be required to check in at the specified location",
		en: "The assigned user will be required to check in at the specified location",
		ar: "سيُطلب من المستخدم المعين تسجيل الوصول في الموقع المحدد",
	},
	{
		id: "No Device Assignment",
		en: "No Device Assignment",
		ar: "لا يوجد إسناد للجهاز",
	},
	{
		id: "This technician currently has no device assigned. You can assign a device using the options below if needed.",
		en: "This field currently has no device assigned. You can assign a device using the options below if needed.",
		ar: "لا يوجد جهاز مُعين حاليًا لهذا المندوب. يمكنك إسناد جهاز باستخدام الخيارات أدناه إذا لزم الأمر.",
	},
	{ id: "no_device", en: "no_device", ar: "بدون جهاز" },

	{
		id: "Describe this skill",
		en: "Describe this skill",
		ar: "وصف هذه المهارة",
	},
	{ id: "Technician Details", en: "Field Staff Details", ar: "تفاصيل المندوب" },
	{ id: "Job Info", en: "Job Info", ar: "معلومات الوظيفة" },
	{ id: "System Access", en: "System Access", ar: "إعداد الحساب" },
	{
		id: "Select specialization",
		en: "Select specialization",
		ar: "اختر التخصص",
	},
	{ id: "Phone is Required", en: "Phone is Required", ar: "رقم الهاتف مطلوب" },
	{
		id: "National ID is Required",
		en: "National ID is Required",
		ar: "البيانات",
	},
	{
		id: "Employee Code is Required",
		en: "Employee Code is Required",
		ar: "مطلوب رمز المندوب",
	},
	{
		id: "Specialization is Required",
		en: "Specialization is Required",
		ar: "التخصص مطلوب",
	},
	{
		id: "Skill is required",
		en: "Skill is required",
		ar: "اسم المهارة مطلوبة",
	},
	{
		id: "Skill level is required",
		en: "Skill level is required",
		ar: "مستوى المهارة مطلوب",
	},
	{
		id: "Break start is required",
		en: "Break start is required",
		ar: "موعد بداية الاستراحة مطلوبة",
	},
	{
		id: "Break end is required",
		en: "Break end is required",
		ar: "موعد نهاية الاستراحة مطلوبة",
	},
	{
		id: "Supervisor is Required",
		en: "Supervisor is Required",
		ar: "يجب اختيار مشرف",
	},
	{
		id: "Shift Start time is required",
		en: "Shift Start time is required",
		ar: "موعد بداية الوردية مطلوب",
	},
	{
		id: "Shift End time is required",
		en: "Shift End time is required",
		ar: "موعد نهاية الوردية مطلوب",
	},
	{
		id: "Select at least 1 day",
		en: "Select at least 1 day",
		ar: "حدد يومًا واحدًا على الأقل",
	},
	{
		id: "Email is required in technician details",
		en: "Email is required in Field Staff details",
		ar: "البريد الإلكتروني مطلوب في تفاصيل المندوب",
	},
	{ id: "Role is required", en: "Role is required", ar: "يجب اختيار الصلاحية" },
	{
		id: "Password is required",
		en: "Password is required",
		ar: "كلمة المرور مطلوبة",
	},
	{
		id: "email must be a valid email",
		en: "email must be a valid email",
		ar: "يجب أن يكون البريد الإلكتروني صالحًا",
	},
	{ id: "Ex. Maintenance", en: "Ex. Maintenance", ar: "مثال: الصيانة" },
	{ id: "Ex. Electrician", en: "Ex. Electrician", ar: "مثال: كهربائي" },
	{
		id: "Select Work Location",
		en: "Select Work Location",
		ar: "اختار مكان العمل",
	},
	{ id: "Select Supervisor", en: "Select Supervisor", ar: "اختار مشرف" },
	{
		id: "Contract Start / End",
		en: "Contract Start / End",
		ar: "بداية / نهاية العقد",
	},
	{ id: "Contract Type", en: "Contract Type", ar: "نوع العقد" },
	{
		id: "Select Contract Type",
		en: "Select Contract Type",
		ar: "اختار نوع العقد",
	},
	{ id: "Select days", en: "Select days", ar: "حدد ايام العمل" },
	{
		id: "Visa expiry date",
		en: "Visa expiry date",
		ar: "تاريخ انتهاء صلاحية التأشيرة",
	},
	{ id: "Add Break", en: "Add Break", ar: "إضافة استراحة" },
	{ id: "Break start", en: "Break start", ar: "موعد بداية الاستراحة" },
	{ id: "Break end", en: "Break end", ar: "موعد نهاية الاستراحة" },
	{ id: "Select Time", en: "Select Time", ar: "اختار الموعد" },
	{
		id: "Upload hiring document",
		en: "Upload hiring document",
		ar: "تحميل مستندات التوظيف",
	},
	{ id: "Sunday", en: "Sunday", ar: "الأحد" },
	{ id: "Monday", en: "Monday", ar: "الاثنين" },
	{ id: "Tuesday", en: "Tuesday", ar: "الثلاثاء" },
	{ id: "Wednesday", en: "Wednesday", ar: "الأربعاء" },
	{ id: "Thursday", en: "Thursday", ar: "الخميس" },
	{ id: "Friday", en: "Friday", ar: "جمعة" },
	{ id: "Saturday", en: "Saturday", ar: "السبت" },
	{ id: "Technician", en: "Field Staff", ar: "مندوب" },
	{
		id: "Generate Random Password",
		en: "Generate Random Password",
		ar: "إنشاء كلمة مرور عشوائية",
	},
	{ id: "technician", en: "Field Staff", ar: "المندوب" },
	{ id: "Saving...", en: "Saving...", ar: "جاري الحفظ" },
	{
		id: "Technician created successfully",
		en: "Field Staff created successfully",
		ar: "تم إنشاء المندوب بنجاح",
	},
	{
		id: "Technician edited successfully",
		en: "Field Staff edited successfully",
		ar: "تم تعديل المندوب بنجاح",
	},
	{ id: "Something went wrong", en: "Something went wrong", ar: "حدث خطأ" },
	{
		id: "cannot start with a space",
		en: "cannot start with a space",
		ar: "لا يمكن البدء بمسافة",
	},
	{
		id: "Contract Type is Required",
		en: "Contract Type is Required",
		ar: "نوع العقد مطلوب",
	},
	{ id: "Edit technician", en: "Edit Field Staff", ar: "تعديل مندوب" },
	{
		id: "Password must be at least 8 characters",
		en: "Password must be at least 8 characters",
		ar: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
	},
	{
		id: "is already uploaded",
		en: "is already uploaded",
		ar: "تم تحميله بالفعل",
	},
	{ id: "is larger than", en: "is larger than", ar: "أكبر من" },
	{
		id: "Work Location is Required",
		en: "Work Location is Required",
		ar: "مكان العمل مطلوب",
	},
	{ id: "Refresh", en: "Refresh", ar: "تحديث" },
	{ id: "Add new task", en: "Add new task", ar: "اضافة مهمة جديدة" },
	{ id: "Kanban", en: "Kanban", ar: "كانبان" },
	{ id: "List", en: "List", ar: "قائمة" },
	{
		id: "tasks-board",
		en: "Field Task Management",
		ar: "إدارة المهام الميدانية",
	},
	{ id: "Unassigned", en: "Unassigned", ar: "غير مسنودة" },
	{ id: "TODO", en: "TODO", ar: "المهام القادمة" },
	{ id: "In Progress", en: "In Progress", ar: "قيد التنفيذ" },
	{ id: "Done", en: "Done", ar: "مكتملة" },
	{ id: "Delayed", en: "Delayed", ar: "متأخرة" },
	{ id: "View task", en: "View task", ar: "عرض المهمة" },
	{ id: "Edit task", en: "Edit task", ar: "تعديل المهمة" },
	{ id: "Delete Task", en: "Delete Task", ar: "حذف المهمة" },
	{ id: "high", en: "high", ar: "قصوي" },
	{ id: "medium", en: "medium", ar: "متوسطة" },
	{ id: "low", en: "low", ar: "منخفضة" },
	{ id: "Task Name", en: "Task Name", ar: "اسم المهمة" },
	{ id: "Assign to", en: "Assign to", ar: "مسنودة الي" },
	{ id: "Priority", en: "Priority", ar: "الأولوية" },
	{
		id: "Duration (minutes)",
		en: "Duration (minutes)",
		ar: "المدة (بالدقائق)",
	},
	{
		id: "Select field staff",
		en: "Select field staff",
		ar: "اختيار المندوبين",
	},
	{ id: "Select Priority", en: "Select Priority", ar: "حدد الأولوية" },
	{ id: "Ex. Task-001", en: "Ex. Task-001", ar: "مثال: المهمة الاولي" },
	{ id: "POI", en: "POI", ar: "نقطة مهمة" },
	{ id: "Assign Form", en: "Assign Form", ar: "النماذج المسنودة" },
	{ id: "Select Forms", en: "Select Forms", ar: "حدد النماذج" },
	{ id: "Notes", en: "Notes", ar: "ملحوظات" },
	{
		id: "Add additional task details...",
		en: "Add additional task details...",
		ar: "إضافة تفاصيل إضافية للمهمة...",
	},
	{ id: "custom attributes", en: "custom attributes", ar: "السمات المخصصة" },
	{ id: "optional", en: "optional", ar: "اختياري" },
	{ id: "Attribute", en: "Attribute", ar: "السمة" },
	{ id: "value", en: "value", ar: "القيمة" },
	{ id: "Boolean", en: "Boolean", ar: "منطقي" },
	{ id: "Text", en: "Text", ar: "نص" },
	{ id: "Number", en: "Number", ar: "رقم" },
	{ id: "Add", en: "Add", ar: "اضافة" },
	{ id: "Enter value", en: "Enter value", ar: "أدخل القيمة" },
	{
		id: "Enter attribute value",
		en: "Enter attribute value",
		ar: "أدخل قيمة السمة",
	},
	{ id: "General", en: "General", ar: "عام" },
	{ id: "Location & POI", en: "Location & POI", ar: "الموقع ونقطة الاهتمام" },
	{ id: "Linked Forms", en: "Linked Forms", ar: "النماذج المرتبطة" },
	{ id: "History", en: "History", ar: "السجل" },
	{ id: "Created At", en: "Created At", ar: "تاريخ الانشاء" },
	{ id: "Created By", en: "Created By", ar: "تم الإنشاء بواسطة" },
	{ id: "Last Modified At", en: "Last Modified At", ar: "تاريخ آخر تعديل" },
	{ id: "Assigned Field Staff", en: "Assigned Field Staff", ar: "مسندة الي" },
	{ id: "POI Name", en: "POI Name", ar: "اسم نقطة الاهتمام" },
	{ id: "POI Location", en: "POI Address", ar: "عنوان نقطة الاهتمام" },
	{
		id: "Schedule & Progress",
		en: "Schedule & Progress",
		ar: "الجدول الزمني والتقدم",
	},
	{
		id: "Point of Interest (POI)",
		en: "Point of Interest (POI)",
		ar: "نقطة الاهتمام",
	},
	{
		id: "POI Preview + Geofence",
		en: "POI Preview + Geofence",
		ar: "معاينة نقطة الاهتمام + السياج الجغرافي",
	},
	{ id: "Forms Progress", en: "Forms Progress", ar: "تقدم النماذج" },
	{ id: "completed", en: "completed", ar: "مكتمل" },
	{ id: "View Details", en: "View Details", ar: "عرض التفاصيل" },
	{
		id: "Task History Details",
		en: "Task History Details",
		ar: "تفاصيل سجل المهام",
	},
	{ id: "System", en: "System", ar: "النظام" },
	{
		id: "Task transfered from",
		en: "Task transfered from",
		ar: "تم نقل المهمة من",
	},
	{ id: "todo", en: "todo", ar: "المهام القادمة" },
	{ id: "unassigned", en: "unassigned", ar: "غير مسنودة" },
	{ id: "inProgress", en: "inProgress", ar: "قيد التنفيذ" },
	{ id: "done", en: "done", ar: "مكتملة" },
	{ id: "delayed", en: "delayed", ar: "مأجلة" },
	{ id: "Expected Duration", en: "Expected Duration", ar: "المدة المتوقعة" },
	{
		id: "Expected Completion",
		en: "Expected Completion",
		ar: "تاريخ الانتهاء المتوقع",
	},
	{ id: "Started At", en: "Started At", ar: "بدأت في" },
	{ id: "Completed At", en: "Completed At", ar: "تم الانتهاء منه في" },
	{ id: "Completed In", en: "Completed In", ar: "المدة المستغرقة" },
	{ id: "Assigned To", en: "Assigned To", ar: "مسندة الي" },
	{ id: "Reassign", en: "Reassign", ar: "إعادة التعيين" },
	{ id: "unAssigned", en: "unAssigned", ar: "غير مسنودة" },
	{ id: "country", en: "country", ar: "الدولة" },
	{ id: "city", en: "city", ar: "المدينة" },
	{ id: "state", en: "state", ar: "ولاية" },
	{ id: "Attributes Preview", en: "Attributes Preview", ar: "معاينة السمات" },
	{
		id: "Task Name is required",
		en: "Task Name is required",
		ar: "اسم المهمة مطلوب",
	},
	{
		id: "Task Name cannot exceed 128 characters",
		en: "Task Name cannot exceed 128 characters",
		ar: "لا يمكن أن يتجاوز اسم المهمة 128 حرفًا",
	},
	{
		id: "Task type is required",
		en: "Task type is required",
		ar: "نوع المهمة مطلوب",
	},
	{
		id: "Priority is required",
		en: "Priority is required",
		ar: "الأولوية مطلوبة",
	},
	{
		id: "Duration must be a number",
		en: "Duration must be a number",
		ar: "يجب أن تكون المدة رقمًا",
	},
	{
		id: "Duration is required",
		en: "Duration is required",
		ar: "المدة المطلوبة",
	},
	{
		id: "Duration must be a positive number",
		en: "Duration must be a positive number",
		ar: "يجب أن تكون المدة عددًا موجبًا",
	},
	{
		id: "Start time must be a valid date",
		en: "Start time must be a valid date",
		ar: "يجب أن يكون وقت البدء تاريخًا صالحًا",
	},
	{
		id: "Start time is required",
		en: "Start time is required",
		ar: "مطلوب وقت البدء",
	},
	{ id: "to", en: "to", ar: "الي" },
	{
		id: "The forms flow follows the same arrangement of choosing forms. Make sure you are entering them in the correct order.",
		en: "The forms flow follows the same arrangement of choosing forms. Make sure you are entering them in the correct order.",
		ar: "يتبع تدفق النماذج نفس ترتيب اختيار النماذج. تأكد من إدخالها بالترتيب الصحيح.",
	},
	{
		id: "Task created successfully",
		en: "Task created successfully",
		ar: "تم انشاء المهمة بنجاح",
	},
	{
		id: "Task edited successfully",
		en: "Task edited successfully",
		ar: "تم تعديل المهمة بنجاح",
	},
	{
		id: "Task Deleted Successfully",
		en: "Task Deleted Successfully",
		ar: "تم حذف المهمة بنجاح",
	},
	{ id: "reschedule", en: "Reschedule", ar: "إعادة الجدولة" },
	{ id: "inspection", en: "Inspection", ar: "فحص" },
	{ id: "delivery", en: "Delivery", ar: "توصيل" },
	{ id: "survey", en: "Survey", ar: "استطلاع" },
	{ id: "maintenance", en: "Maintenance", ar: "صيانة" },
	{ id: "other", en: "Other", ar: "آخر" },
	{ id: "Select Task Type", en: "Select Task Type", ar: "حدد نوع المهمة" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{ id: "Data", en: "Data", ar: "البيانات" },
	{
		id: "deviceMoving",
		en: "deviceMoving",
		ar: "تحرك المركبة",
	},
	{
		id: "ignitionOn",
		en: "ignitionOn",
		ar: "تشغيل الأشعال",
	},
	{
		id: "ignitionOff",
		en: "ignitionOff",
		ar: "إيقاف الأشعال",
	},
	{
		id: "deviceStopped",
		en: "deviceStopped",
		ar: "توقف المركبة",
	},
	{
		id: "deviceOverSpeed",
		en: "deviceOverSpeed",
		ar: "اجتياز السرعة المحددة",
	},
	{
		id: "Maintenance",
		en: "Maintenance",
		ar: "الصيانات",
	},
	{
		id: "Maintenance",
		en: "Maintenance",
		ar: "الصيانات",
	},
	{
		id: "Maintenance Schedules",
		en: "Maintenance Schedules",
		ar: "جدول الصيانات",
	},
	{
		id: "Regular Maintenance",
		en: "Regular Maintenance",
		ar: "الصيانات المنتظمة",
	},
	{
		id: "Work Orders",
		en: "Work Orders",
		ar: "أوامر العمل",
	},
	{
		id: "No Data Found",
		en: "No Data Found",
		ar: "لا توجد بيانات",
	},
	{
		id: "Error fetching data",
		en: "Error fetching data",
		ar: "خطأ في تحميل البيانات",
	},
	{
		id: "currency",
		en: "currency",
		ar: "العملة",
	},
	{
		id: "timezone",
		en: "timezone",
		ar: "المنطقة الزمنية",
	},
	/* POIS */
	{
		id: "timezone",
		en: "timezone",
		ar: "المنطقة الزمنية",
	},
	{
		id: "timezone",
		en: "timezone",
		ar: "المنطقة الزمنية",
	},
	{
		id: "POI Name",
		en: "POI Name",
		ar: "اسم نقطة مهمة",
	},
	{
		id: "Status",
		en: "Status",
		ar: "الحالة",
	},
	{
		id: "Country",
		en: "Country",
		ar: "الدولة",
	},
	{
		id: "City",
		en: "City",
		ar: "المدينة",
	},
	{
		id: "State",
		en: "State",
		ar: "الولاية",
	},
	{
		id: "Zone",
		en: "Zone",
		ar: "المدينة",
	},
	{
		id: "Map",
		en: "Map",
		ar: "الخريطة",
	},
	{
		id: "List",
		en: "List",
		ar: "الجدول",
	},
	{
		id: "Geofenced",
		en: "Geofenced",
		ar: "السياج الجغرافي",
	},
	{
		id: "Created At",
		en: "Created At",
		ar: "تم إنشاؤها في",
	},
	{
		id: "Point-Of-Interest",
		en: "Point-Of-Interest",
		ar: "نقطة مهمة",
	},
	{
		id: "Add new POI",
		en: "Add new POI",
		ar: "إضافة نقطة مهمة جديدة",
	},
	{
		id: "Edit POI",
		en: "Edit POI",
		ar: "تعديل نقطة مهمة",
	},
	{
		id: "information",
		en: "information",
		ar: "المعلومات",
	},
	{
		id: "general information",
		en: "general information",
		ar: "المعلومات العامة",
	},
	{
		id: "type",
		en: "type",
		ar: "النوع",
	},
	{
		id: "Notes or Special Instructions",
		en: "Notes or Special Instructions",
		ar: "ملاحظات أو تعليمات هامة",
	},
	{
		id: "Enter POI name",
		en: "Enter POI name",
		ar: "أدخل اسم نقطة مهمة",
	},
	{
		id: "Select Type",
		en: "Select Type",
		ar: "أختر النوع",
	},
	{
		id: "Enter notes or special instructions",
		en: "Enter notes or special instructions",
		ar: "أدخل الملاحظات أو التعليمات الهامة",
	},
	{
		id: "location setup",
		en: "location setup",
		ar: "إعداد الموقع",
	},
	{
		id: "contact",
		en: "contact",
		ar: "الاتصال",
	},
	{
		id: "extra",
		en: "extra",
		ar: "إضافات",
	},
	{
		id: "Inactive",
		en: "Inactive",
		ar: "غير نشط",
	},
	{
		id: "supermarket",
		en: "supermarket",
		ar: "سوبر ماركت",
	},
	{
		id: "Shopping Area",
		en: "Shopping Area",
		ar: "صالة",
	},
	{
		id: "hospital",
		en: "hospital",
		ar: "مستشفي",
	},
	{
		id: "checkpoint",
		en: "checkpoint",
		ar: "نقطة تفتيش",
	},
	{
		id: "worksite",
		en: "worksite",
		ar: "موقع عمل",
	},
	{
		id: "Region/Zone/Territory",
		en: "Region/Zone/Territory",
		ar: "المنطقة/الإقليم",
	},
	{
		id: "location selection",
		en: "location selection",
		ar: "اختيار الموقع",
	},
	{
		id: "Select Country",
		en: "Select Country",
		ar: "أختر الدولة",
	},
	{
		id: "Select City",
		en: "Select City",
		ar: "أختر المدينة",
	},
	{
		id: "Select State",
		en: "Select State",
		ar: "أختر الولاية",
	},
	{
		id: "Enter Latitude",
		en: "Enter Latitude",
		ar: "أدخل خط العرض",
	},
	{
		id: "Enter Longitude",
		en: "Enter Longitude",
		ar: "أدخل خط الطول",
	},
	{
		id: "geofencing configuration",
		en: "geofencing configuration",
		ar: "إعداد السياج الجغرافي",
	},
	{
		id: "enable geofence",
		en: "enable geofence",
		ar: "تمكين السياج الجغرافي",
	},
	{
		id: "Automatically detect when field staff enter or exit this POI area",
		en: "Automatically detect when field staff enter or exit this POI area",
		ar: "الكشف تلقائيًا عن وقت دخول أو خروج المندوبين من منطقة نقطة مهمة هذه",
	},
	{
		id: "Distance (meters)",
		en: "Distance (meters)",
		ar: "المسافة (متر)",
	},

	{
		id: "Enter distance",
		en: "Enter distance",
		ar: "أدخل المسافة",
	},
	{
		id: "Field staff with mobile apps will automatically log attendance and trigger task updates when entering or exiting.",
		en: "Field staff with mobile apps will automatically log attendance and trigger task updates when entering or exiting.",
		ar: "سيقوم موظفو الميدان الذين يستخدمون تطبيقات الهاتف المحمول بتسجيل الحضور تلقائيًا وتشغيل تحديثات المهام عند الدخول أو الخروج.",
	},
	{
		id: "Min 50m - Max 1000m",
		en: "Min 50m - Max 1000m",
		ar: "الحد الأدنى 50 مترًا - الحد الأقصى 1000 متر",
	},
	{
		id: "Interactive map for location selection",
		en: "Interactive map for location selection",
		ar: "خريطة تفاعلية لاختيار الموقع",
	},
	{
		id: "Address of the selected location",
		en: "Address of the selected location",
		ar: "عنوان الموقع المحدد",
	},
	{
		id: "contact info",
		en: "contact info",
		ar: "معلومات الاتصال",
	},
	{
		id: "optional",
		en: "optional",
		ar: "أختياري",
	},
	{
		id: "Client/Customer Name",
		en: "Client/Customer Name",
		ar: "اسم العميل",
	},
	{
		id: "Enter client/customer name",
		en: "Enter client/customer name",
		ar: "أدخل اسم العميل",
	},
	{
		id: "contact person info",
		en: "contact person info",
		ar: "معلومات الاتصال بالشخص",
	},
	{
		id: "Actual users",
		en: "Actual users",
		ar: "المستخدمين الفعليين",
	},
	{
		id: "Select User",
		en: "Select User",
		ar: "أدخل المستخدم",
	},
	{
		id: "Enter contact name",
		en: "Enter contact name",
		ar: "أدخل اسم جهة الاتصال",
	},
	{
		id: "Enter contact email",
		en: "Enter contact email",
		ar: "أدخل البريد الإلكتروني للاتصال",
	},
	{
		id: "working info",
		en: "working info",
		ar: "معلومات العمل",
	},
	{
		id: "sunday",
		en: "sunday",
		ar: "الأحد",
	},
	{
		id: "monday",
		en: "monday",
		ar: "الأثنين",
	},
	{
		id: "tuesday",
		en: "tuesday",
		ar: "الثلاثاء",
	},
	{
		id: "wednesday",
		en: "wednesday",
		ar: "الأربعاء",
	},
	{
		id: "thursday",
		en: "thursday",
		ar: "الخميس",
	},
	{
		id: "friday",
		en: "friday",
		ar: "الجمعة",
	},
	{
		id: "saturday",
		en: "saturday",
		ar: "السبت",
	},
	{
		id: "attachments",
		en: "attachments",
		ar: "المرفقات",
	},
	{
		id: "Max 5 files, 5MB total.",
		en: "Max 5 files, 5MB total.",
		ar: "الحد الأقصى 5 ملفات، 5 ميجا بايت إجماليًا.",
	},
	{
		id: "custom attributes",
		en: "custom attributes",
		ar: "سمات مخصصة",
	},
	{
		id: "Attribute",
		en: "Attribute",
		ar: "السمة",
	},
	{
		id: "Enter attribute value",
		en: "Enter attribute value",
		ar: "اسم السمة",
	},
	{
		id: "Select type",
		en: "Select type",
		ar: "أختر النوع",
	},
	{
		id: "Boolean",
		en: "Boolean",
		ar: "منطقية",
	},
	{
		id: "Text",
		en: "Text",
		ar: "نص",
	},
	{
		id: "Number",
		en: "Number",
		ar: "رقم",
	},
	{
		id: "value",
		en: "value",
		ar: "القيمة",
	},
	{
		id: "Enter value",
		en: "Enter value",
		ar: "أدخل القيمة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Type is required",
		en: "Type is required",
		ar: "النوع مطلوب",
	},
	{
		id: "Country is required",
		en: "Country is required",
		ar: "الدولة مطلوبة",
	},
	{
		id: "City is required",
		en: "City is required",
		ar: "المدينة مطلوبة",
	},
	{
		id: "State is required",
		en: "State is required",
		ar: "الولاية مطلوبة",
	},
	{
		id: "Type is required",
		en: "Type is required",
		ar: "النوع مطلوب",
	},
	{
		id: "Latitude is required",
		en: "Latitude is required",
		ar: "خط العرض مطلوب",
	},
	{
		id: "Longitude  is required",
		en: "Longitude  is required",
		ar: "خط الطول مطلوب",
	},
	{
		id: "All contact person fields are required if one is filled",
		en: "All contact person fields are required if one is filled",
		ar: "جميع حقول جهة الاتصال مطلوبة إذا تم ملء أحدها",
	},
	{
		id: "POI Is Added Successfully",
		en: "POI Is Added Successfully",
		ar: "تم إضافة نقطة مهمة بنجاح",
	},
	{
		id: "POI Is Edited Successfully",
		en: "POI Is Edited Successfully",
		ar: "تم تعديل نقطة مهمة بنجاح",
	},
	{
		id: "Duplicate files are not allowed!",
		en: "Duplicate files are not allowed!",
		ar: "لا يسمح بالملفات المكررة!",
	},
	{
		id: "Maximum 5 files are allowed.",
		en: "Maximum 5 files are allowed.",
		ar: "الحد الأقصى المسموح به هو 5 ملفات.",
	},
	{
		id: "Total file size must not exceed 5MB.",
		en: "Total file size must not exceed 5MB.",
		ar: "يجب ألا يتجاوز حجم الملف الإجمالي 5 ميجا بايت.",
	},
	{
		id: "Only images and documents are allowed!",
		en: "Only images and documents are allowed!",
		ar: "مسموح بالصور والوثائق فقط!",
	},
	{
		id: "Enabled",
		en: "Enabled",
		ar: "ممكّن",
	},
	{
		id: "Disabled",
		en: "Disabled",
		ar: "معطل",
	},
	{
		id: "point-of-interest",
		en: "point-of-interest",
		ar: "نقطة-مهمة",
	},
	{
		id: "POIs",
		en: "POIs",
		ar: "نقاط مهمة",
	},
	{
		id: "pois",
		en: "pois",
		ar: "النقطة المهمة",
	},
	{
		id: "View Details",
		en: "View Details",
		ar: "عرض التفاصيل",
	},
	{
		id: "POI Deleted Successfully",
		en: "POI Deleted Successfully",
		ar: "تم حذف النقطة المهمة بنجاح",
	},
	{
		id: "general",
		en: "general",
		ar: "عام",
	},
	{
		id: "Basic Details",
		en: "Basic Details",
		ar: "التفاصيل الأساسية",
	},
	{
		id: "poi name",
		en: "poi name",
		ar: "أسم النقطة المهمة",
	},
	{
		id: "poi status",
		en: "poi status",
		ar: "حالة النقطة المهمة",
	},
	{
		id: "poi type",
		en: "poi type",
		ar: "نوع النقطة المهمة",
	},
	{
		id: "region",
		en: "region",
		ar: "المنطقة",
	},
	{
		id: "created by",
		en: "created by",
		ar: "تم إنشاؤها بواسطة",
	},
	{
		id: "created at",
		en: "created at",
		ar: "تم إنشاؤها في",
	},
	{
		id: "updated by",
		en: "updated by",
		ar: "تم تعديلها بواسطة",
	},
	{
		id: "updated at",
		en: "updated at",
		ar: "تم تعديلها في",
	},
	{
		id: "poi latitude",
		en: "poi latitude",
		ar: "خط عرض المهمة",
	},
	{
		id: "poi longitude",
		en: "poi longitude",
		ar: "خط طول المهمة",
	},
	{
		id: "Location Details",
		en: "Location Details",
		ar: "تفاصيل الموقع",
	},
	{
		id: "customer name",
		en: "customer name",
		ar: "اسم العميل",
	},
	{
		id: "contact name",
		en: "contact name",
		ar: "اسم جهة الاتصال",
	},
	{
		id: "contact phone",
		en: "contact phone",
		ar: "هاتف الاتصال",
	},
	{
		id: "contact email",
		en: "contact email",
		ar: "البريد الإلكتروني للاتصال",
	},
	{
		id: "Custom Attributes",
		en: "Custom Attributes",
		ar: "السمات المخصصة",
	},
	{
		id: "Working Hours",
		en: "Working Hours",
		ar: "ساعات العمل",
	},
	{
		id: "Egypt",
		en: "Egypt",
		ar: "مصر",
	},
	{
		id: "Saudi Arabia",
		en: "Saudi Arabia",
		ar: "السعودية",
	},
	{ id: "Alexandria", en: "Alexandria", ar: "الإسكندرية" },
	{ id: "Aswan", en: "Aswan", ar: "أسوان" },
	{ id: "Asyut", en: "Asyut", ar: "أسيوط" },
	{ id: "Beheira", en: "Beheira", ar: "البحيرة" },
	{ id: "Beni Suef", en: "Beni Suef", ar: "بني سويف" },
	{ id: "Cairo", en: "Cairo", ar: "القاهرة" },
	{ id: "Dakahlia", en: "Dakahlia", ar: "الدقهلية" },
	{ id: "Damietta", en: "Damietta", ar: "دمياط" },
	{ id: "Faiyum", en: "Faiyum", ar: "الفيوم" },
	{ id: "Gharbia", en: "Gharbia", ar: "الغربية" },
	{ id: "Giza", en: "Giza", ar: "الجيزة" },
	{ id: "Ismailia", en: "Ismailia", ar: "الإسماعيلية" },
	{ id: "Kafr el-Sheikh", en: "Kafr el-Sheikh", ar: "كفر الشيخ" },
	{ id: "Luxor", en: "Luxor", ar: "الأقصر" },
	{ id: "Matrouh", en: "Matrouh", ar: "مطروح" },
	{ id: "Minya", en: "Minya", ar: "المنيا" },
	{ id: "Monufia", en: "Monufia", ar: "المنوفية" },
	{ id: "New Valley", en: "New Valley", ar: "الوادي الجديد" },

	{ id: "Asir", en: "Asir", ar: "عسير" },
	{ id: "Al Bahah", en: "Al Bahah", ar: "الباحة" },
	{ id: "Al Jawf", en: "Al Jawf", ar: "الجوف" },
	{ id: "Al Madinah", en: "Al Madinah", ar: "المدينة المنورة" },
	{ id: "Al-Qassim", en: "Al-Qassim", ar: "القصيم" },
	{ id: "Eastern Province", en: "Eastern Province", ar: "المنطقة الشرقية" },
	{ id: "Hail", en: "Hail", ar: "حائل" },
	{ id: "Jizan", en: "Jizan", ar: "جازان" },
	{ id: "Makkah", en: "Makkah", ar: "مكة المكرمة" },
	{ id: "Najran", en: "Najran", ar: "نجران" },
	{ id: "Northern Borders", en: "Northern Borders", ar: "الحدود الشمالية" },
	{ id: "Riyadh", en: "Riyadh", ar: "الرياض" },
	{ id: "Tabuk", en: "Tabuk", ar: "تبوك" },
	// KSA regions (report values are lowercase; form/dropdown values are capitalized)
	{ id: "Southern", en: "Southern", ar: "الجنوبية" },
	{ id: "southern", en: "Southern", ar: "الجنوبية" },
	{ id: "Eastern", en: "Eastern", ar: "الشرقية" },
	{ id: "eastern", en: "Eastern", ar: "الشرقية" },
	{ id: "Northern", en: "Northern", ar: "الشمالية" },
	{ id: "northern", en: "Northern", ar: "الشمالية" },
	{ id: "Western", en: "Western", ar: "الغربية" },
	{ id: "western", en: "Western", ar: "الغربية" },
	{ id: "Central", en: "Central", ar: "الوسطى" },
	{ id: "central", en: "Central", ar: "الوسطى" },
	// KSA cities (lowercase report values + capitalized form values)
	{ id: "Jazan", en: "Jazan", ar: "جازان" },
	{ id: "jazan", en: "Jazan", ar: "جازان" },
	{ id: "Khamis Mushait", en: "Khamis Mushait", ar: "خميس مشيط" },
	{ id: "khamis mushait", en: "Khamis Mushait", ar: "خميس مشيط" },
	{ id: "najran", en: "Najran", ar: "نجران" },
	{ id: "Dammam", en: "Dammam", ar: "الدمام" },
	{ id: "dammam", en: "Dammam", ar: "الدمام" },
	{ id: "tabuk", en: "Tabuk", ar: "تبوك" },
	{ id: "Medina", en: "Medina", ar: "المدينة المنورة" },
	{ id: "medina", en: "Medina", ar: "المدينة المنورة" },
	{ id: "Jeddah", en: "Jeddah", ar: "جدة" },
	{ id: "jeddah", en: "Jeddah", ar: "جدة" },
	{ id: "Mecca", en: "Mecca", ar: "مكة المكرمة" },
	{ id: "mecca", en: "Mecca", ar: "مكة المكرمة" },
	{ id: "riyadh", en: "Riyadh", ar: "الرياض" },
	{ id: "Qassim", en: "Qassim", ar: "القصيم" },
	{ id: "qassim", en: "Qassim", ar: "القصيم" },
	//Alex
	{ id: "Abu Qir", en: "Abu Qir", ar: "أبو قير" },
	{ id: "Agami", en: "Agami", ar: "العجمي" },
	{ id: "Alexandria", en: "Alexandria", ar: "الإسكندرية" },
	{ id: "Ar-Raml", en: "Ar-Raml", ar: "محطة الرمل" },
	{ id: "Borg El Arab", en: "Borg El Arab", ar: "برج العرب" },
	{ id: "Montaza", en: "Montaza", ar: "المنتزه" },
	{ id: "New Borg El Arab", en: "New Borg El Arab", ar: "برج العرب" },
	{ id: "Sidi Bishr", en: "Sidi Bishr", ar: "سيدي بشر" },

	//Aswan
	{ id: "Abu Simbel", en: "Abu Simbel", ar: "أبو سمبل" },
	{ id: "Aswan", en: "Aswan", ar: "أسوان" },
	{ id: "Idfū", en: "Idfū", ar: "إدفو" },
	{ id: "Kawm Umbū", en: "Kawm Umbū", ar: "كوم أمبو" },

	//Asyut
	{ id: "Abnūb", en: "Abnūb", ar: "أبنوب" },
	{ id: "Abū Tīj", en: "Abū Tīj", ar: "أبو تيج" },
	{ id: "Al Badārī", en: "Al Badārī", ar: "البداري" },
	{ id: "Al Qūşīyah", en: "Al Qūşīyah", ar: "القوصية" },
	{ id: "Asyūţ", en: "Asyūţ", ar: "أسيوط" },
	{ id: "Dayrūţ", en: "Dayrūţ", ar: "ديروط" },
	{ id: "Manfalūţ", en: "Manfalūţ", ar: "منفلوط" },

	//beheria
	{ id: "Abū al Maţāmīr", en: "Abū al Maţāmīr", ar: "أبو المطامير" },
	{ id: "Ad Dilinjāt", en: "Ad Dilinjāt", ar: "الدلنجات" },
	{ id: "Damanhūr", en: "Damanhūr", ar: "دمنهور" },
	{ id: "Ḩawsh ‘Īsá", en: "Ḩawsh ‘Īsá", ar: "حوش عيسى" },
	{ id: "Idkū", en: "Idkū", ar: "إدكو" },
	{ id: "Kafr ad Dawwār", en: "Kafr ad Dawwār", ar: "كفر الدوار" },
	{ id: "Kawm Ḩamādah", en: "Kawm Ḩamādah", ar: "كوم حمادة" },
	{ id: "Rosetta", en: "Rosetta", ar: "رشيد" },

	//beni suef
	{ id: "Al Fashn", en: "Al Fashn", ar: "الفشن" },
	{ id: "Banī Suwayf", en: "Banī Suwayf", ar: "بني سويف" },
	{ id: "Būsh", en: "Būsh", ar: "بوش" },
	{ id: "Sumusţā as Sulţānī", en: "Sumusţā as Sulţānī", ar: "سمسطا" },

	//cairo
	{ id: "Badr", en: "Badr", ar: "بدر" },
	{ id: "Bulaq", en: "Bulaq", ar: "بولاق" },
	{ id: "cairo", en: "cairo", ar: "القاهرة" },
	{ id: "El Mataria", en: "El Mataria", ar: "المطرية" },
	{ id: "Fustat", en: "Fustat", ar: "الفسطاط" },
	{ id: "Hadayek El Kobba", en: "Hadayek El Kobba", ar: "حدائق القبة" },
	{ id: "Heliopolis", en: "Heliopolis", ar: "هليوبوليس" },
	{ id: "Helwan", en: "Helwan", ar: "حلوان" },
	{ id: "Maadi", en: "Maadi", ar: "المعادي" },
	{ id: "Musturud", en: "Musturud", ar: "مسطرد" },
	{
		id: "New Administrative Capital of Egypt",
		en: "New Administrative Capital of Egypt",
		ar: "العاصمة الإدارية الجديدة",
	},
	{ id: "Shubra", en: "Shubra", ar: "شبرا" },
	{ id: "Tura", en: "Tura", ar: "طرة" },

	//dakahlia
	{ id: "‘Izbat al Burj", en: "‘Izbat al Burj", ar: "عزبة البرج" },
	{ id: "Ajā", en: "Ajā", ar: "أجا" },
	{ id: "Al Jammālīyah", en: "Al Jammālīyah", ar: "الجمالية" },
	{ id: "Al Manşūrah", en: "Al Manşūrah", ar: "المنصورة" },
	{ id: "Al Manzalah", en: "Al Manzalah", ar: "المنزلة" },
	{ id: "Al Maţarīyah", en: "Al Maţarīyah", ar: "المطرية" },
	{ id: "Bilqās", en: "Bilqās", ar: "بلقاس" },
	{ id: "Dikirnis", en: "Dikirnis", ar: "دكرنس" },
	{ id: "Minyat an Naşr", en: "Minyat an Naşr", ar: "منية النصر" },
	{ id: "Shirbīn", en: "Shirbīn", ar: "شربين" },
	{ id: "Ţalkhā", en: "Ţalkhā", ar: "طلخا" },

	//damettia
	{ id: "Az Zarqā", en: "Az Zarqā", ar: "الزرقا" },
	{ id: "Damietta", en: "Damietta", ar: "دمياط" },
	{ id: "Fāraskūr", en: "Fāraskūr", ar: "فارسكور" },

	//fayium
	{ id: "Al Fayyūm", en: "Al Fayyūm", ar: "الفيوم" },
	{ id: "Al Wāsiţah", en: "Al Wāsiţah", ar: "الوسيطة" },
	{ id: "Ibshawāy", en: "Ibshawāy", ar: "إبشواي" },
	{ id: "Iţsā", en: "Iţsā", ar: "إطسا" },
	{ id: "Ţāmiyah", en: "Ţāmiyah", ar: "طامية" },

	//gharbia
	{
		id: "Al Maḩallah al Kubrá",
		en: "Al Maḩallah al Kubrá",
		ar: "المحلة الكبرى",
	},
	{ id: "Basyūn", en: "Basyūn", ar: "بسيون" },
	{ id: "Kafr az Zayyāt", en: "Kafr az Zayyāt", ar: "كفر الزيات" },
	{ id: "Quţūr", en: "Quţūr", ar: "قطور" },
	{ id: "Samannūd", en: "Samannūd", ar: "سمنود" },
	{ id: "Tanda", en: "Tanda", ar: "طنطا" },
	{ id: "Zefta", en: "Zefta", ar: "زفتى" },

	//giza
	{ id: "Al ‘Ayyāţ", en: "Al ‘Ayyāţ", ar: "العياط" },
	{ id: "Al Bawīţī", en: "Al Bawīţī", ar: "الباويطي" },
	{ id: "Al Ḩawāmidīyah", en: "Al Ḩawāmidīyah", ar: "الحوامدية" },
	{ id: "Aş Şaff", en: "Aş Şaff", ar: "الصف" },
	{ id: "Awsīm", en: "Awsīm", ar: "أوسيم" },
	{ id: "Giza", en: "Giza", ar: "الجيزة" },
	{
		id: "Madīnat Sittah Uktūbar",
		en: "Madīnat Sittah Uktūbar",
		ar: "مدينة 6 أكتوبر",
	},

	{ id: "Ismailia", en: "Ismailia", ar: "الإسماعيلية" },

	//kafr el shiekh
	{ id: "Al Ḩāmūl", en: "Al Ḩāmūl", ar: "الحامول" },
	{ id: "Disūq", en: "Disūq", ar: "دسوق" },
	{ id: "Fuwwah", en: "Fuwwah", ar: "فوه" },
	{ id: "Kafr ash Shaykh", en: "Kafr ash Shaykh", ar: "كفر الشيخ" },
	{ id: "Markaz Disūq", en: "Markaz Disūq", ar: "مركز دسوق" },
	{ id: "Munshāt ‘Alī Āghā", en: "Munshāt ‘Alī Āghā", ar: "منشأة علي أغا" },
	{ id: "Sīdī Sālim", en: "Sīdī Sālim", ar: "سيدي سالم" },

	//Luxor
	{ id: "Luxor", en: "Luxor", ar: "الأقصر" },
	{ id: "Markaz al Uqşur", en: "Markaz al Uqşur", ar: "مركز الأقصر" },

	//matrouh
	{ id: "Al ‘Alamayn", en: "Al ‘Alamayn", ar: "العالمين" },
	{ id: "Mersa Matruh", en: "Mersa Matruh", ar: "مرسى مطروح" },
	{ id: "Siwa Oasis", en: "Siwa Oasis", ar: "سيوة" },

	//minya
	{ id: "Abū Qurqāş", en: "Abū Qurqāş", ar: "أبو قرقاص" },
	{ id: "Al Minyā", en: "Al Minyā", ar: "المنيا" },
	{ id: "Banī Mazār", en: "Banī Mazār", ar: "بني مزار" },
	{ id: "Dayr Mawās", en: "Dayr Mawās", ar: "دير مواس" },
	{ id: "Mallawī", en: "Mallawī", ar: "ملوى" },
	{ id: "Maţāy", en: "Maţāy", ar: "مطاي" },
	{ id: "Samālūţ", en: "Samālūţ", ar: "سملوط" },

	// minofya
	{ id: "Al Bājūr", en: "Al Bājūr", ar: "الباجور" },
	{ id: "Ash Shuhadā’", en: "Ash Shuhadā’", ar: "الشهداء" },
	{ id: "Ashmūn", en: "Ashmūn", ar: "أشمون" },
	{ id: "Munūf", en: "Munūf", ar: "منوف" },
	{ id: "Quwaysinā", en: "Quwaysinā", ar: "قويسنا" },
	{ id: "Shibīn al Kawm", en: "Shibīn al Kawm", ar: "شبين الكوم" },
	{ id: "Talā", en: "Talā", ar: "تلا" },

	//new valley
	{ id: "Al Khārijah", en: "Al Khārijah", ar: "الخارجة" },
	{ id: "Qaşr al Farāfirah", en: "Qaşr al Farāfirah", ar: "الفرافرة" },
	{
		id: "to",
		en: "to",
		ar: "إلي",
	},
	{
		id: "No Data",
		en: "No Data",
		ar: "لا توجد بيانات",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	{
		id: "Add",
		en: "Add",
		ar: "إضافة",
	},
	/* POIS */
	/* Forms */
	{
		id: "Forms",
		en: "Forms",
		ar: "النماذج",
	},
	{
		id: "forms",
		en: "forms",
		ar: "النماذج",
	},
	{
		id: "form",
		en: "form",
		ar: "النموذج",
	},
	{
		id: "Form Builder",
		en: "Form Builder",
		ar: "إنشاء نموذج",
	},
	{
		id: "Add new form",
		en: "Add new form",
		ar: "إضافة نموذج جديد",
	},

	{
		id: "create form template",
		en: "create form template",
		ar: "إنشاء النموذج",
	},
	{
		id: "Design custom forms for your workforce tasks",
		en: "Design custom forms for your workforce tasks",
		ar: "تصميم نماذج مخصصة لمهام القوى العاملة الخاصة بك",
	},
	{
		id: "Preview",
		en: "Preview",
		ar: "معاينة",
	},
	{
		id: "Select element on form for edit properties",
		en: "Select element on form for edit properties",
		ar: "حدد عنصرًا في النموذج لتحرير الخصائص",
	},
	{
		id: "Main",
		en: "Main",
		ar: "الرئيسية",
	},
	{
		id: "Fields",
		en: "Fields",
		ar: "حقول النموذج",
	},
	{
		id: "Form Tree",
		en: "Form Tree",
		ar: "تسلسل النموذج",
	},
	{
		id: "form settings",
		en: "form settings",
		ar: "إعدادت النموذج",
	},
	{
		id: "form name",
		en: "form name",
		ar: "إسم النموذج",
	},
	{
		id: "form description",
		en: "form description",
		ar: "وصف النموذج",
	},
	{
		id: "Enter Form Name.",
		en: "Enter Form Name.",
		ar: "أدخل اسم النموذج",
	},
	{
		id: "Enter Form Description.",
		en: "Enter Form Description.",
		ar: "أدخل وصف النموذج",
	},
	{
		id: "Search...",
		en: "Search...",
		ar: "أبحث...",
	},
	{
		id: "Fields",
		en: "Fields",
		ar: "الحقول",
	},
	{
		id: "Static",
		en: "Static",
		ar: "الثوابت",
	},
	{
		id: "Structure",
		en: "Structure",
		ar: "الهيكل",
	},

	{ id: "Checkbox", en: "Checkbox", ar: "خانة اختيار" },
	{ id: "DatePicker", en: "DatePicker", ar: "منتقي التاريخ" },
	{ id: "Dropdown", en: "Dropdown", ar: "قائمة منسدلة" },
	{ id: "Input", en: "Input", ar: "إدخال" },
	{ id: "Radio_group", en: "Radio Group", ar: "مجموعة أزرار اختيار" },
	{ id: "Text_area", en: "Text Area", ar: "منطقة نص" },
	{ id: "Toggle", en: "Toggle", ar: "مفتاح تبديل" },
	{ id: "Uploader", en: "Uploader", ar: "رافع الملفات" },
	{ id: "Button", en: "Button", ar: "زر" },
	{ id: "Camera", en: "Camera", ar: "كاميرا" },
	{ id: "Header", en: "Header", ar: "رأس الصفحة" },
	{ id: "Image", en: "Image", ar: "صورة" },
	{ id: "Label", en: "Label", ar: "تسمية" },
	{ id: "Link", en: "Link", ar: "رابط" },
	{ id: "Progress_circle", en: "Progress Circle", ar: "مؤشر تقدم دائري" },
	{ id: "Progress_line", en: "Progress Line", ar: "مؤشر تقدم خطي" },
	{ id: "Signature", en: "Signature", ar: "توقيع" },
	{ id: "Container", en: "Container", ar: "حاوية" },
	{
		id: "Key",
		en: "Key",
		ar: "الرمز",
	},
	{
		id: "Title",
		en: "Title",
		ar: "العنوان",
	},
	{
		id: "Placeholder",
		en: "Placeholder",
		ar: "العنصر النائب",
	},
	{
		id: "Input Type",
		en: "Input Type",
		ar: "نوع الإدخال",
	},
	{
		id: "Required",
		en: "Required",
		ar: "مطلوب",
	},
	{
		id: "Enter input title",
		en: "Enter input title",
		ar: "أدخل عنوان الإدخال",
	},
	{
		id: "Enter input placeholder",
		en: "Enter input placeholder",
		ar: "أدخل العنصر النائب",
	},
	{
		id: "Validation Message",
		en: "Validation Message",
		ar: "رسالة التحقق",
	},
	{
		id: "Enter validation message",
		en: "Enter validation message",
		ar: "أدخل رسالة التحقق",
	},
	{
		id: "Container must have at least one input",
		en: "Container must have at least one input",
		ar: "يجب أن تحتوي الحاوية على مدخل واحد على الأقل",
	},
	{
		id: "Option",
		en: "Option",
		ar: "إختيار",
	},
	{
		id: "Custom data",
		en: "Custom data",
		ar: "بيانات مخصصة",
	},
	{
		id: "Database",
		en: "Database",
		ar: "قاعدة البيانات",
	},
	{
		id: "Database key",
		en: "Database key",
		ar: "مفتاح قاعدة البيانات",
	},
	{
		id: "Enter Query key",
		en: "Enter Query key",
		ar: "أدخل اسم قاعدة البيانات",
	},
	{
		id: "this field is required",
		en: "this field is required",
		ar: "هذا الحقل مطلوب",
	},
	{
		id: "No input selected",
		en: "No input selected",
		ar: "لم يتم اختيار حقل",
	},
	{
		id: "Click to Upload",
		en: "Click to Upload",
		ar: "رفع ملف",
	},
	{
		id: "Button Type",
		en: "Button Type",
		ar: "نوع الزر",
	},
	{
		id: "Image Link",
		en: "Image Link",
		ar: "مسار الصورة",
	},
	{
		id: "Enter Image Link",
		en: "Enter Image Link",
		ar: "أدخل مسار الصورةس",
	},
	{
		id: "Link",
		en: "Link",
		ar: "الرابط",
	},
	{
		id: "Enter hyperLink",
		en: "Enter hyperLink",
		ar: "أدخل الرابط",
	},
	{
		id: "Drop Area",
		en: "Drop Area",
		ar: "منطقة إسقاط",
	},
	{
		id: "No Image Uploaded",
		en: "No Image Uploaded",
		ar: "لا يوجد صورة",
	},
	{
		id: "direction",
		en: "direction",
		ar: "الإتجاه",
	},
	{
		id: "margin top",
		en: "margin top",
		ar: "إزاحة لأعلي",
	},
	{
		id: "margin bottom",
		en: "margin bottom",
		ar: "إزاحة لأسفل",
	},
	{
		id: "margin right",
		en: "margin right",
		ar: "إزاحة لليمين",
	},
	{
		id: "margin left",
		en: "margin left",
		ar: "إزاحة لليسار",
	},
	{
		id: "background color",
		en: "background color",
		ar: "لون الخلفية",
	},
	{
		id: "height",
		en: "height",
		ar: "الطول",
	},
	{
		id: "gap",
		en: "gap",
		ar: "الفراغ",
	},
	{
		id: "align items",
		en: "align items",
		ar: "محاذاة العناصر",
	},
	{
		id: "flex wrap",
		en: "flex wrap",
		ar: "التفاف المرن",
	},
	{
		id: "justify",
		en: "justify",
		ar: "ضبط",
	},
	{
		id: "Choose direction",
		en: "Choose direction",
		ar: "إختر الاتجاه",
	},
	{
		id: "Choose wrap",
		en: "Choose wrap",
		ar: "إختر نوع الإلتفاف",
	},
	{
		id: "Choose align type",
		en: "Choose align type",
		ar: "إختر نوع المحاذاة",
	},
	{
		id: "Choose justify type",
		en: "Choose justify type",
		ar: "إختر نوع الضبط",
	},
	{
		id: "Choose direction",
		en: "Choose direction",
		ar: "إختر الاتجاه",
	},
	{
		id: "Font Weight",
		en: "Font Weight",
		ar: "وزن الخط",
	},
	{
		id: "Font Family",
		en: "Font Family",
		ar: "نوع الخط",
	},
	{
		id: "Font Size",
		en: "Font Size",
		ar: "حجم الخط",
	},
	{
		id: "color",
		en: "color",
		ar: "اللون",
	},
	{
		id: "Style",
		en: "Style",
		ar: "التنسيقات",
	},
	{
		id: "Field Settings",
		en: "Field Settings",
		ar: "إعدادت الحقل",
	},
	{
		id: "Title is required",
		en: "Title is required",
		ar: "العنوان مطلوب",
	},
	{
		id: "Validation message is required",
		en: "Validation message is required",
		ar: "رسالة التحقق مطلوبة",
	},
	{
		id: "Image path is required",
		en: "Image path is required",
		ar: "مسار الصورة مطلوب",
	},
	{
		id: "Link is required",
		en: "Link is required",
		ar: "الرابط مطلوب",
	},
	{
		id: "Container must contain at least one item",
		en: "Container must contain at least one item",
		ar: "يجب أن تحتوي الحاوية على عنصر واحد على الأقل",
	},
	{
		id: "This is how your form will appear to workers",
		en: "This is how your form will appear to workers",
		ar: "هكذا سيظهر نموذجك للعاملين",
	},
	{
		id: "Mobile perspective",
		en: "Mobile perspective",
		ar: "منظور الهاتف",
	},
	{
		id: "Tablet perspective",
		en: "Tablet perspective",
		ar: "منظور التابلت",
	},
	{
		id: "Desktop perspective",
		en: "Desktop perspective",
		ar: "منظور شاشة الكمبيوتر",
	},
	{
		id: "Field Services",
		en: "Field Services",
		ar: "الخدمات الميدانية",
	},
	{
		id: "More",
		en: "More",
		ar: "المزيد",
	},
	/* Forms */
	{
		id: "Field Task Management",
		en: "Field Task Management",
		ar: "إدارة المهام الميدانية",
	},
	{
		id: "Tasks",
		en: "Tasks",
		ar: "المهام",
	},
	{
		id: "Field Staff",
		en: "Field Staff",
		ar: "المندوبين",
	},
	{ id: "requests", en: "Requests", ar: "الطلبات" },
	{ id: "Service Type", en: "Service Type", ar: "نوع الخدمة" },
	{ id: "preferred time", en: "preferred time", ar: "الوقت المناسب" },
	{ id: "Add new request", en: "Add new request", ar: "إضافة طلب جديد" },
	{ id: "Edit Requset", en: "Edit Requset", ar: "تعديل طلب" },
	{
		id: "Request description is required",
		en: "Request description is required",
		ar: "وصف الطلب مطلوب",
	},
	{
		id: "Request description cannot minimum 10 characters",
		en: "Request description cannot minimum 10 characters",
		ar: "وصف الطلب لا يمكن أن يحتوي على الحد الأدنى من 10 أحرف",
	},
	{
		id: "Request type is required",
		en: "Request type is required",
		ar: "نوع الطلب مطلوب",
	},
	{
		id: "Preferred time must be a valid date",
		en: "Preferred time must be a valid date",
		ar: "يجب أن يكون الوقت المناسب تاريخًا صالحًا",
	},
	{
		id: "Preferred time is required",
		en: "Preferred time is required",
		ar: "الوقت المناسب مطلوب",
	},
	{
		id: "Write Request description",
		en: "Write Request description",
		ar: "اكتب وصف الطلب",
	},
	{
		id: "Request created successfully",
		en: "Request created successfully",
		ar: "تم إنشاء الطلب بنجاح",
	},
	{
		id: "Request edited successfully",
		en: "Request edited successfully",
		ar: "تم تعديل الطلب بنجاح",
	},
	{ id: "Create Task", en: "Create Task", ar: "إنشاء مهمة" },
	{ id: "Request Details", en: "Request Details", ar: "تفاصيل الطلب" },
	{ id: "Photos", en: "Photos", ar: "الصور" },
	{ id: "Assigned", en: "Assigned", ar: "مسندة" },
	{ id: "pending", en: "pending", ar: "قيد الانتظار" },
	{ id: "cancelled", en: "cancelled", ar: "تم الإلغاء" },
	{ id: "Over Due", en: "Over Due", ar: "متأخرة" },
	{
		id: "The actual start time was later than the scheduled start time",
		en: "The actual start time was later than the scheduled start time",
		ar: "تأخر وقت البدء الفعلي عن وقت البدء المحدد",
	},
	{
		id: "The work exceeded the estimated duration",
		en: "The work exceeded the estimated duration",
		ar: "تجاوز تنفيذ المهمة المدة المقدرة",
	},
	{
		id: "More",
		en: "More",
		ar: "المزيد",
	},
	/* Forms */
	{
		id: "Field Task Management",
		en: "Field Task Management",
		ar: "إدارة المهام الميدانية",
	},
	{
		id: "Tasks",
		en: "Tasks",
		ar: "المهام",
	},
	{
		id: "Field Staff",
		en: "Field Staff",
		ar: "المندوبين",
	},
	{
		id: "Task Code",
		en: "Task code",
		ar: "كود المهمة",
	},
	{
		id: "Submitted At",
		en: "Submitted At",
		ar: "قدمت في",
	},
	{
		id: "Submitted",
		en: "Submitted",
		ar: "قدمت",
	},
	{
		id: "Form Submission",
		en: "Form Submission",
		ar: "تقديم النموذج",
	},
	{
		id: "Are you sure you want to cancel this request",
		en: "Are you sure you want to cancel this request",
		ar: "هل انت متأكد أنك تريد إلغاء هذا الطلب",
	},
	{
		id: "Cancel Requset",
		en: "Cancel Requset",
		ar: "إلغاء الطلب",
	},
	{
		id: "Service request cancelled successfully",
		en: "Service request cancelled successfully",
		ar: "تم إلغاء طلب الخدمة بنجاح",
	},
	{
		id: "Failed to cancel request",
		en: "Failed to cancel request",
		ar: "فشل في إلغاء الطلب",
	},
	{
		id: "Request Deleted Successfully",
		en: "Request Deleted Successfully",
		ar: "تم حذف الطلب بنجاح",
	},
	{
		id: "submission",
		en: "submission",
		ar: "المٌقدمه",
	},
	{
		id: "Submitted By",
		en: "Submitted By",
		ar: "قدمت بواسطة",
	},
	{
		id: "Start time must be in the future when assigning a task",
		en: "Start time must be in the future when assigning a task",
		ar: "يجب أن يكون وقت البدء في المستقبل عند تعيين مهمة",
	},
	{ id: "workforce", en: "workforce", ar: "القوى العاملة" },
	{ id: "fieldservices", en: "Field Services", ar: "الخدمات الميدانية" },
	{
		id: "productivity",
		en: "Productivity & workload",
		ar: "الإنتاجية وحجم العمل",
	},
	{
		id: "staff name",
		en: "Staff Name",
		ar: "اسم المندوب",
	},
	{
		id: "processed tasks",
		en: "Processed Tasks",
		ar: "المهام المكتملة",
	},
	{
		id: "performance",
		en: "Performance",
		ar: "أداء",
	},
	{
		id: "Under Performing",
		en: "Under Performing",
		ar: "أقل من المتوقع",
	},
	{
		id: "Out Performing",
		en: "Out Performing",
		ar: "متفوق",
	},
	{
		id: "Avg Expected (min)",
		en: "Avg Expected (min)",
		ar: "متوسط ​​المتوقع (بالدقائق)",
	},
	{
		id: "Avg Actual(min)",
		en: "Avg Actual(min)",
		ar: "متوسط ​​الفعلي (بالدقائق)",
	},
	{
		id: "Efficiency %",
		en: "Efficiency %",
		ar: "الكفاءة ٪",
	},
	{
		id: "Tasks Assigned",
		en: "Tasks Assigned",
		ar: "المهام الموكلة",
	},
	{
		id: "Workload Status",
		en: "Workload Status",
		ar: "حالة عبء العمل",
	},
	{
		id: "overloaded",
		en: "Overloaded",
		ar: "مثقل",
	},
	{
		id: "underutilized",
		en: "Underutilized",
		ar: "غير مستغل",
	},
	{
		id: "balanced",
		en: "Balanced",
		ar: "متوازن",
	},
	{
		id: "Complete Tasks",
		en: "Complete Tasks",
		ar: "المهام المكتملة",
	},
	{
		id: "Total Tasks",
		en: "Total Tasks",
		ar: "مجموع المهام",
	},
	{
		id: "Total Staff",
		en: "Total Staff",
		ar: "مجموع المندوبين",
	},
	{
		id: "Underutilized Staff",
		en: "Underutilized Staff",
		ar: "المندوبين غير المستغلين",
	},
	{
		id: "Overload Staff",
		en: "Overload Staff",
		ar: "زيادة تحميل المندوبين",
	},
	{
		id: "Average Efficiency",
		en: "Average Efficiency",
		ar: "متوسط ​​الكفاءة",
	},
	{
		id: "Efficiency Threshold: ",
		en: "Efficiency Threshold",
		ar: "مقياس الكفاءة: ",
	},
	{
		id: "Select Service Type",
		en: "Select Service Type",
		ar: "حدد نوع الخدمة",
	},
	{
		id: "electrical",
		en: "electrical",
		ar: "كهرباء",
	},
	{
		id: "air conditioning",
		en: "air conditioning",
		ar: "تكييف",
	},
	{
		id: "Form Submission Details",
		en: "Form Submission Details",
		ar: "تفاصيل تقديم النموذج",
	},
	{
		id: "Form Submission Values",
		en: "Form Submission Values",
		ar: "قيم إرسال النموذج",
	},
	{
		id: "Form Submission Attachments",
		en: "Form Submission Attachments",
		ar: "مرفقات إرسال النموذج",
	},
	{
		id: "submitted",
		en: "submitted",
		ar: "مُقَدَّم",
	},
	{
		id: "Form Name",
		en: "Form Name",
		ar: "اسم النموذج",
	},
	{ id: "field services", en: "field services", ar: "الخدمات الميدانية" },
	{
		id: "showing tasks completed, efficiency, and workload distribution across staff.",
		en: "showing tasks completed, efficiency, and workload distribution across staff.",
		ar: "إظهار المهام المنجزة والكفاءة وتوزيع عبء العمل بين المندوبين.",
	},
	{
		id: "Field Staff Productivity & Workload Report",
		en: "Field Staff Productivity & Workload Report",
		ar: "تقرير إنتاجية المندوبين وحجم العمل",
	},
	{ id: "fieldservices", en: "field services", ar: "الخدمات الميدانية" },
	{ id: "Select POI", en: "Select POI", ar: "اختر نقطة مهمة" },
	{ id: "user name", en: "user name", ar: "اسم العميل" },
	/* efficiency report */
	{ id: "Task ID", en: "Task ID", ar: "كود المهمة" },
	{ id: "Assignee To", en: "Assignee To", ar: "المكلف به" },
	{
		id: "Planned Duration (hrs)",
		en: "Planned Duration (hrs)",
		ar: "المدة المخطط لها (ساعات)",
	},
	{
		id: "Avg Duration (hrs)",
		en: "Avg Duration (hrs)",
		ar: "متوسط ​​المدة (ساعات)",
	},
	{ id: "Variance", en: "Variance", ar: "التباين" },
	{ id: "Variance (hrs)", en: "Variance (hrs)", ar: "التباين (الساعات)" },
	{
		id: "Average Planned Duration",
		en: "Average Planned Duration",
		ar: "متوسط ​​المدة المخطط لها",
	},
	{
		id: "Average Actual Duration",
		en: "Average Actual Duration",
		ar: "متوسط ​​المدة الفعلية",
	},
	{
		id: "Over Due Percentage",
		en: "Over Due Percentage",
		ar: "نسبة المتأخرات",
	},
	{ id: "Users", en: "Users", ar: "المستخدمين" },
	{ id: "efficiency", en: "efficiency", ar: "كفاءة" },
	{ id: "Select POI", en: "Select POI", ar: "أختر نقطة مهمة" },
	{ id: "Select status", en: "Select status", ar: "أختر الحالة" },
	{
		id: "Duration Efficency Report",
		en: "Duration Efficency Report",
		ar: "تقرير كفاءة المدة",
	},
	{
		id: "Field Staff Productivity & Workload Report",
		en: "Field Staff Productivity & Workload Report",
		ar: "تقرير إنتاجية المندوبين وحجم العمل",
	},
	{
		id: "showing tasks completed, efficiency, and workload distribution across staff.",
		en: "showing tasks completed, efficiency, and workload distribution across staff.",
		ar: "إظهار المهام المنجزة والكفاءة وتوزيع عبء العمل بين المندوبين.",
	},
	{ id: "On Time", en: "On Time", ar: "في الوقت المحدد" },
	{ id: "Overdue", en: "Overdue", ar: "متأخر" },
	{ id: "Customer", en: "Customer", ar: "العميل" },
	{
		id: "Please Select Date Range",
		en: "Please Select Date Range",
		ar: "الرجاء تحديد النطاق الزمني",
	},
	{
		id: "Total Service Requests",
		en: "Total Service Requests",
		ar: "إجمالي طلبات الخدمة",
	},
	{
		id: "Total Completed Tasks",
		en: "Total Completed Tasks",
		ar: "إجمالي المهام المنجزة",
	},
	{
		id: "Average Task Duration",
		en: "Average Task Duration",
		ar: "متوسط ​​مدة المهمة",
	},
	{
		id: "Total Service Time",
		en: "Total Service Time",
		ar: "إجمالي وقت الخدمة",
	},
	{ id: "Taken Time", en: "Taken Time", ar: "الوقت المستغرق" },
	{ id: "Requested By", en: "Requested By", ar: "طلب من" },
	{ id: "Priority", en: "Priority", ar: "أولوية" },
	{ id: "Request Code", en: "Request Code", ar: "كود الطلب" },
	{ id: "Select requester", en: "Select requester", ar: "أختر الطالب" },
	{ id: "Requesters", en: "Requesters", ar: "الطالبون" },
	{
		id: "Actual Duration (hrs)",
		en: "Actual Duration (hrs)",
		ar: "(الساعات) المدة الفعلية",
	},
	{ id: "Preferred Time", en: "Preferred Time", ar: "الوقت المفضل" },
	{
		id: "Service Request Report",
		en: "Service Request Report",
		ar: "تقرير طلب الخدمة",
	},

	{
		id: "Empowering management with data-driven insights to boost efficiency, productivity, client satisfaction, and overall performance.",
		en: "Empowering management with data-driven insights to boost efficiency, productivity, client satisfaction, and overall performance.",
		ar: "تمكين الإدارة من خلال الرؤى المستندة إلى البيانات لتعزيز الكفاءة والإنتاجية ورضا العملاء والأداء العام.",
	},
	{
		id: "Enabling supervisors to assess task efficiency and detect delays to improve productivity and service quality.",
		en: "Enabling supervisors to assess task efficiency and detect delays to improve productivity and service quality.",
		ar: "تمكين المشرفين من تقييم كفاءة المهام واكتشاف التأخيرات لتحسين الإنتاجية وجودة الخدمة.",
	},
	{
		id: "Tasks Performance Report",
		en: "Tasks Performance Report",
		ar: "تقرير أداء المهام",
	},
	{ id: "air_conditioning", en: "air_conditioning", ar: "تكييف" },
	{ id: "moderate", en: "moderate", ar: "متوسطة" },
	{ id: "medium-high", en: "medium-high", ar: "متوسطة عالية" },
	{ id: "intensity", en: "intensity", ar: "الشدة" },
	{ id: "Countries Level", en: "Countries Level", ar: "مستوي الدول" },
	{ id: "States Level", en: "States Level", ar: "مستوي الولايات" },
	{ id: "Cities Level", en: "Cities Level", ar: "مستوي المدن" },
	{
		id: "Distance is required",
		en: "Distance is required",
		ar: "المسافة مطلوبة",
	},
	{
		id: "Minimum distance is 50m",
		en: "Minimum distance is 50m",
		ar: "أقل مسافة 50 متر",
	},
	{
		id: "Maximum distance is 1000m",
		en: "Maximum distance is 1000m",
		ar: "أقصي مسافة 1000 متر",
	},
	{ id: "POIs Name", en: "POIs Name", ar: "اسم النقطة المهمة" },
	{ id: "completion rate", en: "completion rate", ar: "معدل الإنجاز" },
	{
		id: "total tasks",
		en: "total tasks",
		ar: "مجموع المهام",
	},
	{ id: "POIs Number", en: "POIs Number", ar: "عدد النقاط المهمة" },
	{ id: "Level", en: "Level", ar: "المستوي" },
	{ id: "heatmap", en: "heatmap", ar: "الخريطة الحرارية" },
	{ id: "Tasks Heatmap", en: "Tasks Heatmap", ar: "الخريطة الحرارية للمهام" },
	{ id: "data", en: "data", ar: "" },
	{ id: "data", en: "data", ar: "" },
	/* efficiency report */
	// ------------------------- FSM Dashboard -------------------------
	{
		id: "Field Service Management Dashboard",
		en: "Field Service Management Dashboard",
		ar: "لوحة معلومات إدارة الخدمة الميدانية",
	},
	{ id: "Last updated:", en: "Last updated:", ar: "آخر تحديث:" },
	{
		id: "Exit Fullscreen",
		en: "Exit Fullscreen",
		ar: "الخروج من وضع ملء الشاشة",
	},
	{ id: "Fullscreen", en: "Fullscreen", ar: "ملء الشاشة" },
	{ id: "Delayed Tasks", en: "Delayed Tasks", ar: "المهام المتأخرة" },
	{
		id: "Tasks that are past their scheduled start time",
		en: "Tasks that are past their scheduled start time",
		ar: "المهام التي تجاوزت وقت البدء المقرر لها",
	},
	{
		id: "Delayed Tasks",
		en: "Delayed Tasks",
		ar: "المهام المتأخرة",
	},
	{
		id: "Tasks that are past their scheduled start time",
		en: "Tasks that are past their scheduled start time",
		ar: "المهام التي تجاوزت وقت البدء المجدول لها",
	},
	{
		id: "SLA Violations",
		en: "SLA Violations",
		ar: "مخالفات العقود",
	},
	{
		id: "High priority tasks that are overdue",
		en: "High priority tasks that are overdue",
		ar: "المهام ذات الأولوية العالية والمتأخرة عن موعدها",
	},
	{
		id: "Idle Technicians",
		en: "Idle Field Staff",
		ar: "المندوبون غير النشطين",
	},
	{
		id: "Technicians not currently assigned to tasks",
		en: "Field Staff not currently assigned to tasks",
		ar: "المندوبون غير المكلّفين بأي مهام حاليًا",
	},
	{
		id: "Missed Check-ins",
		en: "Missed Check-ins",
		ar: "تسجيلات الدخول الفائتة",
	},
	{
		id: "Required geofence check-ins that were missed",
		en: "Required geofence check-ins that were missed",
		ar: "تسجيلات الدخول المطلوبة ضمن الموقع الجغرافي والتي لم تتم",
	},
	{
		id: "Pending Forms",
		en: "Pending Forms",
		ar: "النماذج المعلقة",
	},
	{
		id: "Forms that need to be completed",
		en: "Forms that need to be completed",
		ar: "النماذج التي تحتاج إلى إكمال",
	},
	{
		id: "Unassigned Requests",
		en: "Unassigned Requests",
		ar: "الطلبات غير المسندة",
	},
	{
		id: "Service requests without assigned tasks",
		en: "Service requests without assigned tasks",
		ar: "طلبات الخدمة التي لم يتم إسناد مهام لها",
	},
	{ id: "Critical", en: "Critical", ar: "شديد الأهمية" },
	{ id: "System Alerts", en: "System Alerts", ar: "تنبيهات النظام" },
	{
		id: "Real-time alerts requiring attention",
		en: "Real-time alerts requiring attention",
		ar: "تنبيهات في الوقت الحالي تتطلب الاهتمام",
	},
	{ id: "Details", en: "Details", ar: "تفاصيل" },
	{ id: "Close", en: "Close", ar: "إغلاق" },
	{
		id: "Recommended Actions:",
		en: "Recommended Actions:",
		ar: "الإجراءات الموصى بها:",
	},
	{
		id: "Review task priorities and reassign if necessary",
		en: "Review task priorities and reassign if necessary",
		ar: "مراجعة أولويات المهام وإعادة التوزيع إذا لزم الأمر",
	},
	{
		id: "Contact technicians to understand delays",
		en: "Contact field staff to understand delays",
		ar: "التواصل مع المندوبين لفهم أسباب التأخير",
	},
	{
		id: "Consider adjusting schedules for future tasks",
		en: "Consider adjusting schedules for future tasks",
		ar: "النظر في تعديل الجداول للمهام المستقبلية",
	},
	{
		id: "Immediately escalate to supervisors",
		en: "Immediately escalate to supervisors",
		ar: "تصعيد الأمر فورًا إلى المشرفين",
	},
	{
		id: "Reassign to available technicians",
		en: "Reassign to available field staff",
		ar: "إعادة الإسناد إلى المندوبين المتاحين",
	},
	{
		id: "Notify customers of potential delays",
		en: "Notify customers of potential delays",
		ar: "إخطار العملاء باحتمال حدوث تأخير",
	},
	{
		id: "Assign pending tasks to idle technicians",
		en: "Assign pending tasks to idle field staff",
		ar: "إسناد المهام المعلقة إلى المندوبين غير النشطين",
	},
	{
		id: "Review workload distribution",
		en: "Review workload distribution",
		ar: "مراجعة توزيع عبء العمل",
	},
	{
		id: "Consider training or maintenance activities",
		en: "Consider training or maintenance activities",
		ar: "النظر في التدريب أو أنشطة الصيانة",
	},
	{
		id: "Contact technicians to verify location",
		en: "Contact field staff to verify location",
		ar: "التواصل مع المندوبين للتحقق من الموقع",
	},
	{
		id: "Review geofence requirements",
		en: "Review geofence requirements",
		ar: "مراجعة متطلبات الموقع الجغرافي",
	},
	{
		id: "Update check-in procedures if needed",
		en: "Update check-in procedures if needed",
		ar: "تحديث إجراءات تسجيل الدخول عند الحاجة",
	},

	// Pending Forms
	{
		id: "Send reminders to technicians",
		en: "Send reminders to field staff",
		ar: "إرسال تذكيرات للمندوبين",
	},
	{
		id: "Review form completion requirements",
		en: "Review form completion requirements",
		ar: "مراجعة متطلبات استكمال النماذج",
	},
	{
		id: "Provide additional training if needed",
		en: "Provide additional training if needed",
		ar: "تقديم تدريب إضافي عند الحاجة",
	},
	{
		id: "Review and prioritize service requests",
		en: "Review and prioritize service requests",
		ar: "مراجعة وترتيب أولويات طلبات الخدمة",
	},
	{
		id: "Assign to available technicians",
		en: "Assign to available field staff",
		ar: "إسناد المهام إلى المندوبين المتاحين",
	},
	{
		id: "Create tasks for urgent requests",
		en: "Create tasks for urgent requests",
		ar: "إنشاء مهام للطلبات العاجلة",
	},
	{
		id: "Active Tasks",
		en: "Active Tasks",
		ar: "المهام النشطة",
	},
	{
		id: "Tasks currently in progress",
		en: "Tasks currently in progress",
		ar: "المهام الجاري تنفيذها حاليًا",
	},
	{
		id: "Active Technicians",
		en: "Active field staff",
		ar: "المندوبون النشطون",
	},
	{
		id: "Technicians currently working on tasks",
		en: "field staff currently working on tasks",
		ar: "المندوبون الذين يعملون على المهام حاليًا",
	},
	{
		id: "Open Service Requests",
		en: "Open Service Requests",
		ar: "طلبات الخدمة المفتوحة",
	},
	{
		id: "Service requests awaiting completion",
		en: "Service requests awaiting completion",
		ar: "طلبات الخدمة التي تنتظر الإكمال",
	},
	{
		id: "Completion Rate",
		en: "Completion Rate",
		ar: "معدل الإكمال",
	},
	{
		id: "Task completion rate for today",
		en: "Task completion rate for today",
		ar: "معدل إكمال المهام لليوم",
	},
	{
		id: "Overview Statistics",
		en: "Overview Statistics",
		ar: "نظرة عامة",
	},
	{ id: "vs yesterday", en: "vs yesterday", ar: "مقارنة بأمس" },
	{
		id: "Key performance indicators for field service operations",
		en: "Key performance indicators for field service operations",
		ar: "مؤشرات الأداء الرئيسية لعمليات الخدمة الميدانية",
	},
	{ id: "Resource Status", en: "Resource Status", ar: "حالة الموارد" },
	{
		id: "Real-time status of all technicians",
		en: "Real-time status of all field staff",
		ar: "الحالة في الوقت الحالي لجميع المندوبين",
	},
	{
		id: "Active on Task",
		en: "Active on Task",
		ar: "نشط في مهمة",
	},
	{
		id: "Technicians currently working on tasks",
		en: "field staff currently working on tasks",
		ar: "المندوبون الذين يعملون على المهام حاليًا",
	},
	{
		id: "In Transit",
		en: "In Transit",
		ar: "في الطريق",
	},
	{
		id: "Technicians traveling to job sites",
		en: "field staff traveling to job sites",
		ar: "المندوبون المتجهون إلى مواقع العمل",
	},
	{
		id: "Available",
		en: "Available",
		ar: "متاح",
	},
	{
		id: "Technicians ready for new assignments",
		en: "field staff ready for new assignments",
		ar: "المندوبون الجاهزون لمهام جديدة",
	},
	{
		id: "On Break",
		en: "On Break",
		ar: "في استراحة",
	},
	{
		id: "Technicians currently on scheduled breaks",
		en: "field staff currently on scheduled breaks",
		ar: "المندوبون الذين في استراحة مجدولة حاليًا",
	},

	{
		id: "Off Shift",
		en: "Off Shift",
		ar: "خارج الوردية",
	},
	{
		id: "Technicians not currently scheduled",
		en: "field staff not currently scheduled",
		ar: "المندوبون غير المجدولين حاليًا",
	},
	{ id: "Total Technicians", en: "Total field staff", ar: "إجمالي المندوبين" },
	{ id: "Utilization Rate", en: "Utilization Rate", ar: "معدل الاستخدام" },
	{
		id: "Resource Utilization",
		en: "Resource Utilization",
		ar: "استخدام الموارد",
	},
	{ id: "Status Breakdown", en: "Status Breakdown", ar: "تفصيل الحالة" },
	{ id: "of", en: "of", ar: "من" },
	{ id: "Utilization:", en: "Utilization:", ar: "الاستخدام:" },
	{ id: "Optimal", en: "Optimal", ar: "الأفضل" },
	{ id: "Below Target", en: "Below Target", ar: "أقل من الهدف" },
	{ id: "Capacity:", en: "Capacity:", ar: "السعة:" },
	{ id: "At Capacity", en: "At Capacity", ar: "عند السعة" },
	{ id: "Task Distribution", en: "Task Distribution", ar: "توزيع المهام" },
	{
		id: "Distribution of tasks by priority, status, and type",
		en: "Distribution of tasks by priority, status, and type",
		ar: "توزيع المهام حسب الأولوية والحالة والنوع",
	},
	{
		id: "Total Tasks",
		en: "Total Tasks",
		ar: "إجمالي المهام",
	},
	{
		id: "Completed",
		en: "Completed",
		ar: "مكتملة",
	},
	{
		id: "In Progress",
		en: "In Progress",
		ar: "قيد التنفيذ",
	},
	{
		id: "To Do",
		en: "To Do",
		ar: "قيد البدء",
	},
	{
		id: "By Type",
		en: "By Type",
		ar: "حسب النوع",
	},
	{
		id: "By Location",
		en: "By Location",
		ar: "حسب الموقع",
	},
	{
		id: "By Priority",
		en: "By Priority",
		ar: "حسب الأولوية",
	},
	{
		id: "Currently working on tasks",
		en: "Currently working on tasks",
		ar: "يعمل حاليا على المهام",
	},
	{
		id: "Available but not assigned",
		en: "Available but not assigned",
		ar: "متاح ولكن غير نشط",
	},
	{
		id: "Not available or off-shift",
		en: "Not available or off-shift",
		ar: "غير متوفر أو خارج الوردية",
	},
	{ id: "Target:", en: "Target:", ar: "الهدف:" },
	{
		id: "Technician Status",
		en: "field staff Status",
		ar: "حالة المندوبين",
	},
	{
		id: "Current status and utilization of all technicians",
		en: "Current status and utilization of all field staff",
		ar: "الحالة الحالية ومستوى الاستفادة من جميع المندوبين",
	},
	{
		id: "Total Technicians",
		en: "Total field staff",
		ar: "إجمالي المندوبين",
	},
	{
		id: "Avg Tasks/Technician",
		en: "Avg Tasks/field staff",
		ar: "متوسط المهام لكل مندوب",
	},
	{
		id: "Utilization Rate",
		en: "Utilization Rate",
		ar: "معدل الاستفادة",
	},
	{
		id: "Status Breakdown",
		en: "Status Breakdown",
		ar: "تفصيل الحالة",
	},
	{
		id: "Utilization:",
		en: "Utilization:",
		ar: "الاستفادة:",
	},
	{
		id: "Excellent",
		en: "Excellent",
		ar: "ممتاز",
	},
	{
		id: "Good",
		en: "Good",
		ar: "جيد",
	},
	{
		id: "Needs Improvement",
		en: "Needs Improvement",
		ar: "يحتاج إلى تحسين",
	},
	{
		id: "Capacity:",
		en: "Capacity:",
		ar: "القدرة:",
	},
	{
		id: "At Full Capacity",
		en: "At Full Capacity",
		ar: "بكامل طاقتها",
	},
	{
		id: "Service Request Pipeline",
		en: "Service Request Pipeline",
		ar: "مسار طلبات الخدمة",
	},
	{
		id: "Status of service requests through the workflow",
		en: "Status of service requests through the workflow",
		ar: "حالة طلبات الخدمة عبر سير العمل",
	},
	{
		id: "Workflow Progress",
		en: "Workflow Progress",
		ar: "تقدم سير العمل",
	},
	{
		id: "Distribution",
		en: "Distribution",
		ar: "التوزيع",
	},
	{
		id: "By Service Type",
		en: "By Service Type",
		ar: "حسب نوع الخدمة",
	},
	{
		id: "Other",
		en: "Other",
		ar: "أخرى",
	},
	{
		id: "more types",
		en: "more types",
		ar: "أنواع أخرى",
	},
	{
		id: "Backlog:",
		en: "Backlog:",
		ar: "التراكم:",
	},
	{
		id: "Clear",
		en: "Clear",
		ar: "لا يوجد",
	},
	{
		id: "Manageable",
		en: "Manageable",
		ar: "قابل للإدارة",
	},
	{
		id: "High",
		en: "High",
		ar: "مرتفع",
	},
	{
		id: "Activity:",
		en: "Activity:",
		ar: "النشاط:",
	},
	{
		id: "New Received",
		en: "New Received",
		ar: "مستلمة جديدة",
	},
	{
		id: "Tasks created",
		en: "Tasks created",
		ar: "تم إنشاء المهام",
	},
	{
		id: "Work started",
		en: "Work started",
		ar: "تم بدء العمل",
	},
	{
		id: "Work finished",
		en: "Work finished",
		ar: "تم الانتهاء من العمل",
	},
	{
		id: "Task Metrics",
		en: "Task Metrics",
		ar: "مؤشرات المهام",
	},
	{
		id: "Detailed analytics for task performance and completion",
		en: "Detailed analytics for task performance and completion",
		ar: "تحليلات تفصيلية لأداء وإكمال المهام",
	},

	// Key Metrics
	{
		id: "Total Tasks",
		en: "Total Tasks",
		ar: "إجمالي المهام",
	},
	{
		id: "Completed",
		en: "Completed",
		ar: "منجز",
	},
	{
		id: "Overdue Tasks",
		en: "Overdue Tasks",
		ar: "المهام المتأخرة",
	},
	{
		id: "Rate",
		en: "Rate",
		ar: "النسبة",
	},

	// Performance Metrics
	{
		id: "Completion Rate",
		en: "Completion Rate",
		ar: "معدل الإكمال",
	},
	{
		id: "First-Time Fix Rate",
		en: "First-Time Fix Rate",
		ar: "معدل الإصلاح من المحاولة الأولى",
	},
	{
		id: "Current:",
		en: "Current:",
		ar: "الحالي:",
	},
	{
		id: "Average Task Duration",
		en: "Average Task Duration",
		ar: "متوسط مدة المهمة",
	},
	{
		id: "Per task",
		en: "Per task",
		ar: "لكل مهمة",
	},
	{
		id: "Tasks by Priority",
		en: "Tasks by Priority",
		ar: "المهام حسب الأولوية",
	},

	// Status Distribution
	{
		id: "Tasks by Status",
		en: "Tasks by Status",
		ar: "المهام حسب الحالة",
	},
	{
		id: "TODO",
		en: "TODO",
		ar: "للعمل",
	},
	{
		id: "INPROGRESS",
		en: "INPROGRESS",
		ar: "قيد التنفيذ",
	},
	{
		id: "DONE",
		en: "DONE",
		ar: "منجز",
	},
	{
		id: "CANCELLED",
		en: "CANCELLED",
		ar: "ملغي",
	},
	{
		id: "Performance:",
		en: "Performance:",
		ar: "الأداء:",
	},
	{
		id: "Timeliness:",
		en: "Timeliness:",
		ar: "الالتزام بالوقت:",
	},
	{
		id: "On Track",
		en: "On Track",
		ar: "على المسار",
	},
	{
		id: "Behind Schedule",
		en: "Behind Schedule",
		ar: "متأخر عن الجدول",
	},
	{ id: "UNASSIGNED", en: "UNASSIGNED", ar: "غير مسند" },
	{ id: "Form Metrics", en: "Form Metrics", ar: "مؤشرات النماذج" },
	{
		id: "Form completion statistics and pending submissions",
		en: "Form completion statistics and pending submissions",
		ar: "إحصائيات إكمال النماذج والإرسالات المعلقة",
	},
	{ id: "Pending", en: "Pending", ar: "معلق" },
	{ id: "Total Assigned", en: "Total Assigned", ar: "إجمالي المعين" },
	{ id: "Submitted Today", en: "Submitted Today", ar: "تم الإرسال اليوم" },
	{ id: "Completed", en: "Completed", ar: "مكتمل" },
	{
		id: "Overall Completion Rate",
		en: "Overall Completion Rate",
		ar: "معدل الإكمال العام",
	},
	{ id: "Completed Forms", en: "Completed Forms", ar: "النماذج المكتملة" },
	{
		id: "Successfully submitted",
		en: "Successfully submitted",
		ar: "تم الإرسال بنجاح",
	},
	{ id: "Pending Forms", en: "Pending Forms", ar: "النماذج المعلقة" },
	{
		id: "Awaiting submission",
		en: "Awaiting submission",
		ar: "في انتظار الإرسال",
	},
	{ id: "Today's Submissions", en: "Today's Submissions", ar: "إرسالات اليوم" },
	{ id: "Forms submitted", en: "Forms submitted", ar: "نماذج مرسلة" },
	{ id: "Completion:", en: "Completion:", ar: "الإكمال:" },
	{ id: "All Clear", en: "All Clear", ar: "لا يوجد مشاكل" },
	{ id: "Manageable", en: "Manageable", ar: "يمكن السيطرة عليه" },
	{ id: "High Priority", en: "High Priority", ar: "أولوية قصوى" },
	{
		id: "Geofence Metrics",
		en: "Geofence Metrics",
		ar: "مؤشرات التسييج الجغرافي",
	},
	{
		id: "Location-based check-ins and site visit analytics",
		en: "Location-based check-ins and site visit analytics",
		ar: "تحليلات تسجيل الدخول بناءً على الموقع وزيارات المواقع",
	},
	{ id: "Missed", en: "Missed", ar: "فائت" },

	{ id: "Check-ins Today", en: "Check-ins Today", ar: "تسجيلات اليوم" },
	{ id: "Total Events", en: "Total Events", ar: "إجمالي الأحداث" },

	{
		id: "Check-in Compliance Rate",
		en: "Check-in Compliance Rate",
		ar: "معدل الالتزام بالتسجيل",
	},
	{
		id: "Average Time at Site",
		en: "Average Time at Site",
		ar: "متوسط الوقت في الموقع",
	},
	{ id: "Per visit", en: "Per visit", ar: "لكل زيارة" },

	{ id: "Check-in Status", en: "Check-in Status", ar: "حالة التسجيل" },
	{
		id: "Successful Check-ins",
		en: "Successful Check-ins",
		ar: "تسجيلات ناجحة",
	},
	{
		id: "Completed on time",
		en: "Completed on time",
		ar: "أُنجز في الوقت المحدد",
	},
	{ id: "Missed Check-ins", en: "Missed Check-ins", ar: "تسجيلات فائتة" },
	{ id: "Require attention", en: "Require attention", ar: "تتطلب الانتباه" },

	{ id: "Today's Activity", en: "Today's Activity", ar: "نشاط اليوم" },
	{ id: "Check-ins", en: "Check-ins", ar: "تسجيلات" },

	{ id: "Compliance:", en: "Compliance:", ar: "الالتزام:" },
	{ id: "Excellent", en: "Excellent", ar: "ممتاز" },
	{ id: "Good", en: "Good", ar: "جيد" },
	{ id: "Needs Improvement", en: "Needs Improvement", ar: "بحاجة لتحسين" },

	{ id: "Missed:", en: "Missed:", ar: "فائت:" },
	{ id: "Acceptable", en: "Acceptable", ar: "مقبول" },

	{ id: "Monthly Comparison", en: "Monthly Comparison", ar: "مقارنة شهرية" },
	{
		id: "Performance comparison between current and previous month",
		en: "Performance comparison between current and previous month",
		ar: "مقارنة الأداء بين الشهر الحالي والسابق",
	},

	{ id: "This month", en: "This month", ar: "هذا الشهر" },
	{ id: "Last month", en: "Last month", ar: "الشهر الماضي" },

	{ id: "Performance Summary", en: "Performance Summary", ar: "ملخص الأداء" },

	{ id: "Tasks:", en: "Tasks:", ar: "المهام:" },
	{ id: "Growing", en: "Growing", ar: "في تزايد" },
	{ id: "Declining", en: "Declining", ar: "في انخفاض" },

	{ id: "Improving", en: "Improving", ar: "في تحسن" },

	{ id: "Duration:", en: "Duration:", ar: "المدة:" },
	{ id: "Increasing", en: "Increasing", ar: "في ازدياد" },
	{ id: "Tasks Created", en: "Tasks Created", ar: "المهام المُنشأة" },
	{ id: "Tasks Completed", en: "Tasks Completed", ar: "المهام المكتملة" },
	{ id: "Service Requests", en: "Service Requests", ar: "طلبات الخدمة" },
	{ id: "Avg Duration", en: "Avg Duration", ar: "المتوسط الزمني" },
	{
		id: "Total tasks created this month vs last month",
		en: "Total tasks created this month vs last month",
		ar: "إجمالي المهام المُنشأة هذا الشهر مقارنة بالشهر الماضي",
	},
	{
		id: "Tasks completed this month vs last month",
		en: "Tasks completed this month vs last month",
		ar: "المهام المكتملة هذا الشهر مقارنة بالشهر الماضي",
	},
	{
		id: "New service requests this month vs last month",
		en: "New service requests this month vs last month",
		ar: "طلبات الخدمة الجديدة هذا الشهر مقارنة بالشهر الماضي",
	},
	{
		id: "Average task duration this month vs last month",
		en: "Average task duration this month vs last month",
		ar: "متوسط مدة المهام هذا الشهر مقارنة بالشهر الماضي",
	},
	{ id: "Performance Trends", en: "Performance Trends", ar: "اتجاهات الأداء" },
	{ id: "Tasks Trend", en: "Tasks Trend", ar: "اتجاه المهام" },
	{ id: "Completions Trend", en: "Completions Trend", ar: "اتجاه الإنجازات" },
	{ id: "Requests Trend", en: "Requests Trend", ar: "اتجاه الطلبات" },
	{ id: "Rate Trend", en: "Rate Trend", ar: "اتجاه المعدل" },

	{ id: "Tasks Created", en: "Tasks Created", ar: "المهام المُنشأة" },
	{ id: "Tasks Completed", en: "Tasks Completed", ar: "المهام المُكتملة" },
	{ id: "Service Requests", en: "Service Requests", ar: "طلبات الخدمة" },
	{
		id: "Completion Rate",
		en: "Completion Rate",
		ar: "معدل الإنجاز",
	},
	{
		id: "Performance Insights",
		en: "Performance Insights",
		ar: "تحليلات الأداء",
	},
	{ id: "Workload", en: "Workload", ar: "عبء العمل" },
	{ id: "Efficiency", en: "Efficiency", ar: "الكفاءة" },
	{ id: "Increasing", en: "Increasing", ar: "في ازدياد" },
	{ id: "Decreasing", en: "Decreasing", ar: "في انخفاض" },
	{ id: "Improving", en: "Improving", ar: "يتحسن" },
	{ id: "Declining", en: "Declining", ar: "يتراجع" },
	{
		id: "Loading performance trends...",
		en: "Loading performance trends...",
		ar: "جارٍ تحميل اتجاهات الأداء...",
	},
	{
		id: "Failed to load performance trends",
		en: "Failed to load performance trends",
		ar: "فشل تحميل اتجاهات الأداء",
	},
	{ id: "Months", en: "Months", ar: "شهور" },
	{ id: "Completions", en: "Completions", ar: "المنتهية" },
	{ id: "account", en: "account", ar: "الحساب" },
	{ id: "setup", en: "setup", ar: "الاعدادات" },
	{ id: "Field Tasks", en: "Field Tasks", ar: "المهام الميدانية" },
	{ id: "tasks", en: "tasks", ar: "المهام" },
	{ id: "Export PDF", en: "Export PDF", ar: "تنزيل PDF" },
	{ id: "Export XLSX", en: "Export XLSX", ar: "تنزيل XLSX" },
	{ id: "Customer Location", en: "Customer Location", ar: "موقع العميل" },
	{
		id: "You are not authorized",
		en: "You are not authorized",
		ar: "غير مسموح بالدخول",
	},
	{
		id: "You can't drop a container into a container",
		en: "You can't drop a container into a container",
		ar: "غير مسموح بإضافة container داخل container أخر ",
	},
	{
		id: "Please add at least one field to the form",
		en: "Please add at least one field to the form",
		ar: "برجاء إضافة حقل واحد علي الأقل داخل النموذج",
	},
	{
		id: "Failed to edit geofence",
		en: "Failed to edit geofence",
		ar: "فشل في تعديل السياج",
	},
	{
		id: "Failed to add geofence",
		en: "Failed to add geofence",
		ar: "فشل في إضافة السياج",
	},
	{ id: "Failed to login", en: "Failed to login", ar: "فشل في تسجيل الدخول" },
	{ id: "Task assigned to", en: "Task assigned to", ar: "تم إسناد المهمة إلي" },
	{ id: "Task unassigned", en: "Task unassigned", ar: "مهمة غير معينة" },
	{ id: "Session Expired", en: "Session Expired", ar: "انتهت صلاحية الجلسة" },
	{
		id: "All rights reserved",
		en: "All rights reserved",
		ar: "جميع الحقوق محفوظة",
	},
	{ id: "tasks", en: "tasks", ar: "المهام" },
	{
		id: "Failed to load task distribution",
		en: "Failed to load task distribution",
		ar: "فشل في تحميل توزيع المهام",
	},
	{
		id: "Total Tasks",
		en: "Total Tasks",
		ar: "إجمالي المهام",
	},
	{
		id: "Completed",
		en: "Completed",
		ar: "مكتملة",
	},
	{
		id: "In Progress",
		en: "In Progress",
		ar: "قيد التنفيذ",
	},
	{
		id: "Pending",
		en: "Pending",
		ar: "معلقة",
	},
	{
		id: "Task Distribution",
		en: "Task Distribution",
		ar: "توزيع المهام",
	},
	{
		id: "Comprehensive Task Analytics",
		en: "Comprehensive Task Analytics",
		ar: "تحليلات شاملة للمهام",
	},
	{
		id: "Total",
		en: "Total",
		ar: "الإجمالي",
	},
	{
		id: "Complete",
		en: "Complete",
		ar: "مكتمل",
	},
	{
		id: "Active",
		en: "Active",
		ar: "نشط",
	},
	{
		id: "Distribution by Location",
		en: "Distribution by Location",
		ar: "التوزيع حسب الموقع",
	},
	{
		id: "Tasks by Type",
		en: "Tasks by Type",
		ar: "المهام حسب النوع",
	},
	{
		id: "Priority Breakdown",
		en: "Priority Breakdown",
		ar: "تفصيل الأولويات",
	},
	{
		id: "No location data available",
		en: "No location data available",
		ar: "لا توجد بيانات موقع متاحة",
	},
	{
		id: "No task type data available",
		en: "No task type data available",
		ar: "لا توجد بيانات نوع مهام متاحة",
	},
	{
		id: "Urgent Tasks",
		en: "Urgent Tasks",
		ar: "مهام عاجلة",
	},
	{
		id: "High Priority",
		en: "High Priority",
		ar: "أولوية عالية",
	},
	{
		id: "Medium Priority",
		en: "Medium Priority",
		ar: "أولوية متوسطة",
	},
	{
		id: "Low Priority",
		en: "Low Priority",
		ar: "أولوية منخفضة",
	},
	{
		id: "Other",
		en: "Other",
		ar: "أخرى",
	},
	{
		id: "Urgent",
		en: "Urgent",
		ar: "عاجل",
	},
	{
		id: "High",
		en: "High",
		ar: "عالي",
	},
	{
		id: "Medium",
		en: "Medium",
		ar: "متوسط",
	},
	{
		id: "Low",
		en: "Low",
		ar: "منخفض",
	},
	{
		id: "Priority",
		en: "Priority",
		ar: "الأولوية",
	},
	{
		id: "of total",
		en: "of total",
		ar: "من الإجمالي",
	},
	{
		id: "Tasks",
		en: "Tasks",
		ar: "المهام",
	},
	{
		id: "Real-time monitoring & notifications",
		en: "Real-time monitoring & notifications",
		ar: "المتابعة اللحظية والإشعارات",
	},
	{
		id: "Critical alerts require immediate attention",
		en: "Critical alerts require immediate attention",
		ar: "تنبيهات حرجة تتطلب التدخل الفوري",
	},
	{
		id: "items requiring attention",
		en: "items requiring attention",
		ar: "عناصر تتطلب الانتباه",
	},
	{
		id: "of all alerts",
		en: "of all alerts",
		ar: "من إجمالي التنبيهات",
	},
	{
		id: "No Active Alerts",
		en: "No Active Alerts",
		ar: "لا توجد تنبيهات نشطة",
	},
	{
		id: "Status Distribution",
		en: "Status Distribution",
		ar: "توزيع الحالات",
	},
	{
		id: "Pipeline Overview",
		en: "Pipeline Overview",
		ar: "نظرة عامة على سير العمل",
	},
	{
		id: "New",
		en: "New",
		ar: "جديد",
	},
	{
		id: "Pipeline Status",
		en: "Pipeline Status",
		ar: "حالة سير العمل",
	},
	{
		id: "Top Service Types",
		en: "Top Service Types",
		ar: "أعلي الخدمات طلبا",
	},
	{
		id: "Hourly Request Distribution",
		en: "Hourly Request Distribution",
		ar: "توزيع الطلبات حسب الوقت",
	},
	{
		id: "Average Completion Duration",
		en: "Average Completion Duration",
		ar: "متوسط الزمن المستغرق",
	},
	{
		id: "Top Performers",
		en: "Top Performers",
		ar: "الأكثر كفاءة",
	},
	{
		id: "Performance by Location",
		en: "Performance by Location",
		ar: "الأداء حسب الموقع",
	},
	{
		id: "7-Day Backlog Trend",
		en: "7-Day Backlog Trend",
		ar: "اتجاه الأعمال المتراكمة خلال 7 أيام",
	},
	{
		id: "Task Types Performance",
		en: "Task Types Performance",
		ar: "الاداء بالنسبه لأنواع المهام",
	},
	{
		id: "Total Forms",
		en: "Total Forms",
		ar: "إجمالي النماذج",
	},
	{
		id: "Comprehensive Task Analytics",
		en: "Comprehensive Task Analytics",
		ar: "تحليلات شاملة للمهام",
	},
	{
		id: "Active",
		en: "Active",
		ar: "نشط",
	},
	{
		id: "Complete",
		en: "Complete",
		ar: "مكتمل",
	},
	{
		id: "Total",
		en: "Total",
		ar: "إجمالي",
	},
	{
		id: "Busy",
		en: "Busy",
		ar: "مشغول",
	},
	{
		id: "Backlog",
		en: "Backlog",
		ar: "الأعمال المتراكمة",
	},
	{
		id: "Coverage",
		en: "Coverage",
		ar: "التغطية",
	},
	{
		id: "Utilization",
		en: "Utilization",
		ar: "المندوبين المستخدمين",
	},
	{
		id: "On Shift",
		en: "On Shift",
		ar: "في الوردية",
	},
	{
		id: "Ready to assign",
		en: "Ready to assign",
		ar: "جاهز للإسناد",
	},
	{
		id: "Working now",
		en: "Working now",
		ar: "يعمل الآن",
	},
	{
		id: "Real-time Employee overview",
		en: "Real-time Employee overview",
		ar: "نظرة عامة على المندوبين في الوقت الحالي",
	},
	{
		id: "Monthly Performance",
		en: "Monthly Performance",
		ar: "الأداء الشهري",
	},
	{
		id: "THIS MONTH",
		en: "THIS MONTH",
		ar: "هذا الشهر",
	},
	{
		id: "Last Month",
		en: "Last Month",
		ar: "الشهر الماضي",
	},
	{
		id: "Compare current month performance with previous month",
		en: "Compare current month performance with previous month",
		ar: "مقارنة أداء الشهر الحالي بالشهر السابق",
	},
	{
		id: "Historical performance trends and patterns",
		en: "Historical Performance Trends and Patterns",
		ar: "اتجاهات وأنماط الأداء الفترة الماضية",
	},
	{
		id: "vs Last Month",
		en: "vs Last Month",
		ar: "مقارنة بالشهر الماضي",
	},
	{
		id: "Performance Chart",
		en: "Performance Chart",
		ar: "مخطط الأداء",
	},
	{
		id: "All",
		en: "All",
		ar: "الجميع",
	},
	{
		id: "user type",
		en: "user type",
		ar: "اختيار دور المستخدم",
	},
	{ id: "Absent Staff", en: "Absent Staff", ar: "المندوبين الغائبين" },
	{
		id: "Comprehensive Form Analytics",
		en: "Comprehensive Form Analytics",
		ar: "تحليلات النماذج الشاملة",
	},
	{
		id: "Field Staff is linked to user successfully",
		en: "Field Staff is linked to user successfully",
		ar: "تم ربط المندوب بالمستخدم بنجاح",
	},
	{
		id: "Field Staff is unlinked from user successfully",
		en: "Field Staff is unlinked from user successfully",
		ar: "تم فصل المندوب عن المستخدم بنجاح",
	},
	{
		id: "Exisiting customers",
		en: "Exisiting customers",
		ar: "العملاء الحاليين",
	},
	{
		id: "Add new customer",
		en: "Add new customer",
		ar: "إضافة عميل جديد",
	},
	{
		id: "customers",
		en: "customers",
		ar: "العملاء",
	},
	{
		id: "Edit customer",
		en: "Edit customer",
		ar: "تعديل بيانات العميل",
	},
	{
		id: "You can't delete POI with un resolved tasks",
		en: "You can't delete POI with un resolved tasks",
		ar: "لا يمكن حذف نقطة مهمة مسندة لمهام غير منفذة",
	},
	// POI deletion blockers (backend returns a `code`, the UI builds the message
	// so the task/child counts can be interpolated per language).
	{
		id: "This POI has unresolved tasks",
		en: "This POI has unresolved tasks",
		ar: "هذه النقطة المهمة بها مهام غير منفذة",
	},
	{
		id: "This POI has active child POIs",
		en: "This POI has active child POIs",
		ar: "هذه النقطة المهمة بها نقاط فرعية نشطة",
	},
	{
		id: "unresolved task(s) are still attached to it",
		en: "unresolved task(s) are still attached to it",
		ar: "مهمة غير منفذة لا تزال مرتبطة بها",
	},
	{
		id: "active child POI(s) must be deleted first",
		en: "active child POI(s) must be deleted first",
		ar: "نقطة فرعية نشطة يجب حذفها أولاً",
	},
	{
		id: "Delete these child POIs first, then delete this one",
		en: "Delete these child POIs first, then delete this one",
		ar: "احذف النقاط الفرعية التالية أولاً، ثم احذف هذه النقطة",
	},
	{
		id: "Resolve or reassign these tasks first",
		en: "Resolve or reassign these tasks first",
		ar: "يرجى إنهاء أو إعادة إسناد هذه المهام أولاً",
	},
	{
		id: "Cancel these tasks and delete POI",
		en: "Cancel these tasks and delete POI",
		ar: "إلغاء هذه المهام وحذف النقطة",
	},
	{
		id: "Cancelling is permanent and cannot be undone",
		en: "Cancelling is permanent and cannot be undone",
		ar: "الإلغاء نهائي ولا يمكن التراجع عنه",
	},
	{
		id: "Only administrators can cancel these tasks",
		en: "Only administrators can cancel these tasks",
		ar: "فقط المسؤولون يمكنهم إلغاء هذه المهام",
	},
	{
		id: "and more",
		en: "and more",
		ar: "وغيرها",
	},
	{
		id: "task(s) cancelled",
		en: "task(s) cancelled",
		ar: "مهمة تم إلغاؤها",
	},
	{
		id: "Field Staff is linked to user successfully",
		en: "Field Staff is linked to user successfully",
		ar: "تم ربط المندوب بالمستخدم بنجاح",
	},
	{
		id: "Field Staff is unlinked from user successfully",
		en: "Field Staff is unlinked from user successfully",
		ar: "تم فصل المندوب عن المستخدم بنجاح",
	},
	{
		id: "Field Staff is linked to user successfully",
		en: "Field Staff is linked to user successfully",
		ar: "تم ربط المندوب بالمستخدم بنجاح",
	},
	{
		id: "Field Staff is unlinked from user successfully",
		en: "Field Staff is unlinked from user successfully",
		ar: "تم فصل المندوب عن المستخدم بنجاح",
	},
	{ id: "Total Shifts", en: "Total Shifts", ar: "اجمالي عدد الورديات" },
	{ id: "Shift Attendance", en: "Shift Attendance", ar: "عدد ورديات الحضور" },
	{ id: "Absent Shifts", en: "Absent Shifts", ar: "عدد مرات الغياب" },
	{ id: "Late Attendance", en: "Late Attendance", ar: "عدد مرات التأخير" },
	{
		id: "Early Departure",
		en: "Early Departure",
		ar: "عدد مرات المغادرة المبكرة",
	},
	{
		id: "Shift Compliance Report",
		en: "Shift Compliance Report",
		ar: "تقرير الالتزام بالوردية",
	},
	{ id: "Total Work Hours", en: "Total Work Hours", ar: "اجمالي ساعات العمل" },
	{ id: "Total Late", en: "Total Late", ar: "اجمالي عدد مرات التأخير" },
	{
		id: "Total Early Departure",
		en: "Total Early Departure",
		ar: "إجمالي المغادرة المبكرة",
	},
	{ id: "Total Overtime", en: "Total Overtime", ar: "إجمالي الوقت الإضافي" },
	{ id: "Shift Attendance %", en: "Shift Attendance %", ar: "نسبة الحضور" },
	{ id: "Shift Absence %", en: "Shift Absence %", ar: "نسبة الغياب" },
	{
		id: "Attendance Threshold",
		en: "Attendance Threshold",
		ar: "الحد الأدني للحضور",
	},
	{ id: "Late Threshold", en: "Late Threshold", ar: "الحد الأدني للتأخير" },
	{ id: "Min", en: "Min", ar: "دقيقة" },
	{ id: "Hr", en: "Hr", ar: "ساعة" },
	{ id: "attendance", en: "Shift Compliance", ar: "الالتزام للوردية" },
	{ id: "shift Compliance", en: "shift Compliance", ar: "الالتزام للوردية" },
	{ id: "Attendance Report", en: "Attendance Report", ar: "تقرير الحضور" },
	{ id: "dailyAttendance", en: "Attendance Report", ar: "تقرير الحضور" },
	{ id: "Assigned Shift", en: "Assigned Shift", ar: "الورديات المسنودة" },
	{ id: "Actual Shift", en: "Actual Shift", ar: "الورديات الفعلية" },
	{ id: "Work Hours", en: "Work Hours", ar: "ساعات العمل" },
	{ id: "Early Leave", en: "Early Leave", ar: "إجازة مبكرة" },
	{ id: "Late Hours", en: "Late Hours", ar: "ساعات متأخرة" },
	{ id: "Overtime", en: "Overtime", ar: "الوقت الاضافي" },
	{ id: "UAE", en: "UAE", ar: "الإمارات" },
	{ id: "busy", en: "busy", ar: "مشغول" },
	{ id: "true", en: "true", ar: "نعم" },
	{ id: "false", en: "false", ar: "لا" },
	{
		id: "you're not allowed to edit on this task, please contact the reporter!",
		en: "you're not allowed to edit on this task, please contact the reporter!",
		ar: "لا يُسمح لك بتحرير هذه المهمة، يرجى الاتصال المسؤول!",
	},
	{
		id: "Exisiting customers",
		en: "Exisiting customers",
		ar: "العملاء الحاليين",
	},
	{
		id: "Add new customer",
		en: "Add new customer",
		ar: "إضافة عميل جديد",
	},
	{
		id: "customers",
		en: "customers",
		ar: "العملاء",
	},
	{
		id: "Edit customer",
		en: "Edit customer",
		ar: "تعديل بيانات العميل",
	},
	{
		id: "You can't delete POI with un resolved tasks",
		en: "You can't delete POI with un resolved tasks",
		ar: "لا يمكن حذف نقطة مهمة مسندة لمهام غير منفذة",
	},
	{
		id: "Customer expiration date is required",
		en: "Customer expiration date is required",
		ar: "تاريخ انتهاء الصلاحية مطلوب",
	},
	{
		id: "Cannot delete a form that has submissions",
		en: "Cannot delete a form that has submissions",
		ar: "لا يمكن حذف نموذج تم استخدامه",
	},
	{
		id: "Customer is linked to user successfully",
		en: "Customer is linked to user successfully",
		ar: "تم ربط المندوب بالمستخدم بنجاح",
	},
	{
		id: "Customer is unlinked from user successfully",
		en: "Customer is unlinked from user successfully",
		ar: "تم فصل المندوب عن المستخدم بنجاح",
	},
	{
		id: "POI is linked to user successfully",
		en: "POI is linked to user successfully",
		ar: "تم ربط نقطة مهمة بالمستخدم بنجاح",
	},
	{
		id: "POI is unlinked from user successfully",
		en: "POI is unlinked from user successfully",
		ar: "تم فصل نقطة مهمة عن المستخدم بنجاح",
	},
	{
		id: "Delayed tasks beyond deadlines.",
		en: "Delayed tasks beyond deadlines.",
		ar: "المهام المتأخرة عن المواعيد المحددة",
	},
	{ id: "SLA violations.", en: "SLA violations.", ar: "إنتهاكات مستوى الخدمة" },
	{
		id: "Inactive field staff.",
		en: "Inactive field staff.",
		ar: "المندوبين غير المكلفين بالمهام ",
	},
	{
		id: "Currently absent staff.",
		en: "Currently absent staff.",
		ar: "المندوبين الغائبين حاليًا",
	},
	{
		id: "Forms awaiting submission or approval",
		en: "Forms awaiting submission or approval",
		ar: "نماذج بانتظار الإرسال أو الموافقة",
	},
	{
		id: "Requests under review ",
		en: "Requests under review ",
		ar: "طلبات قيد المراجعة",
	},
	{
		id: "Staff Count",
		en: "Staff Count",
		ar: "إجمالي عدد المندوبين",
	},
	{
		id: "Measure of how efficiently resources are used",
		en: "Measure of how efficiently resources are used",
		ar: "مقياس كفاءة استخدام الموارد",
	},
	{
		id: "Extent of staff availability across operations",
		en: "Extent of staff availability across operations",
		ar: "مدى توفر المندوبين لتغطية العمليات",
	},
	{
		id: "Pending workload / Outstanding tasks",
		en: "Pending workload / Outstanding tasks",
		ar: "المهام غير المنجزة من قبل المندوب",
	},
	{
		id: "Overall count of tasks",
		en: "Overall count of tasks",
		ar: "إجمالي عدد المهام  المسجلة",
	},
	{
		id: "Tasks currently being worked on",
		en: "Tasks currently being worked on",
		ar: "المهام التي يتم تنفيذها حاليًا",
	},
	{
		id: "Number of tasks successfully completed",
		en: "Number of tasks successfully completed",
		ar: "عدد المهام التي تم إنجازها بنجاح",
	},
	{
		id: "Tasks awaiting action or start",
		en: "Tasks awaiting action or start",
		ar: "مهام بانتظار البدأ بها ",
	},
	{
		id: "Shows how data is distributed across locations",
		en: "Shows how data is distributed across locations",
		ar: "كيفية توزيع البيانات عبر المواقع",
	},
	{
		id: "Displays task distribution based on type",
		en: "Displays task distribution based on type",
		ar: "توزيع المهام حسب النوع",
	},
	{
		id: "Forms awaiting submission or approval.",
		en: "Forms awaiting submission or approval.",
		ar: "نماذج بانتظار الإرسال أو الموافقة",
	},
	{
		id: "Requests under review.",
		en: "Requests under review.",
		ar: "طلبات قيد المراجعة",
	},
	{
		id: "Total number of submitted and pending forms",
		en: "Total number of submitted and pending forms",
		ar: "إجمالي عدد النماذج المقدّمة والمعلقة",
	},
	{
		id: "Forms successfully submitted",
		en: "Forms successfully submitted",
		ar: "نماذج تم إرسالها بنجاح من قبل المستخدم",
	},
	{
		id: "Forms awaiting review or approval",
		en: "Forms awaiting review or approval",
		ar: "نماذج بانتظار المراجعة أو الموافقة",
	},
	{
		id: "Percentage of forms completed successfully",
		en: "Percentage of forms completed successfully",
		ar: "نسبة النماذج التي تم إكمالها بنجاح",
	},
	{
		id: "Weekly backlog performance trend",
		en: "Weekly backlog performance trend",
		ar: "يعرض النماذج خلال آخر 7 أيام",
	},
	{
		id: "Compares performance across different locations",
		en: "Compares performance across different locations",
		ar: "يقارن الأداء فى المواقع المختلفة",
	},
	{
		id: "Recently created service requests awaiting assignment",
		en: "Recently created service requests awaiting assignment",
		ar: "طلبات خدمة جديدة بانتظار الإسناد",
	},
	{
		id: "Requests assigned to team members for action",
		en: "Requests assigned to team members for action",
		ar: "طلبات تم إسنادها لأعضاء الفريق للتنفيذ",
	},
	{
		id: "Requests currently being handled by the team",
		en: "Requests currently being handled by the team",
		ar: "طلبات قيد المعالجة من الفريق",
	},
	{
		id: "Requests successfully completed and closed",
		en: "Requests successfully completed and closed",
		ar: "طلبات تم تنفيذها وإغلاقها بنجاح",
	},
	{
		id: "Shows how service requests are distributed throughout the day",
		en: "Shows how service requests are distributed throughout the day",
		ar: "يعرض توزيع طلبات الخدمة على مدار اليوم",
	},
	{
		id: "Highlights employees with the best task completion rates",
		en: "Highlights employees with the best task completion rates",
		ar: "يعرض المندوبين ذوي أعلى معدل إنجاز بناءً على المهام المخصصة له",
	},
	{
		id: "Compares submitted and pending forms by task type",
		en: "Compares submitted and pending forms by task type",
		ar: "يقارن بين المهام المقدّمة والمعلقة حسب نوع المهمة",
	},
	{
		id: "Indicates monthly variation in total tasks created",
		en: "Indicates monthly variation in total tasks created",
		ar: "يوضح التغير الشهري في عدد المهام المنشأة",
	},
	{
		id: "Tracks the change in completed tasks over time",
		en: "Tracks the change in completed tasks over time",
		ar: "يتتبع التغير في عدد المهام المكتملة بمرور الوقت",
	},
	{
		id: "Shows how service request volume changes ",
		en: "Shows how service request volume changes ",
		ar: "يعرض تغيير حجم طلبات الخدمة شهريًا",
	},
	{
		id: "Represents changes in overall performance rate",
		en: "Represents changes in overall performance rate",
		ar: "يمثل تغير معدل الأداء العام",
	},
	{
		id: "Number of tasks successfully completed during the month.",
		en: "Number of tasks successfully completed during the month.",
		ar: "عدد المهام التي تم إنجازها بنجاح خلال الشهر.",
	},
	{
		id: "Total number of tasks created this month.",
		en: "Total number of tasks created this month.",
		ar: "إجمالي عدد المهام التي تم إنشاؤها هذا الشهر.",
	},
	{
		id: "Total service requests received within the month.",
		en: "Total service requests received within the month.",
		ar: "إجمالي طلبات الخدمة المستلمة خلال الشهر.",
	},
	{
		id: "Average time taken to complete all tasks.",
		en: "Average time taken to complete all tasks.",
		ar: "متوسط الوقت المستغرق لإكمال جميع المهام.",
	},
	{
		id: "a quick overview of workload and efficiency trends to consider operational performance.",
		en: "a quick overview of workload and efficiency trends to consider operational performance.",
		ar: "نظرة عامة سريعة على اتجاهات العمل والكفاءة.",
	},
	{
		id: "Summarizes key performance indicators to track overall progress",
		en: "Summarizes key performance indicators to track overall progress",
		ar: "ملخّص لأبرز مؤشرات الأداء لمتابعة التقدم العام",
	},
	{
		id: "Displays the average time taken to complete each service type",
		en: "Displays the average time taken to complete each service type",
		ar: "يعرض متوسط الوقت المستغرق لإتمام كل نوع من الخدمات",
	},
	{
		id: "Shows performance changes and trends over a period of time",
		en: "Shows performance changes and trends over a period of time",
		ar: "يعرض تغيرات واتجاهات الأداء خلال فترة زمنية",
	},
	{
		id: "Compares current month performance with the previous month.",
		en: "Compares current month performance with the previous month.",
		ar: "يقارن أداء الشهر الحالي بالشهر السابق",
	},
	{
		id: "Shows the percentage of active staff currently engaged in tasks",
		en: "Shows the percentage of active staff currently engaged in tasks",
		ar: "يوضح نسبة المندوبين النشطين المشاركين في المهام حاليًا",
	},
	{
		id: "Visual breakdown of staff activity status across all shifts",
		en: "Visual breakdown of staff activity status across all shifts",
		ar: "توزيع حالة المندوبين خلال جميع الورديات",
	},
	{
		id: "Displays task distribution by priority level to help identify workload ",
		en: "Displays task distribution by priority level to help identify workload ",
		ar: "يعرض توزيع المهام حسب الأولوية",
	},
	{
		id: "Shows the progress of service requests through different workflow stages",
		en: "Shows the progress of service requests through different workflow stages",
		ar: "يعرض مدى تقدم طلبات الخدمة عبر مراحل سير العمل المختلفة",
	},
	{
		id: "Highlights the most frequently requested service categories",
		en: "Highlights the most frequently requested service categories",
		ar: "يظهر أكثر أنواع الخدمات طلبًا",
	},
	{
		id: "Tracks monthly trends in tasks, completions, and service requests to evaluate",
		en: "Tracks monthly trends in tasks, completions, and service requests to evaluate performance efficiency",
		ar: "يتتبع الأداء الشهري للمهام والإنجازات وطلبات الخدمة لتقييم كفاءة الأداء",
	},
	{
		id: "Add new permission",
		en: "Add new permission",
		ar: "إضافة إذن جديد",
	},
	{
		id: "Add new role",
		en: "Add new role",
		ar: "إضافة دور جديد",
	},
	{
		id: "roles&permissions",
		en: "roles&permissions",
		ar: "الأدوار والأذونات",
	},
	{
		id: "overview",
		en: "overview",
		ar: "الملخص",
	},
	{
		id: "roles",
		en: "roles",
		ar: "الأدوار",
	},
	{
		id: "permissions",
		en: "permissions",
		ar: "الأذونات",
	},
	{
		id: "users",
		en: "users",
		ar: "المستخدمين",
	},
	{
		id: "history",
		en: "history",
		ar: "السجل",
	},
	{
		id: "Resource",
		en: "Resource",
		ar: "المصدر",
	},
	{
		id: "Module",
		en: "Module",
		ar: "الوحدة",
	},
	{
		id: "Resources",
		en: "Resources",
		ar: "المصادر",
	},
	{
		id: "Modules",
		en: "Modules",
		ar: "الوحدات",
	},
	{
		id: "Hierarchy Level",
		en: "Hierarchy Level",
		ar: "مستوى التسلسل الهرمي",
	},
	{
		id: "Access Level",
		en: "Access Level",
		ar: "مستوي الوصول",
	},
	{
		id: "access control",
		en: "access control",
		ar: "التحكم في الوصول",
	},
	{
		id: "Sub Module",
		en: "Sub Module",
		ar: "الوحدة الفرعية",
	},
	{
		id: "Sub-Modules",
		en: "Sub-Modules",
		ar: "الوحدات الفرعية",
	},
	{
		id: "e.g., View Attendance Records",
		en: "e.g., View Attendance Records",
		ar: "مثال، عرض سجلات الحضور",
	},
	{
		id: "Describe what this permission allows",
		en: "Describe what this permission allows",
		ar: "وصف ما يسمح به هذا الإذن",
	},
	{
		id: "Select resource",
		en: "Select resource",
		ar: "إختيار المصدر",
	},
	{
		id: "Select module",
		en: "Select module",
		ar: "إختيار الوحدة",
	},
	{
		id: "Select sub-module",
		en: "Select sub-module",
		ar: "إختيار الوحدة الفرعية",
	},
	{
		id: "Select access-level",
		en: "Select access-level",
		ar: "إختيار مستوي الوصول",
	},
	{
		id: "Select hierarchy-level",
		en: "Select hierarchy-level",
		ar: "إختيار مستوي التسلسل الهرمي",
	},
	{
		id: "View",
		en: "View",
		ar: "عرض",
	},
	{
		id: "Admin",
		en: "Admin",
		ar: "المسؤل",
	},
	{
		id: "Task",
		en: "Task",
		ar: "المهمة",
	},
	{
		id: "Route",
		en: "Route",
		ar: "مسار",
	},
	{
		id: "Fleet management & Live tracking",
		en: "Fleet management & Live tracking",
		ar: "إدارة الأسطول والتتبع المباشر",
	},
	{
		id: "Select actions",
		en: "Select actions",
		ar: "إختيار الإجراء",
	},
	{
		id: "task",
		en: "task",
		ar: "مهمة",
	},
	{
		id: "Form",
		en: "Form",
		ar: "نموذج",
	},
	{
		id: "Resource is required",
		en: "Resource is required",
		ar: "المصدر مطلوب",
	},
	{
		id: "Sub-Module is required",
		en: "Sub-Module is required",
		ar: "الوحدة الفرعية مطلوبة",
	},
	{
		id: "Actions is required",
		en: "Actions is required",
		ar: "الإجراءات مطلوبة",
	},
	{
		id: "Module is required",
		en: "Module is required",
		ar: "الوحدة مطلوبة",
	},
	{
		id: "poi",
		en: "poi",
		ar: "نقطة مهمة",
	},
	{
		id: "ADMIN",
		en: "ADMIN",
		ar: "المسؤل",
	},
	{
		id: "MANAGER",
		en: "MANAGER",
		ar: "المدير",
	},
	{
		id: "DEVICE_READ_ONLY",
		en: "DEVICE_READ_ONLY",
		ar: "صلاحية الأجهزة فقط",
	},
	{
		id: "READ_ONLY",
		en: "READ_ONLY",
		ar: "صلاحية العرض فقط",
	},
	{
		id: "FIELD_STAFF",
		en: "FIELD_STAFF",
		ar: "المندوبيين الميدانيين",
	},
	{
		id: "TRACKING",
		en: "TRACKING",
		ar: "إدارة الأسطول والتتبع المباشر",
	},
	{
		id: "Setup",
		en: "Setup",
		ar: "الإعدادت",
	},
	{
		id: "A permission with this name already exists.",
		en: "A permission with this name already exists.",
		ar: "يوجد إذن بهذا الاسم بالفعل.",
	},
	{
		id: "Permission Added Successfully",
		en: "Permission Added Successfully",
		ar: "تم إضافة الإذن بنجاح",
	},
	{
		id: "Edit permission",
		en: "Edit permission",
		ar: "تعديل إذن",
	},
	{
		id: "Permission Edited Successfully",
		en: "Permission Edited Successfully",
		ar: "تم تعديل الإذن بنجاح",
	},
	{
		id: "Permission Deleted Successfully",
		en: "Permission Deleted Successfully",
		ar: "تم حذف الإذن بنجاح",
	},
	{
		id: "permission",
		en: "permission",
		ar: "الإذن",
	},
	{
		id: "Hierarchy Levels is required",
		en: "Hierarchy Levels is required",
		ar: "التسلسل الهرمي مطلوب",
	},
	{
		id: "Access Type",
		en: "Access Type",
		ar: "نوع الوصول",
	},
	{
		id: "You can only update permissions you created",
		en: "You can only update permissions you created",
		ar: "يمكنك فقط تحديث الأذونات التي قمت بإنشائها",
	},
	{
		id: "You've already created a permission with this name.",
		en: "You've already created a permission with this name.",
		ar: "لقد قمت بالفعل بإنشاء إذن بهذا الاسم.",
	},
	{
		id: "You can only delete permissions you created",
		en: "You can only delete permissions you created",
		ar: "يمكنك فقط حذف الأذونات التي قمت بإنشائها",
	},
	{
		id: "access type",
		en: "access type",
		ar: "نوع الوصول",
	},
	{
		id: "Access Type is required",
		en: "Access Type is required",
		ar: "نوع الوصول مطلوب",
	},
	{
		id: "Select access type",
		en: "Select access type",
		ar: "إختيار نوع الوصول",
	},
	{
		id: "Name cannot contain special characters",
		en: "Name cannot contain special characters",
		ar: "لا يمكن أن يحتوي الاسم على أحرف خاصة",
	},
	{ id: "Select permissions", en: "Select permissions", ar: "إختيار الأذونات" },
	{
		id: "Role Expiration Date",
		en: "Role Expiration Date",
		ar: "تاريخ إنتهاء صلاحية الدور",
	},
	{ id: "Enter role name", en: "Enter role name", ar: "أدخل اسم الدور" },
	{ id: "User Type", en: "User Type", ar: "نوع المستخدم" },
	{
		id: "e.g. Supervisor , Field Staff",
		en: "e.g. Supervisor , Field Staff",
		ar: "على سبيل المثال المشرف، المندوبين",
	},
	{
		id: "Permissions is required",
		en: "Permissions is required",
		ar: "الأذونات مطلوبة",
	},
	{
		id: "User type is required",
		en: "User type is required",
		ar: "نوع المستخدم مطلوب",
	},
	{ id: "Permissions", en: "Permissions", ar: "ألأذونات" },
	{ id: "SUPERVISOR", en: "SUPERVISOR", ar: "المشرف" },
	{
		id: "Role Deleted Successfully",
		en: "Role Deleted Successfully",
		ar: "تم حذف الدور بنجاح",
	},
	{
		id: "Name must be at most 20 characters",
		en: "Name must be at most 20 characters",
		ar: "يجب أن يتكون الاسم من 20 حرفًا على الأكثر",
	},

	{
		id: "Role Name can be only in Arabic or English languages and valid characters",
		en: "Role Name can be only in Arabic or English languages and valid characters",
		ar: "يمكن أن يكون اسم الدور باللغة العربية أو الإنجليزية فقط وبأحرف صحيحة",
	},
	{
		id: "A role with this name already exists.",
		en: "A role with this name already exists.",
		ar: "يوجد بالفعل دور بهذا الاسم.",
	},
	{
		id: "Description must be text",
		en: "Description must be text",
		ar: "يجب أن يكون الوصف نصًا",
	},
	{
		id: "Notes must be text",
		en: "Notes must be text",
		ar: "يجب أن تكون الملاحظات نصًا",
	},
	{
		id: "Description cannot exceed 1000 characters",
		en: "Description cannot exceed 1000 characters",
		ar: "لا يمكن أن يتجاوز الوصف 1000 حرف",
	},
	{
		id: "Description can be only in Arabic or English languages",
		en: "Description can be only in Arabic or English languages",
		ar: "يمكن أن يكون الوصف باللغة العربية أو الإنجليزية فقط",
	},
	{
		id: "Each Role must have an User type",
		en: "Each Role must have an User type",
		ar: "يجب أن يحتوي كل دور على نوع مستخدم",
	},
	{
		id: "User type must be one of: SUPERVISOR, FIELD_STAFF, CUSTOMER",
		en: "User type must be one of: SUPERVISOR, FIELD_STAFF, CUSTOMER",
		ar: "يجب أن يكون نوع المستخدم أحد القيم التالية: SUPERVISOR أو FIELD_STAFF أو CUSTOMER",
	},
	{
		id: "Access type must be one of: SUPERVISOR, FIELD_STAFF, CUSTOMER",
		en: "Access type must be one of: SUPERVISOR, FIELD_STAFF, CUSTOMER",
		ar: "يجب أن يكون نوع الوصول أحد القيم التالية: SUPERVISOR أو FIELD_STAFF أو CUSTOMER",
	},
	{
		id: "One or more permissions are invalid",
		en: "One or more permissions are invalid",
		ar: "إذن واحد أو أكثر غير صالح",
	},
	{
		id: "Inactive roles cannot have an expiry date.",
		en: "Inactive roles cannot have an expiry date.",
		ar: "لا يمكن للأدوار غير النشطة أن تحتوي على تاريخ انتهاء صلاحية.",
	},
	{
		id: "Expiry must be a valid date",
		en: "Expiry must be a valid date",
		ar: "يجب أن يكون تاريخ الانتهاء صالحًا",
	},
	{
		id: "Expiry date must be in the future",
		en: "Expiry date must be in the future",
		ar: "يجب أن يكون تاريخ الانتهاء في المستقبل",
	},
	{
		id: "Expiry date must be in the future when activating a role.",
		en: "Expiry date must be in the future when activating a role.",
		ar: "يجب أن يكون تاريخ الانتهاء في المستقبل عند تفعيل الدور.",
	},
	{
		id: "Expiry date can only be set for active roles",
		en: "Expiry date can only be set for active roles",
		ar: "يمكن تحديد تاريخ الانتهاء للأدوار النشطة فقط",
	},
	{
		id: "Cannot change user type while existing permissions belong to a different user type. Please remove those permissions first or assign new ones with the correct user type.",
		en: "Cannot change user type while existing permissions belong to a different user type. Please remove those permissions first or assign new ones with the correct user type.",
		ar: "لا يمكن تغيير نوع المستخدم بينما الأذونات الحالية تنتمي إلى نوع مستخدم مختلف. يرجى إزالة تلك الأذونات أولاً أو تعيين أذونات جديدة بنوع المستخدم الصحيح.",
	},
	{
		id: "Cannot delete this role. It is assigned to active users",
		en: "Cannot delete this role. It is assigned to active users",
		ar: "لا يمكن حذف هذا الدور، فهو مخصص لـالمستخدمين النشطين",
	},
	{
		id: "Description must be at most 1000 characters",
		en: "Description must be at most 1000 characters",
		ar: "يجب أن يكون الوصف 1000 حرف على الأكثر",
	},
	{
		id: "Description cannot contain special characters",
		en: "Description cannot contain special characters",
		ar: "لا يمكن أن يحتوي الوصف على أحرف خاصة",
	},
	{
		id: "Cannot remove connection. User has un resolved task(s) that need to be reassigned or completed first.",
		en: "Cannot remove connection. User has un resolved task(s) that need to be reassigned or completed first.",
		ar: "لا يمكن إزالة الاتصال. لدى المستخدم مهام غير محلولة تحتاج إلى إعادة تعيينها أو إكمالها أولاً.",
	},
	{ id: "customer info", en: "customer info", ar: "بيانات المستخدم" },
	{ id: "customer location", en: "customer location", ar: "موقع العميل" },
	{ id: "address", en: "address", ar: "العنوان" },
	{
		id: "Ex. tahrir st, cairo",
		en: "Ex. tahrir st, cairo",
		ar: "مثال شارع التحرير القاهرة",
	},
	{ id: "customer contact", en: "customer contact", ar: "الاتصال بالعميل" },
	{ id: "Website", en: "Website", ar: "الموقع الإلكتروني" },
	{ id: "Fax", en: "Fax", ar: "الفاكس" },
	{ id: "Tax Id", en: "Tax Id", ar: "الرقم الضريبي" },
	{ id: "Enter Tax Id", en: "Enter Tax Id", ar: "أدخل الرقم الضريبي" },
	{ id: "egypt", en: "egypt", ar: "مصر" },
	{
		id: "Customer Deleted Successfully",
		en: "Customer Deleted Successfully",
		ar: "تم حذف العميل بنجاح",
	},
	{ id: "customer", en: "customer", ar: "العميل" },
	{
		id: "Customer Is Edited Successfully",
		en: "Customer Is Edited Successfully",
		ar: "تم تعديل العميل بنجاح",
	},
	{
		id: "Please try again",
		en: "Please try again",
		ar: "من فضلك حاول مرة أخري",
	},
	{
		id: "Customer Is Added Successfully",
		en: "Customer Is Added Successfully",
		ar: "تم إضافة العميل بنجاح",
	},
	{ id: "location", en: "location", ar: "الموقع" },
	{ id: "Egypt", en: "Egypt", ar: "مصر" },
	{ id: "Customer Details", en: "Customer Details", ar: "تفاصيل العميل" },
	{ id: "Customer Location", en: "Customer Location", ar: "موقع العميل" },
	{
		id: "Contact Person Name",
		en: "Contact Person Name",
		ar: "اسم جهة الاتصال",
	},
	{
		id: "Contact Person Phone",
		en: "Contact Person Phone",
		ar: "رقم هاتف جهة الاتصال",
	},
	{
		id: "Contact Person Email",
		en: "Contact Person Email",
		ar: "البريد الإلكتروني لجهة الاتصال",
	},
	{
		id: "customer extra info",
		en: "customer extra info",
		ar: "بيانات إضافية للعميل",
	},

	{
		id: "Customer Name can be only in Arabic or English languages and valid characters",
		en: "Customer Name can be only in Arabic or English languages and valid characters",
		ar: "يمكن أن يكون اسم العميل باللغة العربية أو الإنجليزية فقط وبأحرف صالحة",
	},

	{
		id: "Email cannot exceed 150 characters",
		en: "Email cannot exceed 150 characters",
		ar: "لا يمكن أن يتجاوز البريد الإلكتروني 150 حرفاً",
	},
	{
		id: "Invalid global email format. (ex. mu.taw@global.com)",
		en: "Invalid global email format. (ex. mu.taw@global.com)",
		ar: "تنسيق البريد الإلكتروني العالمي غير صالح. (مثال: mu.taw@global.com)",
	},
	{
		id: "Email already exists for another customer",
		en: "Email already exists for another customer",
		ar: "البريد الإلكتروني موجود بالفعل لعميل آخر",
	},
	{
		id: "Email already exists in the system",
		en: "Email already exists in the system",
		ar: "البريد الإلكتروني موجود بالفعل في النظام",
	},

	{
		id: "Country Name can be only in Arabic or English languages and valid characters",
		en: "Country Name can be only in Arabic or English languages and valid characters",
		ar: "يمكن أن يكون اسم الدولة باللغة العربية أو الإنجليزية فقط وبأحرف صالحة",
	},

	{
		id: "City Name can be only in Arabic or English languages and valid characters",
		en: "City Name can be only in Arabic or English languages and valid characters",
		ar: "يمكن أن يكون اسم المدينة باللغة العربية أو الإنجليزية فقط وبأحرف صالحة",
	},

	{
		id: "A phone number must be between 3 and 24 numbers, as in global formatting standards",
		en: "A phone number must be between 3 and 24 numbers, as in global formatting standards",
		ar: "يجب أن يكون رقم الهاتف بين 3 و 24 رقماً، وفقاً لمعايير التنسيق العالمية",
	},

	{
		id: "Phone number already exists for another customer",
		en: "Phone number already exists for another customer",
		ar: "رقم الهاتف موجود بالفعل لعميل آخر",
	},
	{
		id: "Phone number already exists in the system",
		en: "Phone number already exists in the system",
		ar: "رقم الهاتف موجود بالفعل في النظام",
	},

	{
		id: "Fax number must contain only digits and plus sign",
		en: "Fax number must contain only digits and plus sign",
		ar: "يجب أن يحتوي رقم الفاكس على أرقام وعلامة الجمع فقط",
	},

	{
		id: "Fax number already exists for another customer",
		en: "Fax number already exists for another customer",
		ar: "رقم الفاكس موجود بالفعل لعميل آخر",
	},
	{
		id: "Tax ID cannot exceed 50 characters",
		en: "Tax ID cannot exceed 50 characters",
		ar: "لا يمكن أن يتجاوز الرقم الضريبي 50 حرفاً",
	},
	{
		id: "Tax ID already exists for another customer",
		en: "Tax ID already exists for another customer",
		ar: "الرقم الضريبي موجود بالفعل لعميل آخر",
	},

	{
		id: "Address can be only in Arabic or English languages",
		en: "Address can be only in Arabic or English languages",
		ar: "يمكن أن يكون العنوان باللغة العربية أو الإنجليزية فقط",
	},

	{
		id: "Website must be a valid URL including http:// or https://",
		en: "Website must be a valid URL including http:// or https://",
		ar: "يجب أن يكون الموقع الإلكتروني عنوان URL صالحاً يتضمن http:// أو https://",
	},

	{
		id: "Invalid website URL format",
		en: "Invalid website URL format",
		ar: "تنسيق عنوان URL للموقع غير صالح",
	},

	{
		id: "Contact person must have a name.",
		en: "Contact person must have a name.",
		ar: "يجب أن يكون لشخص الاتصال اسم.",
	},
	{
		id: "Contact person name must be between 3 and 64 characters.",
		en: "Contact person name must be between 3 and 64 characters.",
		ar: "يجب أن يكون اسم شخص الاتصال بين 3 و 64 حرفاً.",
	},
	{
		id: "Contact person must have at least a phone or an email.",
		en: "Contact person must have at least a phone or an email.",
		ar: "يجب أن يكون لشخص الاتصال هاتف أو بريد إلكتروني على الأقل.",
	},
	{
		id: "A customer with this name and email already exists",
		en: "A customer with this name and email already exists",
		ar: "عميل بهذا الاسم والبريد الإلكتروني موجود بالفعل",
	},
	{
		id: "You can only update Customers you created",
		en: "You can only update Customers you created",
		ar: "يمكنك فقط تحديث العملاء الذين قمت بإنشائهم",
	},
	{
		id: "You can only delete Customers you created",
		en: "You can only delete Customers you created",
		ar: "يمكنك فقط حذف العملاء الذين قمت بإنشائهم",
	},
	{ id: "Customers", en: "Customers", ar: "العملاء" },
	{
		id: "Email must be a valid email address with a valid domain",
		en: "Email must be a valid email address with a valid domain",
		ar: "يجب أن يكون البريد الإلكتروني عنوان بريد إلكتروني صالحًا مع نطاق صالح",
	},
	{ id: "Current User", en: "Current User", ar: "المستخدم الحالي" },
	{
		id: "Current Login Date",
		en: "Current Login Date",
		ar: "تاريخ وقت الدخول",
	},
	{ id: "Total Logins", en: "Total Logins", ar: "عدد الدخول" },
	{
		id: "First Login Date",
		en: "First Login Date",
		ar: "تاريخ وقت الدخول الأول",
	},
	{
		id: "Total Duration Days",
		en: "Total Duration Days",
		ar: "مدة الدخول الكلية",
	},
	{
		id: "Total Devices Tracked",
		en: "Total Devices Tracked",
		ar: "عدد الأجهزة المتتبعة",
	},
	{
		id: "Total Active Users",
		en: "Total Active Users",
		ar: "عدد المستخدمين النشطين",
	},
	{
		id: "Total Unique Users",
		en: "Total Unique Users",
		ar: "عدد المستخدمين الفريدين",
	},
	{
		id: "Average assignments per device",
		en: "Average assignments per device",
		ar: "عدد المهام المتوسطة للجهاز",
	},
	{ id: "User Name", en: "User Name", ar: "اسم المستخدم" },
	{ id: "Department", en: "Department", ar: "القسم" },
	{ id: "Assigned At", en: "Assigned At", ar: "تاريخ وقت التعيين" },
	{ id: "Unassigned At", en: "Unassigned At", ar: "تاريخ وقت الإلغاء" },
	{ id: "Duration Days", en: "Duration Days", ar: "مدة التعيين الكلية" },
	{
		id: "deviceAssignment",
		en: "Device Usage Report",
		ar: "تقرير استخدام الأجهزة",
	},
	{
		id: "Device Usage Report",
		en: "Device Usage Report",
		ar: "تقرير استخدام الأجهزة",
	},
	{
		id: "hierarchical access",
		en: "hierarchical access",
		ar: "إمكانية الوصول",
	},
	{
		id: "Nasr City",
		en: "Nasr City",
		ar: "مدينة نصر",
	},
	{
		id: "El Obour",
		en: "El Obour",
		ar: "العبور",
	},
	{
		id: "Ain Shams",
		en: "Ain Shams",
		ar: "عين شمس",
	},
	{
		id: "El Marg",
		en: "El Marg",
		ar: "المرج",
	},
	{
		id: "El Salam City",
		en: "El Salam City",
		ar: "مدينة السلام",
	},
	{
		id: "El Shorouk City",
		en: "El Shorouk City",
		ar: "مدينة الشروق",
	},
	{
		id: "Fifth Settlement",
		en: "Fifth Settlement",
		ar: "التجمع الخامس",
	},
	{
		id: "El Zahraa",
		en: "El Zahraa",
		ar: "الزهراء",
	},
	{
		id: "El Sayeda Zeinab",
		en: "El Sayeda Zeinab",
		ar: "السيدة زينب",
	},
	{
		id: "Abbassia",
		en: "Abbassia",
		ar: "العباسية",
	},
	{
		id: "El Zaytoun",
		en: "El Zaytoun",
		ar: "الزيتون",
	},
	{
		id: "Hadayek El Zaitoun",
		en: "Hadayek El Zaitoun",
		ar: "حدائق الزيتون",
	},
	{
		id: "El Mokattam",
		en: "El Mokattam",
		ar: "المقطم",
	},
	{
		id: "El Darb El Ahmar",
		en: "El Darb El Ahmar",
		ar: "الدرب الأحمر",
	},
	{
		id: "Bab El Louk",
		en: "Bab El Louk",
		ar: "باب اللوق",
	},
	{
		id: "Garden City",
		en: "Garden City",
		ar: "جاردن سيتي",
	},
	{
		id: "El Sayeda Aisha",
		en: "El Sayeda Aisha",
		ar: "السيدة عائشة",
	},
	{
		id: "Masr El Gedida",
		en: "Masr El Gedida",
		ar: "مصر الجديدة",
	},
	{
		id: "Rod El Farag",
		en: "Rod El Farag",
		ar: "روض الفرج",
	},
	{
		id: "Zamalek",
		en: "Zamalek",
		ar: "الزمالك",
	},
	{
		id: "Dokki",
		en: "Dokki",
		ar: "الدقي",
	},
	{
		id: "Mohandessin",
		en: "Mohandessin",
		ar: "المهندسين",
	},
	{
		id: "Haram",
		en: "Haram",
		ar: "الهرم",
	},
	{
		id: "Boulaq Ad Dakrour",
		en: "Boulaq Ad Dakrour",
		ar: "بولاق الدكرور",
	},
	{
		id: "Warraq",
		en: "Warraq",
		ar: "الوراق",
	},
	{
		id: "Talbia",
		en: "Talbia",
		ar: "الطالبية",
	},
	{
		id: "Saft El Laban",
		en: "Saft El Laban",
		ar: "صفط اللبن",
	},
	{
		id: "Hadayek Al Ahram",
		en: "Hadayek Al Ahram",
		ar: "حدائق الأهرام",
	},
	{
		id: "Faisal",
		en: "Faisal",
		ar: "فيصل",
	},
	{
		id: "El Monib",
		en: "El Monib",
		ar: "المنيب",
	},
	{
		id: "El Behous",
		en: "El Behous",
		ar: "البحوث",
	},
	{
		id: "showing the devices usage by the field staff.",
		en: "showing the devices usage by the field staff.",
		ar: "عرض استخدام الأجهزة بواسطة المندوبين",
	},
	{ id: "For More Details", en: "For More Details", ar: "لمزيد من التفاصيل" },
	{ id: "Delay Duration", en: "Delay Duration", ar: "مدة التأخير" },
	{ id: "Requester (Customer)", en: "Requester (Customer)", ar: "العميل" },
	{ id: "Request Type", en: "Request Type", ar: "نوع الطلب" },
	{ id: "Violation Type", en: "Violation Type", ar: "نوع التعطل" },
	{ id: "Assigned Staff", en: "Assigned Staff", ar: "المندوب المعين" },
	{ id: "Request Status", en: "Request Status", ar: "حالة الطلب" },
	{ id: "Response Time", en: "Response Time", ar: "وقت الاستجابة" },
	{ id: "Resolution Time", en: "Resolution Time", ar: "وقت الحل" },
	{
		id: "Last Activity Time",
		en: "Last Activity Time",
		ar: "وقت النشاط الأخير",
	},
	{ id: "Shift", en: "Shift", ar: "الوقت" },
	{ id: "Preferred Date", en: "Preferred Date", ar: "التاريخ المفضل" },
	{ id: "View all", en: "View all", ar: "عرض كل" },
	{ id: "service requests", en: "service requests", ar: "طلبات الخدمة" },
	{ id: "Sequential Task", en: "Sequential Task", ar: "مهمة متسلسلة" },
	{ id: "Flexible Task", en: "Flexible Task", ar: "مهمة مرنة" },
	{
		id: "Must finish all forms step by step to complete the task, end only when all are done",
		en: "Must finish all forms step by step to complete the task, end only when all are done",
		ar: "يجب إكمال جميع النماذج تدريجياً لإنهاء المهمة، وإنهاء فقط عندما يكون كلها مكتملة",
	},
	{
		id: "Complete forms freely and end anytime, task can end with pending forms",
		en: "Complete forms freely and end anytime, task can end with pending forms",
		ar: "إكمل النماذج بحرية وإنهاء أي وقت، يمكن إنهاء المهمة بالنماذج المتبقية",
	},
	{ id: "Select Flow", en: "Select Flow", ar: "اختيار التدفق" },
	{
		id: "This field is required",
		en: "This field is required",
		ar: "هذا الحقل مطلوب",
	},
	{ id: "Project", en: "Project", ar: "المشروع" },
	{ id: "Zonep", en: "Zone", ar: "المنطقة" },
	{ id: "building", en: "building", ar: "المبني" },
	{ id: "Select Project", en: "Select Project", ar: "إختيار المشروع" },
	{ id: "Select Zone", en: "Select Zone", ar: "إختيار المنطقة" },
	{ id: "Inspection Request", en: "Inspection Request", ar: "طلب التفتيش" },
	{ id: "IR", en: "IR", ar: "طلب التفتيش" },
	{ id: "data", en: "data", ar: "" },
	{ id: "data", en: "data", ar: "" },
	{ id: "QA Dashboard", en: "QA Dashboard", ar: "لوحة تحكم ضمان الجودة" },
	{
		id: "QA Dashboard for managing field operations, technicians, and service requests",
		en: "QA Dashboard for managing field operations, technicians, and service requests",
		ar: "لوحة تحكم ضمان الجودة لإدارة العمليات الميدانية والمندوبين وطلبات الخدمة",
	},
	{ id: "All Types", en: "All Types", ar: "جميع الأنواع" },
	{ id: "Snag", en: "Snag", ar: "عيب" },
	{ id: "Submittal", en: "Submittal", ar: "تقديم" },
	{ id: "All Projects", en: "All Projects", ar: "جميع المشاريع" },
	// QAAlertsSummary translations
	{
		id: "Total Active Items",
		en: "Total Active Items",
		ar: "إجمالي العناصر النشطة",
	},
	{
		id: "Pending QA / Consultant.",
		en: "Pending QA / Consultant.",
		ar: "في انتظار ضمان الجودة / المستشار.",
	},
	{
		id: "Delayed Approvals Rate",
		en: "Delayed Approvals Rate",
		ar: "معدل الموافقات المتأخرة",
	},
	{
		id: "Requests exceeding SLA.",
		en: "Requests exceeding SLA.",
		ar: "الطلبات التي تتجاوز اتفاقية مستوى الخدمة.",
	},
	{
		id: "Delayed Approvals Count",
		en: "Delayed Approvals Count",
		ar: "عدد الموافقات المتأخرة",
	},
	{
		id: "Rejected IRs/MIRs.",
		en: "Rejected IRs/MIRs.",
		ar: "طلبات التفتيش المرفوضة / طلبات التفتيش المعدلة المرفوضة.",
	},
	{ id: "Rejection Rate", en: "Rejection Rate", ar: "معدل الرفض" },
	{
		id: "qa_approved_at - submitted_at.",
		en: "qa_approved_at - submitted_at.",
		ar: "تاريخ موافقة ضمان الجودة - تاريخ الإرسال.",
	},
	{ id: "Total Rejected", en: "Total Rejected", ar: "إجمالي المرفوض" },
	{
		id: "consultant_approved_at - qa_approved_at.",
		en: "consultant_approved_at - qa_approved_at.",
		ar: "تاريخ موافقة المستشار - تاريخ موافقة ضمان الجودة.",
	},
	{
		id: "Avg. QA Approval Time",
		en: "Avg. QA Approval Time",
		ar: "متوسط وقت موافقة ضمان الجودة",
	},
	{
		id: "Severity = CRITICAL & OPEN.",
		en: "Severity = CRITICAL & OPEN.",
		ar: "الشدة = حرج ومفتوح.",
	},
	{
		id: "Avg. Consultant Approval Time",
		en: "Avg. Consultant Approval Time",
		ar: "متوسط وقت موافقة المستشار",
	},
	{
		id: "From submission to closure.",
		en: "From submission to closure.",
		ar: "من الإرسال إلى الإغلاق.",
	},
	{
		id: "Critical Open Items",
		en: "Critical Open Items",
		ar: "العناصر المفتوحة الحرجة",
	},
	{
		id: "Pending correction.",
		en: "Pending correction.",
		ar: "في انتظار التصحيح.",
	},
	// QACharts translations
	{ id: "Count", en: "Count", ar: "العدد" },
	{ id: "Open", en: "Open", ar: "مفتوح" },
	{ id: "Closed", en: "Closed", ar: "مغلق" },
	{ id: "Rejected", en: "Rejected", ar: "مرفوض" },
	{
		id: "Requests by Module",
		en: "Requests by Module",
		ar: "الطلبات حسب الوحدة",
	},
	{
		id: "No data available",
		en: "No data available",
		ar: "لا توجد بيانات متاحة",
	},
	{
		id: "Pending Load by Team",
		en: "Pending Load by Team",
		ar: "الحمل المعلق حسب الفريق",
	},
	{
		id: "Contractors Performance",
		en: "Contractors Performance",
		ar: "أداء المقاولين",
	},
	{ id: "Failed", en: "Failed", ar: "فشل" },
	{ id: "Moderate", en: "Moderate", ar: "متوسط" },
	{ id: "Successful", en: "Successful", ar: "ناجح" },
	{ id: "Unknown", en: "Unknown", ar: "غير معروف" },
	{ id: "Contractor Name", en: "Contractor Name", ar: "اسم المقاول" },
	{ id: "Backlog", en: "Backlog", ar: "التراكم" },
	{ id: "Total IRs", en: "Total IRs", ar: "إجمالي طلبات التفتيش" },
	{ id: "IR Backlog", en: "IR Backlog", ar: "تراكم طلبات التفتيش" },
	{ id: "Total Snags", en: "Total Snags", ar: "إجمالي العيوب" },
	{ id: "Snag Backlog", en: "Snag Backlog", ar: "تراكم العيوب" },
	{ id: "Critical Snags", en: "Critical Snags", ar: "العيوب الحرجة" },
	{ id: "Total MIRs", en: "Total MIRs", ar: "إجمالي طلبات التفتيش المعدلة" },
	{ id: "MIR Backlog", en: "MIR Backlog", ar: "تراكم طلبات التفتيش المعدلة" },
	{ id: "Total Submittals", en: "Total Submittals", ar: "إجمالي التقديمات" },
	{ id: "Submittal Backlog", en: "Submittal Backlog", ar: "تراكم التقديمات" },
	{ id: "Avg Revisions", en: "Avg Revisions", ar: "متوسط المراجعات" },
	{
		id: "Avg Response Time",
		en: "Avg Response Time",
		ar: "متوسط وقت الاستجابة",
	},
	{ id: "Score", en: "Score", ar: "النتيجة" },
	// Additional QA Dashboard translations
	{
		id: "Requests exceeding SLA",
		en: "Requests exceeding SLA",
		ar: "الطلبات التي تتجاوز اتفاقية مستوى الخدمة",
	},
	{
		id: "Rejected IR/MIR",
		en: "Rejected IR/MIR",
		ar: "طلبات التفتيش المرفوضة / طلبات التفتيش المعدلة المرفوضة",
	},
	{
		id: "Average time from QA Approval to Consultant Approval (IR)",
		en: "Average time from QA Approval to Consultant Approval (IR)",
		ar: "متوسط وقت من موافقة ضمان الجودة إلى موافقة المستشار",
	},
	{
		id: "Average time from contractor submission to QA approval (IR)",
		en: "Average time from contractor submission to QA approval (IR)",
		ar: "متوسط وقت من الإرسال إلى موافقة ضمان الجودة",
	},
	{
		id: "From submission to closure",
		en: "From submission to closure",
		ar: "من الإرسال إلى الإغلاق",
	},
	{
		id: "Open Deficiencies",
		en: "Open Deficiencies",
		ar: "النواقص المفتوحة",
	},
	{
		id: "Pending correction",
		en: "Pending correction",
		ar: "في انتظار التصحيح",
	},
	{
		id: "Pending QA / Consultant",
		en: "Pending QA / Consultant",
		ar: "في انتظار ضمان الجودة / المستشار",
	},
	{
		id: "Avg Cycle Time",
		en: "Avg Cycle Time",
		ar: "متوسط وقت الدورة",
	},
	{
		id: "Avg QA Approval Time",
		en: "Avg QA Approval Time",
		ar: "متوسط وقت موافقة ضمان الجودة",
	},
	{
		id: "Avg Consultant Approval Time",
		en: "Avg Consultant Approval Time",
		ar: "متوسط وقت موافقة المستشار",
	},
	{ id: "Warning", en: "Warning", ar: "تحذير" },
	{ id: "Success", en: "Success", ar: "نجاح" },
	{ id: "Contractor", en: "Contractor", ar: "المقاول" },
	{
		id: "Workload Overview",
		en: "Workload Overview",
		ar: "نظرة عامة على عبء العمل",
	},
	{ id: "IRs", en: "IRs", ar: "طلبات التفتيش" },
	{ id: "MIRs", en: "MIRs", ar: "طلبات التفتيش المعدلة" },
	{ id: "Submittals", en: "Submittals", ar: "التقديمات" },
	{
		id: "Backlog Health",
		en: "Backlog Health",
		ar: "صحة التراكم",
	},
	{
		id: "Performance",
		en: "Performance",
		ar: "الأداء",
	},
	{ id: "Status", en: "Status", ar: "الحالة" },
	// SnagList translations
	{ id: "Snag List", en: "Snag List", ar: "قائمة العيوب" },
	{ id: "Snag Number", en: "Snag Number", ar: "رقم العيب" },
	{ id: "Reported At", en: "Reported At", ar: "تاريخ الإبلاغ" },
	{ id: "level", en: "level", ar: "المستوى" },
	{ id: "Sector", en: "Sector", ar: "القطاع" },
	{ id: "Subsystem", en: "Subsystem", ar: "النظام الفرعي" },
	{ id: "Severity", en: "Severity", ar: "الشدة" },
	{ id: "Assigned To", en: "Assigned To", ar: "مخصص لـ" },
	{ id: "Add new snag", en: "Add new snag", ar: "إضافة عيب جديد" },
	// ViewSnag translations
	{ id: "Rectify", en: "Rectify", ar: "تصحيح" },
	{ id: "Approve", en: "Approve", ar: "موافقة" },
	{ id: "Reject", en: "Reject", ar: "رفض" },
	// ViewSnagBody translations
	{ id: "Snag Details", en: "Snag Details", ar: "تفاصيل العيب" },
	{
		id: "Rectifies and Reviews History",
		en: "Rectifies and Reviews History",
		ar: "تاريخ التصحيحات والمراجعات",
	},
	{ id: "Technical Details", en: "Technical Details", ar: "التفاصيل التقنية" },
	{ id: "Building", en: "Building", ar: "المبنى" },
	{ id: "Discipline", en: "Discipline", ar: "التخصص" },
	{ id: "Item", en: "Item", ar: "العنصر" },
	{ id: "Location", en: "Location", ar: "الموقع" },
	{ id: "Area/Room", en: "Area/Room", ar: "المنطقة/الغرفة" },
	{ id: "Target Date", en: "Target Date", ar: "التاريخ المستهدف" },
	{ id: "Acceptance Criteria", en: "Acceptance Criteria", ar: "معايير القبول" },
	{ id: "Inspection Method", en: "Inspection Method", ar: "طريقة التفتيش" },
	{ id: "Location Details", en: "Location Details", ar: "تفاصيل الموقع" },
	{ id: "Download All", en: "Download All", ar: "تحميل الكل" },
	{ id: "Uploaded by", en: "Uploaded by", ar: "تم الرفع بواسطة" },
	{ id: "on", en: "on", ar: "في" },
	{ id: "Snag History", en: "Snag History", ar: "تاريخ العيب" },
	{
		id: "No history available",
		en: "No history available",
		ar: "لا يوجد تاريخ متاح",
	},
	{ id: "By", en: "By", ar: "بواسطة" },
	// FormSnag translations
	{ id: "Sector is required", en: "Sector is required", ar: "القطاع مطلوب" },
	{
		id: "Assign To is required",
		en: "Assign To is required",
		ar: "التعيين مطلوب",
	},
	{
		id: "Description is required",
		en: "Description is required",
		ar: "الوصف مطلوب",
	},
	{ id: "Project is required", en: "Project is required", ar: "المشروع مطلوب" },
	{
		id: "At least one snag is required",
		en: "At least one snag is required",
		ar: "يجب إضافة عيب واحد على الأقل",
	},
	{ id: "Saving...", en: "Saving...", ar: "جاري الحفظ..." },
	{
		id: "Snags created successfully",
		en: "Snags created successfully",
		ar: "تم إنشاء العيوب بنجاح",
	},
	{ id: "Something went wrong", en: "Something went wrong", ar: "حدث خطأ ما" },
	// SnagFormBody translations
	{ id: "Select Project", en: "Select Project", ar: "اختر المشروع" },
	{ id: "Select Zone", en: "Select Zone", ar: "اختر المنطقة" },
	{ id: "Select Building", en: "Select Building", ar: "اختر المبنى" },
	{ id: "Select Level", en: "Select Level", ar: "اختر المستوى" },
	{ id: "Snags", en: "Snags", ar: "العيوب" },
	{ id: "Add Another Snag", en: "Add Another Snag", ar: "إضافة عيب آخر" },
	// SnagItemRow translations
	{ id: "Select Sector", en: "Select Sector", ar: "اختر القطاع" },
	{ id: "Assign To", en: "Assign To", ar: "تعيين لـ" },
	{ id: "Select Assign To", en: "Select Assign To", ar: "اختر التعيين لـ" },
	{ id: "Select Subsystem", en: "Select Subsystem", ar: "اختر النظام الفرعي" },
	{ id: "Select Discipline", en: "Select Discipline", ar: "اختر التخصص" },
	{ id: "Select Item", en: "Select Item", ar: "اختر العنصر" },
	{
		id: "Select Acceptance Criteria",
		en: "Select Acceptance Criteria",
		ar: "اختر معايير القبول",
	},
	{
		id: "Select Inspection Method",
		en: "Select Inspection Method",
		ar: "اختر طريقة التفتيش",
	},
	{ id: "Enter description", en: "Enter description", ar: "أدخل الوصف" },
	{ id: "Asset Tag ID", en: "Asset Tag ID", ar: "معرف علامة الأصل" },
	{
		id: "Enter asset tag ID",
		en: "Enter asset tag ID",
		ar: "أدخل معرف علامة الأصل",
	},
	{ id: "Drawing Reference", en: "Drawing Reference", ar: "مرجع الرسم" },
	{
		id: "Enter drawing reference",
		en: "Enter drawing reference",
		ar: "أدخل مرجع الرسم",
	},
	{ id: "Select Area/Room", en: "Select Area/Room", ar: "اختر المنطقة/الغرفة" },
	{ id: "Enter location", en: "Enter location", ar: "أدخل الموقع" },
	{ id: "Select severity", en: "Select severity", ar: "اختر الشدة" },
	{
		id: "Enter location details",
		en: "Enter location details",
		ar: "أدخل تفاصيل الموقع",
	},
	{ id: "Upload Files", en: "Upload Files", ar: "رفع الملفات" },
	// ApproveRejectPopup translations
	{ id: "Approve Snag", en: "Approve Snag", ar: "الموافقة على العيب" },
	{ id: "Reject Snag", en: "Reject Snag", ar: "رفض العيب" },
	{
		id: "Comments are required",
		en: "Comments are required",
		ar: "التعليقات مطلوبة",
	},
	{
		id: "Enter approval comments",
		en: "Enter approval comments",
		ar: "أدخل تعليقات الموافقة",
	},
	{
		id: "Enter rejection comments",
		en: "Enter rejection comments",
		ar: "أدخل تعليقات الرفض",
	},
	{ id: "Submitting...", en: "Submitting...", ar: "جاري الإرسال..." },
	{
		id: "Snag approved successfully",
		en: "Snag approved successfully",
		ar: "تمت الموافقة على العيب بنجاح",
	},
	{
		id: "Snag rejected successfully",
		en: "Snag rejected successfully",
		ar: "تم رفض العيب بنجاح",
	},
	// RectifyPopup translations
	{ id: "Rectify Snag", en: "Rectify Snag", ar: "تصحيح العيب" },
	{
		id: "Rectification notes are required",
		en: "Rectification notes are required",
		ar: "ملاحظات التصحيح مطلوبة",
	},
	{
		id: "Rectification Notes",
		en: "Rectification Notes",
		ar: "ملاحظات التصحيح",
	},
	{
		id: "Enter rectification notes",
		en: "Enter rectification notes",
		ar: "أدخل ملاحظات التصحيح",
	},
	{ id: "Submit", en: "Submit", ar: "إرسال" },
	{
		id: "Snag rectified successfully",
		en: "Snag rectified successfully",
		ar: "تم تصحيح العيب بنجاح",
	},
	{ id: "snag-list", en: "Snag List", ar: "قائمة العيوب" },
	{ id: "Rectified", en: "Rectified", ar: "تم التصحيح" },
	{ id: "Qa Verified", en: "Qa Verified", ar: "تم التحقق من ضمان الجودة" },
	{
		id: "Consultant Approved",
		en: "Consultant Approved",
		ar: "تم الموافقة من قبل المستشار",
	},
	{ id: "Qa Rejected", en: "Qa Rejected", ar: "تم الرفض من قبل ضمان الجودة" },
	{
		id: "Consultant Rejected",
		en: "Consultant Rejected",
		ar: "تم الرفض من قبل المستشار",
	},
	// IRHistory translations
	{ id: "IR History", en: "IR History", ar: "تاريخ طلبات التفتيش" },
	{ id: "IR Number", en: "IR Number", ar: "رقم طلب التفتيش" },
	{ id: "Submitted Date", en: "Submitted Date", ar: "تاريخ الإرسال" },
	{ id: "Reviewed Date", en: "Reviewed Date", ar: "تاريخ المراجعة" },
	{ id: "Review Result", en: "Review Result", ar: "نتيجة المراجعة" },
	{ id: "Deficiencies", en: "Deficiencies", ar: "النواقص" },
	{ id: "Turnaround Time", en: "Turnaround Time", ar: "وقت الاستجابة" },
	{ id: "Total Reviewed", en: "Total Reviewed", ar: "إجمالي المراجعات" },
	{
		id: "Approved This Period",
		en: "Approved This Period",
		ar: "المعتمد في هذه الفترة",
	},
	{
		id: "Rejected This Period",
		en: "Rejected This Period",
		ar: "المرفوض في هذه الفترة",
	},
	{
		id: "Average Review Time",
		en: "Average Review Time",
		ar: "متوسط وقت المراجعة",
	},
	{ id: "Mechanical", en: "Mechanical", ar: "ميكانيكي" },
	{ id: "Civil", en: "Civil", ar: "مدني" },
	{ id: "Architectural", en: "Architectural", ar: "معماري" },
	{ id: "Other", en: "Other", ar: "أخرى" },
	{ id: "NCR", en: "NCR", ar: "إشعار عدم المطابقة" },
	{ id: "SNAG", en: "SNAG", ar: "عيب" },
	// Status translations
	{ id: "DRAFT", en: "DRAFT", ar: "مسودة" },
	{ id: "PENDING QA", en: "PENDING QA", ar: "في انتظار ضمان الجودة" },
	{ id: "QA APPROVED", en: "QA APPROVED", ar: "موافق عليه من ضمان الجودة" },
	{ id: "QA REJECTED", en: "QA REJECTED", ar: "مرفوض من ضمان الجودة" },
	{
		id: "PENDING CONSULTANT",
		en: "PENDING CONSULTANT",
		ar: "في انتظار المستشار",
	},
	{
		id: "CONSULTANT APPROVED",
		en: "CONSULTANT APPROVED",
		ar: "موافق عليه من المستشار",
	},
	{
		id: "CONSULTANT APPROVED WITH COMMENTS",
		en: "CONSULTANT APPROVED WITH COMMENTS",
		ar: "موافق عليه من المستشار مع تعليقات",
	},
	{
		id: "CONSULTANT REJECTED",
		en: "CONSULTANT REJECTED",
		ar: "مرفوض من المستشار",
	},
	{ id: "CLOSED", en: "CLOSED", ar: "مغلق" },
	{ id: "CANCELLED", en: "CANCELLED", ar: "ملغي" },
	{ id: "APPROVED", en: "APPROVED", ar: "موافق عليه" },
	{ id: "REJECTED", en: "REJECTED", ar: "مرفوض" },
	{ id: "Add new IR", en: "Add new IR", ar: "إضافة طلب تفتيش" },
	{ id: "projects", en: "projects", ar: "المشروعات" },
	{ id: "zones", en: "zones", ar: "المناطق" },
	{ id: "level", en: "level", ar: "الدور" },
	{ id: "Select Level", en: "Select Level", ar: "إختيار الدور" },
	{ id: "Select Form", en: "Select Form", ar: "إختيار النموذج" },
	{ id: "Select Discipline", en: "Select Discipline", ar: "إختيار التخصص" },
	{ id: "discipline", en: "discipline", ar: "التخصص" },
	{ id: "Disciplines", en: "Disciplines", ar: "التخصصات" },
	{ id: "Ready Date", en: "Ready Date", ar: "تاريخ الجاهزيه" },
	{ id: "form submission", en: "form submission", ar: "تقديم النموذج" },
	{ id: "Project is required", en: "Project is required", ar: "المشروع مطلوب" },
	{
		id: "Discipline is required",
		en: "Discipline is required",
		ar: "التخصص مطلوب",
	},
	{
		id: "Ready Date is required",
		en: "Ready Date is required",
		ar: "تاريخ الجاهزيه مطلوب",
	},
	{ id: "Form is required", en: "Form is required", ar: "النموذج مطلوب" },
	{ id: "ELECTRICAL", en: "Electrical", ar: "كهرباء" },
	{ id: "MECHANICAL", en: "Mechanical", ar: "ميكانيكا" },
	{ id: "PLUMBING", en: "Plumbing", ar: "سباكة" },
	{ id: "CIVIL", en: "Civil", ar: "مدني" },
	{ id: "ARCHITECTURAL", en: "Architectural", ar: "معماري" },
	{ id: "OTHER", en: "Other", ar: "أخرى" },
	{ id: "PENDING", en: "Pending", ar: "قيد الانتظار" },
	{ id: "APPROVED", en: "Approved", ar: "موافق عليه" },
	{ id: "REJECTED", en: "Rejected", ar: "مرفوض" },
	{ id: "MINOR", en: "Minor", ar: "طفيف" },
	{ id: "MAJOR", en: "Major", ar: "كبير" },
	{ id: "CRITICAL", en: "Critical", ar: "حرج" },
	{ id: "GROUND_FLOOR", en: "Ground Floor", ar: "الدور الأرضي" },
	{ id: "FIRST_FLOOR", en: "First Floor", ar: "الدور الأول" },
	{ id: "SECOND_FLOOR", en: "Second Floor", ar: "الدور الثاني" },
	{ id: "THIRD_FLOOR", en: "Third Floor", ar: "الدور الثالث" },
	{ id: "FOURTH_FLOOR", en: "Fourth Floor", ar: "الدور الرابع" },
	{ id: "BASEMENT_1", en: "Basement 1", ar: "القبو 1" },
	{ id: "BASEMENT_2", en: "Basement 2", ar: "القبو 2" },
	{ id: "ROOF", en: "Roof", ar: "السطح" },
	{ id: "MEZZANINE", en: "Mezzanine", ar: "ميزانين" },
	{ id: "PENTHOUSE", en: "Penthouse", ar: "البنتهاوس" },
	{ id: "DRAFT", en: "Draft", ar: "مسودة" },
	{ id: "PENDING_QA", en: "Pending QA", ar: "قيد انتظار مراقبة الجودة" },
	{ id: "QA_APPROVED", en: "QA Approved", ar: "تمت الموافقة من مراقبة الجودة" },
	{ id: "QA_REJECTED", en: "QA Rejected", ar: "تم الرفض من مراقبة الجودة" },
	{
		id: "PENDING_CONSULTANT",
		en: "Pending Consultant",
		ar: "قيد انتظار المستشار",
	},
	{
		id: "CONSULTANT_APPROVED",
		en: "Consultant Approved",
		ar: "تمت الموافقة من المستشار",
	},
	{
		id: "CONSULTANT_APPROVED_WITH_COMMENTS",
		en: "Consultant Approved With Comments",
		ar: "تمت الموافقة مع ملاحظات من المستشار",
	},
	{
		id: "CONSULTANT_REJECTED",
		en: "Consultant Rejected",
		ar: "تم الرفض من المستشار",
	},
	{ id: "CLOSED", en: "Closed", ar: "مغلق" },
	{ id: "CANCELLED", en: "Cancelled", ar: "ملغى" },
	{
		id: "Add Inspection Request",
		en: "Add Inspection Request",
		ar: "إضافة طلب تفتيش",
	},
	{
		id: "Edit Inspection Request",
		en: "Edit Inspection Request",
		ar: "إضافة طلب تفتيش",
	},
	{ id: "Discipline", en: "Discipline", ar: "التخصص" },
	{ id: "deficiency", en: "deficiency", ar: "العيوب" },
	{
		id: "Inspection Request Details",
		en: "Inspection Request Details",
		ar: "تفاصيل طلب التفتيش",
	},
	{ id: "Resubmit", en: "Resubmit", ar: "إعادة تقديم" },
	{
		id: "No deficiencies have been recorded yet",
		en: "No deficiencies have been recorded yet",
		ar: "لم يتم تسجيل أي عيوب حتى الآن",
	},
	{
		id: "Please fill all deficiency data",
		en: "Please fill all deficiency data",
		ar: "يرجى ملء جميع بيانات النقص",
	},
	{
		id: "IR Consultant Review Submitted Successfully",
		en: "IR Consultant Review Submitted Successfully",
		ar: "تم تقديم مراجعة استشاري العلاقات مع المستثمرين بنجاح",
	},
	{
		id: "IR QA Review Submitted Successfully",
		en: "IR QA Review Submitted Successfully",
		ar: "تم تقديم مراجعة ضمان الجودة مع المستثمرين بنجاح",
	},
	{ id: "Comments", en: "Comments", ar: "التعليقات" },
	{
		id: "Enter your comments",
		en: "Enter your comments",
		ar: "إدخل التعليقات",
	},
	{ id: "Category", en: "Category", ar: "الفئة" },
	{ id: "Select Category", en: "Select Category", ar: "اختر الفئة" },
	{ id: "Severity", en: "Severity", ar: "شدة" },
	{ id: "Select Severity", en: "Select Severity", ar: "اختر الشدة" },
	{ id: "Description", en: "Description", ar: "الوصف" },
	{ id: "Enter description", en: "Enter description", ar: "أدخل الوصف" },
	{ id: "Remove", en: "Remove", ar: "إزالة" },
	{ id: "Add Deficiency", en: "Add Deficiency", ar: "إضافة ملاحظة" },
	{ id: "Approve", en: "Approve", ar: "الموافقة" },
	{
		id: "Approve With Comments",
		en: "Approve With Comments",
		ar: "الموافقة مع التعليقات",
	},
	{ id: "Reject", en: "Reject", ar: "رفض" },
	{ id: "Identified Details", en: "Identified Details", ar: "تفاصيل الملاحظة" },
	{ id: "Deficiency Severity", en: "Deficiency Severity", ar: "شدة الملاحظة" },
	{ id: "Deficiency Category", en: "Deficiency Category", ar: "فئة الملاحظة" },
	{ id: "Description", en: "Description", ar: "الوصف" },
	{ id: "Date Identified", en: "Date Identified", ar: "تاريخ التحديد" },
	{ id: "Identified By", en: "Identified By", ar: "تم التحديد بواسطة" },
	{ id: "Correction Details", en: "Correction Details", ar: "تفاصيل التصحيح" },
	{ id: "Notes", en: "Notes", ar: "ملاحظات" },
	{ id: "Corrected At", en: "Corrected At", ar: "تاريخ التصحيح" },
	{ id: "Corrected By", en: "Corrected By", ar: "تم التصحيح بواسطة" },
	{ id: "Workmanship", en: "Workmanship", ar: "جودة العمل" },
	{ id: "Dimensional", en: "Dimensional", ar: "الأبعاد" },
	{ id: "Material", en: "Material", ar: "المواد" },
	{ id: "Installation", en: "Installation", ar: "التركيب" },
	{ id: "Documentation", en: "Documentation", ar: "التوثيق" },
	{ id: "Safety", en: "Safety", ar: "السلامة" },
	{
		id: "Testing & Commissioning",
		en: "Testing & Commissioning",
		ar: "الاختبار والتشغيل",
	},
	{
		id: "Design/Coordination",
		en: "Design/Coordination",
		ar: "التصميم / التنسيق",
	},
	{ id: "Non-Compliance", en: "Non-Compliance", ar: "عدم الالتزام" },
	{
		id: "Incomplete/Rework",
		en: "Incomplete/Rework",
		ar: "غير مكتمل / إعادة العمل",
	},
	{ id: "Result is required", en: "Result is required", ar: "النتيجة مطلوبة" },
	{
		id: "Add deficiency only in QA process",
		en: "Add deficiency only in QA process",
		ar: "إضافة العيوب فقط في عملية ضمان الجودة",
	},
	{
		id: "Add comments only in Consultant QA process",
		en: "Add comments only in Consultant QA process",
		ar: "أضف التعليقات فقط في عملية ضمان الجودة للمستشار",
	},
	{
		id: "Critical items still open in IRs and SNAG lists",
		en: "Critical items still open in IRs and SNAG lists",
		ar: "العناصر الحرجة المفتوحة في قوائم الطلبات المرفوضة والعيوب",
	},
	{
		id: "across all types (IR, SNAG, Submittals)",
		en: "across all types (IR, SNAG, Submittals)",
		ar: "عبر جميع الأنواع (طلبات التفتيش، العيوب، المواد المقدمة)",
	},
	{
		id: "Percentage of total rejected items",
		en: "Percentage of total rejected items",
		ar: "النسبة المئوية للعناصر المرفوضة بشكل إجمالي",
	},
	{
		id: "Percentage of submitted IRs, MIRs, and Submittals that were rejected",
		en: "Percentage of submitted IRs, MIRs, and Submittals that were rejected",
		ar: "النسبة المئوية للطلبات المرفوضة من طلبات التفتيش، المواد المرفوضة من المواد المقدمة",
	},
	{
		id: "Avg. time from QA to Consultant approval",
		en: "Avg. time from QA to Consultant approval",
		ar: "متوسط وقت من موافقة ضمان الجودة إلى موافقة المستشار",
	},
	{
		id: "Avg. time from contractor submission to QA approval",
		en: "Avg. time from contractor submission to QA approval",
		ar: "متوسط وقت من الإرسال إلى موافقة ضمان الجودة",
	},
	{
		id: "Requests that exceeded their due date",
		en: "Requests that exceeded their due date",
		ar: "الطلبات التي أعطت مواعيد متأخرة",
	},
	{
		id: "Items should be approved within these timeframes. For IR and MIR, QA within 2 days and Consultant within 3 days. For SNAG, QA within 1 day and Consultant within 2 days. For Submittals, QA within 3 days and Consultant within 5 days. Anything beyond these limits is considered delayed.",
		en: "Items should be approved within these timeframes. For IR and MIR, QA within 2 days and Consultant within 3 days. For SNAG, QA within 1 day and Consultant within 2 days. For Submittals, QA within 3 days and Consultant within 5 days. Anything beyond these limits is considered delayed.",
		ar: "يجب أن تتم موافقة العناصر داخل هذه الفترات. للطلبات المرفوضة والمواد المرفوضة من المواد المقدمة",
	},
	{
		id: "Items needing correction (IR)",
		en: "Items needing correction (IR)",
		ar: "العناصر التي تحتاج إلى تصحيح (طلب التفتيش)",
	},
	{
		id: "days",
		en: "days",
		ar: "أيام",
	},
	{ id: "Dashboard", en: "Dashboard", ar: "لوحة التحكم" },
	{
		id: "Submittals Backlog",
		en: "Submittals Backlog",
		ar: "المواد المقدمة المتأخرة",
	},
	{
		id: "A customer with this name and email already exists",
		en: "A customer with this name and email already exists",
		ar: "عميل بهذا الاسم والبريد الإلكتروني موجود بالفعل",
	},
	{
		id: "You can only update Customers you created",
		en: "You can only update Customers you created",
		ar: "يمكنك فقط تحديث العملاء الذين قمت بإنشائهم",
	},
	{
		id: "You can only delete Customers you created",
		en: "You can only delete Customers you created",
		ar: "يمكنك فقط حذف العملاء الذين قمت بإنشائهم",
	},
	{ id: "Customers", en: "Customers", ar: "العملاء" },
	{
		id: "Email must be a valid email address with a valid domain",
		en: "Email must be a valid email address with a valid domain",
		ar: "يجب أن يكون البريد الإلكتروني عنوان بريد إلكتروني صالحًا مع نطاق صالح",
	},
	{ id: "Current User", en: "Current User", ar: "المستخدم الحالي" },
	{
		id: "Current Login Date",
		en: "Current Login Date",
		ar: "تاريخ وقت الدخول",
	},
	{ id: "Total Logins", en: "Total Logins", ar: "عدد الدخول" },
	{
		id: "First Login Date",
		en: "First Login Date",
		ar: "تاريخ وقت الدخول الأول",
	},
	{
		id: "Total Duration Days",
		en: "Total Duration Days",
		ar: "مدة الدخول الكلية",
	},
	{
		id: "Total Devices Tracked",
		en: "Total Devices Tracked",
		ar: "عدد الأجهزة المتتبعة",
	},
	{
		id: "Total Active Users",
		en: "Total Active Users",
		ar: "عدد المستخدمين النشطين",
	},
	{
		id: "Total Unique Users",
		en: "Total Unique Users",
		ar: "عدد المستخدمين الفريدين",
	},
	{
		id: "Average assignments per device",
		en: "Average assignments per device",
		ar: "عدد المهام المتوسطة للجهاز",
	},
	{ id: "User Name", en: "User Name", ar: "اسم المستخدم" },
	{ id: "Department", en: "Department", ar: "القسم" },
	{ id: "Assigned At", en: "Assigned At", ar: "تاريخ وقت التعيين" },
	{ id: "Unassigned At", en: "Unassigned At", ar: "تاريخ وقت الإلغاء" },
	{ id: "Duration Days", en: "Duration Days", ar: "مدة التعيين الكلية" },
	{
		id: "deviceAssignment",
		en: "Device Usage Report",
		ar: "تقرير استخدام الأجهزة",
	},
	{
		id: "Device Usage Report",
		en: "Device Usage Report",
		ar: "تقرير استخدام الأجهزة",
	},
	{
		id: "hierarchical access",
		en: "hierarchical access",
		ar: "إمكانية الوصول",
	},
	{
		id: "Nasr City",
		en: "Nasr City",
		ar: "مدينة نصر",
	},
	{
		id: "El Obour",
		en: "El Obour",
		ar: "العبور",
	},
	{
		id: "Ain Shams",
		en: "Ain Shams",
		ar: "عين شمس",
	},
	{
		id: "El Marg",
		en: "El Marg",
		ar: "المرج",
	},
	{
		id: "El Salam City",
		en: "El Salam City",
		ar: "مدينة السلام",
	},
	{
		id: "El Shorouk City",
		en: "El Shorouk City",
		ar: "مدينة الشروق",
	},
	{
		id: "Fifth Settlement",
		en: "Fifth Settlement",
		ar: "التجمع الخامس",
	},
	{
		id: "El Zahraa",
		en: "El Zahraa",
		ar: "الزهراء",
	},
	{
		id: "El Sayeda Zeinab",
		en: "El Sayeda Zeinab",
		ar: "السيدة زينب",
	},
	{
		id: "Abbassia",
		en: "Abbassia",
		ar: "العباسية",
	},
	{
		id: "El Zaytoun",
		en: "El Zaytoun",
		ar: "الزيتون",
	},
	{
		id: "Hadayek El Zaitoun",
		en: "Hadayek El Zaitoun",
		ar: "حدائق الزيتون",
	},
	{
		id: "El Mokattam",
		en: "El Mokattam",
		ar: "المقطم",
	},
	{
		id: "El Darb El Ahmar",
		en: "El Darb El Ahmar",
		ar: "الدرب الأحمر",
	},
	{
		id: "Bab El Louk",
		en: "Bab El Louk",
		ar: "باب اللوق",
	},
	{
		id: "Garden City",
		en: "Garden City",
		ar: "جاردن سيتي",
	},
	{
		id: "El Sayeda Aisha",
		en: "El Sayeda Aisha",
		ar: "السيدة عائشة",
	},
	{
		id: "Masr El Gedida",
		en: "Masr El Gedida",
		ar: "مصر الجديدة",
	},
	{
		id: "Rod El Farag",
		en: "Rod El Farag",
		ar: "روض الفرج",
	},
	{
		id: "Zamalek",
		en: "Zamalek",
		ar: "الزمالك",
	},
	{
		id: "Dokki",
		en: "Dokki",
		ar: "الدقي",
	},
	{
		id: "Mohandessin",
		en: "Mohandessin",
		ar: "المهندسين",
	},
	{
		id: "Haram",
		en: "Haram",
		ar: "الهرم",
	},
	{
		id: "Boulaq Ad Dakrour",
		en: "Boulaq Ad Dakrour",
		ar: "بولاق الدكرور",
	},
	{
		id: "Warraq",
		en: "Warraq",
		ar: "الوراق",
	},
	{
		id: "Talbia",
		en: "Talbia",
		ar: "الطالبية",
	},
	{
		id: "Saft El Laban",
		en: "Saft El Laban",
		ar: "صفط اللبن",
	},
	{
		id: "Hadayek Al Ahram",
		en: "Hadayek Al Ahram",
		ar: "حدائق الأهرام",
	},
	{
		id: "Faisal",
		en: "Faisal",
		ar: "فيصل",
	},
	{
		id: "El Monib",
		en: "El Monib",
		ar: "المنيب",
	},
	{
		id: "El Behous",
		en: "El Behous",
		ar: "البحوث",
	},
	{
		id: "showing the devices usage by the field staff.",
		en: "showing the devices usage by the field staff.",
		ar: "عرض استخدام الأجهزة بواسطة المندوبين",
	},
	{ id: "For More Details", en: "For More Details", ar: "لمزيد من التفاصيل" },
	{ id: "Delay Duration", en: "Delay Duration", ar: "مدة التأخير" },
	{ id: "Requester (Customer)", en: "Requester (Customer)", ar: "العميل" },
	{ id: "Request Type", en: "Request Type", ar: "نوع الطلب" },
	{ id: "Violation Type", en: "Violation Type", ar: "نوع التعطل" },
	{ id: "Assigned Staff", en: "Assigned Staff", ar: "المندوب المعين" },
	{ id: "Request Status", en: "Request Status", ar: "حالة الطلب" },
	{ id: "Response Time", en: "Response Time", ar: "وقت الاستجابة" },
	{ id: "Resolution Time", en: "Resolution Time", ar: "وقت الحل" },
	{
		id: "Last Activity Time",
		en: "Last Activity Time",
		ar: "وقت النشاط الأخير",
	},
	{ id: "Shift", en: "Shift", ar: "الوقت" },
	{ id: "Preferred Date", en: "Preferred Date", ar: "التاريخ المفضل" },
	{ id: "View all", en: "View all", ar: "عرض كل" },
	{ id: "service requests", en: "service requests", ar: "طلبات الخدمة" },
	{ id: "Sequential Task", en: "Sequential Task", ar: "مهمة متسلسلة" },
	{ id: "Flexible Task", en: "Flexible Task", ar: "مهمة مرنة" },
	{
		id: "Must finish all forms step by step to complete the task, end only when all are done",
		en: "Must finish all forms step by step to complete the task, end only when all are done",
		ar: "يجب إكمال جميع النماذج تدريجياً لإنهاء المهمة، وإنهاء فقط عندما يكون كلها مكتملة",
	},
	{
		id: "Complete forms freely and end anytime, task can end with pending forms",
		en: "Complete forms freely and end anytime, task can end with pending forms",
		ar: "إكمل النماذج بحرية وإنهاء أي وقت، يمكن إنهاء المهمة بالنماذج المتبقية",
	},
	{ id: "Select Flow", en: "Select Flow", ar: "اختيار التدفق" },
	{
		id: "This field is required",
		en: "This field is required",
		ar: "هذا الحقل مطلوب",
	},
	{ id: "Project", en: "Project", ar: "المشروع" },
	{ id: "Zonep", en: "Zone", ar: "المنطقة" },
	{ id: "building", en: "building", ar: "المبني" },
	{ id: "Select Project", en: "Select Project", ar: "إختيار المشروع" },
	{ id: "Select Zone", en: "Select Zone", ar: "إختيار المنطقة" },
	{ id: "Inspection Request", en: "Inspection Request", ar: "طلب التفتيش" },
	{ id: "IR", en: "IR", ar: "طلب التفتيش" },
	{ id: "data", en: "data", ar: "" },
	{ id: "data", en: "data", ar: "" },
	{ id: "QA Dashboard", en: "QA Dashboard", ar: "لوحة تحكم ضمان الجودة" },
	{
		id: "QA Dashboard for managing field operations, technicians, and service requests",
		en: "QA Dashboard for managing field operations, technicians, and service requests",
		ar: "لوحة تحكم ضمان الجودة لإدارة العمليات الميدانية والمندوبين وطلبات الخدمة",
	},
	{ id: "All Types", en: "All Types", ar: "جميع الأنواع" },
	{ id: "Snag", en: "Snag", ar: "عيب" },
	{ id: "Submittal", en: "Submittal", ar: "تقديم" },
	{ id: "All Projects", en: "All Projects", ar: "جميع المشاريع" },
	// QAAlertsSummary translations
	{
		id: "Total Active Items",
		en: "Total Active Items",
		ar: "إجمالي العناصر النشطة",
	},
	{
		id: "Pending QA / Consultant.",
		en: "Pending QA / Consultant.",
		ar: "في انتظار ضمان الجودة / المستشار.",
	},
	{
		id: "Delayed Approvals Rate",
		en: "Delayed Approvals Rate",
		ar: "معدل الموافقات المتأخرة",
	},
	{
		id: "Requests exceeding SLA.",
		en: "Requests exceeding SLA.",
		ar: "الطلبات التي تتجاوز اتفاقية مستوى الخدمة.",
	},
	{
		id: "Delayed Approvals Count",
		en: "Delayed Approvals Count",
		ar: "عدد الموافقات المتأخرة",
	},
	{
		id: "Rejected IRs/MIRs.",
		en: "Rejected IRs/MIRs.",
		ar: "طلبات التفتيش المرفوضة / طلبات التفتيش المعدلة المرفوضة.",
	},
	{ id: "Rejection Rate", en: "Rejection Rate", ar: "معدل الرفض" },
	{
		id: "qa_approved_at - submitted_at.",
		en: "qa_approved_at - submitted_at.",
		ar: "تاريخ موافقة ضمان الجودة - تاريخ الإرسال.",
	},
	{ id: "Total Rejected", en: "Total Rejected", ar: "إجمالي المرفوض" },
	{
		id: "consultant_approved_at - qa_approved_at.",
		en: "consultant_approved_at - qa_approved_at.",
		ar: "تاريخ موافقة المستشار - تاريخ موافقة ضمان الجودة.",
	},
	{
		id: "Avg. QA Approval Time",
		en: "Avg. QA Approval Time",
		ar: "متوسط وقت موافقة ضمان الجودة",
	},
	{
		id: "Severity = CRITICAL & OPEN.",
		en: "Severity = CRITICAL & OPEN.",
		ar: "الشدة = حرج ومفتوح.",
	},
	{
		id: "Avg. Consultant Approval Time",
		en: "Avg. Consultant Approval Time",
		ar: "متوسط وقت موافقة المستشار",
	},
	{
		id: "From submission to closure.",
		en: "From submission to closure.",
		ar: "من الإرسال إلى الإغلاق.",
	},
	{
		id: "Critical Open Items",
		en: "Critical Open Items",
		ar: "العناصر المفتوحة الحرجة",
	},
	{
		id: "Pending correction.",
		en: "Pending correction.",
		ar: "في انتظار التصحيح.",
	},
	// QACharts translations
	{ id: "Count", en: "Count", ar: "العدد" },
	{ id: "Open", en: "Open", ar: "مفتوح" },
	{ id: "Closed", en: "Closed", ar: "مغلق" },
	{ id: "Rejected", en: "Rejected", ar: "مرفوض" },
	{
		id: "Requests by Module",
		en: "Requests by Module",
		ar: "الطلبات حسب الوحدة",
	},
	{
		id: "No data available",
		en: "No data available",
		ar: "لا توجد بيانات متاحة",
	},
	{
		id: "Pending Load by Team",
		en: "Pending Load by Team",
		ar: "الحمل المعلق حسب الفريق",
	},
	{
		id: "Contractors Performance",
		en: "Contractors Performance",
		ar: "أداء المقاولين",
	},
	{ id: "Failed", en: "Failed", ar: "فشل" },
	{ id: "Moderate", en: "Moderate", ar: "متوسط" },
	{ id: "Successful", en: "Successful", ar: "ناجح" },
	{ id: "Unknown", en: "Unknown", ar: "غير معروف" },
	{ id: "Contractor Name", en: "Contractor Name", ar: "اسم المقاول" },
	{ id: "Backlog", en: "Backlog", ar: "التراكم" },
	{ id: "Total IRs", en: "Total IRs", ar: "إجمالي طلبات التفتيش" },
	{ id: "IR Backlog", en: "IR Backlog", ar: "تراكم طلبات التفتيش" },
	{ id: "Total Snags", en: "Total Snags", ar: "إجمالي العيوب" },
	{ id: "Snag Backlog", en: "Snag Backlog", ar: "تراكم العيوب" },
	{ id: "Critical Snags", en: "Critical Snags", ar: "العيوب الحرجة" },
	{ id: "Total MIRs", en: "Total MIRs", ar: "إجمالي طلبات التفتيش المعدلة" },
	{ id: "MIR Backlog", en: "MIR Backlog", ar: "تراكم طلبات التفتيش المعدلة" },
	{ id: "Total Submittals", en: "Total Submittals", ar: "إجمالي التقديمات" },
	{ id: "Submittal Backlog", en: "Submittal Backlog", ar: "تراكم التقديمات" },
	{ id: "Avg Revisions", en: "Avg Revisions", ar: "متوسط المراجعات" },
	{
		id: "Avg Response Time",
		en: "Avg Response Time",
		ar: "متوسط وقت الاستجابة",
	},
	{ id: "Score", en: "Score", ar: "النتيجة" },
	// Additional QA Dashboard translations
	{
		id: "Requests exceeding SLA",
		en: "Requests exceeding SLA",
		ar: "الطلبات التي تتجاوز اتفاقية مستوى الخدمة",
	},
	{
		id: "Rejected IR/MIR",
		en: "Rejected IR/MIR",
		ar: "طلبات التفتيش المرفوضة / طلبات التفتيش المعدلة المرفوضة",
	},
	{
		id: "QA approved at - submitted at",
		en: "QA approved at - submitted at",
		ar: "تاريخ موافقة ضمان الجودة - تاريخ الإرسال",
	},
	{
		id: "From submission to closure",
		en: "From submission to closure",
		ar: "من الإرسال إلى الإغلاق",
	},
	{
		id: "Open Deficiencies",
		en: "Open Deficiencies",
		ar: "النواقص المفتوحة",
	},
	{
		id: "Pending correction",
		en: "Pending correction",
		ar: "في انتظار التصحيح",
	},
	{
		id: "Pending QA / Consultant",
		en: "Pending QA / Consultant",
		ar: "في انتظار ضمان الجودة / المستشار",
	},
	{
		id: "Avg Cycle Time",
		en: "Avg Cycle Time",
		ar: "متوسط وقت الدورة",
	},
	{
		id: "Avg QA Approval Time",
		en: "Avg QA Approval Time",
		ar: "متوسط وقت موافقة ضمان الجودة",
	},
	{
		id: "Avg Consultant Approval Time",
		en: "Avg Consultant Approval Time",
		ar: "متوسط وقت موافقة المستشار",
	},
	{ id: "Warning", en: "Warning", ar: "تحذير" },
	{ id: "Success", en: "Success", ar: "نجاح" },
	{ id: "Contractor", en: "Contractor", ar: "المقاول" },
	{
		id: "Workload Overview",
		en: "Workload Overview",
		ar: "نظرة عامة على عبء العمل",
	},
	{ id: "IRs", en: "IRs", ar: "طلبات التفتيش" },
	{ id: "MIRs", en: "MIRs", ar: "طلبات التفتيش المعدلة" },
	{ id: "Submittals", en: "Submittals", ar: "التقديمات" },
	{
		id: "Backlog Health",
		en: "Backlog Health",
		ar: "صحة التراكم",
	},
	{
		id: "Performance",
		en: "Performance",
		ar: "الأداء",
	},
	{ id: "Status", en: "Status", ar: "الحالة" },
	// SnagList translations
	{ id: "Snag List", en: "Snag List", ar: "قائمة العيوب" },
	{ id: "Snag Number", en: "Snag Number", ar: "رقم العيب" },
	{ id: "Reported At", en: "Reported At", ar: "تاريخ الإبلاغ" },
	{ id: "level", en: "level", ar: "المستوى" },
	{ id: "Sector", en: "Sector", ar: "القطاع" },
	{ id: "Subsystem", en: "Subsystem", ar: "النظام الفرعي" },
	{ id: "Severity", en: "Severity", ar: "الشدة" },
	{ id: "Assigned To", en: "Assigned To", ar: "مخصص لـ" },
	{ id: "Add new snag", en: "Add new snag", ar: "إضافة عيب جديد" },
	// ViewSnag translations
	{ id: "Rectify", en: "Rectify", ar: "تصحيح" },
	{ id: "Approve", en: "Approve", ar: "موافقة" },
	{ id: "Reject", en: "Reject", ar: "رفض" },
	// ViewSnagBody translations
	{ id: "Snag Details", en: "Snag Details", ar: "تفاصيل العيب" },
	{
		id: "Rectifies and Reviews History",
		en: "Rectifies and Reviews History",
		ar: "تاريخ التصحيحات والمراجعات",
	},
	{ id: "Technical Details", en: "Technical Details", ar: "التفاصيل التقنية" },
	{ id: "Building", en: "Building", ar: "المبنى" },
	{ id: "Discipline", en: "Discipline", ar: "التخصص" },
	{ id: "Item", en: "Item", ar: "العنصر" },
	{ id: "Location", en: "Location", ar: "الموقع" },
	{ id: "Area/Room", en: "Area/Room", ar: "المنطقة/الغرفة" },
	{ id: "Target Date", en: "Target Date", ar: "التاريخ المستهدف" },
	{ id: "Acceptance Criteria", en: "Acceptance Criteria", ar: "معايير القبول" },
	{ id: "Inspection Method", en: "Inspection Method", ar: "طريقة التفتيش" },
	{ id: "Location Details", en: "Location Details", ar: "تفاصيل الموقع" },
	{ id: "Download All", en: "Download All", ar: "تحميل الكل" },
	{ id: "Uploaded by", en: "Uploaded by", ar: "تم الرفع بواسطة" },
	{ id: "on", en: "on", ar: "في" },
	{ id: "Snag History", en: "Snag History", ar: "تاريخ العيب" },
	{
		id: "No history available",
		en: "No history available",
		ar: "لا يوجد تاريخ متاح",
	},
	{ id: "By", en: "By", ar: "بواسطة" },
	// FormSnag translations
	{ id: "Sector is required", en: "Sector is required", ar: "القطاع مطلوب" },
	{
		id: "Assign To is required",
		en: "Assign To is required",
		ar: "التعيين مطلوب",
	},
	{
		id: "Description is required",
		en: "Description is required",
		ar: "الوصف مطلوب",
	},
	{ id: "Project is required", en: "Project is required", ar: "المشروع مطلوب" },
	{
		id: "At least one snag is required",
		en: "At least one snag is required",
		ar: "يجب إضافة عيب واحد على الأقل",
	},
	{ id: "Saving...", en: "Saving...", ar: "جاري الحفظ..." },
	{
		id: "Snags created successfully",
		en: "Snags created successfully",
		ar: "تم إنشاء العيوب بنجاح",
	},
	{ id: "Something went wrong", en: "Something went wrong", ar: "حدث خطأ ما" },
	// SnagFormBody translations
	{ id: "Select Project", en: "Select Project", ar: "اختر المشروع" },
	{ id: "Select Zone", en: "Select Zone", ar: "اختر المنطقة" },
	{ id: "Select Building", en: "Select Building", ar: "اختر المبنى" },
	{ id: "Select Level", en: "Select Level", ar: "اختر المستوى" },
	{ id: "Snags", en: "Snags", ar: "العيوب" },
	{ id: "Add Another Snag", en: "Add Another Snag", ar: "إضافة عيب آخر" },
	// SnagItemRow translations
	{ id: "Select Sector", en: "Select Sector", ar: "اختر القطاع" },
	{ id: "Assign To", en: "Assign To", ar: "تعيين لـ" },
	{ id: "Select Assign To", en: "Select Assign To", ar: "اختر التعيين لـ" },
	{ id: "Select Subsystem", en: "Select Subsystem", ar: "اختر النظام الفرعي" },
	{ id: "Select Discipline", en: "Select Discipline", ar: "اختر التخصص" },
	{ id: "Select Item", en: "Select Item", ar: "اختر العنصر" },
	{
		id: "Select Acceptance Criteria",
		en: "Select Acceptance Criteria",
		ar: "اختر معايير القبول",
	},
	{
		id: "Select Inspection Method",
		en: "Select Inspection Method",
		ar: "اختر طريقة التفتيش",
	},
	{ id: "Enter description", en: "Enter description", ar: "أدخل الوصف" },
	{ id: "Asset Tag ID", en: "Asset Tag ID", ar: "معرف علامة الأصل" },
	{
		id: "Enter asset tag ID",
		en: "Enter asset tag ID",
		ar: "أدخل معرف علامة الأصل",
	},
	{ id: "Drawing Reference", en: "Drawing Reference", ar: "مرجع الرسم" },
	{
		id: "Enter drawing reference",
		en: "Enter drawing reference",
		ar: "أدخل مرجع الرسم",
	},
	{ id: "Select Area/Room", en: "Select Area/Room", ar: "اختر المنطقة/الغرفة" },
	{ id: "Enter location", en: "Enter location", ar: "أدخل الموقع" },
	{ id: "Select severity", en: "Select severity", ar: "اختر الشدة" },
	{
		id: "Enter location details",
		en: "Enter location details",
		ar: "أدخل تفاصيل الموقع",
	},
	{ id: "Upload Files", en: "Upload Files", ar: "رفع الملفات" },
	// ApproveRejectPopup translations
	{ id: "Approve Snag", en: "Approve Snag", ar: "الموافقة على العيب" },
	{ id: "Reject Snag", en: "Reject Snag", ar: "رفض العيب" },
	{
		id: "Comments are required",
		en: "Comments are required",
		ar: "التعليقات مطلوبة",
	},
	{
		id: "Enter approval comments",
		en: "Enter approval comments",
		ar: "أدخل تعليقات الموافقة",
	},
	{
		id: "Enter rejection comments",
		en: "Enter rejection comments",
		ar: "أدخل تعليقات الرفض",
	},
	{ id: "Submitting...", en: "Submitting...", ar: "جاري الإرسال..." },
	{
		id: "Snag approved successfully",
		en: "Snag approved successfully",
		ar: "تمت الموافقة على العيب بنجاح",
	},
	{
		id: "Snag rejected successfully",
		en: "Snag rejected successfully",
		ar: "تم رفض العيب بنجاح",
	},
	// RectifyPopup translations
	{ id: "Rectify Snag", en: "Rectify Snag", ar: "تصحيح العيب" },
	{
		id: "Rectification notes are required",
		en: "Rectification notes are required",
		ar: "ملاحظات التصحيح مطلوبة",
	},
	{
		id: "Rectification Notes",
		en: "Rectification Notes",
		ar: "ملاحظات التصحيح",
	},
	{
		id: "Enter rectification notes",
		en: "Enter rectification notes",
		ar: "أدخل ملاحظات التصحيح",
	},
	{ id: "Submit", en: "Submit", ar: "إرسال" },
	{
		id: "Snag rectified successfully",
		en: "Snag rectified successfully",
		ar: "تم تصحيح العيب بنجاح",
	},
	{ id: "snag-list", en: "Snag List", ar: "قائمة العيوب" },
	{ id: "Rectified", en: "Rectified", ar: "تم التصحيح" },
	{ id: "Qa Verified", en: "Qa Verified", ar: "تم التحقق من ضمان الجودة" },
	{
		id: "Consultant Approved",
		en: "Consultant Approved",
		ar: "تم الموافقة من قبل المستشار",
	},
	{ id: "Qa Rejected", en: "Qa Rejected", ar: "تم الرفض من قبل ضمان الجودة" },
	{
		id: "Consultant Rejected",
		en: "Consultant Rejected",
		ar: "تم الرفض من قبل المستشار",
	},
	// IRHistory translations
	{ id: "IR History", en: "IR History", ar: "تاريخ طلبات التفتيش" },
	{ id: "IR Number", en: "IR Number", ar: "رقم طلب التفتيش" },
	{ id: "Submitted Date", en: "Submitted Date", ar: "تاريخ الإرسال" },
	{ id: "Reviewed Date", en: "Reviewed Date", ar: "تاريخ المراجعة" },
	{ id: "Review Result", en: "Review Result", ar: "نتيجة المراجعة" },
	{ id: "Deficiencies", en: "Deficiencies", ar: "النواقص" },
	{ id: "Turnaround Time", en: "Turnaround Time", ar: "وقت الاستجابة" },
	{ id: "Total Reviewed", en: "Total Reviewed", ar: "إجمالي المراجعات" },
	{
		id: "Approved This Period",
		en: "Approved This Period",
		ar: "المعتمد في هذه الفترة",
	},
	{
		id: "Rejected This Period",
		en: "Rejected This Period",
		ar: "المرفوض في هذه الفترة",
	},
	{
		id: "Average Review Time",
		en: "Average Review Time",
		ar: "متوسط وقت المراجعة",
	},
	{ id: "Mechanical", en: "Mechanical", ar: "ميكانيكي" },
	{ id: "Civil", en: "Civil", ar: "مدني" },
	{ id: "Architectural", en: "Architectural", ar: "معماري" },
	{ id: "Other", en: "Other", ar: "أخرى" },
	{ id: "NCR", en: "NCR", ar: "إشعار عدم المطابقة" },
	{ id: "SNAG", en: "SNAG", ar: "عيب" },
	// Status translations
	{ id: "DRAFT", en: "DRAFT", ar: "مسودة" },
	{ id: "PENDING QA", en: "PENDING QA", ar: "في انتظار ضمان الجودة" },
	{ id: "QA APPROVED", en: "QA APPROVED", ar: "موافق عليه من ضمان الجودة" },
	{ id: "QA REJECTED", en: "QA REJECTED", ar: "مرفوض من ضمان الجودة" },
	{
		id: "PENDING CONSULTANT",
		en: "PENDING CONSULTANT",
		ar: "في انتظار المستشار",
	},
	{
		id: "CONSULTANT APPROVED",
		en: "CONSULTANT APPROVED",
		ar: "موافق عليه من المستشار",
	},
	{
		id: "CONSULTANT APPROVED WITH COMMENTS",
		en: "CONSULTANT APPROVED WITH COMMENTS",
		ar: "موافق عليه من المستشار مع تعليقات",
	},
	{
		id: "CONSULTANT REJECTED",
		en: "CONSULTANT REJECTED",
		ar: "مرفوض من المستشار",
	},
	{ id: "CLOSED", en: "CLOSED", ar: "مغلق" },
	{ id: "CANCELLED", en: "CANCELLED", ar: "ملغي" },
	{ id: "APPROVED", en: "APPROVED", ar: "موافق عليه" },
	{ id: "REJECTED", en: "REJECTED", ar: "مرفوض" },
	{ id: "Add new IR", en: "Add new IR", ar: "إضافة طلب تفتيش" },
	{ id: "projects", en: "projects", ar: "المشروعات" },
	{ id: "zones", en: "zones", ar: "المناطق" },
	{ id: "level", en: "level", ar: "الدور" },
	{ id: "Select Level", en: "Select Level", ar: "إختيار الدور" },
	{ id: "Select Form", en: "Select Form", ar: "إختيار النموذج" },
	{ id: "Select Discipline", en: "Select Discipline", ar: "إختيار التخصص" },
	{ id: "discipline", en: "discipline", ar: "التخصص" },
	{ id: "Disciplines", en: "Disciplines", ar: "التخصصات" },
	{ id: "Ready Date", en: "Ready Date", ar: "تاريخ الجاهزيه" },
	{ id: "form submission", en: "form submission", ar: "تقديم النموذج" },
	{ id: "Project is required", en: "Project is required", ar: "المشروع مطلوب" },
	{
		id: "Discipline is required",
		en: "Discipline is required",
		ar: "التخصص مطلوب",
	},
	{
		id: "Ready Date is required",
		en: "Ready Date is required",
		ar: "تاريخ الجاهزيه مطلوب",
	},
	{ id: "Form is required", en: "Form is required", ar: "النموذج مطلوب" },
	{ id: "ELECTRICAL", en: "Electrical", ar: "كهرباء" },
	{ id: "MECHANICAL", en: "Mechanical", ar: "ميكانيكا" },
	{ id: "PLUMBING", en: "Plumbing", ar: "سباكة" },
	{ id: "CIVIL", en: "Civil", ar: "مدني" },
	{ id: "ARCHITECTURAL", en: "Architectural", ar: "معماري" },
	{ id: "OTHER", en: "Other", ar: "أخرى" },
	{ id: "PENDING", en: "Pending", ar: "قيد الانتظار" },
	{ id: "APPROVED", en: "Approved", ar: "موافق عليه" },
	{ id: "REJECTED", en: "Rejected", ar: "مرفوض" },
	{ id: "MINOR", en: "Minor", ar: "طفيف" },
	{ id: "MAJOR", en: "Major", ar: "كبير" },
	{ id: "CRITICAL", en: "Critical", ar: "حرج" },
	{ id: "GROUND_FLOOR", en: "Ground Floor", ar: "الدور الأرضي" },
	{ id: "FIRST_FLOOR", en: "First Floor", ar: "الدور الأول" },
	{ id: "SECOND_FLOOR", en: "Second Floor", ar: "الدور الثاني" },
	{ id: "THIRD_FLOOR", en: "Third Floor", ar: "الدور الثالث" },
	{ id: "FOURTH_FLOOR", en: "Fourth Floor", ar: "الدور الرابع" },
	{ id: "BASEMENT_1", en: "Basement 1", ar: "القبو 1" },
	{ id: "BASEMENT_2", en: "Basement 2", ar: "القبو 2" },
	{ id: "ROOF", en: "Roof", ar: "السطح" },
	{ id: "MEZZANINE", en: "Mezzanine", ar: "ميزانين" },
	{ id: "PENTHOUSE", en: "Penthouse", ar: "البنتهاوس" },
	{ id: "DRAFT", en: "Draft", ar: "مسودة" },
	{ id: "PENDING_QA", en: "Pending QA", ar: "قيد انتظار مراقبة الجودة" },
	{ id: "QA_APPROVED", en: "QA Approved", ar: "تمت الموافقة من مراقبة الجودة" },
	{ id: "QA_REJECTED", en: "QA Rejected", ar: "تم الرفض من مراقبة الجودة" },
	{
		id: "PENDING_CONSULTANT",
		en: "Pending Consultant",
		ar: "قيد انتظار المستشار",
	},
	{
		id: "CONSULTANT_APPROVED",
		en: "Consultant Approved",
		ar: "تمت الموافقة من المستشار",
	},
	{
		id: "CONSULTANT_APPROVED_WITH_COMMENTS",
		en: "Consultant Approved With Comments",
		ar: "تمت الموافقة مع ملاحظات من المستشار",
	},
	{
		id: "CONSULTANT_REJECTED",
		en: "Consultant Rejected",
		ar: "تم الرفض من المستشار",
	},
	{ id: "CLOSED", en: "Closed", ar: "مغلق" },
	{ id: "CANCELLED", en: "Cancelled", ar: "ملغى" },
	{
		id: "Add Inspection Request",
		en: "Add Inspection Request",
		ar: "إضافة طلب تفتيش",
	},
	{
		id: "Edit Inspection Request",
		en: "Edit Inspection Request",
		ar: "إضافة طلب تفتيش",
	},
	{ id: "Discipline", en: "Discipline", ar: "التخصص" },
	{ id: "deficiency", en: "deficiency", ar: "العيوب" },
	{
		id: "Inspection Request Details",
		en: "Inspection Request Details",
		ar: "تفاصيل طلب التفتيش",
	},
	{ id: "Resubmit", en: "Resubmit", ar: "إعادة تقديم" },
	{
		id: "No deficiencies have been recorded yet",
		en: "No deficiencies have been recorded yet",
		ar: "لم يتم تسجيل أي عيوب حتى الآن",
	},
	{
		id: "Please fill all deficiency data",
		en: "Please fill all deficiency data",
		ar: "يرجى ملء جميع بيانات النقص",
	},
	{
		id: "IR Consultant Review Submitted Successfully",
		en: "IR Consultant Review Submitted Successfully",
		ar: "تم تقديم مراجعة استشاري العلاقات مع المستثمرين بنجاح",
	},
	{
		id: "IR QA Review Submitted Successfully",
		en: "IR QA Review Submitted Successfully",
		ar: "تم تقديم مراجعة ضمان الجودة مع المستثمرين بنجاح",
	},
	{ id: "Comments", en: "Comments", ar: "التعليقات" },
	{
		id: "Enter your comments",
		en: "Enter your comments",
		ar: "إدخل التعليقات",
	},
	{ id: "Category", en: "Category", ar: "الفئة" },
	{ id: "Select Category", en: "Select Category", ar: "اختر الفئة" },
	{ id: "Severity", en: "Severity", ar: "شدة" },
	{ id: "Select Severity", en: "Select Severity", ar: "اختر الشدة" },
	{ id: "Description", en: "Description", ar: "الوصف" },
	{ id: "Enter description", en: "Enter description", ar: "أدخل الوصف" },
	{ id: "Remove", en: "Remove", ar: "إزالة" },
	{ id: "Add Deficiency", en: "Add Deficiency", ar: "إضافة ملاحظة" },
	{ id: "Approve", en: "Approve", ar: "الموافقة" },
	{
		id: "Approve With Comments",
		en: "Approve With Comments",
		ar: "الموافقة مع التعليقات",
	},
	{ id: "Reject", en: "Reject", ar: "رفض" },
	{ id: "Identified Details", en: "Identified Details", ar: "تفاصيل الملاحظة" },
	{ id: "Deficiency Severity", en: "Deficiency Severity", ar: "شدة الملاحظة" },
	{ id: "Deficiency Category", en: "Deficiency Category", ar: "فئة الملاحظة" },
	{ id: "Description", en: "Description", ar: "الوصف" },
	{ id: "Date Identified", en: "Date Identified", ar: "تاريخ التحديد" },
	{ id: "Identified By", en: "Identified By", ar: "تم التحديد بواسطة" },
	{ id: "Correction Details", en: "Correction Details", ar: "تفاصيل التصحيح" },
	{ id: "Notes", en: "Notes", ar: "ملاحظات" },
	{ id: "Corrected At", en: "Corrected At", ar: "تاريخ التصحيح" },
	{ id: "Corrected By", en: "Corrected By", ar: "تم التصحيح بواسطة" },
	{ id: "Workmanship", en: "Workmanship", ar: "جودة العمل" },
	{ id: "Dimensional", en: "Dimensional", ar: "الأبعاد" },
	{ id: "Material", en: "Material", ar: "المواد" },
	{ id: "Installation", en: "Installation", ar: "التركيب" },
	{ id: "Documentation", en: "Documentation", ar: "التوثيق" },
	{ id: "Safety", en: "Safety", ar: "السلامة" },
	{
		id: "Testing & Commissioning",
		en: "Testing & Commissioning",
		ar: "الاختبار والتشغيل",
	},
	{
		id: "Design/Coordination",
		en: "Design/Coordination",
		ar: "التصميم / التنسيق",
	},
	{ id: "Non-Compliance", en: "Non-Compliance", ar: "عدم الالتزام" },
	{
		id: "Incomplete/Rework",
		en: "Incomplete/Rework",
		ar: "غير مكتمل / إعادة العمل",
	},
	{ id: "Result is required", en: "Result is required", ar: "النتيجة مطلوبة" },
	{
		id: "Add deficiency only in QA process",
		en: "Add deficiency only in QA process",
		ar: "إضافة العيوب فقط في عملية ضمان الجودة",
	},
	{
		id: "Add comments only in Consultant QA process",
		en: "Add comments only in Consultant QA process",
		ar: "أضف التعليقات فقط في عملية ضمان الجودة للمستشار",
	},
	{ id: "MATERIAL", en: "Material", ar: "المواد" },
	{ id: "SHOP_DRAWING", en: "Shop Drawing", ar: "الرسومات التنفيذية" },
	{ id: "METHOD_STATEMENT", en: "Method Statement", ar: "منهجية العمل" },
	{
		id: "INSPECTION_AND_TEST_PLAN",
		en: "Inspection and Test Plan",
		ar: "خطة الفحص والاختبار",
	},
	{
		id: "WORK_INSPECTION_REQUESTS",
		en: "Work Inspection Requests",
		ar: "طلبات فحص العمل",
	},
	{ id: "SAMPLES", en: "Samples", ar: "العينات" },
	{ id: "TECHNICAL", en: "Technical", ar: "تقني" },
	{
		id: "PRE_QUALIFICATION_DOCUMENTS",
		en: "Pre-Qualification Documents",
		ar: "مستندات التأهيل المسبق",
	},
	{
		id: "MOCKUP_APPROVALS",
		en: "Mockup Approvals",
		ar: "اعتمادات النموذج الأولي",
	},
	{
		id: "AS_BUILT_DRAWINGS",
		en: "As-Built Drawings",
		ar: "رسومات حسب التنفيذ",
	},
	{ id: "OM_MANUALS", en: "O&M Manuals", ar: "كتيبات التشغيل والصيانة" },
	{ id: "OTHERS", en: "Others", ar: "أخرى" },

	/* ---- Submittal categories (SubmittalType). The document-number code for each is
	   shown in brackets: EGP38-YTC-[MS]-GN-001. Superseded the MATERIAL/SHOP_DRAWING/...
	   list above, which is still live for Inspection Requests. ---- */
	{ id: "PLAN", en: "Plan", ar: "خطة" }, // PL
	{ id: "DRAWING", en: "Drawing", ar: "رسم" }, // DW
	{ id: "CALCULATION", en: "Calculation", ar: "حسابات" }, // CA
	{
		id: "DATA_SHEET", // DS
		en: "Data Sheet / Specification Sheet",
		ar: "ورقة بيانات / ورقة مواصفات",
	},
	// METHOD_STATEMENT (MS) already defined above as "منهجية العمل"

	/* ---- Submittal disciplines (SubmittalDiscipline): EGP38-YTC-MS-[GN]-001 ---- */
	{ id: "GENERAL", en: "General / Management", ar: "عام / إدارة" }, // GN
	{
		id: "PHOTOVOLTAIC_POWER", // PV
		en: "Photovoltaic Power",
		ar: "الطاقة الشمسية الكهروضوئية",
	},
	{ id: "BATTERY_POWER", en: "Battery Power", ar: "طاقة البطاريات" }, // BT
	{
		id: "MV_UNDERGROUND_LINE", // UG
		en: "MV Underground Line",
		ar: "خط الجهد المتوسط الأرضي",
	},
	// CIVIL (CV) already defined above as "مدني"
	{
		id: "ELECTRICAL_MECHANICAL", // EM
		en: "Electrical, Airconditioning, Mechanical",
		ar: "كهرباء وتكييف وميكانيكا",
	},
	{
		id: "TEST_COMMISSIONING", // TC
		en: "Test & Commissioning",
		ar: "الاختبار والتشغيل",
	},
	{ id: "LOGISTICS", en: "Logistics", ar: "الخدمات اللوجستية" }, // LG

	/* ---- Submittal revision cycles ---- */
	{ id: "ISR", en: "Internal", ar: "داخلي" },
	{ id: "ESR", en: "External", ar: "خارجي" },
	{ id: "Internal Revisions", en: "Internal Revisions", ar: "المراجعات الداخلية" },
	{ id: "External Revisions", en: "External Revisions", ar: "المراجعات الخارجية" },
	{ id: "Revision History", en: "Revision History", ar: "سجل المراجعات" },
	{
		id: "Revision Information",
		en: "Revision Information",
		ar: "معلومات المراجعة",
	},
	{ id: "No revisions found", en: "No revisions found", ar: "لا توجد مراجعات" },
	{ id: "Submitted At", en: "Submitted At", ar: "تاريخ التقديم" },
	{ id: "Submitted By", en: "Submitted By", ar: "قدم بواسطة" },
	{ id: "Reviewed At", en: "Reviewed At", ar: "تاريخ المراجعة" },
	{ id: "Reviewed By", en: "Reviewed By", ar: "روجع بواسطة" },
	{ id: "Review Result", en: "Review Result", ar: "نتيجة المراجعة" },
	{ id: "Review Comments", en: "Review Comments", ar: "ملاحظات المراجعة" },
	{ id: "Correction Notes", en: "Correction Notes", ar: "ملاحظات التصحيح" },
	{ id: "Turnaround", en: "Turnaround", ar: "مدة الاستجابة" },
	{ id: "In Progress", en: "In Progress", ar: "قيد التنفيذ" },
	{ id: "RETURNED", en: "Returned", ar: "أعيد" },
	{ id: "Current Revision", en: "Current Revision", ar: "المراجعة الحالية" },
	{ id: "Export to Excel", en: "Export to Excel", ar: "تصدير إلى إكسل" },
	{
		id: "Exports the submittals currently shown, with their revisions",
		en: "Exports the submittals currently shown, with their revisions",
		ar: "تصدير التقديمات المعروضة حاليًا مع مراجعاتها",
	},
	{
		id: "Failed to download Excel",
		en: "Failed to download Excel",
		ar: "تعذر تنزيل ملف إكسل",
	},
	{
		id: "No submittals found matching the criteria",
		en: "No submittals found matching the criteria",
		ar: "لم يتم العثور على تقديمات مطابقة للمعايير",
	},
	{ id: "First", en: "First", ar: "الأول" },
	{ id: "Last", en: "Last", ar: "الأخير" },
	{ id: "No attachments", en: "No attachments", ar: "لا توجد مرفقات" },
	/*-----------------TTTTTTTTTTTT---------------- */
	{ id: "MATERIAL", en: "Material", ar: "المواد" },
	{ id: "SHOP_DRAWING", en: "Shop Drawing", ar: "الرسومات التنفيذية" },
	{ id: "METHOD_STATEMENT", en: "Method Statement", ar: "منهجية العمل" },
	{
		id: "INSPECTION_AND_TEST_PLAN",
		en: "Inspection and Test Plan",
		ar: "خطة الفحص والاختبار",
	},
	{
		id: "WORK_INSPECTION_REQUESTS",
		en: "Work Inspection Requests",
		ar: "طلبات فحص العمل",
	},
	{ id: "SAMPLES", en: "Samples", ar: "العينات" },
	{ id: "TECHNICAL", en: "Technical", ar: "تقني" },
	{
		id: "PRE_QUALIFICATION_DOCUMENTS",
		en: "Pre-Qualification Documents",
		ar: "مستندات التأهيل المسبق",
	},
	{
		id: "MOCKUP_APPROVALS",
		en: "Mockup Approvals",
		ar: "اعتمادات النموذج الأولي",
	},
	{
		id: "AS_BUILT_DRAWINGS",
		en: "As-Built Drawings",
		ar: "رسومات حسب التنفيذ",
	},
	{ id: "OM_MANUALS", en: "O&M Manuals", ar: "كتيبات التشغيل والصيانة" },
	{ id: "OTHERS", en: "Others", ar: "أخرى" },
	{ id: "Review Date", en: "Review Date", ar: "تاريخ الجاهزيه" },
	{ id: "REVISION_REQUIRED", en: "Revision Required", ar: "المراجعة مطلوبة" },
	{
		id: "RETURNED_TO_CONTRACTOR",
		en: "Returned to Contractor",
		ar: "أعيد إلى المقاول",
	},
	{ id: "Add new Submittal", en: "Add new Submittal", ar: "إضافة تقديم جديد" },
	{ id: "Add Submittal", en: "Add Submittal", ar: "إضافة تقديم" },
	{ id: "Edit Submittal", en: "Edit Submittal", ar: "تعديل تقديم" },
	{
		id: "Enter your description",
		en: "Enter your description",
		ar: "أدخل الوصف",
	},
	{
		id: "Max 10 files, 50MB total.",
		en: "Max 10 files, 50MB total.",
		ar: "الحد الأقصى 10 ملفات، 50 ميجا بايت إجماليًا.",
	},
	{ id: "Submittal Details", en: "Submittal Details", ar: "تفاصيل التقديم" },
	{ id: "review", en: "review", ar: "مراجعة" },
	{ id: "Submittal Number", en: "Submittal Number", ar: "رقم التقديم" },
	{
		id: "Reviewed By QA",
		en: "Reviewed By QA",
		ar: "مراجع بواسطة فريق الجودة",
	},
	{
		id: "Reviewed By Consultant",
		en: "Reviewed By Consultant",
		ar: "مراجع بواسطة الاستشاري",
	},

	{ id: "Home", en: "Home", ar: "الرئيسية" },
	{
		id: "No deficiencies have been recorded yet",
		en: "No deficiencies have been recorded yet",
		ar: "لم يتم تسجيل أي عيوب حتى الآن",
	},
	{ id: "Revision", en: "Revision", ar: "مراجعه" },
	{
		id: "Submittal Consultant Review Submitted Successfully",
		en: "Submittal Consultant Review Submitted Successfully",
		ar: "تم تقديم مراجعة الاستشاري بنجاح",
	},
	{
		id: "Submittal QA Review Submitted Successfully",
		en: "Submittal QA Review Submitted Successfully",
		ar: "تم تقديم مراجعة ضمان الجودة بنجاح",
	},
	{
		id: "Please add comment in case of Returning Submittal",
		en: "Please add comment in case of Returning Submittal",
		ar: "يرجى إضافة تعليق في حالة إرجاع الإرسال",
	},
	{
		id: "Please add comment in case of Revisioning Submittal",
		en: "Please add comment in case of Revisioning Submittal",
		ar: "في حالة مراجعة المخططات يُرجى إضافة تعليق",
	},
	{
		id: "Please add comment in case of Rejecting Submittal",
		en: "Please add comment in case of Rejecting Submittal",
		ar: "في حالة رفض المخططات يُرجى إضافة تعليق",
	},
	{
		id: "Submittal Re-Submission Submitted Successfully",
		en: "Submittal Re-Submission Submitted Successfully",
		ar: "تم إرسال إعادة تقديم الطلب بنجاح",
	},
	{
		id: "Comment is required",
		en: "Comment is required",
		ar: "التعليق مطلوب",
	},
	{
		id: "Submittal Added Successfully",
		en: "Submittal Added Successfully",
		ar: "تم إرسال الملفات بنجاح",
	},
	{
		id: "Submittal Edited Successfully",
		en: "Submittal Edited Successfully",
		ar: "تم تعديل الملفات بنجاح",
	},
	{ id: "OTHERS", en: "Others", ar: "أخرى" },
	{ id: "History & Actions", en: "History & Actions", ar: "السجل والإجراءات" },
	{
		id: "Enter Contractor label",
		en: "Enter Contractor label",
		ar: "أدخل اسم المقاول",
	},
	{ id: "Customer 1 Name", en: "Customer 1 Name", ar: "اسم العميل 1" },
	{ id: "Customer 2 Name", en: "Customer 2 Name", ar: "اسم العميل 2" },
	{
		id: "Enter Customer 1 label",
		en: "Enter Customer 1 label",
		ar: "أدخل اسم العميل 1",
	},
	{
		id: "Enter Customer 2 label",
		en: "Enter Customer 2 label",
		ar: "أدخل اسم العميل 2",
	},
	{
		id: "Enter Consultant label",
		en: "Enter Consultant label",
		ar: "أدخل اسم الاستشاري",
	},
	{ id: "Customer 1", en: "Customer 1", ar: "العميل 1" },
	{ id: "Customer 2", en: "Customer 2", ar: "العميل 2" },
	{
		id: "Enter Customer 2",
		en: "Enter Customer 2",
		ar: "أدخل اسم العميل 2",
	},
	{ id: "Consultant Name", en: "Consultant Name", ar: "اسم الاستشاري" },
	{ id: "Consultant", en: "Consultant", ar: "الاستشاري" },
	{
		id: "Consultant_label",
		en: "Enter Consultant label",
		ar: "أدخل اسم المستشار",
	},
	{ id: "Upload_file", en: "Upload File", ar: "رفع ملف" },
	{ id: "Logos", en: "Logos", ar: "الشعارات" },
	{
		id: "You can only upload image files",
		en: "You can only upload image files",
		ar: "يمكنك إضافة صور فقط",
	},
	{ id: "Assigned By", en: "Assigned By", ar: "مسندة بواسطة" },
	{ id: "Expires At", en: "Expires At", ar: "تنتهي في" },
	{
		id: "Role Expiration Date",
		en: "Role Expiration Date",
		ar: "تاريخ إنتهاء الصلاحية",
	},
	{
		id: "This user already has an assigned role.",
		en: "This user already has an assigned role.",
		ar: "هذا المستخدم لديه دور معين بالفعل.",
	},
	{
		id: "Role assigned to user successfully",
		en: "Role assigned to user successfully",
		ar: "تم تعيين الدور للمستخدم بنجاح",
	},
	{
		id: "Role unassigned from user successfully",
		en: "Role unassigned from user successfully",
		ar: "تم إلغاء تعيين الدور من المستخدم بنجاح",
	},
	{ id: "Assign Role", en: "Assign To Users", ar: "تعيين لمستخدمين" },
	{ id: "Fleet Management", en: "Fleet Management", ar: "ادارة الأسطول" },
	{
		id: "QA/QC",
		en: "QA/QC",
		ar: "ضمان الجودة / مراقبة الجودة",
	},
	{ id: "surveillance", en: "surveillance", ar: "المراقبة" },
	{ id: "fms", en: "fms", ar: "ادارة الأسطول" },
	{ id: "fms vehicles", en: "fms vehicles", ar: "ادارة الأسطول مركبات" },
	{ id: "fms drivers", en: "fms drivers", ar: "ادارة الأسطول سائقين" },
	{ id: "setup account", en: "setup account", ar: "إعدادات الملف الشخصي" },
	{
		id: "setup user roles",
		en: "setup user roles",
		ar: "إعدادات أدوار المستخدمين",
	},

	{
		id: "Trips Report",
		en: "Trips Report",
		ar: "تقرير الرحلات",
	},
	{
		id: "Vehicles Speed Report",
		en: "Vehicles Speed Report",
		ar: "تقرير سرعة المركبات",
	},
	{
		id: "Vehicles Stop Report",
		en: "Vehicles Stop Report",
		ar: "تقرير توقف المركبات",
	},
	{
		id: "Vehicles Distance Report",
		en: "Vehicles Distance Report",
		ar: "تقرير مسافة المركبات",
	},
	{
		id: "Vehicles Device Behavior Report",
		en: "Vehicles Device Behavior Report",
		ar: "تقرير سلوك جهاز المركبة",
	},
	{
		id: "Vehicles Fuel Report",
		en: "Vehicles Fuel Report",
		ar: "تقرير وقود المركبات",
	},
	{
		id: "Vehicles Odometer Report",
		en: "Vehicles Odometer Report",
		ar: "تقرير عداد المسافات للمركبات",
	},

	{
		id: "Live Stream",
		en: "Live Stream",
		ar: "البث المباشر",
	},
	{
		id: "Playback",
		en: "Playback",
		ar: "تشغيل المسار",
	},
	{
		id: "Live tracking controls - control engine",
		en: "Live tracking controls - control engine",
		ar: "التحكم في التتبع المباشر - التحكم في المحرك",
	},
	{
		id: "Live tracking controls - alerts",
		en: "Live tracking controls - alerts",
		ar: "التحكم في التتبع المباشر - التنبيهات",
	},
	{
		id: "Live tracking history",
		en: "Live tracking history",
		ar: "سجل التتبع المباشر",
	},
	{
		id: "Please contact your adminstrator to compelete your setup",
		en: "Please contact your adminstrator to compelete your setup",
		ar: " برجاء التواصل مع إدارة النظام لإكمال الإعدادات الخاصة بك",
	},
	{
		id: "Sorry, you don't have permission to access this page.",
		en: "Sorry, you don't have permission to access this page.",
		ar: "عذراً، ليس لديك الإذن للوصول إلى هذه الصفحة.",
	},
	{
		id: "tasks heatmap",
		en: "tasks heatmap",
		ar: "الخريطة الحرارية للمهام",
	},
	{
		id: "Live Tracking",
		en: "Live Tracking",
		ar: "تتبع مباشر",
	},
	{ id: "Historical", en: "Historical", ar: "السجل" },
	{ id: "NotificatioNs", en: "Notifications", ar: "اشعارات" },
	{ id: "FMS", en: "FMS", ar: "ادارة الأسطول" },
	{ id: "Reports", en: "Reports", ar: "التقارير" },
	/*----------------YYYYYYYYYYYYYY------------------*/
	{
		id: "Ungrouped Devices",
		en: "Ungrouped Devices",
		ar: "الأجهزة غير المصنفة",
	},
	{
		id: "Mobility",
		en: "Mobility",
		ar: "الأجهزة المتنقلة",
	},
	{
		id: "Device name",
		en: "Device name",
		ar: "اسم الجهاز",
	},
	{
		id: "assignment to",
		en: "assignment to",
		ar: "التعيين إلى",
	},
	{
		id: "Device Details",
		en: "Device Details",
		ar: "تفاصيل الجهاز",
	},
	{
		id: "Device App Version",
		en: "Device App Version",
		ar: "إصدار تطبيق الجهاز",
	},
	{
		id: "Device OS Version",
		en: "Device OS Version",
		ar: "إصدار نظام التشغيل",
	},
	{
		id: "Device Brand",
		en: "Device Brand",
		ar: "علامة الجهاز",
	},
	{
		id: "Device Model",
		en: "Device Model",
		ar: "نموذج الجهاز",
	},
	{
		id: "last update",
		en: "last update",
		ar: "آخر تحديث",
	},
	{
		id: "Last Update",
		en: "Last Update",
		ar: "آخر تحديث",
	},
	{
		id: "Current Assignment",
		en: "Current Assignment",
		ar: "التعيين الحالي",
	},
	{
		id: "Assignment Date",
		en: "Assignment Date",
		ar: "تاريخ التعيين",
	},
	{ id: "Moving", en: "Moving", ar: "متحرك" },
	{ id: "project setup", en: "project setup", ar: "إعداد المشروع" },
	{ id: "project-setup", en: "project-setup", ar: "إعداد المشروع" },
	{ id: "companies", en: "companies", ar: "الشركات" },
	{ id: "teams", en: "teams", ar: "الفرق" },
	{ id: "Snag Report", en: "Snag Report", ar: "تقرير العيوب" },
	{
		id: "Add new project setup",
		en: "Add new project setup",
		ar: "إضافة إعداد مشروع جديد",
	},
	{ id: "Project Name", en: "Project Name", ar: "اسم المشروع" },
	{ id: "Continue Setup", en: "Continue Setup", ar: "متابعة الإعداد" },
	{ id: "Buildings", en: "Buildings", ar: "المباني" },
	{ id: "buildings", en: "buildings", ar: "المباني" },
	{ id: "Infrastructure", en: "Infrastructure", ar: "البنية التحتية" },
	{ id: "infrastructure", en: "infrastructure", ar: "البنية التحتية" },
	{ id: "Roads", en: "Roads", ar: "الطرق" },
	{ id: "roads", en: "roads", ar: "الطرق" },
	{ id: "MEP", en: "MEP", ar: "الأعمال الميكانيكية والكهربائية" },
	{ id: "MixedUse", en: "Mixed Use", ar: "متعدد الاستخدامات" },
	{ id: "mixedUse", en: "mixedUse", ar: "متعدد الاستخدامات" },
	{ id: "Active", en: "Active", ar: "نشط" },
	{ id: "active", en: "active", ar: "نشط" },
	{ id: "OnHold", en: "On Hold", ar: "متوقف مؤقتًا" },
	{ id: "onHold", en: "onHold", ar: "متوقف مؤقتًا" },
	{ id: "Completed", en: "Completed", ar: "مكتمل" },
	{ id: "completed", en: "completed", ar: "مكتمل" },
	{ id: "Planning Phase", en: "Planning Phase", ar: "مرحلة التخطيط" },
	{ id: "planningPhase", en: "planningPhase", ar: "مرحلة التخطيط" },
	{ id: "Project Details", en: "Project Details", ar: "تفاصيل المشروع" },
	{ id: "Building Details", en: "Building Details", ar: "تفاصيل المبني" },
	{ id: "Level Details", en: "Level Details", ar: "تفاصيل الطابق" },
	{ id: "Room Details", en: "Room Details", ar: "تفاصيل الغرفة" },
	{ id: "project", en: "project", ar: "المشروع" },
	{ id: "space", en: "space", ar: "الغرفة" },
	{ id: "project layout", en: "project layout", ar: "تخطيط المشروع" },
	{ id: "building layout", en: "building layout", ar: "تخطيط المبنى" },
	{ id: "level layout", en: "level layout", ar: "تخطيط الطابق" },
	{ id: "space layout", en: "space layout", ar: "تخطيط الغرفة" },
	{
		id: "Upload the project file first",
		en: "Upload the project file first",
		ar: "إضافة ملف المشروع أولاً",
	},
	{
		id: "Upload the building file first",
		en: "Upload the building file first",
		ar: "إضافة ملف المبنى أولاً",
	},
	{
		id: "Upload the level file first",
		en: "Upload the level file first",
		ar: "إضافة ملف الطابق أولاً",
	},
	{
		id: "Upload the space file first",
		en: "Upload the space file first",
		ar: "إضافة ملف الغرفة أولاً",
	},
	{
		id: "Max 1 files, 5MB total.",
		en: "Max 1 files, 5MB total.",
		ar: "الحد الأقصى 1 ملفات، 5 ميجابايت إجمالي.",
	},
	{ id: "Layout is required", en: "Layout is required", ar: "المخطط مطلوب" },
	{ id: "Layout", en: "Layout", ar: "المخطط" },
	{
		id: "Enter project name",
		en: "Enter project name",
		ar: "أدخل اسم المشروع",
	},
	{
		id: "Enter project code",
		en: "Enter project code",
		ar: "أدخل كود المشروع",
	},
	{
		id: "Enter project description",
		en: "Enter project description",
		ar: "أدخل وصف المشروع",
	},
	{
		id: "Enter project location",
		en: "Enter project location",
		ar: "أدخل موقع المشروع",
	},
	{
		id: "Select project type",
		en: "Select project type",
		ar: "اختر نوع المشروع",
	},
	{
		id: "Select project status",
		en: "Select project status",
		ar: "اختر حالة المشروع",
	},
	{ id: "Select customer", en: "Select customer", ar: "اختر العميل" },
	{ id: "Project Code", en: "Project Code", ar: "كود المشروع" },
	{ id: "Project Status", en: "Project Status", ar: "حالة المشروع" },
	{ id: "Project Type", en: "Project Type", ar: "نوع المشروع" },
	{ id: "Project Location", en: "Project Location", ar: "موقع المشروع" },
	{ id: "Customer Name", en: "Customer Name", ar: "اسم العميل" },
	{ id: "Select date", en: "Select date", ar: "اختر التاريخ" },
	{ id: "Save & Continue", en: "Save & Continue", ar: "حفظ ومتابعة" },
	{ id: "Finish", en: "Finish", ar: "إنهاء" },
	{ id: "Continue", en: "Continue", ar: "متابعة" },
	{
		id: "Enter building name",
		en: "Enter building name",
		ar: "أدخل اسم المبنى",
	},
	{
		id: "Enter level name",
		en: "Enter level name",
		ar: "أدخل اسم المستوى",
	},
	{
		id: "Enter space name",
		en: "Enter space name",
		ar: "أدخل اسم الغرفة",
	},
	{
		id: "Enter building code",
		en: "Enter building code",
		ar: "أدخل كود المبنى",
	},
	{
		id: "Enter level code",
		en: "Enter level code",
		ar: "أدخل كود المستوى",
	},
	{
		id: "Enter space code",
		en: "Enter space code",
		ar: "أدخل كود الغرفة",
	},
	{
		id: "Enter building description",
		en: "Enter building description",
		ar: "أدخل وصف المبنى",
	},
	{
		id: "Enter level description",
		en: "Enter level description",
		ar: "أدخل وصف المستوى",
	},
	{
		id: "Enter space description",
		en: "Enter space description",
		ar: "أدخل وصف الغرفة",
	},
	{ id: "Building Name", en: "Building Name", ar: "اسم المبنى" },
	{ id: "Building Code", en: "Building Code", ar: "كود المبنى" },
	{ id: "Level Name", en: "Level Name", ar: "اسم المستوى" },
	{ id: "Level Code", en: "Level Code", ar: "كود المستوى" },
	{ id: "Space Name", en: "Space Name", ar: "اسم الغرفة" },
	{ id: "Space Code", en: "Space Code", ar: "كود الغرفة" },
	{
		id: "Please select at least one vehicle to perform this action.",
		en: "Please select at least one vehicle to perform this action.",
		ar: "يرجى تحديد مركبة واحدة على الأقل لتنفيذ هذا الإجراء.",
	},
	{ id: "Select Vehicles", en: "Select Vehicles", ar: "اختر المركبات" },
	{ id: "Stop Engine", en: "Stop Engine", ar: "إيقاف المحرك" },
	{ id: "Set Geofence", en: "Set Geofence", ar: "تحديد المنطقة الجغرافية" },
	{ id: "Alerts", en: "Alerts", ar: "التنبيهات" },
	{ id: "Streaming", en: "Streaming", ar: "المراقبة" },
	{ id: "Vehicle Info", en: "Vehicle Info", ar: "معلومات المركبة" },
	{ id: "camera", en: "camera", ar: "الكاميرا" },
	{ id: "total cameras", en: "total cameras", ar: "إجمالي الكاميرات" },
	{ id: "Quick Actions", en: "Quick Actions", ar: "الإجراءات السريعة" },
	{ id: "Moving", en: "Moving", ar: "متحرك" },
	{ id: "Parking", en: "Parking", ar: "متوقف" },
	{ id: "Idle", en: "Idle", ar: "خامل" },
	{ id: "More Actions", en: "More Actions", ar: "المزيد من الإجراءات" },
	{ id: "Less Actions", en: "Less Actions", ar: "أقل إجراءات" },
	{
		id: "Vehicle Alerts & Control",
		en: "Vehicle Alerts & Control",
		ar: "التنبيهات والتحكم",
	},
	{ id: "device type", en: "device type", ar: "نوع الجهاز" },
	{ id: "MDVR", en: "MDVR", ar: "مسجل كاميرات" },
	{ id: "TRACKER", en: "TRACKER", ar: "جهاز تتبع" },
	{
		id: "Device type is required",
		en: "Device type is required",
		ar: "نوع الجهاز مطلوب",
	},
	{ id: "Device Type", en: "Device Type", ar: "نوع الجهاز" },
	{ id: "account limits", en: "account limits", ar: "الحد الاقصي للحساب" },
	{ id: "teams", en: "teams", ar: "الفرق" },
	{ id: "teams", en: "teams", ar: "الفرق" },

	/*----------------YYYYYYYYYYYYYY------------------*/
	// ---------------------- Mod Live Streaming and Playback ----------------------
	{
		id: "Mod Live Streaming",
		en: "Live Streaming",
		ar: "المراقبة",
	},
	{ id: "Mod Playback", en: "Playback", ar: "المراقبة" },
	{ id: "mod-streaming", en: "Live Streaming", ar: "المراقبة" },
	{ id: "all status", en: "All Status", ar: "جميع الحالات" },
	{ id: "all groups", en: "All Groups", ar: "جميع المجموعات" },
	{ id: "ungrouped", en: "Ungrouped", ar: "بدون مجموعة" },
	{
		id: "search imei/name",
		en: "Search IMEI/Name",
		ar: "بحث برقم الIMEI/الاسم",
	},
	{
		id: "no active streams",
		en: "No Active Streams",
		ar: "لا يوجد مراقبات مفعلة",
	},
	{
		id: "select a channel from the sidebar to start streaming",
		en: "Select a channel from the sidebar to start streaming",
		ar: "اختر قناة على الشريط الجانبي لبدء المراقبة",
	},
	{ id: "live stream", en: "Live Stream", ar: "المراقبة المباشرة" },
	{
		id: "Failed to start stream for ",
		en: "Failed to start stream for ",
		ar: " فشل بدء المراقبة ل",
	},
	{ id: "mod-playback", en: "Mod Playback", ar: "سجل المراقبة" },
	{ id: "Date Filter", en: "Date Filter", ar: "تاريخ المراقبة" },
	{ id: "Today", en: "Today", ar: "اليوم" },
	{ id: "Yesterday", en: "Yesterday", ar: "اليوم السابق" },
	{ id: "Custom Date", en: "Custom Date", ar: "تاريخ مخصص" },
	{ id: "Grouped Vehicles", en: "Grouped Vehicles", ar: "المركبات المجمعة" },
	{ id: "Vehicle Name", en: "Vehicle Name", ar: "اسم المركبة" },
	{ id: "Vehicle IMEI", en: "Vehicle IMEI", ar: "رقم الIMEI المركبة" },
	{ id: "Vehicle Status", en: "Vehicle Status", ar: "حالة المركبة" },
	{ id: "History Results", en: "History Results", ar: "نتائج السجل" },
	{
		id: "Loading segments...",
		en: "Loading segments...",
		ar: "جاري تحميل المراقبات...",
	},
	{
		id: "No history segments found",
		en: "No history segments found",
		ar: "لا يوجد مراقبات في السجل",
	},
	{
		id: "Try selecting a different date range",
		en: "Try selecting a different date range",
		ar: "يرجى تحديد تاريخ مختلف",
	},
	{ id: "segments", en: "segments", ar: "تسجيلات" },
	{
		id: "Select a segment to play",
		en: "Select a segment to play",
		ar: "اختر تسجيل لتشغيله",
	},
	{
		id: "Loading playback...",
		en: "Loading playback...",
		ar: "جاري تحميل التسجيل...",
	},
	{
		id: "Preparing video...",
		en: "Preparing video...",
		ar: "جاري تحضير الفيديو...",
	},
	{ id: "No vehicles found", en: "No vehicles found", ar: "لا يوجد مركبات" },
	{
		id: "Loading vehicles...",
		en: "Loading vehicles...",
		ar: "جاري تحميل المركبات...",
	},
	{
		id: "Password must be at least 12 characters long",
		en: "Password must be at least 12 characters long",
		ar: "كلمة المرور يجب أن تكون 12 حرفًا على الأقل",
	},
	{
		id: "Password must contain at least one uppercase letter",
		en: "Password must contain at least one uppercase letter",
		ar: "كلمة المرور يجب أن تحتوي على حرف كبير واحد على الأقل",
	},
	{
		id: "Password must contain at least one digit",
		en: "Password must contain at least one digit",
		ar: "كلمة المرور يجب أن تحتوي على رقم واحد على الأقل",
	},
	{
		id: "Password must contain at least one special character",
		en: "Password must contain at least one special character",
		ar: "كلمة المرور يجب أن تحتوي على رمز خاص واحد على الأقل",
	},
	{
		id: "Confirm Password Is Required",
		en: "Confirm Password Is Required",
		ar: "تأكيد كلمة السر مطلوب",
	},
	{
		id: "Passwords do not match",
		en: "Passwords do not match",
		ar: "كلمات السر ليست مطابقة",
	},
	{ id: "Confirm Password", en: "Confirm Password", ar: "تأكيد كلمة السر" },
	{ id: "Validation Error", en: "Validation Error", ar: "خطأ في التحقق " },
	{
		id: "You will be logged out in 1 minute due to inactivity.",
		en: "You will be logged out in 1 minute due to inactivity.",
		ar: "سيتم تسجيل خروجك خلال دقيقة واحدة بسبب عدم النشاط.",
	},
	{
		id: "You have been logged out due to inactivity.",
		en: "You have been logged out due to inactivity.",
		ar: "تم تسجيل خروجك بسبب عدم النشاط.",
	},
	{
		id: "User is not authorized, invalid cookie, please login to get access.",
		en: "User is not authorized, please login to get access.",
		ar: "المستخدم ليس غير مصرح به, برجاء تسجيل الدخول للحصور علي تصريح",
	},
	{
		id: "Are you sure you want to logout from another accounts.",
		en: "Are you sure you want to logout from another accounts.",
		ar: "Are you sure you want to logout from another accounts.",
	},
	{
		id: "This account will be logged out from all connected devices.",
		en: "This account will be logged out from all connected devices.",
		ar: "سيتم تسجيل خروج هذا الحساب من جميع الأجهزة المتصلة.",
	},
	{ id: "Form Category", en: "Form Category", ar: "فئة النموذج" },
	{
		id: "Select form category",
		en: "Select form category",
		ar: "اختر فئة النموذج",
	},
	{
		id: "Form category is required",
		en: "Form category is required",
		ar: "فئة النموذج مطلوبة",
	},
	{ id: "Select form", en: "Select form", ar: "إختر النموذج" },
	{
		id: "Edit Project Setup",
		en: "Edit Project Setup",
		ar: "تعديل إعداد المشروع",
	},
	{
		id: "Project information",
		en: "Project information",
		ar: "بيانات المشروع	",
	},
	{
		id: "Too many login attempts. Please try again in",
		en: "Too many login attempts. Please try again in",
		ar: "تم إدخال عدد كبير من محاولات تسجيل الدخول. يرجى المحاولة مرة أخرى بعد",
	},
	{ id: "Try again in", en: "Try again in", ar: "حاول مرة أخرى بعد" },
	{ id: "segments", en: "segments", ar: "تسجيلات" },
	{ id: "Info", en: "Info", ar: "المعلومات" },
	{ id: "Workflow", en: "Workflow", ar: "العمليات" },
	/*----------------YYYYYYYYYYYYYY------------------*/
	// ---------------------- Mod Live Streaming and Playback ----------------------
	{
		id: "Mod Live Streaming",
		en: "Live Streaming",
		ar: "المراقبة",
	},
	{ id: "Mod Playback", en: "Playback", ar: "المراقبة" },
	{ id: "mod-streaming", en: "Live Streaming", ar: "المراقبة" },
	{ id: "all status", en: "All Status", ar: "جميع الحالات" },
	{ id: "all groups", en: "All Groups", ar: "جميع المجموعات" },
	{ id: "ungrouped", en: "Ungrouped", ar: "بدون مجموعة" },
	{
		id: "search imei/name",
		en: "Search IMEI/Name",
		ar: "بحث برقم الIMEI/الاسم",
	},
	{
		id: "no active streams",
		en: "No Active Streams",
		ar: "لا يوجد مراقبات مفعلة",
	},
	{
		id: "select a channel from the sidebar to start streaming",
		en: "Select a channel from the sidebar to start streaming",
		ar: "اختر قناة على الشريط الجانبي لبدء المراقبة",
	},
	{ id: "live stream", en: "Live Stream", ar: "المراقبة المباشرة" },
	{
		id: "Failed to start stream for ",
		en: "Failed to start stream for ",
		ar: " فشل بدء المراقبة ل",
	},
	{ id: "mod-playback", en: "Mod Playback", ar: "سجل المراقبة" },
	{ id: "Date Filter", en: "Date Filter", ar: "تاريخ المراقبة" },
	{ id: "Today", en: "Today", ar: "اليوم" },
	{ id: "Yesterday", en: "Yesterday", ar: "اليوم السابق" },
	{ id: "Custom Date", en: "Custom Date", ar: "تاريخ مخصص" },
	{ id: "Grouped Vehicles", en: "Grouped Vehicles", ar: "المركبات المجمعة" },
	{ id: "Vehicle Name", en: "Vehicle Name", ar: "اسم المركبة" },
	{ id: "Vehicle IMEI", en: "Vehicle IMEI", ar: "رقم الIMEI المركبة" },
	{ id: "Vehicle Status", en: "Vehicle Status", ar: "حالة المركبة" },
	{ id: "History Results", en: "History Results", ar: "نتائج السجل" },
	{
		id: "Loading segments...",
		en: "Loading segments...",
		ar: "جاري تحميل المراقبات...",
	},
	{
		id: "No history segments found",
		en: "No history segments found",
		ar: "لا يوجد مراقبات في السجل",
	},
	{
		id: "Try selecting a different date range",
		en: "Try selecting a different date range",
		ar: "يرجى تحديد تاريخ مختلف",
	},
	{ id: "segments", en: "segments", ar: "تسجيلات" },
	{
		id: "Select a segment to play",
		en: "Select a segment to play",
		ar: "اختر تسجيل لتشغيله",
	},
	{
		id: "Loading playback...",
		en: "Loading playback...",
		ar: "جاري تحميل التسجيل...",
	},
	{
		id: "Preparing video...",
		en: "Preparing video...",
		ar: "جاري تحضير الفيديو...",
	},
	{ id: "No vehicles found", en: "No vehicles found", ar: "لا يوجد مركبات" },
	{
		id: "Loading vehicles...",
		en: "Loading vehicles...",
		ar: "جاري تحميل المركبات...",
	},
	{
		id: "Password must be at least 12 characters long",
		en: "Password must be at least 12 characters long",
		ar: "كلمة المرور يجب أن تكون 12 حرفًا على الأقل",
	},
	{
		id: "Password must contain at least one uppercase letter",
		en: "Password must contain at least one uppercase letter",
		ar: "كلمة المرور يجب أن تحتوي على حرف كبير واحد على الأقل",
	},
	{
		id: "Password must contain at least one digit",
		en: "Password must contain at least one digit",
		ar: "كلمة المرور يجب أن تحتوي على رقم واحد على الأقل",
	},
	{
		id: "Password must contain at least one special character",
		en: "Password must contain at least one special character",
		ar: "كلمة المرور يجب أن تحتوي على رمز خاص واحد على الأقل",
	},
	{
		id: "Confirm Password Is Required",
		en: "Confirm Password Is Required",
		ar: "تأكيد كلمة السر مطلوب",
	},
	{
		id: "Passwords do not match",
		en: "Passwords do not match",
		ar: "كلمات السر ليست مطابقة",
	},
	{ id: "Confirm Password", en: "Confirm Password", ar: "تأكيد كلمة السر" },
	{ id: "Validation Error", en: "Validation Error", ar: "خطأ في التحقق " },
	{
		id: "You will be logged out in 1 minute due to inactivity.",
		en: "You will be logged out in 1 minute due to inactivity.",
		ar: "سيتم تسجيل خروجك خلال دقيقة واحدة بسبب عدم النشاط.",
	},
	{
		id: "You have been logged out due to inactivity.",
		en: "You have been logged out due to inactivity.",
		ar: "تم تسجيل خروجك بسبب عدم النشاط.",
	},
	{
		id: "User is not authorized, invalid cookie, please login to get access.",
		en: "User is not authorized, please login to get access.",
		ar: "المستخدم ليس غير مصرح به, برجاء تسجيل الدخول للحصور علي تصريح",
	},
	{
		id: "Are you sure you want to logout from another accounts.",
		en: "Are you sure you want to logout from another accounts.",
		ar: "Are you sure you want to logout from another accounts.",
	},
	{
		id: "This account will be logged out from all connected devices.",
		en: "This account will be logged out from all connected devices.",
		ar: "سيتم تسجيل خروج هذا الحساب من جميع الأجهزة المتصلة.",
	},
	{ id: "Form Category", en: "Form Category", ar: "فئة النموذج" },
	{
		id: "Select form category",
		en: "Select form category",
		ar: "اختر فئة النموذج",
	},
	{
		id: "Form category is required",
		en: "Form category is required",
		ar: "فئة النموذج مطلوبة",
	},
	{ id: "Select form", en: "Select form", ar: "إختر النموذج" },
	{
		id: "Edit Project Setup",
		en: "Edit Project Setup",
		ar: "تعديل إعداد المشروع",
	},
	{
		id: "Project information",
		en: "Project information",
		ar: "بيانات المشروع	",
	},
	{
		id: "Too many login attempts. Please try again in",
		en: "Too many login attempts. Please try again in",
		ar: "تم إدخال عدد كبير من محاولات تسجيل الدخول. يرجى المحاولة مرة أخرى بعد",
	},
	{ id: "Try again in", en: "Try again in", ar: "حاول مرة أخرى بعد" },
	{ id: "offline-setup", en: "offline-setup", ar: "الإعداد دون اتصال" },
	{ id: "Set-Up", en: "Set-Up", ar: "إعداد" },
	{ id: "available to cache", en: "available to cache", ar: "متاحة للحفظ" },
	{ id: "Reconfigure", en: "Reconfigure", ar: "إعادة الإعداد" },
	{ id: "Load More", en: "Load More", ar: "تحميل المزيد" },
	{
		id: "Set-Up Configuration",
		en: "Set-Up Configuration",
		ar: "ضبط الإعدادات",
	},
	{
		id: "Select the Data to Use in your offline Mode",
		en: "Select the Data to Use in your offline Mode",
		ar: "اختر البيانات للاستخدام في وضع عدم الاتصال",
	},
	{ id: "Select Module", en: "Select Module", ar: "إختيار الوحدة" },
	{ id: "Select Location", en: "Select Location", ar: "إختيار الموقع" },
	{ id: "Configuration Name", en: "Configuration Name", ar: "إسم الإعداد" },
	{
		id: "Enter Configuration name",
		en: "Enter Configuration name",
		ar: "أدخل اسم الإعداد",
	},
	{
		id: "At least one module is required",
		en: "At least one module is required",
		ar: "يجب اختيار وحدة واحدة على الأقل",
	},
	{
		id: "Name cannot contain double dashes",
		en: "Name cannot contain double dashes",
		ar: "الاسم لا يمكن أن يحتوي على شرطتين متتاليتين",
	},
	{
		id: "Layout is loading...",
		en: "Layout is loading...",
		ar: "جاري تحميل المخطط",
	},
	{ id: "Layout ready", en: "Layout ready", ar: "المخطط جاهز" },
	{
		id: "Failed to load layout",
		en: "Failed to load layout",
		ar: "فشل تحميل المخطط",
	},
	{
		id: "Configuration Is Added Successfully",
		en: "Configuration Is Added Successfully",
		ar: "تمت إضافة الإعدادات بنجاح",
	},
	{
		id: "Configuration Is Edited Successfully",
		en: "Configuration Is Edited Successfully",
		ar: "تمت تعديل الإعدادات بنجاح",
	},
	{
		id: "Configuration Deleted Successfully",
		en: "Configuration Deleted Successfully",
		ar: "تم حذف الإعداد بنجاح",
	},
	{
		id: "Invalid configuration ID",
		en: "Invalid configuration ID",
		ar: "معرف الإعداد غير صحيح",
	},
	{
		id: "No offline configuration is found with this id",
		en: "No offline configuration is found with this id",
		ar: "لم يتم العثور على إعداد بهذا المعرف",
	},
	{
		id: "Building is required",
		en: "Building is required",
		ar: "المبني مطلوب",
	},
	{ id: "Level is required", en: "Level is required", ar: "المستوي مطلوب" },
	{
		id: "Preparing Offline Configuration Data",
		en: "Preparing Offline Configuration Data",
		ar: "إعداد بيانات الإعداد دون اتصال بالإنترنت",
	},
	{
		id: "Activate Offline Mode?",
		en: "Activate Offline Mode?",
		ar: "تفعيل وضع عدم الاتصال؟",
	},
	{
		id: "You’re about to switch to Offline Mode",
		en: "You’re about to switch to Offline Mode",
		ar: "أنت على وشك التبديل إلى وضع عدم الاتصال",
	},
	{ id: "Activate", en: "Activate", ar: "تفعيل" },
	{
		id: "Switch Online Mode?",
		en: "Switch Online Mode?",
		ar: "التبديل إلى الوضع المتصل بالإنترنت؟",
	},
	{
		id: "You’re about to switch to Online Mode",
		en: "You’re about to switch to Online Mode",
		ar: "أنت على وشك التبديل إلى الوضع المتصل بالإنترنت",
	},
	{ id: "Switch", en: "Switch", ar: "تحول" },
	{
		id: "Please select a configuration",
		en: "Please select a configuration",
		ar: "الرجاء تحديد الإعداد",
	},
	{
		id: "You are working offline. Data will sync automatically when connection returns.",
		en: "You are working offline. Data will sync automatically when connection returns.",
		ar: "أنت تعمل دون اتصال. سيتم مزامنة البيانات تلقائيًا عندما يعود الاتصال.",
	},
	{ id: "Add New Snag", en: "Add New Snag", ar: "إضافة عيب جديد" },
	{
		id: "Return to Online",
		en: "Return to Online",
		ar: "العودة إلى الوضع المتصل",
	},
	{
		id: "Configure modules for field use. Setup is required before activating Offline Mode",
		en: "Configure modules for field use. Setup is required before activating Offline Mode",
		ar: "قم بتهيئة الوحدات للاستخدام الميداني. يلزم إجراء الإعداد قبل تفعيل وضع عدم الاتصال بالإنترنت.",
	},
	{ id: "Offline Setup", en: "Offline Setup", ar: "الإعداد دون اتصال" },
	{ id: "available cached", en: "available cached", ar: "البيانات المتاحه" },
	{ id: "cached details", en: "cached details", ar: "تفاصيل البيانات المخزنة" },
	{ id: "Ready", en: "Ready", ar: "جاهز" },
	{
		id: "Inspection Request (IR)",
		en: "Inspection Request (IR)",
		ar: "طلب التفتيش",
	},
	{ id: "Add New IR", en: "Add New IR", ar: "إضافة طلب تفتيش جديد" },
	{ id: "Space", en: "Space", ar: "الغرفة" },
	{
		id: "New Inspection Request",
		en: "New Inspection Request",
		ar: "طلب تفتيش جديد",
	},
	{
		id: "Working Offline — Your data will sync when connection returns",
		en: "Working Offline — Your data will sync when connection returns",
		ar: "العمل دون اتصال — سيتم مزامنة بياناتك عندما يعود الاتصال",
	},
	{ id: "Select Space", en: "Select Space", ar: "إختيار الغرفة" },
	{ id: "Space is required", en: "Space is required", ar: "الغرفة مطلوبة" },
	{ id: "Back", en: "Back", ar: "الرجوع" },
	{
		id: "IR Form Submitted Successfully",
		en: "IR Form Submitted Successfully",
		ar: "تم إرسال نموذج التفتيش بنجاح",
	},
	{
		id: "IR Form Edited Successfully",
		en: "IR Form Edited Successfully",
		ar: "تم تعديل نموذج التفتيش بنجاح",
	},
	{
		id: "Snag Form Submitted Successfully",
		en: "Snag Form Submitted Successfully",
		ar: "تم إرسال نموذج العيب بنجاح",
	},
	{
		id: "Snag Form Edited Successfully",
		en: "Snag Form Edited Successfully",
		ar: "تم تعديل نموذج العيب بنجاح",
	},
	{ id: "Pending Sync", en: "Pending Sync", ar: "قيد المزامنة" },
	{ id: "Synced", en: "Synced", ar: "تم المزامنة" },
	{ id: "Failed", en: "Failed", ar: "فشل" },
	{ id: "Syncing", en: "Syncing", ar: "قيد المزامنة" },
	{ id: "New Snag", en: "New Snag", ar: "عيب جديد" },
	{ id: "Edit Snag", en: "Edit Snag", ar: "تعديل العيب" },
	{
		id: "Subsytem is required",
		en: "Subsytem is required",
		ar: "النظام الفرعي مطلوب",
	},
	{ id: "Offline Requests", en: "Offline Requests", ar: "طلبات عدم الاتصال" },
	{ id: "Sync Selected", en: "Sync Selected", ar: "مزامنة المحدد" },
	{ id: "Sync Pending", en: "Sync Pending", ar: "مزامنة معلقة" },
	{ id: "Retry Failed", en: "Retry Failed", ar: "إعادة المحاولة فشلت" },
	{ id: "offline-requests", en: "offline-requests", ar: "طلبات عدم الاتصال" },
	{
		id: "Select Configuration",
		en: "Select Configuration",
		ar: "اختر الإعداد",
	},
	{ id: "Deleted", en: "Deleted", ar: "محذوف" },
	{ id: "synced record(s)", en: "synced record(s)", ar: "السجلات المزامنة" },
	{ id: "Syncing", en: "Syncing", ar: "قيد المزامنة" },
	{
		id: "All synced successfully",
		en: "All synced successfully",
		ar: "جميع السجلات مزامنة بنجاح",
	},
	{ id: "All failed", en: "All failed", ar: "جميع السجلات فشلت" },
	{ id: "Completed", en: "Completed", ar: "مكتمل" },
	{ id: "Sync", en: "Sync", ar: "مزامنة" },
	{ id: "Offline Model", en: "Offline Model", ar: "النموذج دون اتصال" },
	{
		id: "Inspection Request Deleted Successfully",
		en: "Inspection Request Deleted Successfully",
		ar: "تم حذف طلب التفتيش بنجاح",
	},
	{
		id: "Snag Deleted Successfully",
		en: "Snag Deleted Successfully",
		ar: "تم حذف العيب بنجاح",
	},
	{ id: "Room", en: "Room", ar: "الغرفة" },
	{ id: "segments", en: "segments", ar: "الأجزاء" },
	{ id: "Total Checks", en: "Total Checks", ar: "إجمالي عمليات الفحص" },
	{
		id: "Shelf Availability Rate",
		en: "Shelf Availability Rate",
		ar: "نسبة التوافر على الرف",
	},
	{
		id: "True OOS Rate (D)",
		en: "True OOS Rate (D)",
		ar: "نسبة النفاد الكامل (D)",
	},
	{ id: "Filtered Results", en: "Filtered Results", ar: "النتائج المصفاة" },
	{ id: "State1", en: "State", ar: "الحالة" },
	{ id: "Date", en: "Date", ar: "التاريخ" },
	{ id: "Store", en: "Store", ar: "الفرع" },
	{ id: "Sales Rep", en: "Sales Rep", ar: "مندوب المبيعات" },
	{ id: "SKU", en: "SKU", ar: "الصنف" },
	{ id: "Case Pack", en: "Case Pack", ar: "شدة الكرتونة" },
	{ id: "State", en: "State", ar: "الحالة" },
	{ id: "Shelf Status", en: "Shelf Status", ar: "التواجد على الرف" },
	{ id: "Shelf Qty", en: "Shelf Qty", ar: "كمية الرف" },
	{ id: "Warehouse Status", en: "Warehouse Status", ar: "التواجد في المخزن" },
	{ id: "Warehouse Qty", en: "Warehouse Qty", ar: "كمية المخزن" },
	{ id: "Photo", en: "Photo", ar: "الصورة" },
	{ id: "Notes", en: "Notes", ar: "ملاحظات" },
	{
		id: "shelfAvailability",
		en: "Shelf Availability",
		ar: "التوافر على الرف",
	},
	{
		id: "inventory",
		en: "Inventory",
		ar: "المخزن",
	},
	{
		id: "Shelf & Inventory Report",
		en: "Shelf & Inventory Report",
		ar: "تقرير توفر الرفوف والمخزون",
	},
	{
		id: "Monitor shelf availability, out-of-stock rates, and product states across stores.",
		en: "Monitor shelf availability, out-of-stock rates, and product states across stores.",
		ar: "مراقبة توافر المنتجات على الرفوف، ومعدلات نفاد المخزون، وحالة المنتجات في جميع المتاجر.",
	},
	{
		id: "You must have an internet connection",
		en: "You must have an internet connection",
		ar: "يجب أن يكون لديك اتصال بالإنترنت",
	},
	{
		id: "PDF not found in cache, Please wait whilefetching from server...",
		en: "PDF not found in cache, Please wait while fetching from server...",
		ar: "PDF غير موجود في الذاكرة المؤقتة، يرجى الانتظار أثناء جلبه من الخادم...",
	},
	{
		id: "Config Shift",
		en: "Config Shift",
		ar: "إعداد الوردية",
	},
	{
		id: "Configure start and end shift POI locations for this technician.",
		en: "Configure start and end shift POI locations for this technician.",
		ar: "اعداد مواقع بداية ونهاية الوردية لهذا المندوب.",
	},
	{
		id: "Start Shift POI",
		en: "Start Shift POI",
		ar: "موقع بداية الوردية",
	},
	{
		id: "End Shift POI",
		en: "End Shift POI",
		ar: "موقع نهاية الوردية",
	},
	{
		id: "POI linked successfully",
		en: "POI linked successfully",
		ar: "تم ربط الموقع بنجاح",
	},
	{
		id: "Failed to link POI",
		en: "Failed to link POI",
		ar: "فشل ربط الموقع",
	},
	{
		id: "POI removed successfully",
		en: "POI removed successfully",
		ar: "تم إزالة الموقع بنجاح",
	},
	{
		id: "Failed to remove POI",
		en: "Failed to remove POI",
		ar: "فشل إزالة الموقع",
	},
		{
		id: "How can I help you today?",
		en: "How can I help you today?",
		ar: "كيف يمكنني مساعدتك اليوم ؟",
	},
		{
		id: "Describe the IR you want to create and I'll fill in the details.",
		ar: "قم بوصف طلب الفحص وساقوم بانشاؤه لك",
		en: "Describe the IR you want to create and I'll fill in the details.",
	},
		{
		id: '"Create an IR for HDB project, civil, ground floor, ready tomorrow"',
		en: '"Create an IR for HDB project, civil, ground floor, ready tomorrow"',
		ar: '"قم بانشاء طلب فحص لمشروع الاسكان, التخصص مدني, الدور الارضي, جاهز للمعاينه غدا"',
	},
		{
		id: "IR Copilot",
		en: "IR Copilot",
		ar: "مساعدك الذكي",
	},
		{
		id: "AI Assistant · ready",
		en: "AI Assistant · ready",
		ar: "جاهز",
	},
		{
		id: "Beta",
		en: "Beta",
		ar: "تجريبي",
	},
		{
		id: "Your IR draft will appear here as you chat with the AI.",
		en: "Your IR draft will appear here as you chat with the AI.",
		ar: "سيظهر النموذج هنا عندما تقوم بالتحدث مع المساعد الذكي",
	},
		{
		id: "Create IR with AI Copilot",
		en: "Create IR with AI Copilot",
		ar: "اضافة طلب باستخدام المساعد الذكي",
	},
			{
		id: "Submit IR",
		en: "Submit IR",
		ar: "ارسال",
	},
			{
		id: "Create with AI",
		en: "Create with AI",
		ar: "المساعد الذكي",
	},
			{
		id: "IR Information",
		en: "IR Information",
		ar: "بيانات الطلب",
	},
			{
		id: "Keep chatting to fill required fields.",
		en: "Keep chatting to fill required fields.",
		ar: "واصل المحادثة لادخال جميع التفاصيل المطلوبة",
	},
			{
		id: "Incomplete",
		en: "Incomplete",
		ar: "غير مكتمل",
	},
			{
		id: "Form Fields",
		en: "Form Fields",
		ar: "تفاصيل النموذج"
	},
			{
		id: "Attachments & Signature",
		en: "Attachments & Signature",
		ar: "المرفقات & التوقيع"
	},
			{
		id: "Clear signature",
		en: "Clear signature",
		ar: "امسح التوقيع"
	},
			{
		id: "Add files",
		en: "Add files",
		ar: "اضافة ملفات"
	},
			{
		id: "Ready to submit",
		en: "Ready to submit",
		ar: "جاهز للارسال"
	},
	{ id: "Product Expiration Report", en: "Product Expiration Report", ar: "تقرير انتهاء صلاحية المنتج" },
	{ id: "Track products nearing or past their expiry date across all locations.", en: "Track products nearing or past their expiry date across all locations.", ar: "تتبع المنتجات القريبة من انتهاء الصلاحية أو المنتهية في جميع المواقع." },
	{ id: "By Product", en: "By Product", ar: "حسب المنتج" },
	{ id: "All Records", en: "All Records", ar: "جميع السجلات" },
	{ id: "SKU Name", en: "SKU Name", ar: "اسم المنتج" },
	{ id: "Total Qty", en: "Total Qty", ar: "إجمالي الكمية" },
	{ id: "Worst Status", en: "Worst Status", ar: "أسوأ حالة" },
	{ id: "Nearest Expiry", en: "Nearest Expiry", ar: "أقرب انتهاء صلاحية" },
	{ id: "Locations", en: "Locations", ar: "المواقع" },
	{ id: "Qty", en: "Qty", ar: "الكمية" },
	{ id: "Expiry Date", en: "Expiry Date", ar: "تاريخ انتهاء الصلاحية" },
	{ id: "Days", en: "Days", ar: "أيام" },
	{ id: "Recorded By", en: "Recorded By", ar: "مسجل بواسطة" },
	{ id: "Recorded At", en: "Recorded At", ar: "تاريخ التسجيل" },
	{ id: "Production Date", en: "Production Date", ar: "تاريخ الإنتاج" },
	{ id: "items", en: "items", ar: "عناصر" },
	{ id: "ago", en: "ago", ar: "مضت" },
	{ id: "days", en: "days", ar: "أيام" },
	{ id: "Valid", en: "Valid", ar: "صالح" },
	{ id: "Critical Days", en: "Critical Days", ar: "أيام الخطر" },
	{ id: "Warning Days", en: "Warning Days", ar: "أيام التحذير" },
	{ id: "Submission Date Range", en: "Submission Date Range", ar: "نطاق تاريخ الإدخال" },
	{ id: "Warning Days must be greater than Critical Days", en: "Warning Days must be greater than Critical Days", ar: "يجب أن تكون أيام التحذير أكبر من أيام الخطر" },
	{ id: "EXPIRED", en: "Expired", ar: "منتهي الصلاحية" },
	{ id: "CRITICAL", en: "Critical", ar: "حرج" },
	{ id: "WARNING", en: "Warning", ar: "تحذير" },
	{ id: "VALID", en: "Valid", ar: "صالح" },
	{ id: "SHELF", en: "Shelf", ar: "رف" },
	{ id: "WAREHOUSE", en: "Warehouse", ar: "مستودع" },
	{ id: "Shelf Price", en: "Shelf Price", ar: "سعر الرف" },
	{ id: "Location", en: "Location", ar: "الموقع" },
	{ id: "Location Type", en: "Location Type", ar: "نوع الموقع" },
	{ id: "Tracking", en: "Tracking", ar: "موقع التتبع" },
	{ id: "Item Place", en: "Item Place", ar: "مكان الصنف" },
	{ id: "shoppingarea", en: "Shopping Area", ar: "صاله" },
	{ id: "zone", en: "Building", ar: "المبني" },
	{ id: "room", en: "Room", ar: "الغرفة" },
	{ id: "Total Visits", en: "Total Visits", ar: "إجمالي الزيارات" },
	{ id: "Visit Distribution", en: "Visit Distribution", ar: "توزيع الزيارات" },
	{ id: "Comprehensive Visit Analytics", en: "Comprehensive Visit Analytics", ar: "تحليلات شاملة للزيارات" },
	{ id: "Overall count of visits", en: "Overall count of visits", ar: "العدد الإجمالي للزيارات" },
	{ id: "Failed to load visit distribution", en: "Failed to load visit distribution", ar: "فشل تحميل توزيع الزيارات" },
	{ id: "Containers", en: "Containers", ar: "عدد الكراتين" },
	{ id: "Case Pack", en: "Case Pack", ar: "كمية الكرتونة" },

	// ---- Recurring Task Planners ----
	{ id: "Recurring Planners", en: "Recurring Planners", ar: "المخططات المتكررة" },
	{ id: "Add Recurring Planner", en: "Add Recurring Planner", ar: "إضافة مخطط متكرر" },
	{ id: "Edit Recurring Planner", en: "Edit Recurring Planner", ar: "تعديل المخطط المتكرر" },
	{ id: "Planner Name", en: "Planner Name", ar: "اسم المخطط" },
	{ id: "Planner Details", en: "Planner Details", ar: "تفاصيل المخطط" },
	{ id: "Schedule", en: "Schedule", ar: "الجدول" },
	{ id: "Period", en: "Period", ar: "الفترة" },
	{ id: "Ongoing", en: "Ongoing", ar: "مستمر" },
	{ id: "Time", en: "Time", ar: "الوقت" },
	{ id: "Flow", en: "Flow", ar: "نظام التنفيذ" },
	{ id: "ACTIVE", en: "Active", ar: "نشط" },
	{ id: "PAUSED", en: "Paused", ar: "متوقف مؤقتًا" },
	{ id: "CANCELLED", en: "Cancelled", ar: "ملغي" },
	{ id: "Paused", en: "Paused", ar: "متوقف مؤقتًا" },
	{ id: "Cancelled", en: "Cancelled", ar: "ملغي" },
	{ id: "Pause", en: "Pause", ar: "إيقاف مؤقت" },
	{ id: "Resume", en: "Resume", ar: "استئناف" },
	{ id: "Cancel Planner", en: "Cancel Planner", ar: "إلغاء المخطط" },
	{ id: "Keep Planner", en: "Keep Planner", ar: "الاحتفاظ بالمخطط" },
	{
		id: "Cancel Recurring Planner",
		en: "Cancel Recurring Planner",
		ar: "إلغاء المخطط المتكرر",
	},
	{
		id: "Are you sure you want to cancel this planner? No new tasks will be generated from it. This action cannot be undone.",
		en: "Are you sure you want to cancel this planner? No new tasks will be generated from it. This action cannot be undone.",
		ar: "هل أنت متأكد من إلغاء هذا المخطط؟ لن يتم إنشاء مهام جديدة منه. لا يمكن التراجع عن هذا الإجراء.",
	},
	{
		id: "Planner paused successfully",
		en: "Planner paused successfully",
		ar: "تم إيقاف المخطط مؤقتًا بنجاح",
	},
	{
		id: "Planner resumed successfully",
		en: "Planner resumed successfully",
		ar: "تم استئناف المخطط بنجاح",
	},
	{
		id: "Planner cancelled successfully",
		en: "Planner cancelled successfully",
		ar: "تم إلغاء المخطط بنجاح",
	},
	{
		id: "Recurring planner created successfully",
		en: "Recurring planner created successfully",
		ar: "تم إنشاء المخطط المتكرر بنجاح",
	},
	{
		id: "Recurring planner updated successfully",
		en: "Recurring planner updated successfully",
		ar: "تم تحديث المخطط المتكرر بنجاح",
	},
	{ id: "No changes to save", en: "No changes to save", ar: "لا توجد تغييرات للحفظ" },
	{ id: "Recurrence Schedule", en: "Recurrence Schedule", ar: "جدول التكرار" },
	{ id: "Repeat on", en: "Repeat on", ar: "يتكرر في" },
	{ id: "Every day", en: "Every day", ar: "كل يوم" },
	{
		id: "Select at least one day of the week",
		en: "Select at least one day of the week",
		ar: "اختر يومًا واحدًا على الأقل من أيام الأسبوع",
	},
	{
		id: "A task will be generated automatically on each selected day at the chosen time, within the date range.",
		en: "A task will be generated automatically on each selected day at the chosen time, within the date range.",
		ar: "سيتم إنشاء مهمة تلقائيًا في كل يوم محدد في الوقت المختار، ضمن النطاق الزمني.",
	},
	{
		id: "Recently Generated Tasks",
		en: "Recently Generated Tasks",
		ar: "المهام المُنشأة مؤخرًا",
	},
	{
		id: "No tasks generated yet",
		en: "No tasks generated yet",
		ar: "لم يتم إنشاء مهام بعد",
	},
	{
		id: "Planner Name is required",
		en: "Planner Name is required",
		ar: "اسم المخطط مطلوب",
	},
	{
		id: "Planner Name must be at least 3 characters",
		en: "Planner Name must be at least 3 characters",
		ar: "يجب ألا يقل اسم المخطط عن 3 أحرف",
	},
	{
		id: "Planner Name cannot exceed 128 characters",
		en: "Planner Name cannot exceed 128 characters",
		ar: "لا يمكن أن يتجاوز اسم المخطط 128 حرفًا",
	},
	{
		id: "Duration cannot exceed 1440 minutes",
		en: "Duration cannot exceed 1440 minutes",
		ar: "لا يمكن أن تتجاوز المدة 1440 دقيقة",
	},
	{
		id: "Start date is required",
		en: "Start date is required",
		ar: "تاريخ البدء مطلوب",
	},
	{
		id: "Start date cannot be in the past",
		en: "Start date cannot be in the past",
		ar: "لا يمكن أن يكون تاريخ البدء في الماضي",
	},
	{
		id: "End date must be after start date",
		en: "End date must be after start date",
		ar: "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
	},
	{
		id: "Ex. Daily Site Inspection",
		en: "Ex. Daily Site Inspection",
		ar: "مثال: تفتيش الموقع اليومي",
	},
	{ id: "Not assigned", en: "Not assigned", ar: "غير معين" },
	{ id: "Sun", en: "Sun", ar: "أحد" },
	{ id: "Mon", en: "Mon", ar: "اثنين" },
	{ id: "Tue", en: "Tue", ar: "ثلاثاء" },
	{ id: "Wed", en: "Wed", ar: "أربعاء" },
	{ id: "Thu", en: "Thu", ar: "خميس" },
	{ id: "Fri", en: "Fri", ar: "جمعة" },
	{ id: "Sat", en: "Sat", ar: "سبت" },
	{ id: "Next run", en: "Next run", ar: "التشغيل القادم" },
	{ id: "No upcoming runs", en: "No upcoming runs", ar: "لا توجد تشغيلات قادمة" },
	{ id: "Task History", en: "Task History", ar: "سجل المهام" },
	// ---- POI assignment (field staff) ----
	{ id: "Assign POIs", en: "Assign POIs", ar: "تعيين نقاط الاهتمام" },
	{
		id: "Bulk Assign POIs",
		en: "Bulk Assign POIs",
		ar: "تعيين نقاط الاهتمام بالجملة",
	},
	{
		id: "Manage all POIs (bulk)",
		en: "Manage all POIs (bulk)",
		ar: "إدارة جميع نقاط الاهتمام (بالجملة)",
	},
	{ id: "Available POIs", en: "Available POIs", ar: "نقاط الاهتمام المتاحة" },
	{ id: "Assign selected", en: "Assign selected", ar: "تعيين المحدد" },
	{
		id: "Assign all filtered",
		en: "Assign all filtered",
		ar: "تعيين كل النتائج المصفّاة",
	},
	{ id: "Assign to all", en: "Assign to all", ar: "تعيين للجميع" },
	{ id: "Remove selected", en: "Remove selected", ar: "إزالة المحدد" },
	{
		id: "Remove all filtered",
		en: "Remove all filtered",
		ar: "إزالة كل النتائج المصفّاة",
	},
	{ id: "Search POIs", en: "Search POIs", ar: "بحث في نقاط الاهتمام" },
	{
		id: "Search assigned POIs",
		en: "Search assigned POIs",
		ar: "بحث في النقاط المعيّنة",
	},
	{ id: "added", en: "added", ar: "مضافة" },
	{ id: "removed", en: "removed", ar: "محذوفة" },
	{ id: "staff", en: "staff", ar: "موظف" },
	{ id: "selected", en: "selected", ar: "محدد" },
	{
		id: "Select one or more field staff",
		en: "Select one or more field staff",
		ar: "اختر موظفاً ميدانياً واحداً أو أكثر",
	},
	{
		id: "Select field staff first",
		en: "Select field staff first",
		ar: "اختر الموظف الميداني أولاً",
	},
	{
		id: "No pending changes",
		en: "No pending changes",
		ar: "لا توجد تغييرات معلّقة",
	},
	{ id: "Assigned to", en: "Assigned to", ar: "معيّن إلى" },
	{
		id: "POI assignments updated successfully",
		en: "POI assignments updated successfully",
		ar: "تم تحديث تعيينات نقاط الاهتمام بنجاح",
	},
	{
		id: "Failed to update POI assignments",
		en: "Failed to update POI assignments",
		ar: "فشل تحديث تعيينات نقاط الاهتمام",
	},
	{
		id: "No POIs match your search or filters",
		en: "No POIs match your search or filters",
		ar: "لا توجد نقاط اهتمام مطابقة للبحث أو التصفية",
	},
	{
		id: "No POIs assigned yet — select POIs from the left to assign",
		en: "No POIs assigned yet — select POIs from the left to assign",
		ar: "لا توجد نقاط اهتمام معيّنة بعد — اختر نقاطاً من القائمة المقابلة للتعيين",
	},
	{
		id: "Assign the selected partially-assigned POIs to ALL selected staff",
		en: "Assign the selected partially-assigned POIs to ALL selected staff",
		ar: "تعيين النقاط المحددة المعيّنة جزئياً لجميع الموظفين المحددين",
	},
	{ id: "Will remove", en: "Will remove", ar: "سيتم إزالتها" },
	{
		id: "No POIs assigned to all selected staff yet",
		en: "No POIs assigned to all selected staff yet",
		ar: "لا توجد نقاط اهتمام معيّنة لجميع الموظفين المحددين بعد",
	},
	// Append these entries into the exported array in src/constants/content.js.
// Each is a no-op if production already has an entry with the same id — grep first.

  {
    id: "Date",
    en: "Date",
    ar: "التاريخ",
  },
  {
    id: "City",
    en: "City",
    ar: "المدينة",
  },
  {
    id: "State",
    en: "State",
    ar: "الولاية",
  },
  {
    id: "Submitted At",
    en: "Submitted At",
    ar: "قدمت في",
  },
  {
    id: "Submitted By",
    en: "Submitted By",
    ar: "قدمت بواسطة",
  },
  {
    id: "Shelf Qty",
    en: "Shelf Qty",
    ar: "كمية الرف",
  },
  {
    id: "Warehouse Qty",
    en: "Warehouse Qty",
    ar: "كمية المخزن",
  },
  {
    id: "Price Before",
    en: "Price Before",
    ar: "السعر قبل",
  },
  {
    id: "Price After",
    en: "Price After",
    ar: "السعر بعد",
  },
  {
    id: "First Submitted",
    en: "First Submitted",
    ar: "قُدِّم لأول مرة",
  },
  {
    id: "Last Submitted",
    en: "Last Submitted",
    ar: "آخر ما تم تقديمه",
  },
  {
    id: "Total Submissions",
    en: "Total Submissions",
    ar: "إجمالي المشاركات",
  },
  {
    id: "shelfMovement",
    en: "shelfMovement",
    ar: "حركة الرفوف",
  },
  {
    id: "Client",
    en: "Client",
    ar: "العميل",
  },
  {
    id: "Shelf Movement Report",
    en: "Shelf Movement Report",
    ar: "تقرير حركة الرفوف",
  },
  {
    id: "Report provides visibility into shelf inventory changes during a selected period.",
    en: "Report provides visibility into shelf inventory changes during a selected period.",
    ar: "يوفر التقرير رؤيةً حول التغيرات في مخزون الأرفف خلال فترة محددة.",
  },
  {
    id: "ItemShelf",
    en: "Item",
    ar: "المنتج",
  },
  {
    id: "Near Miss",
    en: "Near Miss",
    ar: "الخطر الكامن",
  },
  {
    id: "Add Near Miss",
    en: "Add Near Miss",
    ar: "إضافة خطر كامن",
  },
  {
    id: "Near Miss Report",
    en: "Near Miss Report",
    ar: "تقرير الخطر الكامن",
  },
  {
    id: "Report a near miss",
    en: "Report a near miss",
    ar: "الإبلاغ عن خطر كامن",
  },
  {
    id: "Near Miss Report Submitted Successfully",
    en: "Near Miss Report Submitted Successfully",
    ar: "تم إرسال تقرير الخطر الكامن بنجاح",
  },
  {
    id: "Please fill in the required fields",
    en: "Please fill in the required fields",
    ar: "برجاء إستكمال الحقول المطلوبة",
  },
  {
    id: "Concerned Department",
    en: "Concerned Department",
    ar: "الإدارة المختصة",
  },
  {
    id: "Central Department",
    en: "Central Department",
    ar: "الإدارة المركزية",
  },
  {
    id: "Alerts summary",
    en: "Alerts summary",
    ar: "ملخص التنبيهات",
  },
  {
    id: "Resource status",
    en: "Resource status",
    ar: "حالة الموارد",
  },
  {
    id: "Task distribution",
    en: "Task distribution",
    ar: "توزيع المهام",
  },
  {
    id: "Form metrics",
    en: "Form metrics",
    ar: "مؤشرات النماذج",
  },
  {
    id: "Service request pipeline",
    en: "Service request pipeline",
    ar: "مراحل طلبات الخدمة",
  },
  {
    id: "Performance trends",
    en: "Performance trends",
    ar: "اتجاهات الأداء",
  },
  {
    id: "Monthly comparison",
    en: "Monthly comparison",
    ar: "المقارنة الشهرية",
  },
  {
    id: "Retail analytics",
    en: "Retail analytics",
    ar: "تحليلات التجزئة",
  },
  {
    id: "Retail period",
    en: "Retail period",
    ar: "فترة التجزئة",
  },
  {
    id: "Select dashboard sections",
    en: "Select dashboard sections",
    ar: "اختر أقسام لوحة المعلومات",
  },
  {
    id: "Visible dashboard sections",
    en: "Visible dashboard sections",
    ar: "أقسام لوحة المعلومات الظاهرة",
  },
  {
    id: "No dashboard sections selected",
    en: "No dashboard sections selected",
    ar: "لم يتم تحديد أي أقسام في لوحة المعلومات",
  },
  {
    id: "Shelf availability, inventory and client visit insights",
    en: "Shelf availability, inventory and client visit insights",
    ar: "رؤى حول توافر المنتجات على الأرفف والمخزون وزيارات العملاء",
  },
  {
    id: "Total visits",
    en: "Total visits",
    ar: "إجمالي الزيارات",
  },
  {
    id: "Clients visited",
    en: "Clients visited",
    ar: "العملاء الذين تمت زيارتهم",
  },
  {
    id: "visits",
    en: "visits",
    ar: "زيارات",
  },
  {
    id: "unique clients",
    en: "unique clients",
    ar: "عملاء مختلفون",
  },
  {
    id: "Client coverage",
    en: "Client coverage",
    ar: "تغطية العملاء",
  },
  {
    id: "clients",
    en: "clients",
    ar: "عملاء",
  },
  {
    id: "Clients",
    en: "Clients",
    ar: "العملاء",
  },
  {
    id: "Shelf availability",
    en: "Shelf availability",
    ar: "توافر المنتجات على الأرفف",
  },
  {
    id: "available checks",
    en: "available checks",
    ar: "حالات متاحة",
  },
  {
    id: "True out of stock",
    en: "True out of stock",
    ar: "نفاد فعلي للمخزون",
  },
  {
    id: "checks",
    en: "checks",
    ar: "حالات فحص",
  },
  {
    id: "Shelf gaps",
    en: "Shelf gaps",
    ar: "فجوات الأرفف",
  },
  {
    id: "Retail activity trend",
    en: "Retail activity trend",
    ar: "اتجاه نشاط التجزئة",
  },
  {
    id: "Visits, true out-of-stock checks and shelf gaps over time",
    en: "Visits, true out-of-stock checks and shelf gaps over time",
    ar: "الزيارات وحالات النفاد الفعلي وفجوات الأرفف بمرور الوقت",
  },
  {
    id: "Client visit frequency",
    en: "Client visit frequency",
    ar: "تكرار زيارات العملاء",
  },
  {
    id: "Most and least visited clients",
    en: "Most and least visited clients",
    ar: "العملاء الأكثر والأقل زيارة",
  },
  {
    id: "Most visited",
    en: "Most visited",
    ar: "الأكثر زيارة",
  },
  {
    id: "Least visited",
    en: "Least visited",
    ar: "الأقل زيارة",
  },
  {
    id: "No client visits in this period",
    en: "No client visits in this period",
    ar: "لا توجد زيارات للعملاء خلال هذه الفترة",
  },
  {
    id: "Out-of-stock distribution",
    en: "Out-of-stock distribution",
    ar: "توزيع حالات نفاد المخزون",
  },
  {
    id: "Latest true out-of-stock items by category, region and city",
    en: "Latest true out-of-stock items by category, region and city",
    ar: "أحدث المنتجات النافدة فعليًا حسب الفئة والمنطقة والمدينة",
  },
  {
    id: "By category",
    en: "By category",
    ar: "حسب الفئة",
  },
  {
    id: "By region",
    en: "By region",
    ar: "حسب المنطقة",
  },
  {
    id: "By city",
    en: "By city",
    ar: "حسب المدينة",
  },
  {
    id: "Out-of-stock items",
    en: "Out-of-stock items",
    ar: "المنتجات النافدة",
  },
  {
    id: "Unique items",
    en: "Unique items",
    ar: "المنتجات المختلفة",
  },
  {
    id: "Affected clients",
    en: "Affected clients",
    ar: "العملاء المتأثرون",
  },
  {
    id: "Inventory existence",
    en: "Inventory existence",
    ar: "توافر المخزون",
  },
  {
    id: "Top 10 items",
    en: "Top 10 items",
    ar: "أعلى 10 منتجات",
  },
  {
    id: "Bottom 10 items",
    en: "Bottom 10 items",
    ar: "أدنى 10 منتجات",
  },
  {
    id: "Shelf",
    en: "Shelf",
    ar: "الرف",
  },
  {
    id: "Warehouse",
    en: "Warehouse",
    ar: "المستودع",
  },
  {
    id: "Clients with stock",
    en: "Clients with stock",
    ar: "العملاء المتوفر لديهم مخزون",
  },
  {
    id: "Observed",
    en: "Observed",
    ar: "تاريخ الرصد",
  },
  {
    id: "No inventory observations in this period",
    en: "No inventory observations in this period",
    ar: "لا توجد بيانات رصد للمخزون خلال هذه الفترة",
  },
  {
    id: "Repeat out-of-stock items",
    en: "Repeat out-of-stock items",
    ar: "المنتجات المتكررة النفاد",
  },
  {
    id: "Items repeatedly unavailable across visits",
    en: "Items repeatedly unavailable across visits",
    ar: "المنتجات غير المتاحة بشكل متكرر عبر الزيارات",
  },
  {
    id: "OOS checks",
    en: "OOS checks",
    ar: "حالات النفاد",
  },
  {
    id: "Unvisited clients",
    en: "Unvisited clients",
    ar: "العملاء الذين لم تتم زيارتهم",
  },
  {
    id: "Known clients without a visit in the selected period",
    en: "Known clients without a visit in the selected period",
    ar: "العملاء المعروفون الذين لم تتم زيارتهم خلال الفترة المحددة",
  },
  {
    id: "All known clients were visited in this period",
    en: "All known clients were visited in this period",
    ar: "تمت زيارة جميع العملاء المعروفين خلال هذه الفترة",
  },
  {
    id: "No repeat out-of-stock items in this period",
    en: "No repeat out-of-stock items in this period",
    ar: "لا توجد منتجات متكررة النفاد خلال هذه الفترة",
  },
  {
    id: "No data available for this period",
    en: "No data available for this period",
    ar: "لا تتوفر بيانات لهذه الفترة",
  },
  {
    id: "Retail dashboard is not configured",
    en: "Retail dashboard is not configured",
    ar: "لم يتم إعداد لوحة معلومات التجزئة",
  },
  {
    id: "A shelf availability form must be configured first.",
    en: "A shelf availability form must be configured first.",
    ar: "يجب إعداد نموذج توافر المنتجات على الأرفف أولًا.",
  },
  {
    id: "Failed to load retail analytics",
    en: "Failed to load retail analytics",
    ar: "تعذر تحميل تحليلات التجزئة",
  },
  {
    id: "Please refresh the dashboard and try again.",
    en: "Please refresh the dashboard and try again.",
    ar: "يرجى تحديث لوحة المعلومات والمحاولة مرة أخرى.",
  },
  {
    id: "Updating",
    en: "Updating",
    ar: "جارٍ التحديث",
  },
  {
    id: "Latest submission in this period",
    en: "Latest submission in this period",
    ar: "أحدث إرسال خلال هذه الفترة",
  },
  {
    id: "Region / City",
    en: "Region / City",
    ar: "المنطقة / المدينة",
  },
  {
    id: "Last visit",
    en: "Last visit",
    ar: "آخر زيارة",
  },
  {
    id: "Visits",
    en: "Visits",
    ar: "الزيارات",
  },
  {
    id: "Region",
    en: "Region",
    ar: "المنطقة",
  },
  {
    id: "Channel",
    en: "Channel",
    ar: "قناة البيع",
  },
  {
    id: "By channel",
    en: "By channel",
    ar: "حسب قناة البيع",
  },
  {
    id: "Supermarket",
    en: "Supermarket",
    ar: "سوبر ماركت",
  },
  {
    id: "Shopping area",
    en: "Shopping area",
    ar: "منطقة تسوق",
  },
  {
    id: "Out-of-stock rate",
    en: "Out-of-stock rate",
    ar: "نسبة نفاد المخزون",
  },
  {
    id: "Shelf availability rate",
    en: "Shelf availability rate",
    ar: "نسبة التوافر على الرف",
  },
  {
    id: "Out-of-stock checks",
    en: "Out-of-stock checks",
    ar: "حالات فحص نفاد المخزون",
  },
  {
    id: "Shelf-available checks",
    en: "Shelf-available checks",
    ar: "حالات التوافر على الرف",
  },
  {
    id: "Shelf-gap checks",
    en: "Shelf-gap checks",
    ar: "حالات فجوة الرف",
  },
  {
    id: "Exact count is not available",
    en: "Exact count is not available",
    ar: "العدد الدقيق غير متاح",
  },
  {
    id: "Hover for exact counts",
    en: "Hover for exact counts",
    ar: "مرر المؤشر لعرض الأعداد الدقيقة",
  },
  {
    id: "No stock checks in this period",
    en: "No stock checks in this period",
    ar: "لا توجد حالات فحص للمخزون خلال هذه الفترة",
  },
  {
    id: "Percentage",
    en: "Percentage",
    ar: "النسبة المئوية",
  },
  {
    id: "Visits and stock-health percentages over time",
    en: "Visits and stock-health percentages over time",
    ar: "الزيارات ونسب حالة المخزون بمرور الوقت",
  },
  {
    id: "Stock health by dimension",
    en: "Stock health by dimension",
    ar: "حالة المخزون حسب البعد",
  },
  {
    id: "Search unvisited clients",
    en: "Search unvisited clients",
    ar: "البحث في العملاء الذين لم تتم زيارتهم",
  },
  {
    id: "No clients match your search",
    en: "No clients match your search",
    ar: "لا يوجد عملاء مطابقون لبحثك",
  },
  {
    id: "Stock status from each client's latest submitted stock report",
    en: "Stock status from each client's latest submitted stock report",
    ar: "حالة المخزون من أحدث تقرير مخزون مُرسل لكل عميل",
  },
  {
    id: "Blank or zero quantity is unavailable. Hover a percentage or focus the stock mix for exact counts.",
    en: "Blank or zero quantity is unavailable. Hover a percentage or focus the stock mix for exact counts.",
    ar: "تُعامل الكمية الفارغة أو الصفرية على أنها غير متاحة. مرر المؤشر فوق النسبة أو ركّز على شريط توزيع المخزون لعرض الأعداد الدقيقة.",
  },
  {
    id: "Top 10 OOS rates are shown in the chart; all results are listed below.",
    en: "Top 10 OOS rates are shown in the chart; all results are listed below.",
    ar: "يعرض الرسم أعلى 10 نسب لنفاد المخزون، وتظهر جميع النتائج في الجدول أدناه.",
  },
  {
    id: "Stock mix",
    en: "Stock mix",
    ar: "توزيع حالة المخزون",
  },
  {
    id: "Shelf available",
    en: "Shelf available",
    ar: "متوفر على الرف",
  },
  {
    id: "Shelf gap",
    en: "Shelf gap",
    ar: "فجوة على الرف",
  },
  {
    id: "Search this dimension",
    en: "Search this dimension",
    ar: "البحث ضمن هذا البُعد",
  },
  {
    id: "Sort stock health",
    en: "Sort stock health",
    ar: "ترتيب حالة المخزون",
  },
  {
    id: "Highest OOS",
    en: "Highest OOS",
    ar: "أعلى نسبة نفاد للمخزون",
  },
  {
    id: "Highest shelf gaps",
    en: "Highest shelf gaps",
    ar: "أعلى نسبة فجوات على الرف",
  },
  {
    id: "Highest shelf availability",
    en: "Highest shelf availability",
    ar: "أعلى نسبة توافر على الرف",
  },
  {
    id: "Name A-Z",
    en: "Name A-Z",
    ar: "الاسم: أ–ي",
  },
  {
    id: "Top 10",
    en: "Top 10",
    ar: "أعلى 10",
  },
  {
    id: "results",
    en: "results",
    ar: "نتائج",
  },
  {
    id: "OOS",
    en: "OOS",
    ar: "نفاد المخزون",
  },
  {
    id: "No matching stock-health results",
    en: "No matching stock-health results",
    ar: "لا توجد نتائج مطابقة لحالة المخزون",
  },
  {
    id: "Stock health details",
    en: "Stock health details",
    ar: "تفاصيل حالة المخزون",
  },
  {
    id: "Items",
    en: "Items",
    ar: "المنتجات",
  },
  {
    id: "Categories",
    en: "Categories",
    ar: "الفئات",
  },
  {
    id: "Cities",
    en: "Cities",
    ar: "المدن",
  },
  {
    id: "Regions",
    en: "Regions",
    ar: "المناطق",
  },
  {
    id: "No detailed stock-health breakdown available",
    en: "No detailed stock-health breakdown available",
    ar: "لا تتوفر تفاصيل إضافية لحالة المخزون",
  },
  {
    id: "Overall existence",
    en: "Overall existence",
    ar: "التوافر الإجمالي",
  },
  {
    id: "Warehouse availability",
    en: "Warehouse availability",
    ar: "التوافر في المستودع",
  },
  {
    id: "Checked clients",
    en: "Checked clients",
    ar: "العملاء الذين تم فحصهم",
  },
  {
    id: "clients checked",
    en: "clients checked",
    ar: "من العملاء الذين تم فحصهم",
  },
  {
    id: "Last checked",
    en: "Last checked",
    ar: "آخر فحص",
  },
  {
    id: "Highest existence",
    en: "Highest existence",
    ar: "الأعلى توافراً",
  },
  {
    id: "Lowest existence",
    en: "Lowest existence",
    ar: "الأقل توافراً",
  },
  {
    id: "Share of checked clients where each item was found in their latest submitted stock report",
    en: "Share of checked clients where each item was found in their latest submitted stock report",
    ar: "نسبة العملاء الذين تم فحصهم وتم العثور على كل منتج لديهم في أحدث تقرير مخزون مُرسل",
  },
  {
    id: "Warehouse availability is the share of checked clients with at least one container. Overall existence means shelf or warehouse presence; rates may overlap.",
    en: "Warehouse availability is the share of checked clients with at least one container. Overall existence means shelf or warehouse presence; rates may overlap.",
    ar: "التوافر في المستودع هو نسبة العملاء الذين تم فحصهم ولديهم حاوية واحدة على الأقل. ويعني التوافر الإجمالي وجود المنتج على الرف أو في المستودع؛ وقد تتداخل النسب.",
  },
  {
    id: "No stock report",
    en: "No stock report",
    ar: "لا يوجد تقرير مخزون",
  },
  {
    id: "Completed visits without a submitted stock report",
    en: "Completed visits without a submitted stock report",
    ar: "زيارات مكتملة دون إرسال تقرير مخزون",
  },
  {
    id: "Filter by categories",
    en: "Filter by categories",
    ar: "التصفية حسب الفئات",
  },
  {
    id: "All categories",
    en: "All categories",
    ar: "جميع الفئات",
  },
  {
    id: "No stock checks for selected categories",
    en: "No stock checks for selected categories",
    ar: "لا توجد فحوصات مخزون للفئات المحددة",
  },
  {
    id: "Stock category filter",
    en: "Stock category filter",
    ar: "تصفية فئات المخزون",
  },
  {
    id: "Applies to stock, inventory and item widgets. Visit metrics remain based on completed tasks.",
    en: "Applies to stock, inventory and item widgets. Visit metrics remain based on completed tasks.",
    ar: "يُطبّق على مؤشرات المخزون والتوافر والمنتجات. وتظل مؤشرات الزيارات مبنية على المهام المكتملة.",
  },
  {
    id: "No inventory observations for selected categories",
    en: "No inventory observations for selected categories",
    ar: "لا توجد بيانات توافر للفئات المحددة",
  },
  {
    id: "No repeat out-of-stock items for selected categories",
    en: "No repeat out-of-stock items for selected categories",
    ar: "لا توجد منتجات متكررة النفاد للفئات المحددة",
  },
  {
    id: "Stock filters",
    en: "Stock filters",
    ar: "فلاتر المخزون",
  },
  {
    id: "Filter stock widgets by category and item. Visit metrics remain based on completed tasks.",
    en: "Filter stock widgets by category and item. Visit metrics remain based on completed tasks.",
    ar: "صفِّ مؤشرات المخزون حسب الفئة والمنتج. وتظل مؤشرات الزيارات مبنية على المهام المكتملة.",
  },
  {
    id: "Filter by items",
    en: "Filter by items",
    ar: "التصفية حسب المنتجات",
  },
  {
    id: "All items",
    en: "All items",
    ar: "جميع المنتجات",
  },
  {
    id: "No items available for selected categories",
    en: "No items available for selected categories",
    ar: "لا توجد منتجات متاحة ضمن الفئات المحددة",
  },
  {
    id: "No matching items",
    en: "No matching items",
    ar: "لا توجد منتجات مطابقة",
  },
  {
    id: "No stock checks for selected filters",
    en: "No stock checks for selected filters",
    ar: "لا توجد فحوصات مخزون مطابقة للفلاتر المحددة",
  },
  {
    id: "No inventory observations for selected filters",
    en: "No inventory observations for selected filters",
    ar: "لا توجد بيانات توافر مطابقة للفلاتر المحددة",
  },
  {
    id: "No repeat out-of-stock items for selected filters",
    en: "No repeat out-of-stock items for selected filters",
    ar: "لا توجد منتجات متكررة النفاد مطابقة للفلاتر المحددة",
  },
  {
    id: "Location filters",
    en: "Location filters",
    ar: "فلاتر المواقع",
  },
  {
    id: "Filters all retail widgets, including visits, coverage and stock metrics.",
    en: "Filters all retail widgets, including visits, coverage and stock metrics.",
    ar: "تصفّي جميع مؤشرات التجزئة، بما في ذلك الزيارات والتغطية ومؤشرات المخزون.",
  },
  {
    id: "All regions",
    en: "All regions",
    ar: "جميع المناطق",
  },
  {
    id: "Filter by regions",
    en: "Filter by regions",
    ar: "التصفية حسب المناطق",
  },
  {
    id: "All cities",
    en: "All cities",
    ar: "جميع المدن",
  },
  {
    id: "Filter by cities",
    en: "Filter by cities",
    ar: "التصفية حسب المدن",
  },
  {
    id: "Client location / Store",
    en: "Client location / Store",
    ar: "موقع العميل / المتجر",
  },
  {
    id: "All client locations",
    en: "All client locations",
    ar: "جميع مواقع العملاء",
  },
  {
    id: "Filter by client locations",
    en: "Filter by client locations",
    ar: "التصفية حسب مواقع العملاء",
  },
  {
    id: "Clear location filters",
    en: "Clear location filters",
    ar: "مسح فلاتر المواقع",
  },
  {
    id: "No matching regions",
    en: "No matching regions",
    ar: "لا توجد مناطق مطابقة",
  },
  {
    id: "No matching cities",
    en: "No matching cities",
    ar: "لا توجد مدن مطابقة",
  },
  {
    id: "No matching client locations",
    en: "No matching client locations",
    ar: "لا توجد مواقع عملاء مطابقة",
  },
  {
    id: "Client selection mode",
    en: "Client selection mode",
    ar: "طريقة تحديد مواقع العملاء",
  },
  {
    id: "Include only",
    en: "Include only",
    ar: "تضمين فقط",
  },
  {
    id: "Exclude",
    en: "Exclude",
    ar: "استبعاد",
  },
  {
    id: "All except",
    en: "All except",
    ar: "الكل باستثناء",
  },
  {
    id: "Choose locations to include",
    en: "Choose locations to include",
    ar: "اختر المواقع المراد تضمينها",
  },
  {
    id: "Choose locations to exclude",
    en: "Choose locations to exclude",
    ar: "اختر المواقع المراد استبعادها",
  },
  {
    id: "Apply filters",
    en: "Apply filters",
    ar: "تطبيق الفلاتر",
  },
  {
    id: "Not applied",
    en: "Not applied",
    ar: "لم يتم التطبيق",
  },
  {
    id: "excluded",
    en: "excluded",
    ar: "مستبعد",
  },
  // Retail month comparison
  {
    id: "Compare months",
    en: "Compare months",
    ar: "مقارنة الأشهر",
  },
  {
    id: "Selected month",
    en: "Selected month",
    ar: "الشهر المحدد",
  },
  {
    id: "Comparison month",
    en: "Comparison month",
    ar: "شهر المقارنة",
  },
  {
    id: "vs",
    en: "vs",
    ar: "مقابل",
  },
  {
    id: "same days",
    en: "same days",
    ar: "نفس الأيام",
  },
  {
    id: "Same days of each month",
    en: "Same days of each month",
    ar: "نفس أيام كل شهر",
  },
  {
    id: "Months are UTC calendar months",
    en: "Months are UTC calendar months",
    ar: "الأشهر بالتوقيت العالمي (UTC)",
  },
  {
    id: "Comparison unavailable",
    en: "Comparison unavailable",
    ar: "المقارنة غير متاحة",
  },
  {
    id: "Comparison data did not match the selected scope",
    en: "Comparison data did not match the selected scope",
    ar: "بيانات المقارنة لا تطابق النطاق المحدد",
  },
  {
    id: "Retry",
    en: "Retry",
    ar: "إعادة المحاولة",
  },
  {
    id: "Comparing",
    en: "Comparing",
    ar: "جارٍ المقارنة",
  },
  {
    id: "Change",
    en: "Change",
    ar: "التغيير",
  },
  {
    id: "pp",
    en: "pp",
    ar: "نقطة مئوية",
  },
  {
    id: "Up",
    en: "Up",
    ar: "ارتفاع",
  },
  {
    id: "Down",
    en: "Down",
    ar: "انخفاض",
  },
  {
    id: "No change",
    en: "No change",
    ar: "بدون تغيير",
  },
  {
    id: "Low sample: fewer than 30 stock checks",
    en: "Low sample: fewer than 30 stock checks",
    ar: "عينة صغيرة: أقل من 30 فحصًا للمخزون",
  },
  {
    id: "No stock checks",
    en: "No stock checks",
    ar: "لا توجد فحوصات للمخزون",
  },
  {
    id: "Not available",
    en: "Not available",
    ar: "غير متاح",
  },
  {
    id: "Not checked",
    en: "Not checked",
    ar: "لم يتم الفحص",
  },
  {
    id: "Repeat in both",
    en: "Repeat in both",
    ar: "متكرر في الشهرين",
  },
  {
    id: "New repeat",
    en: "New repeat",
    ar: "تكرار جديد",
  },
  {
    id: "Also unvisited",
    en: "Also unvisited",
    ar: "غير مزار أيضًا",
  },
  {
    id: "Visited",
    en: "Visited",
    ar: "تمت زيارته",
  },
  {
    id: "Day of month",
    en: "Day of month",
    ar: "يوم الشهر",
  },
  {
    id: "Day",
    en: "Day",
    ar: "يوم",
  },
  {
    id: "Shelf-availability changes",
    en: "Shelf-availability changes",
    ar: "التغيرات في توفر المنتجات على الرف",
  },
  {
    id: "Not comparable (no stock checks in one of the months)",
    en: "Not comparable (no stock checks in one of the months)",
    ar: "غير قابل للمقارنة (لا توجد فحوصات مخزون في أحد الشهرين)",
  },
  {
    id: "Showing every row for the selected filter. Higher shelf availability is better. Stable means a change of less than 0.5 points.",
    en: "Showing every row for the selected filter. Higher shelf availability is better. Stable means a change of less than 0.5 points.",
    ar: "يتم عرض كل العناصر حسب الفلتر المحدد. ارتفاع توفر المنتجات على الرف أفضل. المستقر يعني تغيرًا أقل من 0.5 نقطة.",
  },
  {
    id: "Stable",
    en: "Stable",
    ar: "مستقر",
  },
  {
    id: "No stable rows",
    en: "No stable rows",
    ar: "لا توجد عناصر مستقرة",
  },
  {
    id: "Selected items",
    en: "Selected items",
    ar: "الأصناف المحددة",
  },
  {
    id: "Selected categories",
    en: "Selected categories",
    ar: "الفئات المحددة",
  },
  {
    id: "All products · not affected by the item filter",
    en: "All products · not affected by the item filter",
    ar: "كل المنتجات · لا يتأثر بفلتر الأصناف",
  },
  {
    id: "Only rows with at least 10 stock checks in both months are ranked. Higher shelf availability is better. Stable means a change of less than 0.5 points.",
    en: "Only rows with at least 10 stock checks in both months are ranked. Higher shelf availability is better. Stable means a change of less than 0.5 points.",
    ar: "يتم ترتيب العناصر التي لديها 10 فحوصات مخزون على الأقل في كلا الشهرين فقط. ارتفاع توفر المنتجات على الرف أفضل. المستقر يعني تغيرًا أقل من 0.5 نقطة.",
  },
  {
    id: "By item",
    en: "By item",
    ar: "حسب الصنف",
  },
  {
    id: "Channels",
    en: "Channels",
    ar: "القنوات",
  },
  {
    id: "Full months",
    en: "Full months",
    ar: "أشهر كاملة",
  },
  {
    id: "points",
    en: "points",
    ar: "نقطة",
  },
  {
    id: "Better",
    en: "Better",
    ar: "أفضل",
  },
  {
    id: "Worse",
    en: "Worse",
    ar: "أسوأ",
  },
  {
    id: "This month vs last month",
    en: "This month vs last month",
    ar: "هذا الشهر مقابل الشهر الماضي",
  },
  {
    id: "Last month vs the month before",
    en: "Last month vs the month before",
    ar: "الشهر الماضي مقابل الشهر الذي قبله",
  },
  {
    id: "This month vs same month last year",
    en: "This month vs same month last year",
    ar: "هذا الشهر مقابل نفس الشهر من العام الماضي",
  },
  {
    id: "Single period",
    en: "Single period",
    ar: "فترة واحدة",
  },
  {
    id: "Month",
    en: "Month",
    ar: "الشهر",
  },
  {
    id: "Compare with",
    en: "Compare with",
    ar: "مقارنة مع",
  },
  {
    id: "Quick picks",
    en: "Quick picks",
    ar: "اختيارات سريعة",
  },
  {
    id: "Month comparison",
    en: "Month comparison",
    ar: "مقارنة الأشهر",
  },
  {
    id: "Metric",
    en: "Metric",
    ar: "المؤشر",
  },
  {
    id: "Biggest shelf-availability changes",
    en: "Biggest shelf-availability changes",
    ar: "أكبر التغيرات في توفر المنتجات على الرف",
  },
  {
    id: "Improved",
    en: "Improved",
    ar: "تحسّن",
  },
  {
    id: "No notable improvements",
    en: "No notable improvements",
    ar: "لا توجد تحسينات ملحوظة",
  },
  {
    id: "Declined",
    en: "Declined",
    ar: "تراجع",
  },
  {
    id: "No notable declines",
    en: "No notable declines",
    ar: "لا يوجد تراجع ملحوظ",
  },

];
